/**
 * Generated by orval v7.8.0 🍺
 * Do not edit manually.
 * Synthflow Backend
 * OpenAPI spec version: 1.0
 */
import {useMutation, useQuery} from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  Account,
  AcquirePhoneNumberParams,
  Action,
  ActionListSummary,
  AgentProgressResponse,
  AnalyticsDashboard,
  Appearance,
  Assistant,
  AssistantSummary,
  AssistantTemplate,
  AttachActionToAssistantParams,
  AttachAssistantsToAccountBody,
  BaseError,
  BatchAttachedAction,
  BubbleAuthProxyDelete200,
  BubbleAuthProxyDeleteParams,
  BubbleAuthProxyGet200,
  BubbleAuthProxyGetParams,
  BubbleAuthProxyPatch200,
  BubbleAuthProxyPatchBody,
  BubbleAuthProxyPost200,
  BubbleAuthProxyPostBody,
  BubbleAuthProxyPut200,
  BubbleAuthProxyPutBody,
  Call,
  CallFeedback,
  CallFlow,
  CallPcap,
  CallSuccessResponse,
  Capabilities,
  ChatHistory,
  CloneElevenLabsVoiceParams,
  ContactCreateRequest,
  ContactIdResponse,
  ContactMemoryRequest,
  ContactMemoryResponse,
  ContactResponse,
  ContactUpdateRequest,
  CreateActionFromTemplateBody,
  CreateActionFromTemplateParams,
  CreateAssistantFromTemplateBody,
  CreateAssistantFromTemplateSlugBody,
  CreateAssistantFromTemplateSlugParams,
  CreateOrUpdateAssistantDraft200,
  CreateOrUpdateAssistantDraftBody,
  CreatePhoneBookEntryRequest,
  CreatePhoneBookRequest,
  CreateResult,
  CreateSimulationCaseParams,
  CreateSimulationScenarioParams,
  CreateSimulationSuiteParams,
  CustomActionTemplateSummary,
  DeleteBatchKnowledgeBaseItemsBody,
  DeletePhoneNumberParams,
  DeleteSimulationCaseParams,
  DeleteSimulationScenarioParams,
  DeleteSimulationSuiteParams,
  DetachActionFromAssistantParams,
  DetachAssistantsFromAccountBody,
  DomainWhitelist,
  DuplicateActionBody,
  DuplicateAssistantBody,
  EditPhoneNumberParams,
  ErrorResponse,
  ExportAssistantVersion200,
  FSMValidationResponse,
  FeatureFlag,
  FeatureFlagCreateRequest,
  FetchKnowledgeBaseItems200,
  GenerateSimulationCasesBody,
  GenerateSimulationCasesParams,
  GetAccountDetailsParams,
  GetAccountList200,
  GetAccountListParams,
  GetActionList200,
  GetActionListParams,
  GetActionListSummaryParams,
  GetActionTemplateBySlugParams,
  GetActionTemplates200,
  GetActionTemplatesParams,
  GetAnalyticsApiParams,
  GetAnalyticsParams,
  GetAssistantActions200,
  GetAssistantActionsParams,
  GetAssistantDraft200,
  GetAssistantList200,
  GetAssistantListParams,
  GetAssistantPhoneNumbers200,
  GetAssistantPhoneNumbersParams,
  GetAssistantTemplates200,
  GetAssistantTemplatesOld200,
  GetAssistantTemplatesOldParams,
  GetAssistantTemplatesParams,
  GetAssistantVersionDiff200,
  GetAssistantVersionDiffParams,
  GetAssistantVersions200,
  GetAvailableAssistantTemplates200,
  GetAvailableAssistantTemplatesParams,
  GetCallFlowParams,
  GetCallList200One,
  GetCallListParams,
  GetCallPcapParams,
  GetCallStatParams,
  GetCapabilitiesParams,
  GetChatHistory200,
  GetChatHistoryParams,
  GetContacts200,
  GetContactsApi200,
  GetContactsApiParams,
  GetContactsParams,
  GetElevenLabsVoiceList200,
  GetElevenLabsVoiceListParams,
  GetFeatureFlagsParams,
  GetGHLCalendars200,
  GetKnowledgeBaseList200,
  GetKnowledgeBaseListParams,
  GetMemoryStoreContacts200,
  GetMemoryStoreContactsApi200,
  GetMemoryStoreContactsApiParams,
  GetMemoryStoreContactsParams,
  GetMemoryStores200,
  GetMemoryStoresApi200,
  GetMemoryStoresApiParams,
  GetMemoryStoresParams,
  GetPhoneBookEntries200,
  GetPhoneBookEntriesParams,
  GetPhoneBookList200,
  GetPhoneBookListParams,
  GetPhoneNumberList200,
  GetPhoneNumberListParams,
  GetPhoneNumberParams,
  GetProviderAvailablePhoneNumbers200,
  GetProviderAvailablePhoneNumbersParams,
  GetSimulationCaseParams,
  GetSimulationParams,
  GetSimulationScenarioParams,
  GetSimulationSessionParams,
  GetSimulationSuiteParams,
  GetThemeParams,
  GetValidCallerIdList200,
  GetValidCallerIdList500,
  GetValidCallerIdListParams,
  GetWebhookLogDetailParams,
  GetWhatsAppSenderStatusParams,
  GetWorkflowList200,
  GetWorkspaceProviders200,
  GetWorkspaceProvidersParams,
  GetWorkspaceSubaccounts200,
  ImportElevenLabsVoiceParams,
  InitializeCustomAction200,
  InitializeCustomActionInput,
  InitializeWebHookBody,
  KnowledgeBase,
  KnowledgeBaseItem,
  ListSimulationCases200,
  ListSimulationCasesByAgentParams,
  ListSimulationCasesParams,
  ListSimulationScenarios200,
  ListSimulationScenariosParams,
  ListSimulationSessionsParams,
  ListSimulationSuitesParams,
  ListSimulationsParams,
  ListWebhookLogsParams,
  LocaleInfo,
  MemoryStoreCreateRequest,
  MemoryStoreIdResponse,
  MemoryStoreResponse,
  MemoryStoreUpdateRequest,
  NameValue,
  OAuthTokenResponse,
  OpenCallParams,
  PaginatedSimulationSessionList,
  PaginatedSimulationSuitesList,
  PaginatedSimulationsList,
  PhoneNumber,
  PhoneNumberWithSid,
  PublicAPIErrorResponse,
  PublishAssistantDraft200,
  PublishAssistantDraftBody,
  ReleasePhoneNumberParams,
  RemoveContactFromMemoryStoreApiParams,
  RemoveContactFromMemoryStoreParams,
  RemoveDomainWhitelistParams,
  RenameKnowledgeBaseBody,
  RenameWorkflowBody,
  RequiredInformationCallInput,
  RequiredInformationCallInputOutbound,
  RollbackAssistantVersion200,
  SetThemeParams,
  SimulationCaseCreateIn,
  SimulationCaseReadOut,
  SimulationCaseUpdateIn,
  SimulationCreateIn,
  SimulationReadOut,
  SimulationScenarioCreateIn,
  SimulationScenarioReadOut,
  SimulationScenarioUpdateIn,
  SimulationSessionReadOut,
  SimulationSuiteCreateIn,
  SimulationSuiteReadOut,
  SimulationSuiteUpdateIn,
  StartSimulationParams,
  Statistics,
  TextMessage,
  TimeZone,
  UpdateMyAgentAvatarBody,
  UpdateMyAssistantAvatarBody,
  UpdatePhoneBookRequest,
  UpdateSimulationCaseParams,
  UpdateSimulationScenarioParams,
  UpdateSimulationSuiteParams,
  UploadKnowledgeBaseFileBody,
  UploadResult,
  UsageTrackingRequest,
  UsageTrackingResponse,
  UserInterfaceItem,
  UserJWTAuthRequest,
  UserJWTAuthResponse,
  UserRating,
  ValidateActionInputDTO,
  ValidateActionResponse,
  ValidateAssistantFSMBody,
  VerifyPhoneNumber200,
  VerifyPhoneNumberBody,
  VoiceFile,
  WebhookAssistentPaginatedList,
  WebhookLogDetailResponse,
  WhatsAppSenderRegistrationRequest,
  WhatsAppSenderRegistrationResponse,
  WhatsAppSenderStatusResponse,
  Workflow,
  WriteCookieRequest,
} from "./";

import {axiosInstance} from "../../config/axios.config";

// https://stackoverflow.com/questions/49579094/typescript-conditional-types-filter-out-readonly-properties-pick-only-requir/49579497#49579497
type IfEquals<X, Y, A = X, B = never> =
  (<T>() => T extends X ? 1 : 2) extends <T>() => T extends Y ? 1 : 2 ? A : B;

type WritableKeys<T> = {
  [P in keyof T]-?: IfEquals<{[Q in P]: T[P]}, {-readonly [Q in P]: T[P]}, P>;
}[keyof T];

type UnionToIntersection<U> = (U extends any ? (k: U) => void : never) extends (
  k: infer I,
) => void
  ? I
  : never;
type DistributeReadOnlyOverUnions<T> = T extends any ? NonReadonly<T> : never;

type Writable<T> = Pick<T, WritableKeys<T>>;
type NonReadonly<T> = [T] extends [UnionToIntersection<T>]
  ? {
      [P in keyof Writable<T>]: T[P] extends object
        ? NonReadonly<NonNullable<T[P]>>
        : T[P];
    }
  : DistributeReadOnlyOverUnions<T>;

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

/**
 * Checks the service has started successfully
 */
export const readinessHealthCheck = (signal?: AbortSignal) => {
  return axiosInstance<void>({url: `/health/ready`, method: "GET", signal});
};

export const getReadinessHealthCheckQueryKey = () => {
  return [`/health/ready`] as const;
};

export const getReadinessHealthCheckQueryOptions = <
  TData = Awaited<ReturnType<typeof readinessHealthCheck>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof readinessHealthCheck>>,
      TError,
      TData
    >
  >;
}) => {
  const {query: queryOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getReadinessHealthCheckQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof readinessHealthCheck>>
  > = ({signal}) => readinessHealthCheck(signal);

  return {queryKey, queryFn, ...queryOptions} as UseQueryOptions<
    Awaited<ReturnType<typeof readinessHealthCheck>>,
    TError,
    TData
  > & {queryKey: DataTag<QueryKey, TData, TError>};
};

export type ReadinessHealthCheckQueryResult = NonNullable<
  Awaited<ReturnType<typeof readinessHealthCheck>>
>;
export type ReadinessHealthCheckQueryError = void;

export function useReadinessHealthCheck<
  TData = Awaited<ReturnType<typeof readinessHealthCheck>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof readinessHealthCheck>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof readinessHealthCheck>>,
          TError,
          Awaited<ReturnType<typeof readinessHealthCheck>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useReadinessHealthCheck<
  TData = Awaited<ReturnType<typeof readinessHealthCheck>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof readinessHealthCheck>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof readinessHealthCheck>>,
          TError,
          Awaited<ReturnType<typeof readinessHealthCheck>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};
export function useReadinessHealthCheck<
  TData = Awaited<ReturnType<typeof readinessHealthCheck>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof readinessHealthCheck>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};

export function useReadinessHealthCheck<
  TData = Awaited<ReturnType<typeof readinessHealthCheck>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof readinessHealthCheck>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getReadinessHealthCheckQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & {queryKey: DataTag<QueryKey, TData, TError>};

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Checks the service has started successfully
 */
export const livenessHealthCheck = (signal?: AbortSignal) => {
  return axiosInstance<void>({url: `/health/live`, method: "GET", signal});
};

export const getLivenessHealthCheckQueryKey = () => {
  return [`/health/live`] as const;
};

export const getLivenessHealthCheckQueryOptions = <
  TData = Awaited<ReturnType<typeof livenessHealthCheck>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof livenessHealthCheck>>,
      TError,
      TData
    >
  >;
}) => {
  const {query: queryOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getLivenessHealthCheckQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof livenessHealthCheck>>
  > = ({signal}) => livenessHealthCheck(signal);

  return {queryKey, queryFn, ...queryOptions} as UseQueryOptions<
    Awaited<ReturnType<typeof livenessHealthCheck>>,
    TError,
    TData
  > & {queryKey: DataTag<QueryKey, TData, TError>};
};

export type LivenessHealthCheckQueryResult = NonNullable<
  Awaited<ReturnType<typeof livenessHealthCheck>>
>;
export type LivenessHealthCheckQueryError = void;

export function useLivenessHealthCheck<
  TData = Awaited<ReturnType<typeof livenessHealthCheck>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof livenessHealthCheck>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof livenessHealthCheck>>,
          TError,
          Awaited<ReturnType<typeof livenessHealthCheck>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useLivenessHealthCheck<
  TData = Awaited<ReturnType<typeof livenessHealthCheck>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof livenessHealthCheck>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof livenessHealthCheck>>,
          TError,
          Awaited<ReturnType<typeof livenessHealthCheck>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};
export function useLivenessHealthCheck<
  TData = Awaited<ReturnType<typeof livenessHealthCheck>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof livenessHealthCheck>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};

export function useLivenessHealthCheck<
  TData = Awaited<ReturnType<typeof livenessHealthCheck>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof livenessHealthCheck>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getLivenessHealthCheckQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & {queryKey: DataTag<QueryKey, TData, TError>};

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get agency capabilities by workspace
 */
export const getWorkspaceCapabilities = (
  workspaceId: string,
  signal?: AbortSignal,
) => {
  return axiosInstance<Capabilities>({
    url: `/workspaces/${workspaceId}/capabilities`,
    method: "GET",
    signal,
  });
};

export const getGetWorkspaceCapabilitiesQueryKey = (workspaceId: string) => {
  return [`/workspaces/${workspaceId}/capabilities`] as const;
};

export const getGetWorkspaceCapabilitiesQueryOptions = <
  TData = Awaited<ReturnType<typeof getWorkspaceCapabilities>>,
  TError = unknown,
>(
  workspaceId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getWorkspaceCapabilities>>,
        TError,
        TData
      >
    >;
  },
) => {
  const {query: queryOptions} = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetWorkspaceCapabilitiesQueryKey(workspaceId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getWorkspaceCapabilities>>
  > = ({signal}) => getWorkspaceCapabilities(workspaceId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!workspaceId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getWorkspaceCapabilities>>,
    TError,
    TData
  > & {queryKey: DataTag<QueryKey, TData, TError>};
};

export type GetWorkspaceCapabilitiesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getWorkspaceCapabilities>>
>;
export type GetWorkspaceCapabilitiesQueryError = unknown;

export function useGetWorkspaceCapabilities<
  TData = Awaited<ReturnType<typeof getWorkspaceCapabilities>>,
  TError = unknown,
>(
  workspaceId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getWorkspaceCapabilities>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWorkspaceCapabilities>>,
          TError,
          Awaited<ReturnType<typeof getWorkspaceCapabilities>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetWorkspaceCapabilities<
  TData = Awaited<ReturnType<typeof getWorkspaceCapabilities>>,
  TError = unknown,
>(
  workspaceId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getWorkspaceCapabilities>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWorkspaceCapabilities>>,
          TError,
          Awaited<ReturnType<typeof getWorkspaceCapabilities>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};
export function useGetWorkspaceCapabilities<
  TData = Awaited<ReturnType<typeof getWorkspaceCapabilities>>,
  TError = unknown,
>(
  workspaceId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getWorkspaceCapabilities>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};

export function useGetWorkspaceCapabilities<
  TData = Awaited<ReturnType<typeof getWorkspaceCapabilities>>,
  TError = unknown,
>(
  workspaceId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getWorkspaceCapabilities>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetWorkspaceCapabilitiesQueryOptions(
    workspaceId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & {queryKey: DataTag<QueryKey, TData, TError>};

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Updates the API key for specific 3rd party provider
 */
export const setApiKeyForProvider = (
  workspaceId: string,
  nameValue: NameValue,
) => {
  return axiosInstance<void>({
    url: `/workspaces/${workspaceId}/authroizations`,
    method: "PUT",
    headers: {"Content-Type": "application/json"},
    data: nameValue,
  });
};

export const getSetApiKeyForProviderMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setApiKeyForProvider>>,
    TError,
    {workspaceId: string; data: NameValue},
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof setApiKeyForProvider>>,
  TError,
  {workspaceId: string; data: NameValue},
  TContext
> => {
  const mutationKey = ["setApiKeyForProvider"];
  const {mutation: mutationOptions} = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : {...options, mutation: {...options.mutation, mutationKey}}
    : {mutation: {mutationKey}};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof setApiKeyForProvider>>,
    {workspaceId: string; data: NameValue}
  > = props => {
    const {workspaceId, data} = props ?? {};

    return setApiKeyForProvider(workspaceId, data);
  };

  return {mutationFn, ...mutationOptions};
};

export type SetApiKeyForProviderMutationResult = NonNullable<
  Awaited<ReturnType<typeof setApiKeyForProvider>>
>;
export type SetApiKeyForProviderMutationBody = NameValue;
export type SetApiKeyForProviderMutationError = unknown;

export const useSetApiKeyForProvider = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof setApiKeyForProvider>>,
      TError,
      {workspaceId: string; data: NameValue},
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof setApiKeyForProvider>>,
  TError,
  {workspaceId: string; data: NameValue},
  TContext
> => {
  const mutationOptions = getSetApiKeyForProviderMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Checks if the specified provider has some API keys registered
 */
export const checkProviderApiKey = (
  workspaceId: string,
  providerName: string,
  signal?: AbortSignal,
) => {
  return axiosInstance<void>({
    url: `/workspaces/${workspaceId}/authroizations/${providerName}`,
    method: "GET",
    signal,
  });
};

export const getCheckProviderApiKeyQueryKey = (
  workspaceId: string,
  providerName: string,
) => {
  return [`/workspaces/${workspaceId}/authroizations/${providerName}`] as const;
};

export const getCheckProviderApiKeyQueryOptions = <
  TData = Awaited<ReturnType<typeof checkProviderApiKey>>,
  TError = void,
>(
  workspaceId: string,
  providerName: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof checkProviderApiKey>>,
        TError,
        TData
      >
    >;
  },
) => {
  const {query: queryOptions} = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getCheckProviderApiKeyQueryKey(workspaceId, providerName);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof checkProviderApiKey>>
  > = ({signal}) => checkProviderApiKey(workspaceId, providerName, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(workspaceId && providerName),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof checkProviderApiKey>>,
    TError,
    TData
  > & {queryKey: DataTag<QueryKey, TData, TError>};
};

export type CheckProviderApiKeyQueryResult = NonNullable<
  Awaited<ReturnType<typeof checkProviderApiKey>>
>;
export type CheckProviderApiKeyQueryError = void;

export function useCheckProviderApiKey<
  TData = Awaited<ReturnType<typeof checkProviderApiKey>>,
  TError = void,
>(
  workspaceId: string,
  providerName: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof checkProviderApiKey>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof checkProviderApiKey>>,
          TError,
          Awaited<ReturnType<typeof checkProviderApiKey>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useCheckProviderApiKey<
  TData = Awaited<ReturnType<typeof checkProviderApiKey>>,
  TError = void,
>(
  workspaceId: string,
  providerName: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof checkProviderApiKey>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof checkProviderApiKey>>,
          TError,
          Awaited<ReturnType<typeof checkProviderApiKey>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};
export function useCheckProviderApiKey<
  TData = Awaited<ReturnType<typeof checkProviderApiKey>>,
  TError = void,
>(
  workspaceId: string,
  providerName: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof checkProviderApiKey>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};

export function useCheckProviderApiKey<
  TData = Awaited<ReturnType<typeof checkProviderApiKey>>,
  TError = void,
>(
  workspaceId: string,
  providerName: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof checkProviderApiKey>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getCheckProviderApiKeyQueryOptions(
    workspaceId,
    providerName,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & {queryKey: DataTag<QueryKey, TData, TError>};

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Deletes provider authentication info from workspace
 */
export const deleteProviderApiKey = (
  workspaceId: string,
  providerName: string,
) => {
  return axiosInstance<void>({
    url: `/workspaces/${workspaceId}/authroizations/${providerName}`,
    method: "DELETE",
  });
};

export const getDeleteProviderApiKeyMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteProviderApiKey>>,
    TError,
    {workspaceId: string; providerName: string},
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteProviderApiKey>>,
  TError,
  {workspaceId: string; providerName: string},
  TContext
> => {
  const mutationKey = ["deleteProviderApiKey"];
  const {mutation: mutationOptions} = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : {...options, mutation: {...options.mutation, mutationKey}}
    : {mutation: {mutationKey}};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteProviderApiKey>>,
    {workspaceId: string; providerName: string}
  > = props => {
    const {workspaceId, providerName} = props ?? {};

    return deleteProviderApiKey(workspaceId, providerName);
  };

  return {mutationFn, ...mutationOptions};
};

export type DeleteProviderApiKeyMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteProviderApiKey>>
>;

export type DeleteProviderApiKeyMutationError = void;

export const useDeleteProviderApiKey = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteProviderApiKey>>,
      TError,
      {workspaceId: string; providerName: string},
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteProviderApiKey>>,
  TError,
  {workspaceId: string; providerName: string},
  TContext
> => {
  const mutationOptions = getDeleteProviderApiKeyMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Get list of providers used in workspace
 */
export const getWorkspaceProviders = (
  workspaceId: string,
  params?: GetWorkspaceProvidersParams,
  signal?: AbortSignal,
) => {
  return axiosInstance<GetWorkspaceProviders200>({
    url: `/workspaces/${workspaceId}/providers`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetWorkspaceProvidersQueryKey = (
  workspaceId: string,
  params?: GetWorkspaceProvidersParams,
) => {
  return [
    `/workspaces/${workspaceId}/providers`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetWorkspaceProvidersQueryOptions = <
  TData = Awaited<ReturnType<typeof getWorkspaceProviders>>,
  TError = unknown,
>(
  workspaceId: string,
  params?: GetWorkspaceProvidersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getWorkspaceProviders>>,
        TError,
        TData
      >
    >;
  },
) => {
  const {query: queryOptions} = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetWorkspaceProvidersQueryKey(workspaceId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getWorkspaceProviders>>
  > = ({signal}) => getWorkspaceProviders(workspaceId, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!workspaceId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getWorkspaceProviders>>,
    TError,
    TData
  > & {queryKey: DataTag<QueryKey, TData, TError>};
};

export type GetWorkspaceProvidersQueryResult = NonNullable<
  Awaited<ReturnType<typeof getWorkspaceProviders>>
>;
export type GetWorkspaceProvidersQueryError = unknown;

export function useGetWorkspaceProviders<
  TData = Awaited<ReturnType<typeof getWorkspaceProviders>>,
  TError = unknown,
>(
  workspaceId: string,
  params: undefined | GetWorkspaceProvidersParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getWorkspaceProviders>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWorkspaceProviders>>,
          TError,
          Awaited<ReturnType<typeof getWorkspaceProviders>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetWorkspaceProviders<
  TData = Awaited<ReturnType<typeof getWorkspaceProviders>>,
  TError = unknown,
>(
  workspaceId: string,
  params?: GetWorkspaceProvidersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getWorkspaceProviders>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWorkspaceProviders>>,
          TError,
          Awaited<ReturnType<typeof getWorkspaceProviders>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};
export function useGetWorkspaceProviders<
  TData = Awaited<ReturnType<typeof getWorkspaceProviders>>,
  TError = unknown,
>(
  workspaceId: string,
  params?: GetWorkspaceProvidersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getWorkspaceProviders>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};

export function useGetWorkspaceProviders<
  TData = Awaited<ReturnType<typeof getWorkspaceProviders>>,
  TError = unknown,
>(
  workspaceId: string,
  params?: GetWorkspaceProvidersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getWorkspaceProviders>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetWorkspaceProvidersQueryOptions(
    workspaceId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & {queryKey: DataTag<QueryKey, TData, TError>};

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Generate OAuth frontend token for workspace
 */
export const generateOauthFrontendToken = (
  workspaceId: string,
  signal?: AbortSignal,
) => {
  return axiosInstance<OAuthTokenResponse>({
    url: `/workspaces/${workspaceId}/oauth`,
    method: "POST",
    signal,
  });
};

export const getGenerateOauthFrontendTokenMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateOauthFrontendToken>>,
    TError,
    {workspaceId: string},
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof generateOauthFrontendToken>>,
  TError,
  {workspaceId: string},
  TContext
> => {
  const mutationKey = ["generateOauthFrontendToken"];
  const {mutation: mutationOptions} = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : {...options, mutation: {...options.mutation, mutationKey}}
    : {mutation: {mutationKey}};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof generateOauthFrontendToken>>,
    {workspaceId: string}
  > = props => {
    const {workspaceId} = props ?? {};

    return generateOauthFrontendToken(workspaceId);
  };

  return {mutationFn, ...mutationOptions};
};

export type GenerateOauthFrontendTokenMutationResult = NonNullable<
  Awaited<ReturnType<typeof generateOauthFrontendToken>>
>;

export type GenerateOauthFrontendTokenMutationError = unknown;

export const useGenerateOauthFrontendToken = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof generateOauthFrontendToken>>,
      TError,
      {workspaceId: string},
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof generateOauthFrontendToken>>,
  TError,
  {workspaceId: string},
  TContext
> => {
  const mutationOptions = getGenerateOauthFrontendTokenMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Submits user feedback about some call
 */
export const submitCallFeedback = (
  callId: string,
  callFeedback: CallFeedback,
  signal?: AbortSignal,
) => {
  return axiosInstance<void>({
    url: `/calls/${callId}/feedback`,
    method: "POST",
    headers: {"Content-Type": "application/json"},
    data: callFeedback,
    signal,
  });
};

export const getSubmitCallFeedbackMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof submitCallFeedback>>,
    TError,
    {callId: string; data: CallFeedback},
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof submitCallFeedback>>,
  TError,
  {callId: string; data: CallFeedback},
  TContext
> => {
  const mutationKey = ["submitCallFeedback"];
  const {mutation: mutationOptions} = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : {...options, mutation: {...options.mutation, mutationKey}}
    : {mutation: {mutationKey}};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof submitCallFeedback>>,
    {callId: string; data: CallFeedback}
  > = props => {
    const {callId, data} = props ?? {};

    return submitCallFeedback(callId, data);
  };

  return {mutationFn, ...mutationOptions};
};

export type SubmitCallFeedbackMutationResult = NonNullable<
  Awaited<ReturnType<typeof submitCallFeedback>>
>;
export type SubmitCallFeedbackMutationBody = CallFeedback;
export type SubmitCallFeedbackMutationError = unknown;

export const useSubmitCallFeedback = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof submitCallFeedback>>,
      TError,
      {callId: string; data: CallFeedback},
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof submitCallFeedback>>,
  TError,
  {callId: string; data: CallFeedback},
  TContext
> => {
  const mutationOptions = getSubmitCallFeedbackMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Gets statistics for an assistant!
 */
export const getCallStat = (
  assistantId: string,
  params?: GetCallStatParams,
  signal?: AbortSignal,
) => {
  return axiosInstance<Statistics[] | void>({
    url: `/agents/${assistantId}/stat`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetCallStatQueryKey = (
  assistantId: string,
  params?: GetCallStatParams,
) => {
  return [`/agents/${assistantId}/stat`, ...(params ? [params] : [])] as const;
};

export const getGetCallStatQueryOptions = <
  TData = Awaited<ReturnType<typeof getCallStat>>,
  TError = void,
>(
  assistantId: string,
  params?: GetCallStatParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCallStat>>, TError, TData>
    >;
  },
) => {
  const {query: queryOptions} = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetCallStatQueryKey(assistantId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCallStat>>> = ({
    signal,
  }) => getCallStat(assistantId, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!assistantId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getCallStat>>,
    TError,
    TData
  > & {queryKey: DataTag<QueryKey, TData, TError>};
};

export type GetCallStatQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCallStat>>
>;
export type GetCallStatQueryError = void;

export function useGetCallStat<
  TData = Awaited<ReturnType<typeof getCallStat>>,
  TError = void,
>(
  assistantId: string,
  params: undefined | GetCallStatParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCallStat>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCallStat>>,
          TError,
          Awaited<ReturnType<typeof getCallStat>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetCallStat<
  TData = Awaited<ReturnType<typeof getCallStat>>,
  TError = void,
>(
  assistantId: string,
  params?: GetCallStatParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCallStat>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCallStat>>,
          TError,
          Awaited<ReturnType<typeof getCallStat>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};
export function useGetCallStat<
  TData = Awaited<ReturnType<typeof getCallStat>>,
  TError = void,
>(
  assistantId: string,
  params?: GetCallStatParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCallStat>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};

export function useGetCallStat<
  TData = Awaited<ReturnType<typeof getCallStat>>,
  TError = void,
>(
  assistantId: string,
  params?: GetCallStatParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCallStat>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetCallStatQueryOptions(assistantId, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & {queryKey: DataTag<QueryKey, TData, TError>};

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Gets statistics for an assistant!
 */
export const getAssistantCallStat = (
  assistantId: string,
  signal?: AbortSignal,
) => {
  return axiosInstance<Statistics[] | void>({
    url: `/assistants/${assistantId}/stat`,
    method: "GET",
    signal,
  });
};

export const getGetAssistantCallStatQueryKey = (assistantId: string) => {
  return [`/assistants/${assistantId}/stat`] as const;
};

export const getGetAssistantCallStatQueryOptions = <
  TData = Awaited<ReturnType<typeof getAssistantCallStat>>,
  TError = void,
>(
  assistantId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssistantCallStat>>,
        TError,
        TData
      >
    >;
  },
) => {
  const {query: queryOptions} = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAssistantCallStatQueryKey(assistantId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAssistantCallStat>>
  > = ({signal}) => getAssistantCallStat(assistantId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!assistantId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getAssistantCallStat>>,
    TError,
    TData
  > & {queryKey: DataTag<QueryKey, TData, TError>};
};

export type GetAssistantCallStatQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAssistantCallStat>>
>;
export type GetAssistantCallStatQueryError = void;

export function useGetAssistantCallStat<
  TData = Awaited<ReturnType<typeof getAssistantCallStat>>,
  TError = void,
>(
  assistantId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssistantCallStat>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAssistantCallStat>>,
          TError,
          Awaited<ReturnType<typeof getAssistantCallStat>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAssistantCallStat<
  TData = Awaited<ReturnType<typeof getAssistantCallStat>>,
  TError = void,
>(
  assistantId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssistantCallStat>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAssistantCallStat>>,
          TError,
          Awaited<ReturnType<typeof getAssistantCallStat>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};
export function useGetAssistantCallStat<
  TData = Awaited<ReturnType<typeof getAssistantCallStat>>,
  TError = void,
>(
  assistantId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssistantCallStat>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};

export function useGetAssistantCallStat<
  TData = Awaited<ReturnType<typeof getAssistantCallStat>>,
  TError = void,
>(
  assistantId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssistantCallStat>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetAssistantCallStatQueryOptions(
    assistantId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & {queryKey: DataTag<QueryKey, TData, TError>};

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get analytics dashboard
 */
export const getAnalytics = (
  params: GetAnalyticsParams,
  signal?: AbortSignal,
) => {
  return axiosInstance<AnalyticsDashboard>({
    url: `/analytics`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetAnalyticsQueryKey = (params: GetAnalyticsParams) => {
  return [`/analytics`, ...(params ? [params] : [])] as const;
};

export const getGetAnalyticsQueryOptions = <
  TData = Awaited<ReturnType<typeof getAnalytics>>,
  TError = unknown,
>(
  params: GetAnalyticsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAnalytics>>, TError, TData>
    >;
  },
) => {
  const {query: queryOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAnalyticsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAnalytics>>> = ({
    signal,
  }) => getAnalytics(params, signal);

  return {queryKey, queryFn, ...queryOptions} as UseQueryOptions<
    Awaited<ReturnType<typeof getAnalytics>>,
    TError,
    TData
  > & {queryKey: DataTag<QueryKey, TData, TError>};
};

export type GetAnalyticsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAnalytics>>
>;
export type GetAnalyticsQueryError = unknown;

export function useGetAnalytics<
  TData = Awaited<ReturnType<typeof getAnalytics>>,
  TError = unknown,
>(
  params: GetAnalyticsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAnalytics>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAnalytics>>,
          TError,
          Awaited<ReturnType<typeof getAnalytics>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAnalytics<
  TData = Awaited<ReturnType<typeof getAnalytics>>,
  TError = unknown,
>(
  params: GetAnalyticsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAnalytics>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAnalytics>>,
          TError,
          Awaited<ReturnType<typeof getAnalytics>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};
export function useGetAnalytics<
  TData = Awaited<ReturnType<typeof getAnalytics>>,
  TError = unknown,
>(
  params: GetAnalyticsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAnalytics>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};
/**
 * @summary Get analytics dashboard
 */

export function useGetAnalytics<
  TData = Awaited<ReturnType<typeof getAnalytics>>,
  TError = unknown,
>(
  params: GetAnalyticsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAnalytics>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetAnalyticsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & {queryKey: DataTag<QueryKey, TData, TError>};

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get analytics dashboard via /api prefix
 */
export const getAnalyticsApi = (
  params: GetAnalyticsApiParams,
  signal?: AbortSignal,
) => {
  return axiosInstance<AnalyticsDashboard>({
    url: `/api/analytics`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetAnalyticsApiQueryKey = (params: GetAnalyticsApiParams) => {
  return [`/api/analytics`, ...(params ? [params] : [])] as const;
};

export const getGetAnalyticsApiQueryOptions = <
  TData = Awaited<ReturnType<typeof getAnalyticsApi>>,
  TError = unknown,
>(
  params: GetAnalyticsApiParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAnalyticsApi>>,
        TError,
        TData
      >
    >;
  },
) => {
  const {query: queryOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAnalyticsApiQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAnalyticsApi>>> = ({
    signal,
  }) => getAnalyticsApi(params, signal);

  return {queryKey, queryFn, ...queryOptions} as UseQueryOptions<
    Awaited<ReturnType<typeof getAnalyticsApi>>,
    TError,
    TData
  > & {queryKey: DataTag<QueryKey, TData, TError>};
};

export type GetAnalyticsApiQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAnalyticsApi>>
>;
export type GetAnalyticsApiQueryError = unknown;

export function useGetAnalyticsApi<
  TData = Awaited<ReturnType<typeof getAnalyticsApi>>,
  TError = unknown,
>(
  params: GetAnalyticsApiParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAnalyticsApi>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAnalyticsApi>>,
          TError,
          Awaited<ReturnType<typeof getAnalyticsApi>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAnalyticsApi<
  TData = Awaited<ReturnType<typeof getAnalyticsApi>>,
  TError = unknown,
>(
  params: GetAnalyticsApiParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAnalyticsApi>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAnalyticsApi>>,
          TError,
          Awaited<ReturnType<typeof getAnalyticsApi>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};
export function useGetAnalyticsApi<
  TData = Awaited<ReturnType<typeof getAnalyticsApi>>,
  TError = unknown,
>(
  params: GetAnalyticsApiParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAnalyticsApi>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};
/**
 * @summary Get analytics dashboard via /api prefix
 */

export function useGetAnalyticsApi<
  TData = Awaited<ReturnType<typeof getAnalyticsApi>>,
  TError = unknown,
>(
  params: GetAnalyticsApiParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAnalyticsApi>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetAnalyticsApiQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & {queryKey: DataTag<QueryKey, TData, TError>};

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Gets the avatar image for an assistant
 */
export const getMyAgentAvatar = (assistantId: string, signal?: AbortSignal) => {
  return axiosInstance<unknown>({
    url: `/agents/${assistantId}/avatar`,
    method: "GET",
    signal,
  });
};

export const getGetMyAgentAvatarQueryKey = (assistantId: string) => {
  return [`/agents/${assistantId}/avatar`] as const;
};

export const getGetMyAgentAvatarQueryOptions = <
  TData = Awaited<ReturnType<typeof getMyAgentAvatar>>,
  TError = unknown,
>(
  assistantId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMyAgentAvatar>>,
        TError,
        TData
      >
    >;
  },
) => {
  const {query: queryOptions} = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMyAgentAvatarQueryKey(assistantId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMyAgentAvatar>>
  > = ({signal}) => getMyAgentAvatar(assistantId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!assistantId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getMyAgentAvatar>>,
    TError,
    TData
  > & {queryKey: DataTag<QueryKey, TData, TError>};
};

export type GetMyAgentAvatarQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMyAgentAvatar>>
>;
export type GetMyAgentAvatarQueryError = unknown;

export function useGetMyAgentAvatar<
  TData = Awaited<ReturnType<typeof getMyAgentAvatar>>,
  TError = unknown,
>(
  assistantId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMyAgentAvatar>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyAgentAvatar>>,
          TError,
          Awaited<ReturnType<typeof getMyAgentAvatar>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetMyAgentAvatar<
  TData = Awaited<ReturnType<typeof getMyAgentAvatar>>,
  TError = unknown,
>(
  assistantId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMyAgentAvatar>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyAgentAvatar>>,
          TError,
          Awaited<ReturnType<typeof getMyAgentAvatar>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};
export function useGetMyAgentAvatar<
  TData = Awaited<ReturnType<typeof getMyAgentAvatar>>,
  TError = unknown,
>(
  assistantId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMyAgentAvatar>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};

export function useGetMyAgentAvatar<
  TData = Awaited<ReturnType<typeof getMyAgentAvatar>>,
  TError = unknown,
>(
  assistantId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMyAgentAvatar>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetMyAgentAvatarQueryOptions(assistantId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & {queryKey: DataTag<QueryKey, TData, TError>};

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Changes the avatar image of an assistant
 */
export const updateMyAgentAvatar = (
  assistantId: string,
  updateMyAgentAvatarBody: UpdateMyAgentAvatarBody,
) => {
  const formData = new FormData();
  if (updateMyAgentAvatarBody.file !== undefined) {
    formData.append("file", updateMyAgentAvatarBody.file);
  }

  return axiosInstance<void>({
    url: `/agents/${assistantId}/avatar`,
    method: "PUT",
    headers: {"Content-Type": "multipart/form-data"},
    data: formData,
  });
};

export const getUpdateMyAgentAvatarMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateMyAgentAvatar>>,
    TError,
    {assistantId: string; data: UpdateMyAgentAvatarBody},
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateMyAgentAvatar>>,
  TError,
  {assistantId: string; data: UpdateMyAgentAvatarBody},
  TContext
> => {
  const mutationKey = ["updateMyAgentAvatar"];
  const {mutation: mutationOptions} = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : {...options, mutation: {...options.mutation, mutationKey}}
    : {mutation: {mutationKey}};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateMyAgentAvatar>>,
    {assistantId: string; data: UpdateMyAgentAvatarBody}
  > = props => {
    const {assistantId, data} = props ?? {};

    return updateMyAgentAvatar(assistantId, data);
  };

  return {mutationFn, ...mutationOptions};
};

export type UpdateMyAgentAvatarMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateMyAgentAvatar>>
>;
export type UpdateMyAgentAvatarMutationBody = UpdateMyAgentAvatarBody;
export type UpdateMyAgentAvatarMutationError = void;

export const useUpdateMyAgentAvatar = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateMyAgentAvatar>>,
      TError,
      {assistantId: string; data: UpdateMyAgentAvatarBody},
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateMyAgentAvatar>>,
  TError,
  {assistantId: string; data: UpdateMyAgentAvatarBody},
  TContext
> => {
  const mutationOptions = getUpdateMyAgentAvatarMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Removes avatar image of an assistant
 */
export const deleteMyAgentAvatar = (assistantId: string) => {
  return axiosInstance<void>({
    url: `/agents/${assistantId}/avatar`,
    method: "DELETE",
  });
};

export const getDeleteMyAgentAvatarMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteMyAgentAvatar>>,
    TError,
    {assistantId: string},
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteMyAgentAvatar>>,
  TError,
  {assistantId: string},
  TContext
> => {
  const mutationKey = ["deleteMyAgentAvatar"];
  const {mutation: mutationOptions} = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : {...options, mutation: {...options.mutation, mutationKey}}
    : {mutation: {mutationKey}};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteMyAgentAvatar>>,
    {assistantId: string}
  > = props => {
    const {assistantId} = props ?? {};

    return deleteMyAgentAvatar(assistantId);
  };

  return {mutationFn, ...mutationOptions};
};

export type DeleteMyAgentAvatarMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteMyAgentAvatar>>
>;

export type DeleteMyAgentAvatarMutationError = void;

export const useDeleteMyAgentAvatar = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteMyAgentAvatar>>,
      TError,
      {assistantId: string},
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteMyAgentAvatar>>,
  TError,
  {assistantId: string},
  TContext
> => {
  const mutationOptions = getDeleteMyAgentAvatarMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Gets the avatar image for an assistant
 */
export const getMyAssistantAvatar = (
  assistantId: string,
  signal?: AbortSignal,
) => {
  return axiosInstance<unknown>({
    url: `/assistants/${assistantId}/avatar`,
    method: "GET",
    signal,
  });
};

export const getGetMyAssistantAvatarQueryKey = (assistantId: string) => {
  return [`/assistants/${assistantId}/avatar`] as const;
};

export const getGetMyAssistantAvatarQueryOptions = <
  TData = Awaited<ReturnType<typeof getMyAssistantAvatar>>,
  TError = unknown,
>(
  assistantId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMyAssistantAvatar>>,
        TError,
        TData
      >
    >;
  },
) => {
  const {query: queryOptions} = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMyAssistantAvatarQueryKey(assistantId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMyAssistantAvatar>>
  > = ({signal}) => getMyAssistantAvatar(assistantId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!assistantId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getMyAssistantAvatar>>,
    TError,
    TData
  > & {queryKey: DataTag<QueryKey, TData, TError>};
};

export type GetMyAssistantAvatarQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMyAssistantAvatar>>
>;
export type GetMyAssistantAvatarQueryError = unknown;

export function useGetMyAssistantAvatar<
  TData = Awaited<ReturnType<typeof getMyAssistantAvatar>>,
  TError = unknown,
>(
  assistantId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMyAssistantAvatar>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyAssistantAvatar>>,
          TError,
          Awaited<ReturnType<typeof getMyAssistantAvatar>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetMyAssistantAvatar<
  TData = Awaited<ReturnType<typeof getMyAssistantAvatar>>,
  TError = unknown,
>(
  assistantId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMyAssistantAvatar>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyAssistantAvatar>>,
          TError,
          Awaited<ReturnType<typeof getMyAssistantAvatar>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};
export function useGetMyAssistantAvatar<
  TData = Awaited<ReturnType<typeof getMyAssistantAvatar>>,
  TError = unknown,
>(
  assistantId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMyAssistantAvatar>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};

export function useGetMyAssistantAvatar<
  TData = Awaited<ReturnType<typeof getMyAssistantAvatar>>,
  TError = unknown,
>(
  assistantId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMyAssistantAvatar>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetMyAssistantAvatarQueryOptions(
    assistantId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & {queryKey: DataTag<QueryKey, TData, TError>};

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Changes the avatar image of an assistant
 */
export const updateMyAssistantAvatar = (
  assistantId: string,
  updateMyAssistantAvatarBody: UpdateMyAssistantAvatarBody,
) => {
  const formData = new FormData();
  if (updateMyAssistantAvatarBody.file !== undefined) {
    formData.append("file", updateMyAssistantAvatarBody.file);
  }

  return axiosInstance<void>({
    url: `/assistants/${assistantId}/avatar`,
    method: "PUT",
    headers: {"Content-Type": "multipart/form-data"},
    data: formData,
  });
};

export const getUpdateMyAssistantAvatarMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateMyAssistantAvatar>>,
    TError,
    {assistantId: string; data: UpdateMyAssistantAvatarBody},
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateMyAssistantAvatar>>,
  TError,
  {assistantId: string; data: UpdateMyAssistantAvatarBody},
  TContext
> => {
  const mutationKey = ["updateMyAssistantAvatar"];
  const {mutation: mutationOptions} = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : {...options, mutation: {...options.mutation, mutationKey}}
    : {mutation: {mutationKey}};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateMyAssistantAvatar>>,
    {assistantId: string; data: UpdateMyAssistantAvatarBody}
  > = props => {
    const {assistantId, data} = props ?? {};

    return updateMyAssistantAvatar(assistantId, data);
  };

  return {mutationFn, ...mutationOptions};
};

export type UpdateMyAssistantAvatarMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateMyAssistantAvatar>>
>;
export type UpdateMyAssistantAvatarMutationBody = UpdateMyAssistantAvatarBody;
export type UpdateMyAssistantAvatarMutationError = void;

export const useUpdateMyAssistantAvatar = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateMyAssistantAvatar>>,
      TError,
      {assistantId: string; data: UpdateMyAssistantAvatarBody},
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateMyAssistantAvatar>>,
  TError,
  {assistantId: string; data: UpdateMyAssistantAvatarBody},
  TContext
> => {
  const mutationOptions = getUpdateMyAssistantAvatarMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Removes avatar image of an assistant
 */
export const deleteMyAssistantAvatar = (assistantId: string) => {
  return axiosInstance<void>({
    url: `/assistants/${assistantId}/avatar`,
    method: "DELETE",
  });
};

export const getDeleteMyAssistantAvatarMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteMyAssistantAvatar>>,
    TError,
    {assistantId: string},
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteMyAssistantAvatar>>,
  TError,
  {assistantId: string},
  TContext
> => {
  const mutationKey = ["deleteMyAssistantAvatar"];
  const {mutation: mutationOptions} = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : {...options, mutation: {...options.mutation, mutationKey}}
    : {mutation: {mutationKey}};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteMyAssistantAvatar>>,
    {assistantId: string}
  > = props => {
    const {assistantId} = props ?? {};

    return deleteMyAssistantAvatar(assistantId);
  };

  return {mutationFn, ...mutationOptions};
};

export type DeleteMyAssistantAvatarMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteMyAssistantAvatar>>
>;

export type DeleteMyAssistantAvatarMutationError = void;

export const useDeleteMyAssistantAvatar = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteMyAssistantAvatar>>,
      TError,
      {assistantId: string},
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteMyAssistantAvatar>>,
  TError,
  {assistantId: string},
  TContext
> => {
  const mutationOptions = getDeleteMyAssistantAvatarMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Gets the list of all knowledge bases
 */
export const getKnowledgeBaseList = (
  params: GetKnowledgeBaseListParams,
  signal?: AbortSignal,
) => {
  return axiosInstance<GetKnowledgeBaseList200>({
    url: `/knowledge_bases`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetKnowledgeBaseListQueryKey = (
  params: GetKnowledgeBaseListParams,
) => {
  return [`/knowledge_bases`, ...(params ? [params] : [])] as const;
};

export const getGetKnowledgeBaseListQueryOptions = <
  TData = Awaited<ReturnType<typeof getKnowledgeBaseList>>,
  TError = unknown,
>(
  params: GetKnowledgeBaseListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getKnowledgeBaseList>>,
        TError,
        TData
      >
    >;
  },
) => {
  const {query: queryOptions} = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetKnowledgeBaseListQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getKnowledgeBaseList>>
  > = ({signal}) => getKnowledgeBaseList(params, signal);

  return {queryKey, queryFn, ...queryOptions} as UseQueryOptions<
    Awaited<ReturnType<typeof getKnowledgeBaseList>>,
    TError,
    TData
  > & {queryKey: DataTag<QueryKey, TData, TError>};
};

export type GetKnowledgeBaseListQueryResult = NonNullable<
  Awaited<ReturnType<typeof getKnowledgeBaseList>>
>;
export type GetKnowledgeBaseListQueryError = unknown;

export function useGetKnowledgeBaseList<
  TData = Awaited<ReturnType<typeof getKnowledgeBaseList>>,
  TError = unknown,
>(
  params: GetKnowledgeBaseListParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getKnowledgeBaseList>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getKnowledgeBaseList>>,
          TError,
          Awaited<ReturnType<typeof getKnowledgeBaseList>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetKnowledgeBaseList<
  TData = Awaited<ReturnType<typeof getKnowledgeBaseList>>,
  TError = unknown,
>(
  params: GetKnowledgeBaseListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getKnowledgeBaseList>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getKnowledgeBaseList>>,
          TError,
          Awaited<ReturnType<typeof getKnowledgeBaseList>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};
export function useGetKnowledgeBaseList<
  TData = Awaited<ReturnType<typeof getKnowledgeBaseList>>,
  TError = unknown,
>(
  params: GetKnowledgeBaseListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getKnowledgeBaseList>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};

export function useGetKnowledgeBaseList<
  TData = Awaited<ReturnType<typeof getKnowledgeBaseList>>,
  TError = unknown,
>(
  params: GetKnowledgeBaseListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getKnowledgeBaseList>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetKnowledgeBaseListQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & {queryKey: DataTag<QueryKey, TData, TError>};

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Creates a new knowledge base
 */
export const createKnowledgeBase = (
  knowledgeBase: NonReadonly<KnowledgeBase>,
  signal?: AbortSignal,
) => {
  return axiosInstance<CreateResult>({
    url: `/knowledge_bases`,
    method: "POST",
    headers: {"Content-Type": "application/json"},
    data: knowledgeBase,
    signal,
  });
};

export const getCreateKnowledgeBaseMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createKnowledgeBase>>,
    TError,
    {data: NonReadonly<KnowledgeBase>},
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createKnowledgeBase>>,
  TError,
  {data: NonReadonly<KnowledgeBase>},
  TContext
> => {
  const mutationKey = ["createKnowledgeBase"];
  const {mutation: mutationOptions} = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : {...options, mutation: {...options.mutation, mutationKey}}
    : {mutation: {mutationKey}};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createKnowledgeBase>>,
    {data: NonReadonly<KnowledgeBase>}
  > = props => {
    const {data} = props ?? {};

    return createKnowledgeBase(data);
  };

  return {mutationFn, ...mutationOptions};
};

export type CreateKnowledgeBaseMutationResult = NonNullable<
  Awaited<ReturnType<typeof createKnowledgeBase>>
>;
export type CreateKnowledgeBaseMutationBody = NonReadonly<KnowledgeBase>;
export type CreateKnowledgeBaseMutationError = void;

export const useCreateKnowledgeBase = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createKnowledgeBase>>,
      TError,
      {data: NonReadonly<KnowledgeBase>},
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createKnowledgeBase>>,
  TError,
  {data: NonReadonly<KnowledgeBase>},
  TContext
> => {
  const mutationOptions = getCreateKnowledgeBaseMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Renames a knowledge base
 */
export const renameKnowledgeBase = (
  slug: string,
  renameKnowledgeBaseBody: RenameKnowledgeBaseBody,
) => {
  return axiosInstance<void>({
    url: `/knowledge_bases/${slug}`,
    method: "PATCH",
    headers: {"Content-Type": "application/json"},
    data: renameKnowledgeBaseBody,
  });
};

export const getRenameKnowledgeBaseMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof renameKnowledgeBase>>,
    TError,
    {slug: string; data: RenameKnowledgeBaseBody},
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof renameKnowledgeBase>>,
  TError,
  {slug: string; data: RenameKnowledgeBaseBody},
  TContext
> => {
  const mutationKey = ["renameKnowledgeBase"];
  const {mutation: mutationOptions} = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : {...options, mutation: {...options.mutation, mutationKey}}
    : {mutation: {mutationKey}};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof renameKnowledgeBase>>,
    {slug: string; data: RenameKnowledgeBaseBody}
  > = props => {
    const {slug, data} = props ?? {};

    return renameKnowledgeBase(slug, data);
  };

  return {mutationFn, ...mutationOptions};
};

export type RenameKnowledgeBaseMutationResult = NonNullable<
  Awaited<ReturnType<typeof renameKnowledgeBase>>
>;
export type RenameKnowledgeBaseMutationBody = RenameKnowledgeBaseBody;
export type RenameKnowledgeBaseMutationError = void;

export const useRenameKnowledgeBase = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof renameKnowledgeBase>>,
      TError,
      {slug: string; data: RenameKnowledgeBaseBody},
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof renameKnowledgeBase>>,
  TError,
  {slug: string; data: RenameKnowledgeBaseBody},
  TContext
> => {
  const mutationOptions = getRenameKnowledgeBaseMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Reads a knowledge base item
 */
export const fetchKnowledgeBaseItems = (slug: string, signal?: AbortSignal) => {
  return axiosInstance<FetchKnowledgeBaseItems200>({
    url: `/knowledge_bases/${slug}`,
    method: "GET",
    signal,
  });
};

export const getFetchKnowledgeBaseItemsQueryKey = (slug: string) => {
  return [`/knowledge_bases/${slug}`] as const;
};

export const getFetchKnowledgeBaseItemsQueryOptions = <
  TData = Awaited<ReturnType<typeof fetchKnowledgeBaseItems>>,
  TError = unknown,
>(
  slug: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof fetchKnowledgeBaseItems>>,
        TError,
        TData
      >
    >;
  },
) => {
  const {query: queryOptions} = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getFetchKnowledgeBaseItemsQueryKey(slug);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof fetchKnowledgeBaseItems>>
  > = ({signal}) => fetchKnowledgeBaseItems(slug, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!slug,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof fetchKnowledgeBaseItems>>,
    TError,
    TData
  > & {queryKey: DataTag<QueryKey, TData, TError>};
};

export type FetchKnowledgeBaseItemsQueryResult = NonNullable<
  Awaited<ReturnType<typeof fetchKnowledgeBaseItems>>
>;
export type FetchKnowledgeBaseItemsQueryError = unknown;

export function useFetchKnowledgeBaseItems<
  TData = Awaited<ReturnType<typeof fetchKnowledgeBaseItems>>,
  TError = unknown,
>(
  slug: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof fetchKnowledgeBaseItems>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof fetchKnowledgeBaseItems>>,
          TError,
          Awaited<ReturnType<typeof fetchKnowledgeBaseItems>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useFetchKnowledgeBaseItems<
  TData = Awaited<ReturnType<typeof fetchKnowledgeBaseItems>>,
  TError = unknown,
>(
  slug: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof fetchKnowledgeBaseItems>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof fetchKnowledgeBaseItems>>,
          TError,
          Awaited<ReturnType<typeof fetchKnowledgeBaseItems>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};
export function useFetchKnowledgeBaseItems<
  TData = Awaited<ReturnType<typeof fetchKnowledgeBaseItems>>,
  TError = unknown,
>(
  slug: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof fetchKnowledgeBaseItems>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};

export function useFetchKnowledgeBaseItems<
  TData = Awaited<ReturnType<typeof fetchKnowledgeBaseItems>>,
  TError = unknown,
>(
  slug: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof fetchKnowledgeBaseItems>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getFetchKnowledgeBaseItemsQueryOptions(slug, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & {queryKey: DataTag<QueryKey, TData, TError>};

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Adds an item to a knowledge base
 */
export const addKnowledgeBaseItem = (
  slug: string,
  knowledgeBaseItem: NonReadonly<KnowledgeBaseItem>,
  signal?: AbortSignal,
) => {
  return axiosInstance<CreateResult>({
    url: `/knowledge_bases/${slug}`,
    method: "POST",
    headers: {"Content-Type": "application/json"},
    data: knowledgeBaseItem,
    signal,
  });
};

export const getAddKnowledgeBaseItemMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addKnowledgeBaseItem>>,
    TError,
    {slug: string; data: NonReadonly<KnowledgeBaseItem>},
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof addKnowledgeBaseItem>>,
  TError,
  {slug: string; data: NonReadonly<KnowledgeBaseItem>},
  TContext
> => {
  const mutationKey = ["addKnowledgeBaseItem"];
  const {mutation: mutationOptions} = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : {...options, mutation: {...options.mutation, mutationKey}}
    : {mutation: {mutationKey}};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof addKnowledgeBaseItem>>,
    {slug: string; data: NonReadonly<KnowledgeBaseItem>}
  > = props => {
    const {slug, data} = props ?? {};

    return addKnowledgeBaseItem(slug, data);
  };

  return {mutationFn, ...mutationOptions};
};

export type AddKnowledgeBaseItemMutationResult = NonNullable<
  Awaited<ReturnType<typeof addKnowledgeBaseItem>>
>;
export type AddKnowledgeBaseItemMutationBody = NonReadonly<KnowledgeBaseItem>;
export type AddKnowledgeBaseItemMutationError = void;

export const useAddKnowledgeBaseItem = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof addKnowledgeBaseItem>>,
      TError,
      {slug: string; data: NonReadonly<KnowledgeBaseItem>},
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof addKnowledgeBaseItem>>,
  TError,
  {slug: string; data: NonReadonly<KnowledgeBaseItem>},
  TContext
> => {
  const mutationOptions = getAddKnowledgeBaseItemMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Deletes an item from a knowledge base
 */
export const deleteKnowledgeBase = (slug: string) => {
  return axiosInstance<void>({
    url: `/knowledge_bases/${slug}`,
    method: "DELETE",
  });
};

export const getDeleteKnowledgeBaseMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteKnowledgeBase>>,
    TError,
    {slug: string},
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteKnowledgeBase>>,
  TError,
  {slug: string},
  TContext
> => {
  const mutationKey = ["deleteKnowledgeBase"];
  const {mutation: mutationOptions} = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : {...options, mutation: {...options.mutation, mutationKey}}
    : {mutation: {mutationKey}};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteKnowledgeBase>>,
    {slug: string}
  > = props => {
    const {slug} = props ?? {};

    return deleteKnowledgeBase(slug);
  };

  return {mutationFn, ...mutationOptions};
};

export type DeleteKnowledgeBaseMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteKnowledgeBase>>
>;

export type DeleteKnowledgeBaseMutationError = void;

export const useDeleteKnowledgeBase = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteKnowledgeBase>>,
      TError,
      {slug: string},
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteKnowledgeBase>>,
  TError,
  {slug: string},
  TContext
> => {
  const mutationOptions = getDeleteKnowledgeBaseMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const deleteBatchKnowledgeBaseItems = (
  slug: string,
  deleteBatchKnowledgeBaseItemsBody: DeleteBatchKnowledgeBaseItemsBody,
) => {
  return axiosInstance<void>({
    url: `/knowledge_bases/${slug}/items`,
    method: "DELETE",
    headers: {"Content-Type": "application/json"},
    data: deleteBatchKnowledgeBaseItemsBody,
  });
};

export const getDeleteBatchKnowledgeBaseItemsMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteBatchKnowledgeBaseItems>>,
    TError,
    {slug: string; data: DeleteBatchKnowledgeBaseItemsBody},
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteBatchKnowledgeBaseItems>>,
  TError,
  {slug: string; data: DeleteBatchKnowledgeBaseItemsBody},
  TContext
> => {
  const mutationKey = ["deleteBatchKnowledgeBaseItems"];
  const {mutation: mutationOptions} = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : {...options, mutation: {...options.mutation, mutationKey}}
    : {mutation: {mutationKey}};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteBatchKnowledgeBaseItems>>,
    {slug: string; data: DeleteBatchKnowledgeBaseItemsBody}
  > = props => {
    const {slug, data} = props ?? {};

    return deleteBatchKnowledgeBaseItems(slug, data);
  };

  return {mutationFn, ...mutationOptions};
};

export type DeleteBatchKnowledgeBaseItemsMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteBatchKnowledgeBaseItems>>
>;
export type DeleteBatchKnowledgeBaseItemsMutationBody =
  DeleteBatchKnowledgeBaseItemsBody;
export type DeleteBatchKnowledgeBaseItemsMutationError = void;

export const useDeleteBatchKnowledgeBaseItems = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteBatchKnowledgeBaseItems>>,
      TError,
      {slug: string; data: DeleteBatchKnowledgeBaseItemsBody},
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteBatchKnowledgeBaseItems>>,
  TError,
  {slug: string; data: DeleteBatchKnowledgeBaseItemsBody},
  TContext
> => {
  const mutationOptions =
    getDeleteBatchKnowledgeBaseItemsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Gets a single knowledge base item
 */
export const getKnowledgeBaseItem = (
  slug: string,
  itemSlug: string,
  signal?: AbortSignal,
) => {
  return axiosInstance<KnowledgeBaseItem>({
    url: `/knowledge_bases/${slug}/items/${itemSlug}`,
    method: "GET",
    signal,
  });
};

export const getGetKnowledgeBaseItemQueryKey = (
  slug: string,
  itemSlug: string,
) => {
  return [`/knowledge_bases/${slug}/items/${itemSlug}`] as const;
};

export const getGetKnowledgeBaseItemQueryOptions = <
  TData = Awaited<ReturnType<typeof getKnowledgeBaseItem>>,
  TError = void,
>(
  slug: string,
  itemSlug: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getKnowledgeBaseItem>>,
        TError,
        TData
      >
    >;
  },
) => {
  const {query: queryOptions} = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetKnowledgeBaseItemQueryKey(slug, itemSlug);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getKnowledgeBaseItem>>
  > = ({signal}) => getKnowledgeBaseItem(slug, itemSlug, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(slug && itemSlug),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getKnowledgeBaseItem>>,
    TError,
    TData
  > & {queryKey: DataTag<QueryKey, TData, TError>};
};

export type GetKnowledgeBaseItemQueryResult = NonNullable<
  Awaited<ReturnType<typeof getKnowledgeBaseItem>>
>;
export type GetKnowledgeBaseItemQueryError = void;

export function useGetKnowledgeBaseItem<
  TData = Awaited<ReturnType<typeof getKnowledgeBaseItem>>,
  TError = void,
>(
  slug: string,
  itemSlug: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getKnowledgeBaseItem>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getKnowledgeBaseItem>>,
          TError,
          Awaited<ReturnType<typeof getKnowledgeBaseItem>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetKnowledgeBaseItem<
  TData = Awaited<ReturnType<typeof getKnowledgeBaseItem>>,
  TError = void,
>(
  slug: string,
  itemSlug: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getKnowledgeBaseItem>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getKnowledgeBaseItem>>,
          TError,
          Awaited<ReturnType<typeof getKnowledgeBaseItem>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};
export function useGetKnowledgeBaseItem<
  TData = Awaited<ReturnType<typeof getKnowledgeBaseItem>>,
  TError = void,
>(
  slug: string,
  itemSlug: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getKnowledgeBaseItem>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};

export function useGetKnowledgeBaseItem<
  TData = Awaited<ReturnType<typeof getKnowledgeBaseItem>>,
  TError = void,
>(
  slug: string,
  itemSlug: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getKnowledgeBaseItem>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetKnowledgeBaseItemQueryOptions(
    slug,
    itemSlug,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & {queryKey: DataTag<QueryKey, TData, TError>};

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Upload a file and get the URL
 */
export const uploadKnowledgeBaseFile = (
  slug: string,
  uploadKnowledgeBaseFileBody: UploadKnowledgeBaseFileBody,
  signal?: AbortSignal,
) => {
  const formData = new FormData();
  if (uploadKnowledgeBaseFileBody.name !== undefined) {
    formData.append("name", uploadKnowledgeBaseFileBody.name);
  }
  if (uploadKnowledgeBaseFileBody.file !== undefined) {
    formData.append("file", uploadKnowledgeBaseFileBody.file);
  }

  return axiosInstance<UploadResult>({
    url: `/knowledge_bases/${slug}/file`,
    method: "POST",
    headers: {"Content-Type": "multipart/form-data"},
    data: formData,
    signal,
  });
};

export const getUploadKnowledgeBaseFileMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof uploadKnowledgeBaseFile>>,
    TError,
    {slug: string; data: UploadKnowledgeBaseFileBody},
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof uploadKnowledgeBaseFile>>,
  TError,
  {slug: string; data: UploadKnowledgeBaseFileBody},
  TContext
> => {
  const mutationKey = ["uploadKnowledgeBaseFile"];
  const {mutation: mutationOptions} = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : {...options, mutation: {...options.mutation, mutationKey}}
    : {mutation: {mutationKey}};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof uploadKnowledgeBaseFile>>,
    {slug: string; data: UploadKnowledgeBaseFileBody}
  > = props => {
    const {slug, data} = props ?? {};

    return uploadKnowledgeBaseFile(slug, data);
  };

  return {mutationFn, ...mutationOptions};
};

export type UploadKnowledgeBaseFileMutationResult = NonNullable<
  Awaited<ReturnType<typeof uploadKnowledgeBaseFile>>
>;
export type UploadKnowledgeBaseFileMutationBody = UploadKnowledgeBaseFileBody;
export type UploadKnowledgeBaseFileMutationError = unknown;

export const useUploadKnowledgeBaseFile = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof uploadKnowledgeBaseFile>>,
      TError,
      {slug: string; data: UploadKnowledgeBaseFileBody},
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof uploadKnowledgeBaseFile>>,
  TError,
  {slug: string; data: UploadKnowledgeBaseFileBody},
  TContext
> => {
  const mutationOptions = getUploadKnowledgeBaseFileMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Attaches a knowledge base to an assistant
 */
export const attachKnowledgeBaseToAssistant = (
  assistantId: string,
  slug: string,
) => {
  return axiosInstance<void>({
    url: `/assistants/${assistantId}/knowledge_bases/${slug}`,
    method: "PUT",
  });
};

export const getAttachKnowledgeBaseToAssistantMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof attachKnowledgeBaseToAssistant>>,
    TError,
    {assistantId: string; slug: string},
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof attachKnowledgeBaseToAssistant>>,
  TError,
  {assistantId: string; slug: string},
  TContext
> => {
  const mutationKey = ["attachKnowledgeBaseToAssistant"];
  const {mutation: mutationOptions} = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : {...options, mutation: {...options.mutation, mutationKey}}
    : {mutation: {mutationKey}};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof attachKnowledgeBaseToAssistant>>,
    {assistantId: string; slug: string}
  > = props => {
    const {assistantId, slug} = props ?? {};

    return attachKnowledgeBaseToAssistant(assistantId, slug);
  };

  return {mutationFn, ...mutationOptions};
};

export type AttachKnowledgeBaseToAssistantMutationResult = NonNullable<
  Awaited<ReturnType<typeof attachKnowledgeBaseToAssistant>>
>;

export type AttachKnowledgeBaseToAssistantMutationError = void;

export const useAttachKnowledgeBaseToAssistant = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof attachKnowledgeBaseToAssistant>>,
      TError,
      {assistantId: string; slug: string},
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof attachKnowledgeBaseToAssistant>>,
  TError,
  {assistantId: string; slug: string},
  TContext
> => {
  const mutationOptions =
    getAttachKnowledgeBaseToAssistantMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Detaches a knowledge base from an assistant
 */
export const detachKnowledgeBaseFromAssistant = (assistantId: string) => {
  return axiosInstance<void>({
    url: `/assistants/${assistantId}/knowledge_bases`,
    method: "DELETE",
  });
};

export const getDetachKnowledgeBaseFromAssistantMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof detachKnowledgeBaseFromAssistant>>,
    TError,
    {assistantId: string},
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof detachKnowledgeBaseFromAssistant>>,
  TError,
  {assistantId: string},
  TContext
> => {
  const mutationKey = ["detachKnowledgeBaseFromAssistant"];
  const {mutation: mutationOptions} = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : {...options, mutation: {...options.mutation, mutationKey}}
    : {mutation: {mutationKey}};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof detachKnowledgeBaseFromAssistant>>,
    {assistantId: string}
  > = props => {
    const {assistantId} = props ?? {};

    return detachKnowledgeBaseFromAssistant(assistantId);
  };

  return {mutationFn, ...mutationOptions};
};

export type DetachKnowledgeBaseFromAssistantMutationResult = NonNullable<
  Awaited<ReturnType<typeof detachKnowledgeBaseFromAssistant>>
>;

export type DetachKnowledgeBaseFromAssistantMutationError = void;

export const useDetachKnowledgeBaseFromAssistant = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof detachKnowledgeBaseFromAssistant>>,
      TError,
      {assistantId: string},
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof detachKnowledgeBaseFromAssistant>>,
  TError,
  {assistantId: string},
  TContext
> => {
  const mutationOptions =
    getDetachKnowledgeBaseFromAssistantMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Gets the memory store attached to an assistant
 */
export const getAssistantMemoryStore = (
  assistantId: string,
  signal?: AbortSignal,
) => {
  return axiosInstance<MemoryStoreResponse>({
    url: `/assistants/${assistantId}/memory_stores`,
    method: "GET",
    signal,
  });
};

export const getGetAssistantMemoryStoreQueryKey = (assistantId: string) => {
  return [`/assistants/${assistantId}/memory_stores`] as const;
};

export const getGetAssistantMemoryStoreQueryOptions = <
  TData = Awaited<ReturnType<typeof getAssistantMemoryStore>>,
  TError = void,
>(
  assistantId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssistantMemoryStore>>,
        TError,
        TData
      >
    >;
  },
) => {
  const {query: queryOptions} = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAssistantMemoryStoreQueryKey(assistantId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAssistantMemoryStore>>
  > = ({signal}) => getAssistantMemoryStore(assistantId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!assistantId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getAssistantMemoryStore>>,
    TError,
    TData
  > & {queryKey: DataTag<QueryKey, TData, TError>};
};

export type GetAssistantMemoryStoreQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAssistantMemoryStore>>
>;
export type GetAssistantMemoryStoreQueryError = void;

export function useGetAssistantMemoryStore<
  TData = Awaited<ReturnType<typeof getAssistantMemoryStore>>,
  TError = void,
>(
  assistantId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssistantMemoryStore>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAssistantMemoryStore>>,
          TError,
          Awaited<ReturnType<typeof getAssistantMemoryStore>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAssistantMemoryStore<
  TData = Awaited<ReturnType<typeof getAssistantMemoryStore>>,
  TError = void,
>(
  assistantId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssistantMemoryStore>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAssistantMemoryStore>>,
          TError,
          Awaited<ReturnType<typeof getAssistantMemoryStore>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};
export function useGetAssistantMemoryStore<
  TData = Awaited<ReturnType<typeof getAssistantMemoryStore>>,
  TError = void,
>(
  assistantId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssistantMemoryStore>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};

export function useGetAssistantMemoryStore<
  TData = Awaited<ReturnType<typeof getAssistantMemoryStore>>,
  TError = void,
>(
  assistantId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssistantMemoryStore>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetAssistantMemoryStoreQueryOptions(
    assistantId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & {queryKey: DataTag<QueryKey, TData, TError>};

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Attaches a memory store to an assistant
 */
export const attachMemoryStoreToAssistant = (
  assistantId: string,
  memoryStoreId: string,
) => {
  return axiosInstance<void>({
    url: `/assistants/${assistantId}/memory_stores/${memoryStoreId}`,
    method: "PUT",
  });
};

export const getAttachMemoryStoreToAssistantMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof attachMemoryStoreToAssistant>>,
    TError,
    {assistantId: string; memoryStoreId: string},
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof attachMemoryStoreToAssistant>>,
  TError,
  {assistantId: string; memoryStoreId: string},
  TContext
> => {
  const mutationKey = ["attachMemoryStoreToAssistant"];
  const {mutation: mutationOptions} = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : {...options, mutation: {...options.mutation, mutationKey}}
    : {mutation: {mutationKey}};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof attachMemoryStoreToAssistant>>,
    {assistantId: string; memoryStoreId: string}
  > = props => {
    const {assistantId, memoryStoreId} = props ?? {};

    return attachMemoryStoreToAssistant(assistantId, memoryStoreId);
  };

  return {mutationFn, ...mutationOptions};
};

export type AttachMemoryStoreToAssistantMutationResult = NonNullable<
  Awaited<ReturnType<typeof attachMemoryStoreToAssistant>>
>;

export type AttachMemoryStoreToAssistantMutationError = void;

export const useAttachMemoryStoreToAssistant = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof attachMemoryStoreToAssistant>>,
      TError,
      {assistantId: string; memoryStoreId: string},
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof attachMemoryStoreToAssistant>>,
  TError,
  {assistantId: string; memoryStoreId: string},
  TContext
> => {
  const mutationOptions =
    getAttachMemoryStoreToAssistantMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Detaches a memory store from an assistant
 */
export const detachMemoryStoreFromAssistant = (
  assistantId: string,
  memoryStoreId: string,
) => {
  return axiosInstance<void>({
    url: `/assistants/${assistantId}/memory_stores/${memoryStoreId}`,
    method: "DELETE",
  });
};

export const getDetachMemoryStoreFromAssistantMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof detachMemoryStoreFromAssistant>>,
    TError,
    {assistantId: string; memoryStoreId: string},
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof detachMemoryStoreFromAssistant>>,
  TError,
  {assistantId: string; memoryStoreId: string},
  TContext
> => {
  const mutationKey = ["detachMemoryStoreFromAssistant"];
  const {mutation: mutationOptions} = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : {...options, mutation: {...options.mutation, mutationKey}}
    : {mutation: {mutationKey}};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof detachMemoryStoreFromAssistant>>,
    {assistantId: string; memoryStoreId: string}
  > = props => {
    const {assistantId, memoryStoreId} = props ?? {};

    return detachMemoryStoreFromAssistant(assistantId, memoryStoreId);
  };

  return {mutationFn, ...mutationOptions};
};

export type DetachMemoryStoreFromAssistantMutationResult = NonNullable<
  Awaited<ReturnType<typeof detachMemoryStoreFromAssistant>>
>;

export type DetachMemoryStoreFromAssistantMutationError = void;

export const useDetachMemoryStoreFromAssistant = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof detachMemoryStoreFromAssistant>>,
      TError,
      {assistantId: string; memoryStoreId: string},
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof detachMemoryStoreFromAssistant>>,
  TError,
  {assistantId: string; memoryStoreId: string},
  TContext
> => {
  const mutationOptions =
    getDetachMemoryStoreFromAssistantMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Gets actions attached to an assistant
 */
export const getAssistantActions = (
  assistantId: string,
  params?: GetAssistantActionsParams,
  signal?: AbortSignal,
) => {
  return axiosInstance<GetAssistantActions200>({
    url: `/assistants/${assistantId}/actions`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetAssistantActionsQueryKey = (
  assistantId: string,
  params?: GetAssistantActionsParams,
) => {
  return [
    `/assistants/${assistantId}/actions`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetAssistantActionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getAssistantActions>>,
  TError = void,
>(
  assistantId: string,
  params?: GetAssistantActionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssistantActions>>,
        TError,
        TData
      >
    >;
  },
) => {
  const {query: queryOptions} = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetAssistantActionsQueryKey(assistantId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAssistantActions>>
  > = ({signal}) => getAssistantActions(assistantId, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!assistantId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getAssistantActions>>,
    TError,
    TData
  > & {queryKey: DataTag<QueryKey, TData, TError>};
};

export type GetAssistantActionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAssistantActions>>
>;
export type GetAssistantActionsQueryError = void;

export function useGetAssistantActions<
  TData = Awaited<ReturnType<typeof getAssistantActions>>,
  TError = void,
>(
  assistantId: string,
  params: undefined | GetAssistantActionsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssistantActions>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAssistantActions>>,
          TError,
          Awaited<ReturnType<typeof getAssistantActions>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAssistantActions<
  TData = Awaited<ReturnType<typeof getAssistantActions>>,
  TError = void,
>(
  assistantId: string,
  params?: GetAssistantActionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssistantActions>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAssistantActions>>,
          TError,
          Awaited<ReturnType<typeof getAssistantActions>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};
export function useGetAssistantActions<
  TData = Awaited<ReturnType<typeof getAssistantActions>>,
  TError = void,
>(
  assistantId: string,
  params?: GetAssistantActionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssistantActions>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};

export function useGetAssistantActions<
  TData = Awaited<ReturnType<typeof getAssistantActions>>,
  TError = void,
>(
  assistantId: string,
  params?: GetAssistantActionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssistantActions>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetAssistantActionsQueryOptions(
    assistantId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & {queryKey: DataTag<QueryKey, TData, TError>};

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Attach multiple actions to an assistant at once
 */
export const attachActionToAssistantBatch = (
  assistantId: string,
  batchAttachedAction: BatchAttachedAction,
) => {
  return axiosInstance<void>({
    url: `/assistants/${assistantId}/actions`,
    method: "PUT",
    headers: {"Content-Type": "application/json"},
    data: batchAttachedAction,
  });
};

export const getAttachActionToAssistantBatchMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof attachActionToAssistantBatch>>,
    TError,
    {assistantId: string; data: BatchAttachedAction},
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof attachActionToAssistantBatch>>,
  TError,
  {assistantId: string; data: BatchAttachedAction},
  TContext
> => {
  const mutationKey = ["attachActionToAssistantBatch"];
  const {mutation: mutationOptions} = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : {...options, mutation: {...options.mutation, mutationKey}}
    : {mutation: {mutationKey}};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof attachActionToAssistantBatch>>,
    {assistantId: string; data: BatchAttachedAction}
  > = props => {
    const {assistantId, data} = props ?? {};

    return attachActionToAssistantBatch(assistantId, data);
  };

  return {mutationFn, ...mutationOptions};
};

export type AttachActionToAssistantBatchMutationResult = NonNullable<
  Awaited<ReturnType<typeof attachActionToAssistantBatch>>
>;
export type AttachActionToAssistantBatchMutationBody = BatchAttachedAction;
export type AttachActionToAssistantBatchMutationError = void;

export const useAttachActionToAssistantBatch = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof attachActionToAssistantBatch>>,
      TError,
      {assistantId: string; data: BatchAttachedAction},
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof attachActionToAssistantBatch>>,
  TError,
  {assistantId: string; data: BatchAttachedAction},
  TContext
> => {
  const mutationOptions =
    getAttachActionToAssistantBatchMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Attaches specified action to an assistant
 */
export const attachActionToAssistant = (
  assistantId: string,
  slug: string,
  params?: AttachActionToAssistantParams,
) => {
  return axiosInstance<void>({
    url: `/assistants/${assistantId}/actions/${slug}`,
    method: "PUT",
    params,
  });
};

export const getAttachActionToAssistantMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof attachActionToAssistant>>,
    TError,
    {assistantId: string; slug: string; params?: AttachActionToAssistantParams},
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof attachActionToAssistant>>,
  TError,
  {assistantId: string; slug: string; params?: AttachActionToAssistantParams},
  TContext
> => {
  const mutationKey = ["attachActionToAssistant"];
  const {mutation: mutationOptions} = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : {...options, mutation: {...options.mutation, mutationKey}}
    : {mutation: {mutationKey}};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof attachActionToAssistant>>,
    {assistantId: string; slug: string; params?: AttachActionToAssistantParams}
  > = props => {
    const {assistantId, slug, params} = props ?? {};

    return attachActionToAssistant(assistantId, slug, params);
  };

  return {mutationFn, ...mutationOptions};
};

export type AttachActionToAssistantMutationResult = NonNullable<
  Awaited<ReturnType<typeof attachActionToAssistant>>
>;

export type AttachActionToAssistantMutationError = void;

export const useAttachActionToAssistant = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof attachActionToAssistant>>,
      TError,
      {
        assistantId: string;
        slug: string;
        params?: AttachActionToAssistantParams;
      },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof attachActionToAssistant>>,
  TError,
  {assistantId: string; slug: string; params?: AttachActionToAssistantParams},
  TContext
> => {
  const mutationOptions = getAttachActionToAssistantMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Detaches specified action from the assistant
 */
export const detachActionFromAssistant = (
  assistantId: string,
  slug: string,
  params?: DetachActionFromAssistantParams,
) => {
  return axiosInstance<void>({
    url: `/assistants/${assistantId}/actions/${slug}`,
    method: "DELETE",
    params,
  });
};

export const getDetachActionFromAssistantMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof detachActionFromAssistant>>,
    TError,
    {
      assistantId: string;
      slug: string;
      params?: DetachActionFromAssistantParams;
    },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof detachActionFromAssistant>>,
  TError,
  {assistantId: string; slug: string; params?: DetachActionFromAssistantParams},
  TContext
> => {
  const mutationKey = ["detachActionFromAssistant"];
  const {mutation: mutationOptions} = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : {...options, mutation: {...options.mutation, mutationKey}}
    : {mutation: {mutationKey}};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof detachActionFromAssistant>>,
    {
      assistantId: string;
      slug: string;
      params?: DetachActionFromAssistantParams;
    }
  > = props => {
    const {assistantId, slug, params} = props ?? {};

    return detachActionFromAssistant(assistantId, slug, params);
  };

  return {mutationFn, ...mutationOptions};
};

export type DetachActionFromAssistantMutationResult = NonNullable<
  Awaited<ReturnType<typeof detachActionFromAssistant>>
>;

export type DetachActionFromAssistantMutationError = void;

export const useDetachActionFromAssistant = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof detachActionFromAssistant>>,
      TError,
      {
        assistantId: string;
        slug: string;
        params?: DetachActionFromAssistantParams;
      },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof detachActionFromAssistant>>,
  TError,
  {assistantId: string; slug: string; params?: DetachActionFromAssistantParams},
  TContext
> => {
  const mutationOptions = getDetachActionFromAssistantMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Get phone numbers attached to assistant
 */
export const getAssistantPhoneNumbers = (
  assistantId: string,
  params?: GetAssistantPhoneNumbersParams,
  signal?: AbortSignal,
) => {
  return axiosInstance<GetAssistantPhoneNumbers200>({
    url: `/assistants/${assistantId}/phone_numbers`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetAssistantPhoneNumbersQueryKey = (
  assistantId: string,
  params?: GetAssistantPhoneNumbersParams,
) => {
  return [
    `/assistants/${assistantId}/phone_numbers`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetAssistantPhoneNumbersQueryOptions = <
  TData = Awaited<ReturnType<typeof getAssistantPhoneNumbers>>,
  TError = void,
>(
  assistantId: string,
  params?: GetAssistantPhoneNumbersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssistantPhoneNumbers>>,
        TError,
        TData
      >
    >;
  },
) => {
  const {query: queryOptions} = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetAssistantPhoneNumbersQueryKey(assistantId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAssistantPhoneNumbers>>
  > = ({signal}) => getAssistantPhoneNumbers(assistantId, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!assistantId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getAssistantPhoneNumbers>>,
    TError,
    TData
  > & {queryKey: DataTag<QueryKey, TData, TError>};
};

export type GetAssistantPhoneNumbersQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAssistantPhoneNumbers>>
>;
export type GetAssistantPhoneNumbersQueryError = void;

export function useGetAssistantPhoneNumbers<
  TData = Awaited<ReturnType<typeof getAssistantPhoneNumbers>>,
  TError = void,
>(
  assistantId: string,
  params: undefined | GetAssistantPhoneNumbersParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssistantPhoneNumbers>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAssistantPhoneNumbers>>,
          TError,
          Awaited<ReturnType<typeof getAssistantPhoneNumbers>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAssistantPhoneNumbers<
  TData = Awaited<ReturnType<typeof getAssistantPhoneNumbers>>,
  TError = void,
>(
  assistantId: string,
  params?: GetAssistantPhoneNumbersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssistantPhoneNumbers>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAssistantPhoneNumbers>>,
          TError,
          Awaited<ReturnType<typeof getAssistantPhoneNumbers>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};
export function useGetAssistantPhoneNumbers<
  TData = Awaited<ReturnType<typeof getAssistantPhoneNumbers>>,
  TError = void,
>(
  assistantId: string,
  params?: GetAssistantPhoneNumbersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssistantPhoneNumbers>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};

export function useGetAssistantPhoneNumbers<
  TData = Awaited<ReturnType<typeof getAssistantPhoneNumbers>>,
  TError = void,
>(
  assistantId: string,
  params?: GetAssistantPhoneNumbersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssistantPhoneNumbers>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetAssistantPhoneNumbersQueryOptions(
    assistantId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & {queryKey: DataTag<QueryKey, TData, TError>};

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Attached a phone number to assistant
 */
export const attachPhoneNumberToAssistant = (
  assistantId: string,
  phoneNumberWithSid: PhoneNumberWithSid,
) => {
  return axiosInstance<void>({
    url: `/assistants/${assistantId}/phone_numbers`,
    method: "PUT",
    headers: {"Content-Type": "application/json"},
    data: phoneNumberWithSid,
  });
};

export const getAttachPhoneNumberToAssistantMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof attachPhoneNumberToAssistant>>,
    TError,
    {assistantId: string; data: PhoneNumberWithSid},
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof attachPhoneNumberToAssistant>>,
  TError,
  {assistantId: string; data: PhoneNumberWithSid},
  TContext
> => {
  const mutationKey = ["attachPhoneNumberToAssistant"];
  const {mutation: mutationOptions} = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : {...options, mutation: {...options.mutation, mutationKey}}
    : {mutation: {mutationKey}};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof attachPhoneNumberToAssistant>>,
    {assistantId: string; data: PhoneNumberWithSid}
  > = props => {
    const {assistantId, data} = props ?? {};

    return attachPhoneNumberToAssistant(assistantId, data);
  };

  return {mutationFn, ...mutationOptions};
};

export type AttachPhoneNumberToAssistantMutationResult = NonNullable<
  Awaited<ReturnType<typeof attachPhoneNumberToAssistant>>
>;
export type AttachPhoneNumberToAssistantMutationBody = PhoneNumberWithSid;
export type AttachPhoneNumberToAssistantMutationError = void;

export const useAttachPhoneNumberToAssistant = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof attachPhoneNumberToAssistant>>,
      TError,
      {assistantId: string; data: PhoneNumberWithSid},
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof attachPhoneNumberToAssistant>>,
  TError,
  {assistantId: string; data: PhoneNumberWithSid},
  TContext
> => {
  const mutationOptions =
    getAttachPhoneNumberToAssistantMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Detaches a phone number from assistant
 */
export const detachPhoneNumberFromAssistant = (assistantId: string) => {
  return axiosInstance<void>({
    url: `/assistants/${assistantId}/phone_numbers`,
    method: "DELETE",
  });
};

export const getDetachPhoneNumberFromAssistantMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof detachPhoneNumberFromAssistant>>,
    TError,
    {assistantId: string},
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof detachPhoneNumberFromAssistant>>,
  TError,
  {assistantId: string},
  TContext
> => {
  const mutationKey = ["detachPhoneNumberFromAssistant"];
  const {mutation: mutationOptions} = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : {...options, mutation: {...options.mutation, mutationKey}}
    : {mutation: {mutationKey}};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof detachPhoneNumberFromAssistant>>,
    {assistantId: string}
  > = props => {
    const {assistantId} = props ?? {};

    return detachPhoneNumberFromAssistant(assistantId);
  };

  return {mutationFn, ...mutationOptions};
};

export type DetachPhoneNumberFromAssistantMutationResult = NonNullable<
  Awaited<ReturnType<typeof detachPhoneNumberFromAssistant>>
>;

export type DetachPhoneNumberFromAssistantMutationError = void;

export const useDetachPhoneNumberFromAssistant = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof detachPhoneNumberFromAssistant>>,
      TError,
      {assistantId: string},
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof detachPhoneNumberFromAssistant>>,
  TError,
  {assistantId: string},
  TContext
> => {
  const mutationOptions =
    getDetachPhoneNumberFromAssistantMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Get all published versions for an assistant
 */
export const getAssistantVersions = (
  assistantId: string,
  signal?: AbortSignal,
) => {
  return axiosInstance<GetAssistantVersions200>({
    url: `/assistants/${assistantId}/versions`,
    method: "GET",
    signal,
  });
};

export const getGetAssistantVersionsQueryKey = (assistantId: string) => {
  return [`/assistants/${assistantId}/versions`] as const;
};

export const getGetAssistantVersionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getAssistantVersions>>,
  TError = void,
>(
  assistantId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssistantVersions>>,
        TError,
        TData
      >
    >;
  },
) => {
  const {query: queryOptions} = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAssistantVersionsQueryKey(assistantId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAssistantVersions>>
  > = ({signal}) => getAssistantVersions(assistantId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!assistantId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getAssistantVersions>>,
    TError,
    TData
  > & {queryKey: DataTag<QueryKey, TData, TError>};
};

export type GetAssistantVersionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAssistantVersions>>
>;
export type GetAssistantVersionsQueryError = void;

export function useGetAssistantVersions<
  TData = Awaited<ReturnType<typeof getAssistantVersions>>,
  TError = void,
>(
  assistantId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssistantVersions>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAssistantVersions>>,
          TError,
          Awaited<ReturnType<typeof getAssistantVersions>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAssistantVersions<
  TData = Awaited<ReturnType<typeof getAssistantVersions>>,
  TError = void,
>(
  assistantId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssistantVersions>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAssistantVersions>>,
          TError,
          Awaited<ReturnType<typeof getAssistantVersions>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};
export function useGetAssistantVersions<
  TData = Awaited<ReturnType<typeof getAssistantVersions>>,
  TError = void,
>(
  assistantId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssistantVersions>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};

export function useGetAssistantVersions<
  TData = Awaited<ReturnType<typeof getAssistantVersions>>,
  TError = void,
>(
  assistantId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssistantVersions>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetAssistantVersionsQueryOptions(
    assistantId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & {queryKey: DataTag<QueryKey, TData, TError>};

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Delete a specific version of an assistant
 */
export const deleteAssistantVersion = (
  assistantId: string,
  versionId: string,
) => {
  return axiosInstance<void>({
    url: `/assistants/${assistantId}/versions/${versionId}`,
    method: "DELETE",
  });
};

export const getDeleteAssistantVersionMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteAssistantVersion>>,
    TError,
    {assistantId: string; versionId: string},
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteAssistantVersion>>,
  TError,
  {assistantId: string; versionId: string},
  TContext
> => {
  const mutationKey = ["deleteAssistantVersion"];
  const {mutation: mutationOptions} = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : {...options, mutation: {...options.mutation, mutationKey}}
    : {mutation: {mutationKey}};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteAssistantVersion>>,
    {assistantId: string; versionId: string}
  > = props => {
    const {assistantId, versionId} = props ?? {};

    return deleteAssistantVersion(assistantId, versionId);
  };

  return {mutationFn, ...mutationOptions};
};

export type DeleteAssistantVersionMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteAssistantVersion>>
>;

export type DeleteAssistantVersionMutationError = void;

export const useDeleteAssistantVersion = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteAssistantVersion>>,
      TError,
      {assistantId: string; versionId: string},
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteAssistantVersion>>,
  TError,
  {assistantId: string; versionId: string},
  TContext
> => {
  const mutationOptions = getDeleteAssistantVersionMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Rollback to a previous version by creating a new version with the target version's configuration.

This is a non-destructive rollback that:
- Takes versionable fields from the target version
- Applies them to the current live agent
- Creates a new version representing the rollback

The rollback appears as a new version in the history, preserving the complete audit trail.
Any existing draft will be cleared.

 */
export const rollbackAssistantVersion = (
  assistantId: string,
  versionId: string,
  signal?: AbortSignal,
) => {
  return axiosInstance<RollbackAssistantVersion200>({
    url: `/assistants/${assistantId}/versions/${versionId}/rollback`,
    method: "POST",
    signal,
  });
};

export const getRollbackAssistantVersionMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof rollbackAssistantVersion>>,
    TError,
    {assistantId: string; versionId: string},
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof rollbackAssistantVersion>>,
  TError,
  {assistantId: string; versionId: string},
  TContext
> => {
  const mutationKey = ["rollbackAssistantVersion"];
  const {mutation: mutationOptions} = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : {...options, mutation: {...options.mutation, mutationKey}}
    : {mutation: {mutationKey}};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof rollbackAssistantVersion>>,
    {assistantId: string; versionId: string}
  > = props => {
    const {assistantId, versionId} = props ?? {};

    return rollbackAssistantVersion(assistantId, versionId);
  };

  return {mutationFn, ...mutationOptions};
};

export type RollbackAssistantVersionMutationResult = NonNullable<
  Awaited<ReturnType<typeof rollbackAssistantVersion>>
>;

export type RollbackAssistantVersionMutationError = void;

export const useRollbackAssistantVersion = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof rollbackAssistantVersion>>,
      TError,
      {assistantId: string; versionId: string},
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof rollbackAssistantVersion>>,
  TError,
  {assistantId: string; versionId: string},
  TContext
> => {
  const mutationOptions = getRollbackAssistantVersionMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Export a version (published or draft) as a portable JSON format. The version_id can be a UUID for published versions or "draft" for the current draft.
 */
export const exportAssistantVersion = (
  assistantId: string,
  versionId: string,
  signal?: AbortSignal,
) => {
  return axiosInstance<ExportAssistantVersion200>({
    url: `/assistants/${assistantId}/versions/${versionId}/export`,
    method: "GET",
    signal,
  });
};

export const getExportAssistantVersionQueryKey = (
  assistantId: string,
  versionId: string,
) => {
  return [`/assistants/${assistantId}/versions/${versionId}/export`] as const;
};

export const getExportAssistantVersionQueryOptions = <
  TData = Awaited<ReturnType<typeof exportAssistantVersion>>,
  TError = void,
>(
  assistantId: string,
  versionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof exportAssistantVersion>>,
        TError,
        TData
      >
    >;
  },
) => {
  const {query: queryOptions} = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getExportAssistantVersionQueryKey(assistantId, versionId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof exportAssistantVersion>>
  > = ({signal}) => exportAssistantVersion(assistantId, versionId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(assistantId && versionId),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof exportAssistantVersion>>,
    TError,
    TData
  > & {queryKey: DataTag<QueryKey, TData, TError>};
};

export type ExportAssistantVersionQueryResult = NonNullable<
  Awaited<ReturnType<typeof exportAssistantVersion>>
>;
export type ExportAssistantVersionQueryError = void;

export function useExportAssistantVersion<
  TData = Awaited<ReturnType<typeof exportAssistantVersion>>,
  TError = void,
>(
  assistantId: string,
  versionId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof exportAssistantVersion>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof exportAssistantVersion>>,
          TError,
          Awaited<ReturnType<typeof exportAssistantVersion>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExportAssistantVersion<
  TData = Awaited<ReturnType<typeof exportAssistantVersion>>,
  TError = void,
>(
  assistantId: string,
  versionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof exportAssistantVersion>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof exportAssistantVersion>>,
          TError,
          Awaited<ReturnType<typeof exportAssistantVersion>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};
export function useExportAssistantVersion<
  TData = Awaited<ReturnType<typeof exportAssistantVersion>>,
  TError = void,
>(
  assistantId: string,
  versionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof exportAssistantVersion>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};

export function useExportAssistantVersion<
  TData = Awaited<ReturnType<typeof exportAssistantVersion>>,
  TError = void,
>(
  assistantId: string,
  versionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof exportAssistantVersion>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getExportAssistantVersionQueryOptions(
    assistantId,
    versionId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & {queryKey: DataTag<QueryKey, TData, TError>};

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get the diff between a version and another version (or its previous version). By default, compares with the immediate previous version for published versions, or current live version for drafts.
 */
export const getAssistantVersionDiff = (
  assistantId: string,
  versionId: string,
  params?: GetAssistantVersionDiffParams,
  signal?: AbortSignal,
) => {
  return axiosInstance<GetAssistantVersionDiff200>({
    url: `/assistants/${assistantId}/versions/${versionId}/diff`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetAssistantVersionDiffQueryKey = (
  assistantId: string,
  versionId: string,
  params?: GetAssistantVersionDiffParams,
) => {
  return [
    `/assistants/${assistantId}/versions/${versionId}/diff`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetAssistantVersionDiffQueryOptions = <
  TData = Awaited<ReturnType<typeof getAssistantVersionDiff>>,
  TError = void,
>(
  assistantId: string,
  versionId: string,
  params?: GetAssistantVersionDiffParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssistantVersionDiff>>,
        TError,
        TData
      >
    >;
  },
) => {
  const {query: queryOptions} = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetAssistantVersionDiffQueryKey(assistantId, versionId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAssistantVersionDiff>>
  > = ({signal}) =>
    getAssistantVersionDiff(assistantId, versionId, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(assistantId && versionId),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getAssistantVersionDiff>>,
    TError,
    TData
  > & {queryKey: DataTag<QueryKey, TData, TError>};
};

export type GetAssistantVersionDiffQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAssistantVersionDiff>>
>;
export type GetAssistantVersionDiffQueryError = void;

export function useGetAssistantVersionDiff<
  TData = Awaited<ReturnType<typeof getAssistantVersionDiff>>,
  TError = void,
>(
  assistantId: string,
  versionId: string,
  params: undefined | GetAssistantVersionDiffParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssistantVersionDiff>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAssistantVersionDiff>>,
          TError,
          Awaited<ReturnType<typeof getAssistantVersionDiff>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAssistantVersionDiff<
  TData = Awaited<ReturnType<typeof getAssistantVersionDiff>>,
  TError = void,
>(
  assistantId: string,
  versionId: string,
  params?: GetAssistantVersionDiffParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssistantVersionDiff>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAssistantVersionDiff>>,
          TError,
          Awaited<ReturnType<typeof getAssistantVersionDiff>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};
export function useGetAssistantVersionDiff<
  TData = Awaited<ReturnType<typeof getAssistantVersionDiff>>,
  TError = void,
>(
  assistantId: string,
  versionId: string,
  params?: GetAssistantVersionDiffParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssistantVersionDiff>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};

export function useGetAssistantVersionDiff<
  TData = Awaited<ReturnType<typeof getAssistantVersionDiff>>,
  TError = void,
>(
  assistantId: string,
  versionId: string,
  params?: GetAssistantVersionDiffParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssistantVersionDiff>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetAssistantVersionDiffQueryOptions(
    assistantId,
    versionId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & {queryKey: DataTag<QueryKey, TData, TError>};

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get the single draft for an assistant
 */
export const getAssistantDraft = (
  assistantId: string,
  signal?: AbortSignal,
) => {
  return axiosInstance<GetAssistantDraft200>({
    url: `/assistants/${assistantId}/draft`,
    method: "GET",
    signal,
  });
};

export const getGetAssistantDraftQueryKey = (assistantId: string) => {
  return [`/assistants/${assistantId}/draft`] as const;
};

export const getGetAssistantDraftQueryOptions = <
  TData = Awaited<ReturnType<typeof getAssistantDraft>>,
  TError = void,
>(
  assistantId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssistantDraft>>,
        TError,
        TData
      >
    >;
  },
) => {
  const {query: queryOptions} = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAssistantDraftQueryKey(assistantId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAssistantDraft>>
  > = ({signal}) => getAssistantDraft(assistantId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!assistantId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getAssistantDraft>>,
    TError,
    TData
  > & {queryKey: DataTag<QueryKey, TData, TError>};
};

export type GetAssistantDraftQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAssistantDraft>>
>;
export type GetAssistantDraftQueryError = void;

export function useGetAssistantDraft<
  TData = Awaited<ReturnType<typeof getAssistantDraft>>,
  TError = void,
>(
  assistantId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssistantDraft>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAssistantDraft>>,
          TError,
          Awaited<ReturnType<typeof getAssistantDraft>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAssistantDraft<
  TData = Awaited<ReturnType<typeof getAssistantDraft>>,
  TError = void,
>(
  assistantId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssistantDraft>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAssistantDraft>>,
          TError,
          Awaited<ReturnType<typeof getAssistantDraft>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};
export function useGetAssistantDraft<
  TData = Awaited<ReturnType<typeof getAssistantDraft>>,
  TError = void,
>(
  assistantId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssistantDraft>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};

export function useGetAssistantDraft<
  TData = Awaited<ReturnType<typeof getAssistantDraft>>,
  TError = void,
>(
  assistantId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssistantDraft>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetAssistantDraftQueryOptions(assistantId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & {queryKey: DataTag<QueryKey, TData, TError>};

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Create or update the single draft for an assistant
 */
export const createOrUpdateAssistantDraft = (
  assistantId: string,
  createOrUpdateAssistantDraftBody: CreateOrUpdateAssistantDraftBody,
) => {
  return axiosInstance<CreateOrUpdateAssistantDraft200>({
    url: `/assistants/${assistantId}/draft`,
    method: "PUT",
    headers: {"Content-Type": "application/json"},
    data: createOrUpdateAssistantDraftBody,
  });
};

export const getCreateOrUpdateAssistantDraftMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createOrUpdateAssistantDraft>>,
    TError,
    {assistantId: string; data: CreateOrUpdateAssistantDraftBody},
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createOrUpdateAssistantDraft>>,
  TError,
  {assistantId: string; data: CreateOrUpdateAssistantDraftBody},
  TContext
> => {
  const mutationKey = ["createOrUpdateAssistantDraft"];
  const {mutation: mutationOptions} = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : {...options, mutation: {...options.mutation, mutationKey}}
    : {mutation: {mutationKey}};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createOrUpdateAssistantDraft>>,
    {assistantId: string; data: CreateOrUpdateAssistantDraftBody}
  > = props => {
    const {assistantId, data} = props ?? {};

    return createOrUpdateAssistantDraft(assistantId, data);
  };

  return {mutationFn, ...mutationOptions};
};

export type CreateOrUpdateAssistantDraftMutationResult = NonNullable<
  Awaited<ReturnType<typeof createOrUpdateAssistantDraft>>
>;
export type CreateOrUpdateAssistantDraftMutationBody =
  CreateOrUpdateAssistantDraftBody;
export type CreateOrUpdateAssistantDraftMutationError = unknown;

export const useCreateOrUpdateAssistantDraft = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createOrUpdateAssistantDraft>>,
      TError,
      {assistantId: string; data: CreateOrUpdateAssistantDraftBody},
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createOrUpdateAssistantDraft>>,
  TError,
  {assistantId: string; data: CreateOrUpdateAssistantDraftBody},
  TContext
> => {
  const mutationOptions =
    getCreateOrUpdateAssistantDraftMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Partially update the draft configuration for an assistant
 */
export const updateAssistantDraftPartial = (
  assistantId: string,
  assistant: Assistant,
) => {
  return axiosInstance<Assistant>({
    url: `/assistants/${assistantId}/draft`,
    method: "PATCH",
    headers: {"Content-Type": "application/json"},
    data: assistant,
  });
};

export const getUpdateAssistantDraftPartialMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateAssistantDraftPartial>>,
    TError,
    {assistantId: string; data: Assistant},
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateAssistantDraftPartial>>,
  TError,
  {assistantId: string; data: Assistant},
  TContext
> => {
  const mutationKey = ["updateAssistantDraftPartial"];
  const {mutation: mutationOptions} = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : {...options, mutation: {...options.mutation, mutationKey}}
    : {mutation: {mutationKey}};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateAssistantDraftPartial>>,
    {assistantId: string; data: Assistant}
  > = props => {
    const {assistantId, data} = props ?? {};

    return updateAssistantDraftPartial(assistantId, data);
  };

  return {mutationFn, ...mutationOptions};
};

export type UpdateAssistantDraftPartialMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateAssistantDraftPartial>>
>;
export type UpdateAssistantDraftPartialMutationBody = Assistant;
export type UpdateAssistantDraftPartialMutationError = void;

export const useUpdateAssistantDraftPartial = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateAssistantDraftPartial>>,
      TError,
      {assistantId: string; data: Assistant},
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateAssistantDraftPartial>>,
  TError,
  {assistantId: string; data: Assistant},
  TContext
> => {
  const mutationOptions =
    getUpdateAssistantDraftPartialMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Delete the single draft for an assistant
 */
export const deleteAssistantDraft = (assistantId: string) => {
  return axiosInstance<void>({
    url: `/assistants/${assistantId}/draft`,
    method: "DELETE",
  });
};

export const getDeleteAssistantDraftMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteAssistantDraft>>,
    TError,
    {assistantId: string},
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteAssistantDraft>>,
  TError,
  {assistantId: string},
  TContext
> => {
  const mutationKey = ["deleteAssistantDraft"];
  const {mutation: mutationOptions} = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : {...options, mutation: {...options.mutation, mutationKey}}
    : {mutation: {mutationKey}};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteAssistantDraft>>,
    {assistantId: string}
  > = props => {
    const {assistantId} = props ?? {};

    return deleteAssistantDraft(assistantId);
  };

  return {mutationFn, ...mutationOptions};
};

export type DeleteAssistantDraftMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteAssistantDraft>>
>;

export type DeleteAssistantDraftMutationError = void;

export const useDeleteAssistantDraft = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteAssistantDraft>>,
      TError,
      {assistantId: string},
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteAssistantDraft>>,
  TError,
  {assistantId: string},
  TContext
> => {
  const mutationOptions = getDeleteAssistantDraftMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Publish the single draft as a new version
 */
export const publishAssistantDraft = (
  assistantId: string,
  publishAssistantDraftBody: PublishAssistantDraftBody,
  signal?: AbortSignal,
) => {
  return axiosInstance<PublishAssistantDraft200>({
    url: `/assistants/${assistantId}/draft/publish`,
    method: "POST",
    headers: {"Content-Type": "application/json"},
    data: publishAssistantDraftBody,
    signal,
  });
};

export const getPublishAssistantDraftMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof publishAssistantDraft>>,
    TError,
    {assistantId: string; data: PublishAssistantDraftBody},
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof publishAssistantDraft>>,
  TError,
  {assistantId: string; data: PublishAssistantDraftBody},
  TContext
> => {
  const mutationKey = ["publishAssistantDraft"];
  const {mutation: mutationOptions} = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : {...options, mutation: {...options.mutation, mutationKey}}
    : {mutation: {mutationKey}};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof publishAssistantDraft>>,
    {assistantId: string; data: PublishAssistantDraftBody}
  > = props => {
    const {assistantId, data} = props ?? {};

    return publishAssistantDraft(assistantId, data);
  };

  return {mutationFn, ...mutationOptions};
};

export type PublishAssistantDraftMutationResult = NonNullable<
  Awaited<ReturnType<typeof publishAssistantDraft>>
>;
export type PublishAssistantDraftMutationBody = PublishAssistantDraftBody;
export type PublishAssistantDraftMutationError = void;

export const usePublishAssistantDraft = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof publishAssistantDraft>>,
      TError,
      {assistantId: string; data: PublishAssistantDraftBody},
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof publishAssistantDraft>>,
  TError,
  {assistantId: string; data: PublishAssistantDraftBody},
  TContext
> => {
  const mutationOptions = getPublishAssistantDraftMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Gets the list of assistant templates
 */
export const getAssistantTemplates = (
  params?: GetAssistantTemplatesParams,
  signal?: AbortSignal,
) => {
  return axiosInstance<GetAssistantTemplates200>({
    url: `/templates/assistants`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetAssistantTemplatesQueryKey = (
  params?: GetAssistantTemplatesParams,
) => {
  return [`/templates/assistants`, ...(params ? [params] : [])] as const;
};

export const getGetAssistantTemplatesQueryOptions = <
  TData = Awaited<ReturnType<typeof getAssistantTemplates>>,
  TError = unknown,
>(
  params?: GetAssistantTemplatesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssistantTemplates>>,
        TError,
        TData
      >
    >;
  },
) => {
  const {query: queryOptions} = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAssistantTemplatesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAssistantTemplates>>
  > = ({signal}) => getAssistantTemplates(params, signal);

  return {queryKey, queryFn, ...queryOptions} as UseQueryOptions<
    Awaited<ReturnType<typeof getAssistantTemplates>>,
    TError,
    TData
  > & {queryKey: DataTag<QueryKey, TData, TError>};
};

export type GetAssistantTemplatesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAssistantTemplates>>
>;
export type GetAssistantTemplatesQueryError = unknown;

export function useGetAssistantTemplates<
  TData = Awaited<ReturnType<typeof getAssistantTemplates>>,
  TError = unknown,
>(
  params: undefined | GetAssistantTemplatesParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssistantTemplates>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAssistantTemplates>>,
          TError,
          Awaited<ReturnType<typeof getAssistantTemplates>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAssistantTemplates<
  TData = Awaited<ReturnType<typeof getAssistantTemplates>>,
  TError = unknown,
>(
  params?: GetAssistantTemplatesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssistantTemplates>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAssistantTemplates>>,
          TError,
          Awaited<ReturnType<typeof getAssistantTemplates>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};
export function useGetAssistantTemplates<
  TData = Awaited<ReturnType<typeof getAssistantTemplates>>,
  TError = unknown,
>(
  params?: GetAssistantTemplatesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssistantTemplates>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};

export function useGetAssistantTemplates<
  TData = Awaited<ReturnType<typeof getAssistantTemplates>>,
  TError = unknown,
>(
  params?: GetAssistantTemplatesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssistantTemplates>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetAssistantTemplatesQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & {queryKey: DataTag<QueryKey, TData, TError>};

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Gets list of agent templates
 */
export const getAssistantTemplateBySlug = (
  slug: string,
  signal?: AbortSignal,
) => {
  return axiosInstance<AssistantTemplate>({
    url: `/templates/assistants/${slug}`,
    method: "GET",
    signal,
  });
};

export const getGetAssistantTemplateBySlugQueryKey = (slug: string) => {
  return [`/templates/assistants/${slug}`] as const;
};

export const getGetAssistantTemplateBySlugQueryOptions = <
  TData = Awaited<ReturnType<typeof getAssistantTemplateBySlug>>,
  TError = unknown,
>(
  slug: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssistantTemplateBySlug>>,
        TError,
        TData
      >
    >;
  },
) => {
  const {query: queryOptions} = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAssistantTemplateBySlugQueryKey(slug);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAssistantTemplateBySlug>>
  > = ({signal}) => getAssistantTemplateBySlug(slug, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!slug,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getAssistantTemplateBySlug>>,
    TError,
    TData
  > & {queryKey: DataTag<QueryKey, TData, TError>};
};

export type GetAssistantTemplateBySlugQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAssistantTemplateBySlug>>
>;
export type GetAssistantTemplateBySlugQueryError = unknown;

export function useGetAssistantTemplateBySlug<
  TData = Awaited<ReturnType<typeof getAssistantTemplateBySlug>>,
  TError = unknown,
>(
  slug: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssistantTemplateBySlug>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAssistantTemplateBySlug>>,
          TError,
          Awaited<ReturnType<typeof getAssistantTemplateBySlug>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAssistantTemplateBySlug<
  TData = Awaited<ReturnType<typeof getAssistantTemplateBySlug>>,
  TError = unknown,
>(
  slug: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssistantTemplateBySlug>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAssistantTemplateBySlug>>,
          TError,
          Awaited<ReturnType<typeof getAssistantTemplateBySlug>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};
export function useGetAssistantTemplateBySlug<
  TData = Awaited<ReturnType<typeof getAssistantTemplateBySlug>>,
  TError = unknown,
>(
  slug: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssistantTemplateBySlug>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};

export function useGetAssistantTemplateBySlug<
  TData = Awaited<ReturnType<typeof getAssistantTemplateBySlug>>,
  TError = unknown,
>(
  slug: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssistantTemplateBySlug>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetAssistantTemplateBySlugQueryOptions(slug, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & {queryKey: DataTag<QueryKey, TData, TError>};

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const createAssistantFromTemplateSlug = (
  slug: string,
  createAssistantFromTemplateSlugBody: CreateAssistantFromTemplateSlugBody,
  params?: CreateAssistantFromTemplateSlugParams,
  signal?: AbortSignal,
) => {
  return axiosInstance<CreateResult>({
    url: `/templates/assistants/${slug}`,
    method: "POST",
    headers: {"Content-Type": "application/json"},
    data: createAssistantFromTemplateSlugBody,
    params,
    signal,
  });
};

export const getCreateAssistantFromTemplateSlugMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createAssistantFromTemplateSlug>>,
    TError,
    {
      slug: string;
      data: CreateAssistantFromTemplateSlugBody;
      params?: CreateAssistantFromTemplateSlugParams;
    },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createAssistantFromTemplateSlug>>,
  TError,
  {
    slug: string;
    data: CreateAssistantFromTemplateSlugBody;
    params?: CreateAssistantFromTemplateSlugParams;
  },
  TContext
> => {
  const mutationKey = ["createAssistantFromTemplateSlug"];
  const {mutation: mutationOptions} = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : {...options, mutation: {...options.mutation, mutationKey}}
    : {mutation: {mutationKey}};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createAssistantFromTemplateSlug>>,
    {
      slug: string;
      data: CreateAssistantFromTemplateSlugBody;
      params?: CreateAssistantFromTemplateSlugParams;
    }
  > = props => {
    const {slug, data, params} = props ?? {};

    return createAssistantFromTemplateSlug(slug, data, params);
  };

  return {mutationFn, ...mutationOptions};
};

export type CreateAssistantFromTemplateSlugMutationResult = NonNullable<
  Awaited<ReturnType<typeof createAssistantFromTemplateSlug>>
>;
export type CreateAssistantFromTemplateSlugMutationBody =
  CreateAssistantFromTemplateSlugBody;
export type CreateAssistantFromTemplateSlugMutationError = void;

export const useCreateAssistantFromTemplateSlug = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createAssistantFromTemplateSlug>>,
      TError,
      {
        slug: string;
        data: CreateAssistantFromTemplateSlugBody;
        params?: CreateAssistantFromTemplateSlugParams;
      },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createAssistantFromTemplateSlug>>,
  TError,
  {
    slug: string;
    data: CreateAssistantFromTemplateSlugBody;
    params?: CreateAssistantFromTemplateSlugParams;
  },
  TContext
> => {
  const mutationOptions =
    getCreateAssistantFromTemplateSlugMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Rate the assistant template
 */
export const rateAssistantTemplate = (
  slug: string,
  userRating: UserRating,
  signal?: AbortSignal,
) => {
  return axiosInstance<void>({
    url: `/templates/assistants/${slug}/rating`,
    method: "POST",
    headers: {"Content-Type": "application/json"},
    data: userRating,
    signal,
  });
};

export const getRateAssistantTemplateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof rateAssistantTemplate>>,
    TError,
    {slug: string; data: UserRating},
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof rateAssistantTemplate>>,
  TError,
  {slug: string; data: UserRating},
  TContext
> => {
  const mutationKey = ["rateAssistantTemplate"];
  const {mutation: mutationOptions} = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : {...options, mutation: {...options.mutation, mutationKey}}
    : {mutation: {mutationKey}};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof rateAssistantTemplate>>,
    {slug: string; data: UserRating}
  > = props => {
    const {slug, data} = props ?? {};

    return rateAssistantTemplate(slug, data);
  };

  return {mutationFn, ...mutationOptions};
};

export type RateAssistantTemplateMutationResult = NonNullable<
  Awaited<ReturnType<typeof rateAssistantTemplate>>
>;
export type RateAssistantTemplateMutationBody = UserRating;
export type RateAssistantTemplateMutationError = unknown;

export const useRateAssistantTemplate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof rateAssistantTemplate>>,
      TError,
      {slug: string; data: UserRating},
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof rateAssistantTemplate>>,
  TError,
  {slug: string; data: UserRating},
  TContext
> => {
  const mutationOptions = getRateAssistantTemplateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Chat bot simulator for assistant
 */
export const chatSimulator = (
  assistantId: string,
  textMessage: TextMessage,
  signal?: AbortSignal,
) => {
  return axiosInstance<TextMessage>({
    url: `/assistants/${assistantId}/chat`,
    method: "POST",
    headers: {"Content-Type": "application/json"},
    data: textMessage,
    signal,
  });
};

export const getChatSimulatorMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof chatSimulator>>,
    TError,
    {assistantId: string; data: TextMessage},
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof chatSimulator>>,
  TError,
  {assistantId: string; data: TextMessage},
  TContext
> => {
  const mutationKey = ["chatSimulator"];
  const {mutation: mutationOptions} = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : {...options, mutation: {...options.mutation, mutationKey}}
    : {mutation: {mutationKey}};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof chatSimulator>>,
    {assistantId: string; data: TextMessage}
  > = props => {
    const {assistantId, data} = props ?? {};

    return chatSimulator(assistantId, data);
  };

  return {mutationFn, ...mutationOptions};
};

export type ChatSimulatorMutationResult = NonNullable<
  Awaited<ReturnType<typeof chatSimulator>>
>;
export type ChatSimulatorMutationBody = TextMessage;
export type ChatSimulatorMutationError = unknown;

export const useChatSimulator = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof chatSimulator>>,
      TError,
      {assistantId: string; data: TextMessage},
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof chatSimulator>>,
  TError,
  {assistantId: string; data: TextMessage},
  TContext
> => {
  const mutationOptions = getChatSimulatorMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Gets the history of chat with the agent
 */
export const getChatHistory = (
  assistantId: string,
  params?: GetChatHistoryParams,
  signal?: AbortSignal,
) => {
  return axiosInstance<GetChatHistory200>({
    url: `/assistants/${assistantId}/chat`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetChatHistoryQueryKey = (
  assistantId: string,
  params?: GetChatHistoryParams,
) => {
  return [
    `/assistants/${assistantId}/chat`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetChatHistoryQueryOptions = <
  TData = Awaited<ReturnType<typeof getChatHistory>>,
  TError = unknown,
>(
  assistantId: string,
  params?: GetChatHistoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getChatHistory>>, TError, TData>
    >;
  },
) => {
  const {query: queryOptions} = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetChatHistoryQueryKey(assistantId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getChatHistory>>> = ({
    signal,
  }) => getChatHistory(assistantId, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!assistantId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getChatHistory>>,
    TError,
    TData
  > & {queryKey: DataTag<QueryKey, TData, TError>};
};

export type GetChatHistoryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getChatHistory>>
>;
export type GetChatHistoryQueryError = unknown;

export function useGetChatHistory<
  TData = Awaited<ReturnType<typeof getChatHistory>>,
  TError = unknown,
>(
  assistantId: string,
  params: undefined | GetChatHistoryParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getChatHistory>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getChatHistory>>,
          TError,
          Awaited<ReturnType<typeof getChatHistory>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetChatHistory<
  TData = Awaited<ReturnType<typeof getChatHistory>>,
  TError = unknown,
>(
  assistantId: string,
  params?: GetChatHistoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getChatHistory>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getChatHistory>>,
          TError,
          Awaited<ReturnType<typeof getChatHistory>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};
export function useGetChatHistory<
  TData = Awaited<ReturnType<typeof getChatHistory>>,
  TError = unknown,
>(
  assistantId: string,
  params?: GetChatHistoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getChatHistory>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};

export function useGetChatHistory<
  TData = Awaited<ReturnType<typeof getChatHistory>>,
  TError = unknown,
>(
  assistantId: string,
  params?: GetChatHistoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getChatHistory>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetChatHistoryQueryOptions(
    assistantId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & {queryKey: DataTag<QueryKey, TData, TError>};

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Gets the history of chat with the agent
 */
export const getChatMessages = (
  assistantId: string,
  contextId: string,
  signal?: AbortSignal,
) => {
  return axiosInstance<ChatHistory>({
    url: `/assistants/${assistantId}/chat/${contextId}`,
    method: "GET",
    signal,
  });
};

export const getGetChatMessagesQueryKey = (
  assistantId: string,
  contextId: string,
) => {
  return [`/assistants/${assistantId}/chat/${contextId}`] as const;
};

export const getGetChatMessagesQueryOptions = <
  TData = Awaited<ReturnType<typeof getChatMessages>>,
  TError = void,
>(
  assistantId: string,
  contextId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getChatMessages>>,
        TError,
        TData
      >
    >;
  },
) => {
  const {query: queryOptions} = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetChatMessagesQueryKey(assistantId, contextId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getChatMessages>>> = ({
    signal,
  }) => getChatMessages(assistantId, contextId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(assistantId && contextId),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getChatMessages>>,
    TError,
    TData
  > & {queryKey: DataTag<QueryKey, TData, TError>};
};

export type GetChatMessagesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getChatMessages>>
>;
export type GetChatMessagesQueryError = void;

export function useGetChatMessages<
  TData = Awaited<ReturnType<typeof getChatMessages>>,
  TError = void,
>(
  assistantId: string,
  contextId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getChatMessages>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getChatMessages>>,
          TError,
          Awaited<ReturnType<typeof getChatMessages>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetChatMessages<
  TData = Awaited<ReturnType<typeof getChatMessages>>,
  TError = void,
>(
  assistantId: string,
  contextId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getChatMessages>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getChatMessages>>,
          TError,
          Awaited<ReturnType<typeof getChatMessages>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};
export function useGetChatMessages<
  TData = Awaited<ReturnType<typeof getChatMessages>>,
  TError = void,
>(
  assistantId: string,
  contextId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getChatMessages>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};

export function useGetChatMessages<
  TData = Awaited<ReturnType<typeof getChatMessages>>,
  TError = void,
>(
  assistantId: string,
  contextId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getChatMessages>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetChatMessagesQueryOptions(
    assistantId,
    contextId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & {queryKey: DataTag<QueryKey, TData, TError>};

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Deletes a simulation by getting context id
 */
export const deleteChatMessages = (assistantId: string, contextId: string) => {
  return axiosInstance<void>({
    url: `/assistants/${assistantId}/chat/${contextId}`,
    method: "DELETE",
  });
};

export const getDeleteChatMessagesMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteChatMessages>>,
    TError,
    {assistantId: string; contextId: string},
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteChatMessages>>,
  TError,
  {assistantId: string; contextId: string},
  TContext
> => {
  const mutationKey = ["deleteChatMessages"];
  const {mutation: mutationOptions} = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : {...options, mutation: {...options.mutation, mutationKey}}
    : {mutation: {mutationKey}};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteChatMessages>>,
    {assistantId: string; contextId: string}
  > = props => {
    const {assistantId, contextId} = props ?? {};

    return deleteChatMessages(assistantId, contextId);
  };

  return {mutationFn, ...mutationOptions};
};

export type DeleteChatMessagesMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteChatMessages>>
>;

export type DeleteChatMessagesMutationError = void;

export const useDeleteChatMessages = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteChatMessages>>,
      TError,
      {assistantId: string; contextId: string},
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteChatMessages>>,
  TError,
  {assistantId: string; contextId: string},
  TContext
> => {
  const mutationOptions = getDeleteChatMessagesMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Validates an FSM definition for an assistant. The request body should be the raw FSM definition object.
 */
export const validateAssistantFSM = (
  assistantId: string,
  validateAssistantFSMBody: ValidateAssistantFSMBody,
  signal?: AbortSignal,
) => {
  return axiosInstance<FSMValidationResponse>({
    url: `/assistants/${assistantId}/fsm/validate`,
    method: "POST",
    headers: {"Content-Type": "application/json"},
    data: validateAssistantFSMBody,
    signal,
  });
};

export const getValidateAssistantFSMMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof validateAssistantFSM>>,
    TError,
    {assistantId: string; data: ValidateAssistantFSMBody},
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof validateAssistantFSM>>,
  TError,
  {assistantId: string; data: ValidateAssistantFSMBody},
  TContext
> => {
  const mutationKey = ["validateAssistantFSM"];
  const {mutation: mutationOptions} = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : {...options, mutation: {...options.mutation, mutationKey}}
    : {mutation: {mutationKey}};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof validateAssistantFSM>>,
    {assistantId: string; data: ValidateAssistantFSMBody}
  > = props => {
    const {assistantId, data} = props ?? {};

    return validateAssistantFSM(assistantId, data);
  };

  return {mutationFn, ...mutationOptions};
};

export type ValidateAssistantFSMMutationResult = NonNullable<
  Awaited<ReturnType<typeof validateAssistantFSM>>
>;
export type ValidateAssistantFSMMutationBody = ValidateAssistantFSMBody;
export type ValidateAssistantFSMMutationError = void;

export const useValidateAssistantFSM = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof validateAssistantFSM>>,
      TError,
      {assistantId: string; data: ValidateAssistantFSMBody},
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof validateAssistantFSM>>,
  TError,
  {assistantId: string; data: ValidateAssistantFSMBody},
  TContext
> => {
  const mutationOptions = getValidateAssistantFSMMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Gets the list of phone books
 */
export const getPhoneBookList = (
  params: GetPhoneBookListParams,
  signal?: AbortSignal,
) => {
  return axiosInstance<GetPhoneBookList200>({
    url: `/phonebooks`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetPhoneBookListQueryKey = (params: GetPhoneBookListParams) => {
  return [`/phonebooks`, ...(params ? [params] : [])] as const;
};

export const getGetPhoneBookListQueryOptions = <
  TData = Awaited<ReturnType<typeof getPhoneBookList>>,
  TError = unknown,
>(
  params: GetPhoneBookListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPhoneBookList>>,
        TError,
        TData
      >
    >;
  },
) => {
  const {query: queryOptions} = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetPhoneBookListQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPhoneBookList>>
  > = ({signal}) => getPhoneBookList(params, signal);

  return {queryKey, queryFn, ...queryOptions} as UseQueryOptions<
    Awaited<ReturnType<typeof getPhoneBookList>>,
    TError,
    TData
  > & {queryKey: DataTag<QueryKey, TData, TError>};
};

export type GetPhoneBookListQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPhoneBookList>>
>;
export type GetPhoneBookListQueryError = unknown;

export function useGetPhoneBookList<
  TData = Awaited<ReturnType<typeof getPhoneBookList>>,
  TError = unknown,
>(
  params: GetPhoneBookListParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPhoneBookList>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPhoneBookList>>,
          TError,
          Awaited<ReturnType<typeof getPhoneBookList>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPhoneBookList<
  TData = Awaited<ReturnType<typeof getPhoneBookList>>,
  TError = unknown,
>(
  params: GetPhoneBookListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPhoneBookList>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPhoneBookList>>,
          TError,
          Awaited<ReturnType<typeof getPhoneBookList>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};
export function useGetPhoneBookList<
  TData = Awaited<ReturnType<typeof getPhoneBookList>>,
  TError = unknown,
>(
  params: GetPhoneBookListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPhoneBookList>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};

export function useGetPhoneBookList<
  TData = Awaited<ReturnType<typeof getPhoneBookList>>,
  TError = unknown,
>(
  params: GetPhoneBookListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPhoneBookList>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetPhoneBookListQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & {queryKey: DataTag<QueryKey, TData, TError>};

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Creates a phone book
 */
export const createPhoneBook = (
  createPhoneBookRequest: CreatePhoneBookRequest,
  signal?: AbortSignal,
) => {
  return axiosInstance<CreateResult>({
    url: `/phonebooks`,
    method: "POST",
    headers: {"Content-Type": "application/json"},
    data: createPhoneBookRequest,
    signal,
  });
};

export const getCreatePhoneBookMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createPhoneBook>>,
    TError,
    {data: CreatePhoneBookRequest},
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createPhoneBook>>,
  TError,
  {data: CreatePhoneBookRequest},
  TContext
> => {
  const mutationKey = ["createPhoneBook"];
  const {mutation: mutationOptions} = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : {...options, mutation: {...options.mutation, mutationKey}}
    : {mutation: {mutationKey}};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createPhoneBook>>,
    {data: CreatePhoneBookRequest}
  > = props => {
    const {data} = props ?? {};

    return createPhoneBook(data);
  };

  return {mutationFn, ...mutationOptions};
};

export type CreatePhoneBookMutationResult = NonNullable<
  Awaited<ReturnType<typeof createPhoneBook>>
>;
export type CreatePhoneBookMutationBody = CreatePhoneBookRequest;
export type CreatePhoneBookMutationError = void;

export const useCreatePhoneBook = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createPhoneBook>>,
      TError,
      {data: CreatePhoneBookRequest},
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createPhoneBook>>,
  TError,
  {data: CreatePhoneBookRequest},
  TContext
> => {
  const mutationOptions = getCreatePhoneBookMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Deletes a phone book
 */
export const deletePhoneBook = (slug: string) => {
  return axiosInstance<void>({url: `/phonebooks/${slug}`, method: "DELETE"});
};

export const getDeletePhoneBookMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deletePhoneBook>>,
    TError,
    {slug: string},
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deletePhoneBook>>,
  TError,
  {slug: string},
  TContext
> => {
  const mutationKey = ["deletePhoneBook"];
  const {mutation: mutationOptions} = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : {...options, mutation: {...options.mutation, mutationKey}}
    : {mutation: {mutationKey}};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deletePhoneBook>>,
    {slug: string}
  > = props => {
    const {slug} = props ?? {};

    return deletePhoneBook(slug);
  };

  return {mutationFn, ...mutationOptions};
};

export type DeletePhoneBookMutationResult = NonNullable<
  Awaited<ReturnType<typeof deletePhoneBook>>
>;

export type DeletePhoneBookMutationError = void;

export const useDeletePhoneBook = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deletePhoneBook>>,
      TError,
      {slug: string},
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deletePhoneBook>>,
  TError,
  {slug: string},
  TContext
> => {
  const mutationOptions = getDeletePhoneBookMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Updates a phone book
 */
export const updatePhoneBook = (
  slug: string,
  updatePhoneBookRequest: UpdatePhoneBookRequest,
) => {
  return axiosInstance<void>({
    url: `/phonebooks/${slug}`,
    method: "PATCH",
    headers: {"Content-Type": "application/json"},
    data: updatePhoneBookRequest,
  });
};

export const getUpdatePhoneBookMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updatePhoneBook>>,
    TError,
    {slug: string; data: UpdatePhoneBookRequest},
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updatePhoneBook>>,
  TError,
  {slug: string; data: UpdatePhoneBookRequest},
  TContext
> => {
  const mutationKey = ["updatePhoneBook"];
  const {mutation: mutationOptions} = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : {...options, mutation: {...options.mutation, mutationKey}}
    : {mutation: {mutationKey}};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updatePhoneBook>>,
    {slug: string; data: UpdatePhoneBookRequest}
  > = props => {
    const {slug, data} = props ?? {};

    return updatePhoneBook(slug, data);
  };

  return {mutationFn, ...mutationOptions};
};

export type UpdatePhoneBookMutationResult = NonNullable<
  Awaited<ReturnType<typeof updatePhoneBook>>
>;
export type UpdatePhoneBookMutationBody = UpdatePhoneBookRequest;
export type UpdatePhoneBookMutationError = void;

export const useUpdatePhoneBook = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updatePhoneBook>>,
      TError,
      {slug: string; data: UpdatePhoneBookRequest},
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updatePhoneBook>>,
  TError,
  {slug: string; data: UpdatePhoneBookRequest},
  TContext
> => {
  const mutationOptions = getUpdatePhoneBookMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Gets the list of phone book entries
 */
export const getPhoneBookEntries = (
  slug: string,
  params?: GetPhoneBookEntriesParams,
  signal?: AbortSignal,
) => {
  return axiosInstance<GetPhoneBookEntries200>({
    url: `/phonebooks/${slug}/entries`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetPhoneBookEntriesQueryKey = (
  slug: string,
  params?: GetPhoneBookEntriesParams,
) => {
  return [`/phonebooks/${slug}/entries`, ...(params ? [params] : [])] as const;
};

export const getGetPhoneBookEntriesQueryOptions = <
  TData = Awaited<ReturnType<typeof getPhoneBookEntries>>,
  TError = unknown,
>(
  slug: string,
  params?: GetPhoneBookEntriesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPhoneBookEntries>>,
        TError,
        TData
      >
    >;
  },
) => {
  const {query: queryOptions} = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetPhoneBookEntriesQueryKey(slug, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPhoneBookEntries>>
  > = ({signal}) => getPhoneBookEntries(slug, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!slug,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getPhoneBookEntries>>,
    TError,
    TData
  > & {queryKey: DataTag<QueryKey, TData, TError>};
};

export type GetPhoneBookEntriesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPhoneBookEntries>>
>;
export type GetPhoneBookEntriesQueryError = unknown;

export function useGetPhoneBookEntries<
  TData = Awaited<ReturnType<typeof getPhoneBookEntries>>,
  TError = unknown,
>(
  slug: string,
  params: undefined | GetPhoneBookEntriesParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPhoneBookEntries>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPhoneBookEntries>>,
          TError,
          Awaited<ReturnType<typeof getPhoneBookEntries>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPhoneBookEntries<
  TData = Awaited<ReturnType<typeof getPhoneBookEntries>>,
  TError = unknown,
>(
  slug: string,
  params?: GetPhoneBookEntriesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPhoneBookEntries>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPhoneBookEntries>>,
          TError,
          Awaited<ReturnType<typeof getPhoneBookEntries>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};
export function useGetPhoneBookEntries<
  TData = Awaited<ReturnType<typeof getPhoneBookEntries>>,
  TError = unknown,
>(
  slug: string,
  params?: GetPhoneBookEntriesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPhoneBookEntries>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};

export function useGetPhoneBookEntries<
  TData = Awaited<ReturnType<typeof getPhoneBookEntries>>,
  TError = unknown,
>(
  slug: string,
  params?: GetPhoneBookEntriesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPhoneBookEntries>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetPhoneBookEntriesQueryOptions(
    slug,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & {queryKey: DataTag<QueryKey, TData, TError>};

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Deletes a phone book entry
 */
export const deletePhoneBookEntry = (slug: string) => {
  return axiosInstance<void>({
    url: `/phonebook-entry/${slug}`,
    method: "DELETE",
  });
};

export const getDeletePhoneBookEntryMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deletePhoneBookEntry>>,
    TError,
    {slug: string},
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deletePhoneBookEntry>>,
  TError,
  {slug: string},
  TContext
> => {
  const mutationKey = ["deletePhoneBookEntry"];
  const {mutation: mutationOptions} = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : {...options, mutation: {...options.mutation, mutationKey}}
    : {mutation: {mutationKey}};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deletePhoneBookEntry>>,
    {slug: string}
  > = props => {
    const {slug} = props ?? {};

    return deletePhoneBookEntry(slug);
  };

  return {mutationFn, ...mutationOptions};
};

export type DeletePhoneBookEntryMutationResult = NonNullable<
  Awaited<ReturnType<typeof deletePhoneBookEntry>>
>;

export type DeletePhoneBookEntryMutationError = void;

export const useDeletePhoneBookEntry = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deletePhoneBookEntry>>,
      TError,
      {slug: string},
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deletePhoneBookEntry>>,
  TError,
  {slug: string},
  TContext
> => {
  const mutationOptions = getDeletePhoneBookEntryMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Creates a phone book entry
 */
export const createPhoneBookEntry = (
  createPhoneBookEntryRequest: CreatePhoneBookEntryRequest,
  signal?: AbortSignal,
) => {
  return axiosInstance<CreateResult>({
    url: `/phonebook-entry`,
    method: "POST",
    headers: {"Content-Type": "application/json"},
    data: createPhoneBookEntryRequest,
    signal,
  });
};

export const getCreatePhoneBookEntryMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createPhoneBookEntry>>,
    TError,
    {data: CreatePhoneBookEntryRequest},
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createPhoneBookEntry>>,
  TError,
  {data: CreatePhoneBookEntryRequest},
  TContext
> => {
  const mutationKey = ["createPhoneBookEntry"];
  const {mutation: mutationOptions} = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : {...options, mutation: {...options.mutation, mutationKey}}
    : {mutation: {mutationKey}};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createPhoneBookEntry>>,
    {data: CreatePhoneBookEntryRequest}
  > = props => {
    const {data} = props ?? {};

    return createPhoneBookEntry(data);
  };

  return {mutationFn, ...mutationOptions};
};

export type CreatePhoneBookEntryMutationResult = NonNullable<
  Awaited<ReturnType<typeof createPhoneBookEntry>>
>;
export type CreatePhoneBookEntryMutationBody = CreatePhoneBookEntryRequest;
export type CreatePhoneBookEntryMutationError = void;

export const useCreatePhoneBookEntry = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createPhoneBookEntry>>,
      TError,
      {data: CreatePhoneBookEntryRequest},
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createPhoneBookEntry>>,
  TError,
  {data: CreatePhoneBookEntryRequest},
  TContext
> => {
  const mutationOptions = getCreatePhoneBookEntryMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Gets the list of actions
 */
export const getActionList = (
  params: GetActionListParams,
  signal?: AbortSignal,
) => {
  return axiosInstance<GetActionList200>({
    url: `/actions`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetActionListQueryKey = (params: GetActionListParams) => {
  return [`/actions`, ...(params ? [params] : [])] as const;
};

export const getGetActionListQueryOptions = <
  TData = Awaited<ReturnType<typeof getActionList>>,
  TError = unknown,
>(
  params: GetActionListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getActionList>>, TError, TData>
    >;
  },
) => {
  const {query: queryOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetActionListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getActionList>>> = ({
    signal,
  }) => getActionList(params, signal);

  return {queryKey, queryFn, ...queryOptions} as UseQueryOptions<
    Awaited<ReturnType<typeof getActionList>>,
    TError,
    TData
  > & {queryKey: DataTag<QueryKey, TData, TError>};
};

export type GetActionListQueryResult = NonNullable<
  Awaited<ReturnType<typeof getActionList>>
>;
export type GetActionListQueryError = unknown;

export function useGetActionList<
  TData = Awaited<ReturnType<typeof getActionList>>,
  TError = unknown,
>(
  params: GetActionListParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getActionList>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActionList>>,
          TError,
          Awaited<ReturnType<typeof getActionList>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetActionList<
  TData = Awaited<ReturnType<typeof getActionList>>,
  TError = unknown,
>(
  params: GetActionListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getActionList>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActionList>>,
          TError,
          Awaited<ReturnType<typeof getActionList>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};
export function useGetActionList<
  TData = Awaited<ReturnType<typeof getActionList>>,
  TError = unknown,
>(
  params: GetActionListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getActionList>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};

export function useGetActionList<
  TData = Awaited<ReturnType<typeof getActionList>>,
  TError = unknown,
>(
  params: GetActionListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getActionList>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetActionListQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & {queryKey: DataTag<QueryKey, TData, TError>};

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Creates an action
 */
export const createAction = (
  action: NonReadonly<Action>,
  signal?: AbortSignal,
) => {
  return axiosInstance<CreateResult>({
    url: `/actions`,
    method: "POST",
    headers: {"Content-Type": "application/json"},
    data: action,
    signal,
  });
};

export const getCreateActionMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createAction>>,
    TError,
    {data: NonReadonly<Action>},
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createAction>>,
  TError,
  {data: NonReadonly<Action>},
  TContext
> => {
  const mutationKey = ["createAction"];
  const {mutation: mutationOptions} = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : {...options, mutation: {...options.mutation, mutationKey}}
    : {mutation: {mutationKey}};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createAction>>,
    {data: NonReadonly<Action>}
  > = props => {
    const {data} = props ?? {};

    return createAction(data);
  };

  return {mutationFn, ...mutationOptions};
};

export type CreateActionMutationResult = NonNullable<
  Awaited<ReturnType<typeof createAction>>
>;
export type CreateActionMutationBody = NonReadonly<Action>;
export type CreateActionMutationError = void;

export const useCreateAction = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createAction>>,
      TError,
      {data: NonReadonly<Action>},
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createAction>>,
  TError,
  {data: NonReadonly<Action>},
  TContext
> => {
  const mutationOptions = getCreateActionMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Validates the configuration of an action, such as checking API keys or specific settings for a given action type.
 * @summary Validate Action Configuration
 */
export const validateAction = (
  validateActionInputDTO: ValidateActionInputDTO,
  signal?: AbortSignal,
) => {
  return axiosInstance<ValidateActionResponse>({
    url: `/actions/credentials/validate`,
    method: "POST",
    headers: {"Content-Type": "application/json"},
    data: validateActionInputDTO,
    signal,
  });
};

export const getValidateActionMutationOptions = <
  TError = ErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof validateAction>>,
    TError,
    {data: ValidateActionInputDTO},
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof validateAction>>,
  TError,
  {data: ValidateActionInputDTO},
  TContext
> => {
  const mutationKey = ["validateAction"];
  const {mutation: mutationOptions} = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : {...options, mutation: {...options.mutation, mutationKey}}
    : {mutation: {mutationKey}};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof validateAction>>,
    {data: ValidateActionInputDTO}
  > = props => {
    const {data} = props ?? {};

    return validateAction(data);
  };

  return {mutationFn, ...mutationOptions};
};

export type ValidateActionMutationResult = NonNullable<
  Awaited<ReturnType<typeof validateAction>>
>;
export type ValidateActionMutationBody = ValidateActionInputDTO;
export type ValidateActionMutationError = ErrorResponse;

/**
 * @summary Validate Action Configuration
 */
export const useValidateAction = <TError = ErrorResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof validateAction>>,
      TError,
      {data: ValidateActionInputDTO},
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof validateAction>>,
  TError,
  {data: ValidateActionInputDTO},
  TContext
> => {
  const mutationOptions = getValidateActionMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Get action template items to be used to create new actions
 */
export const getActionTemplates = (
  params?: GetActionTemplatesParams,
  signal?: AbortSignal,
) => {
  return axiosInstance<GetActionTemplates200>({
    url: `/templates/actions`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetActionTemplatesQueryKey = (
  params?: GetActionTemplatesParams,
) => {
  return [`/templates/actions`, ...(params ? [params] : [])] as const;
};

export const getGetActionTemplatesQueryOptions = <
  TData = Awaited<ReturnType<typeof getActionTemplates>>,
  TError = unknown,
>(
  params?: GetActionTemplatesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getActionTemplates>>,
        TError,
        TData
      >
    >;
  },
) => {
  const {query: queryOptions} = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetActionTemplatesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getActionTemplates>>
  > = ({signal}) => getActionTemplates(params, signal);

  return {queryKey, queryFn, ...queryOptions} as UseQueryOptions<
    Awaited<ReturnType<typeof getActionTemplates>>,
    TError,
    TData
  > & {queryKey: DataTag<QueryKey, TData, TError>};
};

export type GetActionTemplatesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getActionTemplates>>
>;
export type GetActionTemplatesQueryError = unknown;

export function useGetActionTemplates<
  TData = Awaited<ReturnType<typeof getActionTemplates>>,
  TError = unknown,
>(
  params: undefined | GetActionTemplatesParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getActionTemplates>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActionTemplates>>,
          TError,
          Awaited<ReturnType<typeof getActionTemplates>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetActionTemplates<
  TData = Awaited<ReturnType<typeof getActionTemplates>>,
  TError = unknown,
>(
  params?: GetActionTemplatesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getActionTemplates>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActionTemplates>>,
          TError,
          Awaited<ReturnType<typeof getActionTemplates>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};
export function useGetActionTemplates<
  TData = Awaited<ReturnType<typeof getActionTemplates>>,
  TError = unknown,
>(
  params?: GetActionTemplatesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getActionTemplates>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};

export function useGetActionTemplates<
  TData = Awaited<ReturnType<typeof getActionTemplates>>,
  TError = unknown,
>(
  params?: GetActionTemplatesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getActionTemplates>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetActionTemplatesQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & {queryKey: DataTag<QueryKey, TData, TError>};

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Gets a special action template
 */
export const getActionTemplateBySlug = (
  slug: string,
  params?: GetActionTemplateBySlugParams,
  signal?: AbortSignal,
) => {
  return axiosInstance<CustomActionTemplateSummary>({
    url: `/templates/actions/${slug}`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetActionTemplateBySlugQueryKey = (
  slug: string,
  params?: GetActionTemplateBySlugParams,
) => {
  return [`/templates/actions/${slug}`, ...(params ? [params] : [])] as const;
};

export const getGetActionTemplateBySlugQueryOptions = <
  TData = Awaited<ReturnType<typeof getActionTemplateBySlug>>,
  TError = unknown,
>(
  slug: string,
  params?: GetActionTemplateBySlugParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getActionTemplateBySlug>>,
        TError,
        TData
      >
    >;
  },
) => {
  const {query: queryOptions} = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetActionTemplateBySlugQueryKey(slug, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getActionTemplateBySlug>>
  > = ({signal}) => getActionTemplateBySlug(slug, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!slug,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getActionTemplateBySlug>>,
    TError,
    TData
  > & {queryKey: DataTag<QueryKey, TData, TError>};
};

export type GetActionTemplateBySlugQueryResult = NonNullable<
  Awaited<ReturnType<typeof getActionTemplateBySlug>>
>;
export type GetActionTemplateBySlugQueryError = unknown;

export function useGetActionTemplateBySlug<
  TData = Awaited<ReturnType<typeof getActionTemplateBySlug>>,
  TError = unknown,
>(
  slug: string,
  params: undefined | GetActionTemplateBySlugParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getActionTemplateBySlug>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActionTemplateBySlug>>,
          TError,
          Awaited<ReturnType<typeof getActionTemplateBySlug>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetActionTemplateBySlug<
  TData = Awaited<ReturnType<typeof getActionTemplateBySlug>>,
  TError = unknown,
>(
  slug: string,
  params?: GetActionTemplateBySlugParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getActionTemplateBySlug>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActionTemplateBySlug>>,
          TError,
          Awaited<ReturnType<typeof getActionTemplateBySlug>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};
export function useGetActionTemplateBySlug<
  TData = Awaited<ReturnType<typeof getActionTemplateBySlug>>,
  TError = unknown,
>(
  slug: string,
  params?: GetActionTemplateBySlugParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getActionTemplateBySlug>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};

export function useGetActionTemplateBySlug<
  TData = Awaited<ReturnType<typeof getActionTemplateBySlug>>,
  TError = unknown,
>(
  slug: string,
  params?: GetActionTemplateBySlugParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getActionTemplateBySlug>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetActionTemplateBySlugQueryOptions(
    slug,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & {queryKey: DataTag<QueryKey, TData, TError>};

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Creates a new action using the specified template slug
 */
export const createActionFromTemplate = (
  slug: string,
  createActionFromTemplateBody: CreateActionFromTemplateBody,
  params?: CreateActionFromTemplateParams,
  signal?: AbortSignal,
) => {
  return axiosInstance<CreateResult>({
    url: `/templates/actions/${slug}`,
    method: "POST",
    headers: {"Content-Type": "application/json"},
    data: createActionFromTemplateBody,
    params,
    signal,
  });
};

export const getCreateActionFromTemplateMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createActionFromTemplate>>,
    TError,
    {
      slug: string;
      data: CreateActionFromTemplateBody;
      params?: CreateActionFromTemplateParams;
    },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createActionFromTemplate>>,
  TError,
  {
    slug: string;
    data: CreateActionFromTemplateBody;
    params?: CreateActionFromTemplateParams;
  },
  TContext
> => {
  const mutationKey = ["createActionFromTemplate"];
  const {mutation: mutationOptions} = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : {...options, mutation: {...options.mutation, mutationKey}}
    : {mutation: {mutationKey}};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createActionFromTemplate>>,
    {
      slug: string;
      data: CreateActionFromTemplateBody;
      params?: CreateActionFromTemplateParams;
    }
  > = props => {
    const {slug, data, params} = props ?? {};

    return createActionFromTemplate(slug, data, params);
  };

  return {mutationFn, ...mutationOptions};
};

export type CreateActionFromTemplateMutationResult = NonNullable<
  Awaited<ReturnType<typeof createActionFromTemplate>>
>;
export type CreateActionFromTemplateMutationBody = CreateActionFromTemplateBody;
export type CreateActionFromTemplateMutationError = void;

export const useCreateActionFromTemplate = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createActionFromTemplate>>,
      TError,
      {
        slug: string;
        data: CreateActionFromTemplateBody;
        params?: CreateActionFromTemplateParams;
      },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createActionFromTemplate>>,
  TError,
  {
    slug: string;
    data: CreateActionFromTemplateBody;
    params?: CreateActionFromTemplateParams;
  },
  TContext
> => {
  const mutationOptions = getCreateActionFromTemplateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Rate the action template
 */
export const rateActionTemplate = (
  slug: string,
  userRating: UserRating,
  signal?: AbortSignal,
) => {
  return axiosInstance<void>({
    url: `/templates/actions/${slug}/rating`,
    method: "POST",
    headers: {"Content-Type": "application/json"},
    data: userRating,
    signal,
  });
};

export const getRateActionTemplateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof rateActionTemplate>>,
    TError,
    {slug: string; data: UserRating},
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof rateActionTemplate>>,
  TError,
  {slug: string; data: UserRating},
  TContext
> => {
  const mutationKey = ["rateActionTemplate"];
  const {mutation: mutationOptions} = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : {...options, mutation: {...options.mutation, mutationKey}}
    : {mutation: {mutationKey}};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof rateActionTemplate>>,
    {slug: string; data: UserRating}
  > = props => {
    const {slug, data} = props ?? {};

    return rateActionTemplate(slug, data);
  };

  return {mutationFn, ...mutationOptions};
};

export type RateActionTemplateMutationResult = NonNullable<
  Awaited<ReturnType<typeof rateActionTemplate>>
>;
export type RateActionTemplateMutationBody = UserRating;
export type RateActionTemplateMutationError = unknown;

export const useRateActionTemplate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof rateActionTemplate>>,
      TError,
      {slug: string; data: UserRating},
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof rateActionTemplate>>,
  TError,
  {slug: string; data: UserRating},
  TContext
> => {
  const mutationOptions = getRateActionTemplateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Gets the created actions summary
 */
export const getActionListSummary = (
  params: GetActionListSummaryParams,
  signal?: AbortSignal,
) => {
  return axiosInstance<ActionListSummary>({
    url: `/actions/summary`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetActionListSummaryQueryKey = (
  params: GetActionListSummaryParams,
) => {
  return [`/actions/summary`, ...(params ? [params] : [])] as const;
};

export const getGetActionListSummaryQueryOptions = <
  TData = Awaited<ReturnType<typeof getActionListSummary>>,
  TError = unknown,
>(
  params: GetActionListSummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getActionListSummary>>,
        TError,
        TData
      >
    >;
  },
) => {
  const {query: queryOptions} = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetActionListSummaryQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getActionListSummary>>
  > = ({signal}) => getActionListSummary(params, signal);

  return {queryKey, queryFn, ...queryOptions} as UseQueryOptions<
    Awaited<ReturnType<typeof getActionListSummary>>,
    TError,
    TData
  > & {queryKey: DataTag<QueryKey, TData, TError>};
};

export type GetActionListSummaryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getActionListSummary>>
>;
export type GetActionListSummaryQueryError = unknown;

export function useGetActionListSummary<
  TData = Awaited<ReturnType<typeof getActionListSummary>>,
  TError = unknown,
>(
  params: GetActionListSummaryParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getActionListSummary>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActionListSummary>>,
          TError,
          Awaited<ReturnType<typeof getActionListSummary>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetActionListSummary<
  TData = Awaited<ReturnType<typeof getActionListSummary>>,
  TError = unknown,
>(
  params: GetActionListSummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getActionListSummary>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActionListSummary>>,
          TError,
          Awaited<ReturnType<typeof getActionListSummary>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};
export function useGetActionListSummary<
  TData = Awaited<ReturnType<typeof getActionListSummary>>,
  TError = unknown,
>(
  params: GetActionListSummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getActionListSummary>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};

export function useGetActionListSummary<
  TData = Awaited<ReturnType<typeof getActionListSummary>>,
  TError = unknown,
>(
  params: GetActionListSummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getActionListSummary>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetActionListSummaryQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & {queryKey: DataTag<QueryKey, TData, TError>};

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Reads an action by name
 */
export const getAction = (slug: string, signal?: AbortSignal) => {
  return axiosInstance<Action>({
    url: `/actions/${slug}`,
    method: "GET",
    signal,
  });
};

export const getGetActionQueryKey = (slug: string) => {
  return [`/actions/${slug}`] as const;
};

export const getGetActionQueryOptions = <
  TData = Awaited<ReturnType<typeof getAction>>,
  TError = unknown,
>(
  slug: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAction>>, TError, TData>
    >;
  },
) => {
  const {query: queryOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetActionQueryKey(slug);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAction>>> = ({
    signal,
  }) => getAction(slug, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!slug,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getAction>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type GetActionQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAction>>
>;
export type GetActionQueryError = unknown;

export function useGetAction<
  TData = Awaited<ReturnType<typeof getAction>>,
  TError = unknown,
>(
  slug: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAction>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAction>>,
          TError,
          Awaited<ReturnType<typeof getAction>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAction<
  TData = Awaited<ReturnType<typeof getAction>>,
  TError = unknown,
>(
  slug: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAction>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAction>>,
          TError,
          Awaited<ReturnType<typeof getAction>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};
export function useGetAction<
  TData = Awaited<ReturnType<typeof getAction>>,
  TError = unknown,
>(
  slug: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAction>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};

export function useGetAction<
  TData = Awaited<ReturnType<typeof getAction>>,
  TError = unknown,
>(
  slug: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAction>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetActionQueryOptions(slug, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & {queryKey: DataTag<QueryKey, TData, TError>};

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Update action data fields (other than type)
 */
export const updateAction = (slug: string, action: NonReadonly<Action>) => {
  return axiosInstance<void>({
    url: `/actions/${slug}`,
    method: "PATCH",
    headers: {"Content-Type": "application/json"},
    data: action,
  });
};

export const getUpdateActionMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateAction>>,
    TError,
    {slug: string; data: NonReadonly<Action>},
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateAction>>,
  TError,
  {slug: string; data: NonReadonly<Action>},
  TContext
> => {
  const mutationKey = ["updateAction"];
  const {mutation: mutationOptions} = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : {...options, mutation: {...options.mutation, mutationKey}}
    : {mutation: {mutationKey}};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateAction>>,
    {slug: string; data: NonReadonly<Action>}
  > = props => {
    const {slug, data} = props ?? {};

    return updateAction(slug, data);
  };

  return {mutationFn, ...mutationOptions};
};

export type UpdateActionMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateAction>>
>;
export type UpdateActionMutationBody = NonReadonly<Action>;
export type UpdateActionMutationError = void;

export const useUpdateAction = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateAction>>,
      TError,
      {slug: string; data: NonReadonly<Action>},
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateAction>>,
  TError,
  {slug: string; data: NonReadonly<Action>},
  TContext
> => {
  const mutationOptions = getUpdateActionMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Deletes an action by its name
 */
export const deleteAction = (slug: string) => {
  return axiosInstance<void>({url: `/actions/${slug}`, method: "DELETE"});
};

export const getDeleteActionMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteAction>>,
    TError,
    {slug: string},
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteAction>>,
  TError,
  {slug: string},
  TContext
> => {
  const mutationKey = ["deleteAction"];
  const {mutation: mutationOptions} = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : {...options, mutation: {...options.mutation, mutationKey}}
    : {mutation: {mutationKey}};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteAction>>,
    {slug: string}
  > = props => {
    const {slug} = props ?? {};

    return deleteAction(slug);
  };

  return {mutationFn, ...mutationOptions};
};

export type DeleteActionMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteAction>>
>;

export type DeleteActionMutationError = void;

export const useDeleteAction = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteAction>>,
      TError,
      {slug: string},
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteAction>>,
  TError,
  {slug: string},
  TContext
> => {
  const mutationOptions = getDeleteActionMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Clones an action
 */
export const duplicateAction = (
  slug: string,
  duplicateActionBody: DuplicateActionBody,
  signal?: AbortSignal,
) => {
  return axiosInstance<CreateResult>({
    url: `/actions/${slug}`,
    method: "POST",
    headers: {"Content-Type": "application/json"},
    data: duplicateActionBody,
    signal,
  });
};

export const getDuplicateActionMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof duplicateAction>>,
    TError,
    {slug: string; data: DuplicateActionBody},
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof duplicateAction>>,
  TError,
  {slug: string; data: DuplicateActionBody},
  TContext
> => {
  const mutationKey = ["duplicateAction"];
  const {mutation: mutationOptions} = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : {...options, mutation: {...options.mutation, mutationKey}}
    : {mutation: {mutationKey}};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof duplicateAction>>,
    {slug: string; data: DuplicateActionBody}
  > = props => {
    const {slug, data} = props ?? {};

    return duplicateAction(slug, data);
  };

  return {mutationFn, ...mutationOptions};
};

export type DuplicateActionMutationResult = NonNullable<
  Awaited<ReturnType<typeof duplicateAction>>
>;
export type DuplicateActionMutationBody = DuplicateActionBody;
export type DuplicateActionMutationError = void;

export const useDuplicateAction = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof duplicateAction>>,
      TError,
      {slug: string; data: DuplicateActionBody},
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof duplicateAction>>,
  TError,
  {slug: string; data: DuplicateActionBody},
  TContext
> => {
  const mutationOptions = getDuplicateActionMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Get GHL Calendars
 */
export const getGHLCalendars = (workspaceId: string, signal?: AbortSignal) => {
  return axiosInstance<GetGHLCalendars200>({
    url: `/actions/ghl/calendars/${workspaceId}`,
    method: "GET",
    signal,
  });
};

export const getGetGHLCalendarsQueryKey = (workspaceId: string) => {
  return [`/actions/ghl/calendars/${workspaceId}`] as const;
};

export const getGetGHLCalendarsQueryOptions = <
  TData = Awaited<ReturnType<typeof getGHLCalendars>>,
  TError = void,
>(
  workspaceId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getGHLCalendars>>,
        TError,
        TData
      >
    >;
  },
) => {
  const {query: queryOptions} = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetGHLCalendarsQueryKey(workspaceId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getGHLCalendars>>> = ({
    signal,
  }) => getGHLCalendars(workspaceId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!workspaceId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getGHLCalendars>>,
    TError,
    TData
  > & {queryKey: DataTag<QueryKey, TData, TError>};
};

export type GetGHLCalendarsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getGHLCalendars>>
>;
export type GetGHLCalendarsQueryError = void;

export function useGetGHLCalendars<
  TData = Awaited<ReturnType<typeof getGHLCalendars>>,
  TError = void,
>(
  workspaceId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getGHLCalendars>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGHLCalendars>>,
          TError,
          Awaited<ReturnType<typeof getGHLCalendars>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetGHLCalendars<
  TData = Awaited<ReturnType<typeof getGHLCalendars>>,
  TError = void,
>(
  workspaceId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getGHLCalendars>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGHLCalendars>>,
          TError,
          Awaited<ReturnType<typeof getGHLCalendars>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};
export function useGetGHLCalendars<
  TData = Awaited<ReturnType<typeof getGHLCalendars>>,
  TError = void,
>(
  workspaceId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getGHLCalendars>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};
/**
 * @summary Get GHL Calendars
 */

export function useGetGHLCalendars<
  TData = Awaited<ReturnType<typeof getGHLCalendars>>,
  TError = void,
>(
  workspaceId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getGHLCalendars>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetGHLCalendarsQueryOptions(workspaceId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & {queryKey: DataTag<QueryKey, TData, TError>};

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Retrieves a custom action by its ID, parses it, and forwards it to the core backend for initialization. Returns the response from the core backend.
 * @summary Initialize a Custom Action
 */
export const initializeCustomAction = (
  actionId: string,
  initializeCustomActionInput: InitializeCustomActionInput,
  signal?: AbortSignal,
) => {
  return axiosInstance<InitializeCustomAction200>({
    url: `/actions/${actionId}/initialize`,
    method: "POST",
    headers: {"Content-Type": "application/json"},
    data: initializeCustomActionInput,
    signal,
  });
};

export const getInitializeCustomActionMutationOptions = <
  TError = ErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof initializeCustomAction>>,
    TError,
    {actionId: string; data: InitializeCustomActionInput},
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof initializeCustomAction>>,
  TError,
  {actionId: string; data: InitializeCustomActionInput},
  TContext
> => {
  const mutationKey = ["initializeCustomAction"];
  const {mutation: mutationOptions} = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : {...options, mutation: {...options.mutation, mutationKey}}
    : {mutation: {mutationKey}};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof initializeCustomAction>>,
    {actionId: string; data: InitializeCustomActionInput}
  > = props => {
    const {actionId, data} = props ?? {};

    return initializeCustomAction(actionId, data);
  };

  return {mutationFn, ...mutationOptions};
};

export type InitializeCustomActionMutationResult = NonNullable<
  Awaited<ReturnType<typeof initializeCustomAction>>
>;
export type InitializeCustomActionMutationBody = InitializeCustomActionInput;
export type InitializeCustomActionMutationError = ErrorResponse;

/**
 * @summary Initialize a Custom Action
 */
export const useInitializeCustomAction = <
  TError = ErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof initializeCustomAction>>,
      TError,
      {actionId: string; data: InitializeCustomActionInput},
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof initializeCustomAction>>,
  TError,
  {actionId: string; data: InitializeCustomActionInput},
  TContext
> => {
  const mutationOptions = getInitializeCustomActionMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Gets paginated list of public assistants
 */
export const getAssistantList = (
  params: GetAssistantListParams,
  signal?: AbortSignal,
) => {
  return axiosInstance<GetAssistantList200>({
    url: `/assistants`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetAssistantListQueryKey = (params: GetAssistantListParams) => {
  return [`/assistants`, ...(params ? [params] : [])] as const;
};

export const getGetAssistantListQueryOptions = <
  TData = Awaited<ReturnType<typeof getAssistantList>>,
  TError = unknown,
>(
  params: GetAssistantListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssistantList>>,
        TError,
        TData
      >
    >;
  },
) => {
  const {query: queryOptions} = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAssistantListQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAssistantList>>
  > = ({signal}) => getAssistantList(params, signal);

  return {queryKey, queryFn, ...queryOptions} as UseQueryOptions<
    Awaited<ReturnType<typeof getAssistantList>>,
    TError,
    TData
  > & {queryKey: DataTag<QueryKey, TData, TError>};
};

export type GetAssistantListQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAssistantList>>
>;
export type GetAssistantListQueryError = unknown;

export function useGetAssistantList<
  TData = Awaited<ReturnType<typeof getAssistantList>>,
  TError = unknown,
>(
  params: GetAssistantListParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssistantList>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAssistantList>>,
          TError,
          Awaited<ReturnType<typeof getAssistantList>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAssistantList<
  TData = Awaited<ReturnType<typeof getAssistantList>>,
  TError = unknown,
>(
  params: GetAssistantListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssistantList>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAssistantList>>,
          TError,
          Awaited<ReturnType<typeof getAssistantList>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};
export function useGetAssistantList<
  TData = Awaited<ReturnType<typeof getAssistantList>>,
  TError = unknown,
>(
  params: GetAssistantListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssistantList>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};

export function useGetAssistantList<
  TData = Awaited<ReturnType<typeof getAssistantList>>,
  TError = unknown,
>(
  params: GetAssistantListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssistantList>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetAssistantListQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & {queryKey: DataTag<QueryKey, TData, TError>};

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Creates a new Assistant
 */
export const createAssistant = (assistant: Assistant, signal?: AbortSignal) => {
  return axiosInstance<CreateResult>({
    url: `/assistants`,
    method: "POST",
    headers: {"Content-Type": "application/json"},
    data: assistant,
    signal,
  });
};

export const getCreateAssistantMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createAssistant>>,
    TError,
    {data: Assistant},
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createAssistant>>,
  TError,
  {data: Assistant},
  TContext
> => {
  const mutationKey = ["createAssistant"];
  const {mutation: mutationOptions} = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : {...options, mutation: {...options.mutation, mutationKey}}
    : {mutation: {mutationKey}};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createAssistant>>,
    {data: Assistant}
  > = props => {
    const {data} = props ?? {};

    return createAssistant(data);
  };

  return {mutationFn, ...mutationOptions};
};

export type CreateAssistantMutationResult = NonNullable<
  Awaited<ReturnType<typeof createAssistant>>
>;
export type CreateAssistantMutationBody = Assistant;
export type CreateAssistantMutationError = unknown;

export const useCreateAssistant = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createAssistant>>,
      TError,
      {data: Assistant},
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createAssistant>>,
  TError,
  {data: Assistant},
  TContext
> => {
  const mutationOptions = getCreateAssistantMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Creates a new assistant from a template
 */
export const createAssistantFromTemplate = (
  createAssistantFromTemplateBody: CreateAssistantFromTemplateBody,
  signal?: AbortSignal,
) => {
  return axiosInstance<CreateResult>({
    url: `/assistants/template`,
    method: "POST",
    headers: {"Content-Type": "application/json"},
    data: createAssistantFromTemplateBody,
    signal,
  });
};

export const getCreateAssistantFromTemplateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createAssistantFromTemplate>>,
    TError,
    {data: CreateAssistantFromTemplateBody},
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createAssistantFromTemplate>>,
  TError,
  {data: CreateAssistantFromTemplateBody},
  TContext
> => {
  const mutationKey = ["createAssistantFromTemplate"];
  const {mutation: mutationOptions} = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : {...options, mutation: {...options.mutation, mutationKey}}
    : {mutation: {mutationKey}};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createAssistantFromTemplate>>,
    {data: CreateAssistantFromTemplateBody}
  > = props => {
    const {data} = props ?? {};

    return createAssistantFromTemplate(data);
  };

  return {mutationFn, ...mutationOptions};
};

export type CreateAssistantFromTemplateMutationResult = NonNullable<
  Awaited<ReturnType<typeof createAssistantFromTemplate>>
>;
export type CreateAssistantFromTemplateMutationBody =
  CreateAssistantFromTemplateBody;
export type CreateAssistantFromTemplateMutationError = unknown;

export const useCreateAssistantFromTemplate = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createAssistantFromTemplate>>,
      TError,
      {data: CreateAssistantFromTemplateBody},
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createAssistantFromTemplate>>,
  TError,
  {data: CreateAssistantFromTemplateBody},
  TContext
> => {
  const mutationOptions =
    getCreateAssistantFromTemplateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Detach all the assistants phone numbers.
 */
export const detachAllNumbers = (workspaceId: string) => {
  return axiosInstance<void>({
    url: `/assistants/detach_phone_numbers/${workspaceId}`,
    method: "DELETE",
  });
};

export const getDetachAllNumbersMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof detachAllNumbers>>,
    TError,
    {workspaceId: string},
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof detachAllNumbers>>,
  TError,
  {workspaceId: string},
  TContext
> => {
  const mutationKey = ["detachAllNumbers"];
  const {mutation: mutationOptions} = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : {...options, mutation: {...options.mutation, mutationKey}}
    : {mutation: {mutationKey}};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof detachAllNumbers>>,
    {workspaceId: string}
  > = props => {
    const {workspaceId} = props ?? {};

    return detachAllNumbers(workspaceId);
  };

  return {mutationFn, ...mutationOptions};
};

export type DetachAllNumbersMutationResult = NonNullable<
  Awaited<ReturnType<typeof detachAllNumbers>>
>;

export type DetachAllNumbersMutationError = void;

export const useDetachAllNumbers = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof detachAllNumbers>>,
      TError,
      {workspaceId: string},
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof detachAllNumbers>>,
  TError,
  {workspaceId: string},
  TContext
> => {
  const mutationOptions = getDetachAllNumbersMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Gets details of an assistant
 */
export const getAssistantDetails = (
  assistantId: string,
  signal?: AbortSignal,
) => {
  return axiosInstance<Assistant>({
    url: `/assistants/${assistantId}`,
    method: "GET",
    signal,
  });
};

export const getGetAssistantDetailsQueryKey = (assistantId: string) => {
  return [`/assistants/${assistantId}`] as const;
};

export const getGetAssistantDetailsQueryOptions = <
  TData = Awaited<ReturnType<typeof getAssistantDetails>>,
  TError = void,
>(
  assistantId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssistantDetails>>,
        TError,
        TData
      >
    >;
  },
) => {
  const {query: queryOptions} = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAssistantDetailsQueryKey(assistantId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAssistantDetails>>
  > = ({signal}) => getAssistantDetails(assistantId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!assistantId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getAssistantDetails>>,
    TError,
    TData
  > & {queryKey: DataTag<QueryKey, TData, TError>};
};

export type GetAssistantDetailsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAssistantDetails>>
>;
export type GetAssistantDetailsQueryError = void;

export function useGetAssistantDetails<
  TData = Awaited<ReturnType<typeof getAssistantDetails>>,
  TError = void,
>(
  assistantId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssistantDetails>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAssistantDetails>>,
          TError,
          Awaited<ReturnType<typeof getAssistantDetails>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAssistantDetails<
  TData = Awaited<ReturnType<typeof getAssistantDetails>>,
  TError = void,
>(
  assistantId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssistantDetails>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAssistantDetails>>,
          TError,
          Awaited<ReturnType<typeof getAssistantDetails>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};
export function useGetAssistantDetails<
  TData = Awaited<ReturnType<typeof getAssistantDetails>>,
  TError = void,
>(
  assistantId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssistantDetails>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};

export function useGetAssistantDetails<
  TData = Awaited<ReturnType<typeof getAssistantDetails>>,
  TError = void,
>(
  assistantId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssistantDetails>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetAssistantDetailsQueryOptions(assistantId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & {queryKey: DataTag<QueryKey, TData, TError>};

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Updates details of an assistant
 */
export const updateAssistantDetails = (
  assistantId: string,
  assistant: Assistant,
) => {
  return axiosInstance<void>({
    url: `/assistants/${assistantId}`,
    method: "PATCH",
    headers: {"Content-Type": "application/json"},
    data: assistant,
  });
};

export const getUpdateAssistantDetailsMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateAssistantDetails>>,
    TError,
    {assistantId: string; data: Assistant},
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateAssistantDetails>>,
  TError,
  {assistantId: string; data: Assistant},
  TContext
> => {
  const mutationKey = ["updateAssistantDetails"];
  const {mutation: mutationOptions} = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : {...options, mutation: {...options.mutation, mutationKey}}
    : {mutation: {mutationKey}};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateAssistantDetails>>,
    {assistantId: string; data: Assistant}
  > = props => {
    const {assistantId, data} = props ?? {};

    return updateAssistantDetails(assistantId, data);
  };

  return {mutationFn, ...mutationOptions};
};

export type UpdateAssistantDetailsMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateAssistantDetails>>
>;
export type UpdateAssistantDetailsMutationBody = Assistant;
export type UpdateAssistantDetailsMutationError = void;

export const useUpdateAssistantDetails = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateAssistantDetails>>,
      TError,
      {assistantId: string; data: Assistant},
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateAssistantDetails>>,
  TError,
  {assistantId: string; data: Assistant},
  TContext
> => {
  const mutationOptions = getUpdateAssistantDetailsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Deletes an assistant
 */
export const deleteAssistant = (assistantId: string) => {
  return axiosInstance<void>({
    url: `/assistants/${assistantId}`,
    method: "DELETE",
  });
};

export const getDeleteAssistantMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteAssistant>>,
    TError,
    {assistantId: string},
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteAssistant>>,
  TError,
  {assistantId: string},
  TContext
> => {
  const mutationKey = ["deleteAssistant"];
  const {mutation: mutationOptions} = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : {...options, mutation: {...options.mutation, mutationKey}}
    : {mutation: {mutationKey}};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteAssistant>>,
    {assistantId: string}
  > = props => {
    const {assistantId} = props ?? {};

    return deleteAssistant(assistantId);
  };

  return {mutationFn, ...mutationOptions};
};

export type DeleteAssistantMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteAssistant>>
>;

export type DeleteAssistantMutationError = void;

export const useDeleteAssistant = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteAssistant>>,
      TError,
      {assistantId: string},
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteAssistant>>,
  TError,
  {assistantId: string},
  TContext
> => {
  const mutationOptions = getDeleteAssistantMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Clones an assistant
 */
export const duplicateAssistant = (
  assistantId: string,
  duplicateAssistantBody: DuplicateAssistantBody,
  signal?: AbortSignal,
) => {
  return axiosInstance<CreateResult>({
    url: `/assistants/${assistantId}`,
    method: "POST",
    headers: {"Content-Type": "application/json"},
    data: duplicateAssistantBody,
    signal,
  });
};

export const getDuplicateAssistantMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof duplicateAssistant>>,
    TError,
    {assistantId: string; data: DuplicateAssistantBody},
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof duplicateAssistant>>,
  TError,
  {assistantId: string; data: DuplicateAssistantBody},
  TContext
> => {
  const mutationKey = ["duplicateAssistant"];
  const {mutation: mutationOptions} = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : {...options, mutation: {...options.mutation, mutationKey}}
    : {mutation: {mutationKey}};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof duplicateAssistant>>,
    {assistantId: string; data: DuplicateAssistantBody}
  > = props => {
    const {assistantId, data} = props ?? {};

    return duplicateAssistant(assistantId, data);
  };

  return {mutationFn, ...mutationOptions};
};

export type DuplicateAssistantMutationResult = NonNullable<
  Awaited<ReturnType<typeof duplicateAssistant>>
>;
export type DuplicateAssistantMutationBody = DuplicateAssistantBody;
export type DuplicateAssistantMutationError = void;

export const useDuplicateAssistant = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof duplicateAssistant>>,
      TError,
      {assistantId: string; data: DuplicateAssistantBody},
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof duplicateAssistant>>,
  TError,
  {assistantId: string; data: DuplicateAssistantBody},
  TContext
> => {
  const mutationOptions = getDuplicateAssistantMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Gets the progress of an assistant
 */
export const getAssistantProgress = (
  assistantId: string,
  signal?: AbortSignal,
) => {
  return axiosInstance<AgentProgressResponse>({
    url: `/assistants/progress/${assistantId}`,
    method: "GET",
    signal,
  });
};

export const getGetAssistantProgressQueryKey = (assistantId: string) => {
  return [`/assistants/progress/${assistantId}`] as const;
};

export const getGetAssistantProgressQueryOptions = <
  TData = Awaited<ReturnType<typeof getAssistantProgress>>,
  TError = BaseError | void,
>(
  assistantId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssistantProgress>>,
        TError,
        TData
      >
    >;
  },
) => {
  const {query: queryOptions} = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAssistantProgressQueryKey(assistantId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAssistantProgress>>
  > = ({signal}) => getAssistantProgress(assistantId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!assistantId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getAssistantProgress>>,
    TError,
    TData
  > & {queryKey: DataTag<QueryKey, TData, TError>};
};

export type GetAssistantProgressQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAssistantProgress>>
>;
export type GetAssistantProgressQueryError = BaseError | void;

export function useGetAssistantProgress<
  TData = Awaited<ReturnType<typeof getAssistantProgress>>,
  TError = BaseError | void,
>(
  assistantId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssistantProgress>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAssistantProgress>>,
          TError,
          Awaited<ReturnType<typeof getAssistantProgress>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAssistantProgress<
  TData = Awaited<ReturnType<typeof getAssistantProgress>>,
  TError = BaseError | void,
>(
  assistantId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssistantProgress>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAssistantProgress>>,
          TError,
          Awaited<ReturnType<typeof getAssistantProgress>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};
export function useGetAssistantProgress<
  TData = Awaited<ReturnType<typeof getAssistantProgress>>,
  TError = BaseError | void,
>(
  assistantId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssistantProgress>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};

export function useGetAssistantProgress<
  TData = Awaited<ReturnType<typeof getAssistantProgress>>,
  TError = BaseError | void,
>(
  assistantId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssistantProgress>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetAssistantProgressQueryOptions(
    assistantId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & {queryKey: DataTag<QueryKey, TData, TError>};

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get an Assistant by Id.
 */
export const getPublicAssistantById = (
  assistantId: string,
  signal?: AbortSignal,
) => {
  return axiosInstance<Assistant>({
    url: `/agents/${assistantId}/public`,
    method: "GET",
    signal,
  });
};

export const getGetPublicAssistantByIdQueryKey = (assistantId: string) => {
  return [`/agents/${assistantId}/public`] as const;
};

export const getGetPublicAssistantByIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getPublicAssistantById>>,
  TError = void,
>(
  assistantId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPublicAssistantById>>,
        TError,
        TData
      >
    >;
  },
) => {
  const {query: queryOptions} = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetPublicAssistantByIdQueryKey(assistantId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPublicAssistantById>>
  > = ({signal}) => getPublicAssistantById(assistantId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!assistantId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getPublicAssistantById>>,
    TError,
    TData
  > & {queryKey: DataTag<QueryKey, TData, TError>};
};

export type GetPublicAssistantByIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPublicAssistantById>>
>;
export type GetPublicAssistantByIdQueryError = void;

export function useGetPublicAssistantById<
  TData = Awaited<ReturnType<typeof getPublicAssistantById>>,
  TError = void,
>(
  assistantId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPublicAssistantById>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPublicAssistantById>>,
          TError,
          Awaited<ReturnType<typeof getPublicAssistantById>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPublicAssistantById<
  TData = Awaited<ReturnType<typeof getPublicAssistantById>>,
  TError = void,
>(
  assistantId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPublicAssistantById>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPublicAssistantById>>,
          TError,
          Awaited<ReturnType<typeof getPublicAssistantById>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};
export function useGetPublicAssistantById<
  TData = Awaited<ReturnType<typeof getPublicAssistantById>>,
  TError = void,
>(
  assistantId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPublicAssistantById>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};

export function useGetPublicAssistantById<
  TData = Awaited<ReturnType<typeof getPublicAssistantById>>,
  TError = void,
>(
  assistantId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPublicAssistantById>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetPublicAssistantByIdQueryOptions(
    assistantId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & {queryKey: DataTag<QueryKey, TData, TError>};

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Makes an assistant public
 */
export const makeAssistantPublic = (assistantId: string) => {
  return axiosInstance<void>({
    url: `/agents/${assistantId}/public`,
    method: "PUT",
  });
};

export const getMakeAssistantPublicMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof makeAssistantPublic>>,
    TError,
    {assistantId: string},
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof makeAssistantPublic>>,
  TError,
  {assistantId: string},
  TContext
> => {
  const mutationKey = ["makeAssistantPublic"];
  const {mutation: mutationOptions} = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : {...options, mutation: {...options.mutation, mutationKey}}
    : {mutation: {mutationKey}};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof makeAssistantPublic>>,
    {assistantId: string}
  > = props => {
    const {assistantId} = props ?? {};

    return makeAssistantPublic(assistantId);
  };

  return {mutationFn, ...mutationOptions};
};

export type MakeAssistantPublicMutationResult = NonNullable<
  Awaited<ReturnType<typeof makeAssistantPublic>>
>;

export type MakeAssistantPublicMutationError = void;

export const useMakeAssistantPublic = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof makeAssistantPublic>>,
      TError,
      {assistantId: string},
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof makeAssistantPublic>>,
  TError,
  {assistantId: string},
  TContext
> => {
  const mutationOptions = getMakeAssistantPublicMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Makes an assistant public
 */
export const makeAssistantPublicV2 = (assistantId: string) => {
  return axiosInstance<void>({
    url: `/assistants/${assistantId}/public`,
    method: "PUT",
  });
};

export const getMakeAssistantPublicV2MutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof makeAssistantPublicV2>>,
    TError,
    {assistantId: string},
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof makeAssistantPublicV2>>,
  TError,
  {assistantId: string},
  TContext
> => {
  const mutationKey = ["makeAssistantPublicV2"];
  const {mutation: mutationOptions} = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : {...options, mutation: {...options.mutation, mutationKey}}
    : {mutation: {mutationKey}};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof makeAssistantPublicV2>>,
    {assistantId: string}
  > = props => {
    const {assistantId} = props ?? {};

    return makeAssistantPublicV2(assistantId);
  };

  return {mutationFn, ...mutationOptions};
};

export type MakeAssistantPublicV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof makeAssistantPublicV2>>
>;

export type MakeAssistantPublicV2MutationError = void;

export const useMakeAssistantPublicV2 = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof makeAssistantPublicV2>>,
      TError,
      {assistantId: string},
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof makeAssistantPublicV2>>,
  TError,
  {assistantId: string},
  TContext
> => {
  const mutationOptions = getMakeAssistantPublicV2MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Get an Assistant default value by Id.
 */
export const getDefaultAssistantById = (
  assistantId: string,
  signal?: AbortSignal,
) => {
  return axiosInstance<Assistant>({
    url: `/agents/${assistantId}/default`,
    method: "GET",
    signal,
  });
};

export const getGetDefaultAssistantByIdQueryKey = (assistantId: string) => {
  return [`/agents/${assistantId}/default`] as const;
};

export const getGetDefaultAssistantByIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getDefaultAssistantById>>,
  TError = void,
>(
  assistantId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDefaultAssistantById>>,
        TError,
        TData
      >
    >;
  },
) => {
  const {query: queryOptions} = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetDefaultAssistantByIdQueryKey(assistantId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getDefaultAssistantById>>
  > = ({signal}) => getDefaultAssistantById(assistantId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!assistantId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getDefaultAssistantById>>,
    TError,
    TData
  > & {queryKey: DataTag<QueryKey, TData, TError>};
};

export type GetDefaultAssistantByIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDefaultAssistantById>>
>;
export type GetDefaultAssistantByIdQueryError = void;

export function useGetDefaultAssistantById<
  TData = Awaited<ReturnType<typeof getDefaultAssistantById>>,
  TError = void,
>(
  assistantId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDefaultAssistantById>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDefaultAssistantById>>,
          TError,
          Awaited<ReturnType<typeof getDefaultAssistantById>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetDefaultAssistantById<
  TData = Awaited<ReturnType<typeof getDefaultAssistantById>>,
  TError = void,
>(
  assistantId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDefaultAssistantById>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDefaultAssistantById>>,
          TError,
          Awaited<ReturnType<typeof getDefaultAssistantById>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};
export function useGetDefaultAssistantById<
  TData = Awaited<ReturnType<typeof getDefaultAssistantById>>,
  TError = void,
>(
  assistantId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDefaultAssistantById>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};

export function useGetDefaultAssistantById<
  TData = Awaited<ReturnType<typeof getDefaultAssistantById>>,
  TError = void,
>(
  assistantId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDefaultAssistantById>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetDefaultAssistantByIdQueryOptions(
    assistantId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & {queryKey: DataTag<QueryKey, TData, TError>};

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Makes an assistant the default one
 */
export const makeAssistantDefault = (assistantId: string) => {
  return axiosInstance<void>({
    url: `/agents/${assistantId}/default`,
    method: "PUT",
  });
};

export const getMakeAssistantDefaultMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof makeAssistantDefault>>,
    TError,
    {assistantId: string},
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof makeAssistantDefault>>,
  TError,
  {assistantId: string},
  TContext
> => {
  const mutationKey = ["makeAssistantDefault"];
  const {mutation: mutationOptions} = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : {...options, mutation: {...options.mutation, mutationKey}}
    : {mutation: {mutationKey}};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof makeAssistantDefault>>,
    {assistantId: string}
  > = props => {
    const {assistantId} = props ?? {};

    return makeAssistantDefault(assistantId);
  };

  return {mutationFn, ...mutationOptions};
};

export type MakeAssistantDefaultMutationResult = NonNullable<
  Awaited<ReturnType<typeof makeAssistantDefault>>
>;

export type MakeAssistantDefaultMutationError = void;

export const useMakeAssistantDefault = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof makeAssistantDefault>>,
      TError,
      {assistantId: string},
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof makeAssistantDefault>>,
  TError,
  {assistantId: string},
  TContext
> => {
  const mutationOptions = getMakeAssistantDefaultMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Makes an assistant the default one
 */
export const makeAssistantDefaultV2 = (assistantId: string) => {
  return axiosInstance<void>({
    url: `/assistants/${assistantId}/default`,
    method: "PUT",
  });
};

export const getMakeAssistantDefaultV2MutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof makeAssistantDefaultV2>>,
    TError,
    {assistantId: string},
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof makeAssistantDefaultV2>>,
  TError,
  {assistantId: string},
  TContext
> => {
  const mutationKey = ["makeAssistantDefaultV2"];
  const {mutation: mutationOptions} = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : {...options, mutation: {...options.mutation, mutationKey}}
    : {mutation: {mutationKey}};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof makeAssistantDefaultV2>>,
    {assistantId: string}
  > = props => {
    const {assistantId} = props ?? {};

    return makeAssistantDefaultV2(assistantId);
  };

  return {mutationFn, ...mutationOptions};
};

export type MakeAssistantDefaultV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof makeAssistantDefaultV2>>
>;

export type MakeAssistantDefaultV2MutationError = void;

export const useMakeAssistantDefaultV2 = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof makeAssistantDefaultV2>>,
      TError,
      {assistantId: string},
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof makeAssistantDefaultV2>>,
  TError,
  {assistantId: string},
  TContext
> => {
  const mutationOptions = getMakeAssistantDefaultV2MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Get all available assistant Templates
 */
export const getAssistantTemplatesOld = (
  params?: GetAssistantTemplatesOldParams,
  signal?: AbortSignal,
) => {
  return axiosInstance<GetAssistantTemplatesOld200>({
    url: `/agents/templates/available`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetAssistantTemplatesOldQueryKey = (
  params?: GetAssistantTemplatesOldParams,
) => {
  return [`/agents/templates/available`, ...(params ? [params] : [])] as const;
};

export const getGetAssistantTemplatesOldQueryOptions = <
  TData = Awaited<ReturnType<typeof getAssistantTemplatesOld>>,
  TError = unknown,
>(
  params?: GetAssistantTemplatesOldParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssistantTemplatesOld>>,
        TError,
        TData
      >
    >;
  },
) => {
  const {query: queryOptions} = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAssistantTemplatesOldQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAssistantTemplatesOld>>
  > = ({signal}) => getAssistantTemplatesOld(params, signal);

  return {queryKey, queryFn, ...queryOptions} as UseQueryOptions<
    Awaited<ReturnType<typeof getAssistantTemplatesOld>>,
    TError,
    TData
  > & {queryKey: DataTag<QueryKey, TData, TError>};
};

export type GetAssistantTemplatesOldQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAssistantTemplatesOld>>
>;
export type GetAssistantTemplatesOldQueryError = unknown;

export function useGetAssistantTemplatesOld<
  TData = Awaited<ReturnType<typeof getAssistantTemplatesOld>>,
  TError = unknown,
>(
  params: undefined | GetAssistantTemplatesOldParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssistantTemplatesOld>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAssistantTemplatesOld>>,
          TError,
          Awaited<ReturnType<typeof getAssistantTemplatesOld>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAssistantTemplatesOld<
  TData = Awaited<ReturnType<typeof getAssistantTemplatesOld>>,
  TError = unknown,
>(
  params?: GetAssistantTemplatesOldParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssistantTemplatesOld>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAssistantTemplatesOld>>,
          TError,
          Awaited<ReturnType<typeof getAssistantTemplatesOld>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};
export function useGetAssistantTemplatesOld<
  TData = Awaited<ReturnType<typeof getAssistantTemplatesOld>>,
  TError = unknown,
>(
  params?: GetAssistantTemplatesOldParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssistantTemplatesOld>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};

export function useGetAssistantTemplatesOld<
  TData = Awaited<ReturnType<typeof getAssistantTemplatesOld>>,
  TError = unknown,
>(
  params?: GetAssistantTemplatesOldParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssistantTemplatesOld>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetAssistantTemplatesOldQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & {queryKey: DataTag<QueryKey, TData, TError>};

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Gets the list of available assistant templates
 */
export const getAvailableAssistantTemplates = (
  params?: GetAvailableAssistantTemplatesParams,
  signal?: AbortSignal,
) => {
  return axiosInstance<GetAvailableAssistantTemplates200>({
    url: `/assistants/templates/avaialable`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetAvailableAssistantTemplatesQueryKey = (
  params?: GetAvailableAssistantTemplatesParams,
) => {
  return [
    `/assistants/templates/avaialable`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetAvailableAssistantTemplatesQueryOptions = <
  TData = Awaited<ReturnType<typeof getAvailableAssistantTemplates>>,
  TError = unknown,
>(
  params?: GetAvailableAssistantTemplatesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAvailableAssistantTemplates>>,
        TError,
        TData
      >
    >;
  },
) => {
  const {query: queryOptions} = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAvailableAssistantTemplatesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAvailableAssistantTemplates>>
  > = ({signal}) => getAvailableAssistantTemplates(params, signal);

  return {queryKey, queryFn, ...queryOptions} as UseQueryOptions<
    Awaited<ReturnType<typeof getAvailableAssistantTemplates>>,
    TError,
    TData
  > & {queryKey: DataTag<QueryKey, TData, TError>};
};

export type GetAvailableAssistantTemplatesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAvailableAssistantTemplates>>
>;
export type GetAvailableAssistantTemplatesQueryError = unknown;

export function useGetAvailableAssistantTemplates<
  TData = Awaited<ReturnType<typeof getAvailableAssistantTemplates>>,
  TError = unknown,
>(
  params: undefined | GetAvailableAssistantTemplatesParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAvailableAssistantTemplates>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAvailableAssistantTemplates>>,
          TError,
          Awaited<ReturnType<typeof getAvailableAssistantTemplates>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAvailableAssistantTemplates<
  TData = Awaited<ReturnType<typeof getAvailableAssistantTemplates>>,
  TError = unknown,
>(
  params?: GetAvailableAssistantTemplatesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAvailableAssistantTemplates>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAvailableAssistantTemplates>>,
          TError,
          Awaited<ReturnType<typeof getAvailableAssistantTemplates>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};
export function useGetAvailableAssistantTemplates<
  TData = Awaited<ReturnType<typeof getAvailableAssistantTemplates>>,
  TError = unknown,
>(
  params?: GetAvailableAssistantTemplatesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAvailableAssistantTemplates>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};

export function useGetAvailableAssistantTemplates<
  TData = Awaited<ReturnType<typeof getAvailableAssistantTemplates>>,
  TError = unknown,
>(
  params?: GetAvailableAssistantTemplatesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAvailableAssistantTemplates>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetAvailableAssistantTemplatesQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & {queryKey: DataTag<QueryKey, TData, TError>};

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Gets feature flags for an assistant
 */
export const getFeatureFlags = (
  params?: GetFeatureFlagsParams,
  signal?: AbortSignal,
) => {
  return axiosInstance<FeatureFlag[]>({
    url: `/feature_flags`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetFeatureFlagsQueryKey = (params?: GetFeatureFlagsParams) => {
  return [`/feature_flags`, ...(params ? [params] : [])] as const;
};

export const getGetFeatureFlagsQueryOptions = <
  TData = Awaited<ReturnType<typeof getFeatureFlags>>,
  TError = void,
>(
  params?: GetFeatureFlagsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getFeatureFlags>>,
        TError,
        TData
      >
    >;
  },
) => {
  const {query: queryOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetFeatureFlagsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getFeatureFlags>>> = ({
    signal,
  }) => getFeatureFlags(params, signal);

  return {queryKey, queryFn, ...queryOptions} as UseQueryOptions<
    Awaited<ReturnType<typeof getFeatureFlags>>,
    TError,
    TData
  > & {queryKey: DataTag<QueryKey, TData, TError>};
};

export type GetFeatureFlagsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFeatureFlags>>
>;
export type GetFeatureFlagsQueryError = void;

export function useGetFeatureFlags<
  TData = Awaited<ReturnType<typeof getFeatureFlags>>,
  TError = void,
>(
  params: undefined | GetFeatureFlagsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getFeatureFlags>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFeatureFlags>>,
          TError,
          Awaited<ReturnType<typeof getFeatureFlags>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetFeatureFlags<
  TData = Awaited<ReturnType<typeof getFeatureFlags>>,
  TError = void,
>(
  params?: GetFeatureFlagsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getFeatureFlags>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFeatureFlags>>,
          TError,
          Awaited<ReturnType<typeof getFeatureFlags>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};
export function useGetFeatureFlags<
  TData = Awaited<ReturnType<typeof getFeatureFlags>>,
  TError = void,
>(
  params?: GetFeatureFlagsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getFeatureFlags>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};

export function useGetFeatureFlags<
  TData = Awaited<ReturnType<typeof getFeatureFlags>>,
  TError = void,
>(
  params?: GetFeatureFlagsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getFeatureFlags>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetFeatureFlagsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & {queryKey: DataTag<QueryKey, TData, TError>};

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Adds a feature flag to an assistant
 */
export const addFeatureFlag = (
  featureFlagCreateRequest: FeatureFlagCreateRequest,
  signal?: AbortSignal,
) => {
  return axiosInstance<CreateResult>({
    url: `/feature_flags`,
    method: "POST",
    headers: {"Content-Type": "application/json"},
    data: featureFlagCreateRequest,
    signal,
  });
};

export const getAddFeatureFlagMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addFeatureFlag>>,
    TError,
    {data: FeatureFlagCreateRequest},
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof addFeatureFlag>>,
  TError,
  {data: FeatureFlagCreateRequest},
  TContext
> => {
  const mutationKey = ["addFeatureFlag"];
  const {mutation: mutationOptions} = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : {...options, mutation: {...options.mutation, mutationKey}}
    : {mutation: {mutationKey}};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof addFeatureFlag>>,
    {data: FeatureFlagCreateRequest}
  > = props => {
    const {data} = props ?? {};

    return addFeatureFlag(data);
  };

  return {mutationFn, ...mutationOptions};
};

export type AddFeatureFlagMutationResult = NonNullable<
  Awaited<ReturnType<typeof addFeatureFlag>>
>;
export type AddFeatureFlagMutationBody = FeatureFlagCreateRequest;
export type AddFeatureFlagMutationError = void;

export const useAddFeatureFlag = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof addFeatureFlag>>,
      TError,
      {data: FeatureFlagCreateRequest},
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof addFeatureFlag>>,
  TError,
  {data: FeatureFlagCreateRequest},
  TContext
> => {
  const mutationOptions = getAddFeatureFlagMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Deletes a feature flag from an assistant
 */
export const deleteFeatureFlag = (featureFlagId: string) => {
  return axiosInstance<void>({
    url: `/feature_flags/${featureFlagId}`,
    method: "DELETE",
  });
};

export const getDeleteFeatureFlagMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteFeatureFlag>>,
    TError,
    {featureFlagId: string},
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteFeatureFlag>>,
  TError,
  {featureFlagId: string},
  TContext
> => {
  const mutationKey = ["deleteFeatureFlag"];
  const {mutation: mutationOptions} = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : {...options, mutation: {...options.mutation, mutationKey}}
    : {mutation: {mutationKey}};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteFeatureFlag>>,
    {featureFlagId: string}
  > = props => {
    const {featureFlagId} = props ?? {};

    return deleteFeatureFlag(featureFlagId);
  };

  return {mutationFn, ...mutationOptions};
};

export type DeleteFeatureFlagMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteFeatureFlag>>
>;

export type DeleteFeatureFlagMutationError = void;

export const useDeleteFeatureFlag = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteFeatureFlag>>,
      TError,
      {featureFlagId: string},
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteFeatureFlag>>,
  TError,
  {featureFlagId: string},
  TContext
> => {
  const mutationOptions = getDeleteFeatureFlagMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Open call detail.
 */
export const openCall = (params?: OpenCallParams, signal?: AbortSignal) => {
  return axiosInstance<unknown>({
    url: `/pbx/open_call/`,
    method: "GET",
    params,
    signal,
  });
};

export const getOpenCallQueryKey = (params?: OpenCallParams) => {
  return [`/pbx/open_call/`, ...(params ? [params] : [])] as const;
};

export const getOpenCallQueryOptions = <
  TData = Awaited<ReturnType<typeof openCall>>,
  TError = void,
>(
  params?: OpenCallParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof openCall>>, TError, TData>
    >;
  },
) => {
  const {query: queryOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getOpenCallQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof openCall>>> = ({
    signal,
  }) => openCall(params, signal);

  return {queryKey, queryFn, ...queryOptions} as UseQueryOptions<
    Awaited<ReturnType<typeof openCall>>,
    TError,
    TData
  > & {queryKey: DataTag<QueryKey, TData, TError>};
};

export type OpenCallQueryResult = NonNullable<
  Awaited<ReturnType<typeof openCall>>
>;
export type OpenCallQueryError = void;

export function useOpenCall<
  TData = Awaited<ReturnType<typeof openCall>>,
  TError = void,
>(
  params: undefined | OpenCallParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof openCall>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof openCall>>,
          TError,
          Awaited<ReturnType<typeof openCall>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useOpenCall<
  TData = Awaited<ReturnType<typeof openCall>>,
  TError = void,
>(
  params?: OpenCallParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof openCall>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof openCall>>,
          TError,
          Awaited<ReturnType<typeof openCall>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};
export function useOpenCall<
  TData = Awaited<ReturnType<typeof openCall>>,
  TError = void,
>(
  params?: OpenCallParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof openCall>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};

export function useOpenCall<
  TData = Awaited<ReturnType<typeof openCall>>,
  TError = void,
>(
  params?: OpenCallParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof openCall>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getOpenCallQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & {queryKey: DataTag<QueryKey, TData, TError>};

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get paginated list of calls or download as CSV based on Accept header
 */
export const getCallList = (
  params: GetCallListParams,
  signal?: AbortSignal,
) => {
  return axiosInstance<GetCallList200One | Blob>({
    url: `/calls`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetCallListQueryKey = (params: GetCallListParams) => {
  return [`/calls`, ...(params ? [params] : [])] as const;
};

export const getGetCallListQueryOptions = <
  TData = Awaited<ReturnType<typeof getCallList>>,
  TError = ErrorResponse,
>(
  params: GetCallListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCallList>>, TError, TData>
    >;
  },
) => {
  const {query: queryOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCallListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCallList>>> = ({
    signal,
  }) => getCallList(params, signal);

  return {queryKey, queryFn, ...queryOptions} as UseQueryOptions<
    Awaited<ReturnType<typeof getCallList>>,
    TError,
    TData
  > & {queryKey: DataTag<QueryKey, TData, TError>};
};

export type GetCallListQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCallList>>
>;
export type GetCallListQueryError = ErrorResponse;

export function useGetCallList<
  TData = Awaited<ReturnType<typeof getCallList>>,
  TError = ErrorResponse,
>(
  params: GetCallListParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCallList>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCallList>>,
          TError,
          Awaited<ReturnType<typeof getCallList>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetCallList<
  TData = Awaited<ReturnType<typeof getCallList>>,
  TError = ErrorResponse,
>(
  params: GetCallListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCallList>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCallList>>,
          TError,
          Awaited<ReturnType<typeof getCallList>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};
export function useGetCallList<
  TData = Awaited<ReturnType<typeof getCallList>>,
  TError = ErrorResponse,
>(
  params: GetCallListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCallList>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};

export function useGetCallList<
  TData = Awaited<ReturnType<typeof getCallList>>,
  TError = ErrorResponse,
>(
  params: GetCallListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCallList>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetCallListQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & {queryKey: DataTag<QueryKey, TData, TError>};

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Creates a call
 */
export const createCall = (call: Call, signal?: AbortSignal) => {
  return axiosInstance<CreateResult>({
    url: `/calls`,
    method: "POST",
    headers: {"Content-Type": "application/json"},
    data: call,
    signal,
  });
};

export const getCreateCallMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createCall>>,
    TError,
    {data: Call},
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createCall>>,
  TError,
  {data: Call},
  TContext
> => {
  const mutationKey = ["createCall"];
  const {mutation: mutationOptions} = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : {...options, mutation: {...options.mutation, mutationKey}}
    : {mutation: {mutationKey}};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createCall>>,
    {data: Call}
  > = props => {
    const {data} = props ?? {};

    return createCall(data);
  };

  return {mutationFn, ...mutationOptions};
};

export type CreateCallMutationResult = NonNullable<
  Awaited<ReturnType<typeof createCall>>
>;
export type CreateCallMutationBody = Call;
export type CreateCallMutationError = unknown;

export const useCreateCall = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createCall>>,
      TError,
      {data: Call},
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createCall>>,
  TError,
  {data: Call},
  TContext
> => {
  const mutationOptions = getCreateCallMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Gets the call information by its Id
 */
export const getCallById = (callId: string, signal?: AbortSignal) => {
  return axiosInstance<Call>({url: `/calls/${callId}`, method: "GET", signal});
};

export const getGetCallByIdQueryKey = (callId: string) => {
  return [`/calls/${callId}`] as const;
};

export const getGetCallByIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getCallById>>,
  TError = unknown,
>(
  callId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCallById>>, TError, TData>
    >;
  },
) => {
  const {query: queryOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCallByIdQueryKey(callId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCallById>>> = ({
    signal,
  }) => getCallById(callId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!callId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getCallById>>,
    TError,
    TData
  > & {queryKey: DataTag<QueryKey, TData, TError>};
};

export type GetCallByIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCallById>>
>;
export type GetCallByIdQueryError = unknown;

export function useGetCallById<
  TData = Awaited<ReturnType<typeof getCallById>>,
  TError = unknown,
>(
  callId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCallById>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCallById>>,
          TError,
          Awaited<ReturnType<typeof getCallById>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetCallById<
  TData = Awaited<ReturnType<typeof getCallById>>,
  TError = unknown,
>(
  callId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCallById>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCallById>>,
          TError,
          Awaited<ReturnType<typeof getCallById>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};
export function useGetCallById<
  TData = Awaited<ReturnType<typeof getCallById>>,
  TError = unknown,
>(
  callId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCallById>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};

export function useGetCallById<
  TData = Awaited<ReturnType<typeof getCallById>>,
  TError = unknown,
>(
  callId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCallById>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetCallByIdQueryOptions(callId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & {queryKey: DataTag<QueryKey, TData, TError>};

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Updates some parts of call information. If success_criteria_analysis and simulation_id are provided, it will also update the corresponding simulation.
 */
export const updateCall = (callId: string, call: Call) => {
  return axiosInstance<void>({
    url: `/calls/${callId}`,
    method: "PATCH",
    headers: {"Content-Type": "application/json"},
    data: call,
  });
};

export const getUpdateCallMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateCall>>,
    TError,
    {callId: string; data: Call},
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateCall>>,
  TError,
  {callId: string; data: Call},
  TContext
> => {
  const mutationKey = ["updateCall"];
  const {mutation: mutationOptions} = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : {...options, mutation: {...options.mutation, mutationKey}}
    : {mutation: {mutationKey}};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateCall>>,
    {callId: string; data: Call}
  > = props => {
    const {callId, data} = props ?? {};

    return updateCall(callId, data);
  };

  return {mutationFn, ...mutationOptions};
};

export type UpdateCallMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateCall>>
>;
export type UpdateCallMutationBody = Call;
export type UpdateCallMutationError = void;

export const useUpdateCall = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateCall>>,
      TError,
      {callId: string; data: Call},
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateCall>>,
  TError,
  {callId: string; data: Call},
  TContext
> => {
  const mutationOptions = getUpdateCallMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Deletes call information
 */
export const deleteCall = (callId: string) => {
  return axiosInstance<void>({url: `/calls/${callId}`, method: "DELETE"});
};

export const getDeleteCallMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteCall>>,
    TError,
    {callId: string},
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteCall>>,
  TError,
  {callId: string},
  TContext
> => {
  const mutationKey = ["deleteCall"];
  const {mutation: mutationOptions} = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : {...options, mutation: {...options.mutation, mutationKey}}
    : {mutation: {mutationKey}};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteCall>>,
    {callId: string}
  > = props => {
    const {callId} = props ?? {};

    return deleteCall(callId);
  };

  return {mutationFn, ...mutationOptions};
};

export type DeleteCallMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteCall>>
>;

export type DeleteCallMutationError = void;

export const useDeleteCall = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteCall>>,
      TError,
      {callId: string},
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteCall>>,
  TError,
  {callId: string},
  TContext
> => {
  const mutationOptions = getDeleteCallMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Gets paginated list of phone numbers
 */
export const getPhoneNumberList = (
  params: GetPhoneNumberListParams,
  signal?: AbortSignal,
) => {
  return axiosInstance<GetPhoneNumberList200>({
    url: `/phone_numbers`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetPhoneNumberListQueryKey = (
  params: GetPhoneNumberListParams,
) => {
  return [`/phone_numbers`, ...(params ? [params] : [])] as const;
};

export const getGetPhoneNumberListQueryOptions = <
  TData = Awaited<ReturnType<typeof getPhoneNumberList>>,
  TError = unknown,
>(
  params: GetPhoneNumberListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPhoneNumberList>>,
        TError,
        TData
      >
    >;
  },
) => {
  const {query: queryOptions} = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetPhoneNumberListQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPhoneNumberList>>
  > = ({signal}) => getPhoneNumberList(params, signal);

  return {queryKey, queryFn, ...queryOptions} as UseQueryOptions<
    Awaited<ReturnType<typeof getPhoneNumberList>>,
    TError,
    TData
  > & {queryKey: DataTag<QueryKey, TData, TError>};
};

export type GetPhoneNumberListQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPhoneNumberList>>
>;
export type GetPhoneNumberListQueryError = unknown;

export function useGetPhoneNumberList<
  TData = Awaited<ReturnType<typeof getPhoneNumberList>>,
  TError = unknown,
>(
  params: GetPhoneNumberListParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPhoneNumberList>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPhoneNumberList>>,
          TError,
          Awaited<ReturnType<typeof getPhoneNumberList>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPhoneNumberList<
  TData = Awaited<ReturnType<typeof getPhoneNumberList>>,
  TError = unknown,
>(
  params: GetPhoneNumberListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPhoneNumberList>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPhoneNumberList>>,
          TError,
          Awaited<ReturnType<typeof getPhoneNumberList>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};
export function useGetPhoneNumberList<
  TData = Awaited<ReturnType<typeof getPhoneNumberList>>,
  TError = unknown,
>(
  params: GetPhoneNumberListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPhoneNumberList>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};

export function useGetPhoneNumberList<
  TData = Awaited<ReturnType<typeof getPhoneNumberList>>,
  TError = unknown,
>(
  params: GetPhoneNumberListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPhoneNumberList>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetPhoneNumberListQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & {queryKey: DataTag<QueryKey, TData, TError>};

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Creates a phone number from payload
 */
export const importPhoneNumber = (
  phoneNumber: NonReadonly<PhoneNumber>,
  signal?: AbortSignal,
) => {
  return axiosInstance<CreateResult>({
    url: `/phone_numbers`,
    method: "POST",
    headers: {"Content-Type": "application/json"},
    data: phoneNumber,
    signal,
  });
};

export const getImportPhoneNumberMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof importPhoneNumber>>,
    TError,
    {data: NonReadonly<PhoneNumber>},
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof importPhoneNumber>>,
  TError,
  {data: NonReadonly<PhoneNumber>},
  TContext
> => {
  const mutationKey = ["importPhoneNumber"];
  const {mutation: mutationOptions} = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : {...options, mutation: {...options.mutation, mutationKey}}
    : {mutation: {mutationKey}};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof importPhoneNumber>>,
    {data: NonReadonly<PhoneNumber>}
  > = props => {
    const {data} = props ?? {};

    return importPhoneNumber(data);
  };

  return {mutationFn, ...mutationOptions};
};

export type ImportPhoneNumberMutationResult = NonNullable<
  Awaited<ReturnType<typeof importPhoneNumber>>
>;
export type ImportPhoneNumberMutationBody = NonReadonly<PhoneNumber>;
export type ImportPhoneNumberMutationError = unknown;

export const useImportPhoneNumber = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof importPhoneNumber>>,
      TError,
      {data: NonReadonly<PhoneNumber>},
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof importPhoneNumber>>,
  TError,
  {data: NonReadonly<PhoneNumber>},
  TContext
> => {
  const mutationOptions = getImportPhoneNumberMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Get list of assistants using this phone number
 */
export const getPhoneNumberAssistants = (
  slug: string,
  signal?: AbortSignal,
) => {
  return axiosInstance<AssistantSummary[]>({
    url: `/phone_numbers/${slug}/assistants`,
    method: "GET",
    signal,
  });
};

export const getGetPhoneNumberAssistantsQueryKey = (slug: string) => {
  return [`/phone_numbers/${slug}/assistants`] as const;
};

export const getGetPhoneNumberAssistantsQueryOptions = <
  TData = Awaited<ReturnType<typeof getPhoneNumberAssistants>>,
  TError = void,
>(
  slug: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPhoneNumberAssistants>>,
        TError,
        TData
      >
    >;
  },
) => {
  const {query: queryOptions} = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetPhoneNumberAssistantsQueryKey(slug);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPhoneNumberAssistants>>
  > = ({signal}) => getPhoneNumberAssistants(slug, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!slug,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getPhoneNumberAssistants>>,
    TError,
    TData
  > & {queryKey: DataTag<QueryKey, TData, TError>};
};

export type GetPhoneNumberAssistantsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPhoneNumberAssistants>>
>;
export type GetPhoneNumberAssistantsQueryError = void;

export function useGetPhoneNumberAssistants<
  TData = Awaited<ReturnType<typeof getPhoneNumberAssistants>>,
  TError = void,
>(
  slug: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPhoneNumberAssistants>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPhoneNumberAssistants>>,
          TError,
          Awaited<ReturnType<typeof getPhoneNumberAssistants>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPhoneNumberAssistants<
  TData = Awaited<ReturnType<typeof getPhoneNumberAssistants>>,
  TError = void,
>(
  slug: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPhoneNumberAssistants>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPhoneNumberAssistants>>,
          TError,
          Awaited<ReturnType<typeof getPhoneNumberAssistants>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};
export function useGetPhoneNumberAssistants<
  TData = Awaited<ReturnType<typeof getPhoneNumberAssistants>>,
  TError = void,
>(
  slug: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPhoneNumberAssistants>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};

export function useGetPhoneNumberAssistants<
  TData = Awaited<ReturnType<typeof getPhoneNumberAssistants>>,
  TError = void,
>(
  slug: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPhoneNumberAssistants>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetPhoneNumberAssistantsQueryOptions(slug, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & {queryKey: DataTag<QueryKey, TData, TError>};

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Gets a phone number by id or slug
 */
export const getPhoneNumber = (
  slug: string,
  params: GetPhoneNumberParams,
  signal?: AbortSignal,
) => {
  return axiosInstance<PhoneNumber>({
    url: `/phone_numbers/${slug}`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetPhoneNumberQueryKey = (
  slug: string,
  params: GetPhoneNumberParams,
) => {
  return [`/phone_numbers/${slug}`, ...(params ? [params] : [])] as const;
};

export const getGetPhoneNumberQueryOptions = <
  TData = Awaited<ReturnType<typeof getPhoneNumber>>,
  TError = void,
>(
  slug: string,
  params: GetPhoneNumberParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPhoneNumber>>, TError, TData>
    >;
  },
) => {
  const {query: queryOptions} = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetPhoneNumberQueryKey(slug, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPhoneNumber>>> = ({
    signal,
  }) => getPhoneNumber(slug, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!slug,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getPhoneNumber>>,
    TError,
    TData
  > & {queryKey: DataTag<QueryKey, TData, TError>};
};

export type GetPhoneNumberQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPhoneNumber>>
>;
export type GetPhoneNumberQueryError = void;

export function useGetPhoneNumber<
  TData = Awaited<ReturnType<typeof getPhoneNumber>>,
  TError = void,
>(
  slug: string,
  params: GetPhoneNumberParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPhoneNumber>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPhoneNumber>>,
          TError,
          Awaited<ReturnType<typeof getPhoneNumber>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPhoneNumber<
  TData = Awaited<ReturnType<typeof getPhoneNumber>>,
  TError = void,
>(
  slug: string,
  params: GetPhoneNumberParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPhoneNumber>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPhoneNumber>>,
          TError,
          Awaited<ReturnType<typeof getPhoneNumber>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};
export function useGetPhoneNumber<
  TData = Awaited<ReturnType<typeof getPhoneNumber>>,
  TError = void,
>(
  slug: string,
  params: GetPhoneNumberParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPhoneNumber>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};

export function useGetPhoneNumber<
  TData = Awaited<ReturnType<typeof getPhoneNumber>>,
  TError = void,
>(
  slug: string,
  params: GetPhoneNumberParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPhoneNumber>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetPhoneNumberQueryOptions(slug, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & {queryKey: DataTag<QueryKey, TData, TError>};

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Edit imported phone number attributes
 */
export const editPhoneNumber = (
  slug: string,
  phoneNumber: NonReadonly<PhoneNumber>,
  params: EditPhoneNumberParams,
) => {
  return axiosInstance<void>({
    url: `/phone_numbers/${slug}`,
    method: "PATCH",
    headers: {"Content-Type": "application/json"},
    data: phoneNumber,
    params,
  });
};

export const getEditPhoneNumberMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof editPhoneNumber>>,
    TError,
    {
      slug: string;
      data: NonReadonly<PhoneNumber>;
      params: EditPhoneNumberParams;
    },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof editPhoneNumber>>,
  TError,
  {slug: string; data: NonReadonly<PhoneNumber>; params: EditPhoneNumberParams},
  TContext
> => {
  const mutationKey = ["editPhoneNumber"];
  const {mutation: mutationOptions} = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : {...options, mutation: {...options.mutation, mutationKey}}
    : {mutation: {mutationKey}};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof editPhoneNumber>>,
    {
      slug: string;
      data: NonReadonly<PhoneNumber>;
      params: EditPhoneNumberParams;
    }
  > = props => {
    const {slug, data, params} = props ?? {};

    return editPhoneNumber(slug, data, params);
  };

  return {mutationFn, ...mutationOptions};
};

export type EditPhoneNumberMutationResult = NonNullable<
  Awaited<ReturnType<typeof editPhoneNumber>>
>;
export type EditPhoneNumberMutationBody = NonReadonly<PhoneNumber>;
export type EditPhoneNumberMutationError = void;

export const useEditPhoneNumber = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof editPhoneNumber>>,
      TError,
      {
        slug: string;
        data: NonReadonly<PhoneNumber>;
        params: EditPhoneNumberParams;
      },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof editPhoneNumber>>,
  TError,
  {slug: string; data: NonReadonly<PhoneNumber>; params: EditPhoneNumberParams},
  TContext
> => {
  const mutationOptions = getEditPhoneNumberMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Delete imported phone number
 */
export const deletePhoneNumber = (
  slug: string,
  params: DeletePhoneNumberParams,
) => {
  return axiosInstance<void>({
    url: `/phone_numbers/${slug}`,
    method: "DELETE",
    params,
  });
};

export const getDeletePhoneNumberMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deletePhoneNumber>>,
    TError,
    {slug: string; params: DeletePhoneNumberParams},
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deletePhoneNumber>>,
  TError,
  {slug: string; params: DeletePhoneNumberParams},
  TContext
> => {
  const mutationKey = ["deletePhoneNumber"];
  const {mutation: mutationOptions} = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : {...options, mutation: {...options.mutation, mutationKey}}
    : {mutation: {mutationKey}};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deletePhoneNumber>>,
    {slug: string; params: DeletePhoneNumberParams}
  > = props => {
    const {slug, params} = props ?? {};

    return deletePhoneNumber(slug, params);
  };

  return {mutationFn, ...mutationOptions};
};

export type DeletePhoneNumberMutationResult = NonNullable<
  Awaited<ReturnType<typeof deletePhoneNumber>>
>;

export type DeletePhoneNumberMutationError = void;

export const useDeletePhoneNumber = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deletePhoneNumber>>,
      TError,
      {slug: string; params: DeletePhoneNumberParams},
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deletePhoneNumber>>,
  TError,
  {slug: string; params: DeletePhoneNumberParams},
  TContext
> => {
  const mutationOptions = getDeletePhoneNumberMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const getProviderAvailablePhoneNumbers = (
  providerName: string,
  params: GetProviderAvailablePhoneNumbersParams,
  signal?: AbortSignal,
) => {
  return axiosInstance<GetProviderAvailablePhoneNumbers200>({
    url: `/providers/${providerName}/phone_numbers`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetProviderAvailablePhoneNumbersQueryKey = (
  providerName: string,
  params: GetProviderAvailablePhoneNumbersParams,
) => {
  return [
    `/providers/${providerName}/phone_numbers`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetProviderAvailablePhoneNumbersQueryOptions = <
  TData = Awaited<ReturnType<typeof getProviderAvailablePhoneNumbers>>,
  TError = unknown,
>(
  providerName: string,
  params: GetProviderAvailablePhoneNumbersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getProviderAvailablePhoneNumbers>>,
        TError,
        TData
      >
    >;
  },
) => {
  const {query: queryOptions} = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetProviderAvailablePhoneNumbersQueryKey(providerName, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getProviderAvailablePhoneNumbers>>
  > = ({signal}) =>
    getProviderAvailablePhoneNumbers(providerName, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!providerName,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getProviderAvailablePhoneNumbers>>,
    TError,
    TData
  > & {queryKey: DataTag<QueryKey, TData, TError>};
};

export type GetProviderAvailablePhoneNumbersQueryResult = NonNullable<
  Awaited<ReturnType<typeof getProviderAvailablePhoneNumbers>>
>;
export type GetProviderAvailablePhoneNumbersQueryError = unknown;

export function useGetProviderAvailablePhoneNumbers<
  TData = Awaited<ReturnType<typeof getProviderAvailablePhoneNumbers>>,
  TError = unknown,
>(
  providerName: string,
  params: GetProviderAvailablePhoneNumbersParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getProviderAvailablePhoneNumbers>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProviderAvailablePhoneNumbers>>,
          TError,
          Awaited<ReturnType<typeof getProviderAvailablePhoneNumbers>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetProviderAvailablePhoneNumbers<
  TData = Awaited<ReturnType<typeof getProviderAvailablePhoneNumbers>>,
  TError = unknown,
>(
  providerName: string,
  params: GetProviderAvailablePhoneNumbersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getProviderAvailablePhoneNumbers>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProviderAvailablePhoneNumbers>>,
          TError,
          Awaited<ReturnType<typeof getProviderAvailablePhoneNumbers>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};
export function useGetProviderAvailablePhoneNumbers<
  TData = Awaited<ReturnType<typeof getProviderAvailablePhoneNumbers>>,
  TError = unknown,
>(
  providerName: string,
  params: GetProviderAvailablePhoneNumbersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getProviderAvailablePhoneNumbers>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};

export function useGetProviderAvailablePhoneNumbers<
  TData = Awaited<ReturnType<typeof getProviderAvailablePhoneNumbers>>,
  TError = unknown,
>(
  providerName: string,
  params: GetProviderAvailablePhoneNumbersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getProviderAvailablePhoneNumbers>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetProviderAvailablePhoneNumbersQueryOptions(
    providerName,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & {queryKey: DataTag<QueryKey, TData, TError>};

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Acquires a phone number
 */
export const acquirePhoneNumber = (
  providerName: string,
  slug: string,
  params: AcquirePhoneNumberParams,
) => {
  return axiosInstance<void>({
    url: `/providers/${providerName}/phone_numbers/${slug}`,
    method: "PUT",
    params,
  });
};

export const getAcquirePhoneNumberMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof acquirePhoneNumber>>,
    TError,
    {providerName: string; slug: string; params: AcquirePhoneNumberParams},
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof acquirePhoneNumber>>,
  TError,
  {providerName: string; slug: string; params: AcquirePhoneNumberParams},
  TContext
> => {
  const mutationKey = ["acquirePhoneNumber"];
  const {mutation: mutationOptions} = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : {...options, mutation: {...options.mutation, mutationKey}}
    : {mutation: {mutationKey}};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof acquirePhoneNumber>>,
    {providerName: string; slug: string; params: AcquirePhoneNumberParams}
  > = props => {
    const {providerName, slug, params} = props ?? {};

    return acquirePhoneNumber(providerName, slug, params);
  };

  return {mutationFn, ...mutationOptions};
};

export type AcquirePhoneNumberMutationResult = NonNullable<
  Awaited<ReturnType<typeof acquirePhoneNumber>>
>;

export type AcquirePhoneNumberMutationError = void;

export const useAcquirePhoneNumber = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof acquirePhoneNumber>>,
      TError,
      {providerName: string; slug: string; params: AcquirePhoneNumberParams},
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof acquirePhoneNumber>>,
  TError,
  {providerName: string; slug: string; params: AcquirePhoneNumberParams},
  TContext
> => {
  const mutationOptions = getAcquirePhoneNumberMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Releases a phone number
 */
export const releasePhoneNumber = (
  providerName: string,
  slug: string,
  params: ReleasePhoneNumberParams,
) => {
  return axiosInstance<void>({
    url: `/providers/${providerName}/phone_numbers/${slug}`,
    method: "DELETE",
    params,
  });
};

export const getReleasePhoneNumberMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof releasePhoneNumber>>,
    TError,
    {providerName: string; slug: string; params: ReleasePhoneNumberParams},
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof releasePhoneNumber>>,
  TError,
  {providerName: string; slug: string; params: ReleasePhoneNumberParams},
  TContext
> => {
  const mutationKey = ["releasePhoneNumber"];
  const {mutation: mutationOptions} = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : {...options, mutation: {...options.mutation, mutationKey}}
    : {mutation: {mutationKey}};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof releasePhoneNumber>>,
    {providerName: string; slug: string; params: ReleasePhoneNumberParams}
  > = props => {
    const {providerName, slug, params} = props ?? {};

    return releasePhoneNumber(providerName, slug, params);
  };

  return {mutationFn, ...mutationOptions};
};

export type ReleasePhoneNumberMutationResult = NonNullable<
  Awaited<ReturnType<typeof releasePhoneNumber>>
>;

export type ReleasePhoneNumberMutationError = void;

export const useReleasePhoneNumber = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof releasePhoneNumber>>,
      TError,
      {providerName: string; slug: string; params: ReleasePhoneNumberParams},
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof releasePhoneNumber>>,
  TError,
  {providerName: string; slug: string; params: ReleasePhoneNumberParams},
  TContext
> => {
  const mutationOptions = getReleasePhoneNumberMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Get list of eleven labs voices
 */
export const getElevenLabsVoiceList = (
  params: GetElevenLabsVoiceListParams,
  signal?: AbortSignal,
) => {
  return axiosInstance<GetElevenLabsVoiceList200>({
    url: `/voices/elevenlabs`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetElevenLabsVoiceListQueryKey = (
  params: GetElevenLabsVoiceListParams,
) => {
  return [`/voices/elevenlabs`, ...(params ? [params] : [])] as const;
};

export const getGetElevenLabsVoiceListQueryOptions = <
  TData = Awaited<ReturnType<typeof getElevenLabsVoiceList>>,
  TError = unknown,
>(
  params: GetElevenLabsVoiceListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getElevenLabsVoiceList>>,
        TError,
        TData
      >
    >;
  },
) => {
  const {query: queryOptions} = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetElevenLabsVoiceListQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getElevenLabsVoiceList>>
  > = ({signal}) => getElevenLabsVoiceList(params, signal);

  return {queryKey, queryFn, ...queryOptions} as UseQueryOptions<
    Awaited<ReturnType<typeof getElevenLabsVoiceList>>,
    TError,
    TData
  > & {queryKey: DataTag<QueryKey, TData, TError>};
};

export type GetElevenLabsVoiceListQueryResult = NonNullable<
  Awaited<ReturnType<typeof getElevenLabsVoiceList>>
>;
export type GetElevenLabsVoiceListQueryError = unknown;

export function useGetElevenLabsVoiceList<
  TData = Awaited<ReturnType<typeof getElevenLabsVoiceList>>,
  TError = unknown,
>(
  params: GetElevenLabsVoiceListParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getElevenLabsVoiceList>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getElevenLabsVoiceList>>,
          TError,
          Awaited<ReturnType<typeof getElevenLabsVoiceList>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetElevenLabsVoiceList<
  TData = Awaited<ReturnType<typeof getElevenLabsVoiceList>>,
  TError = unknown,
>(
  params: GetElevenLabsVoiceListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getElevenLabsVoiceList>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getElevenLabsVoiceList>>,
          TError,
          Awaited<ReturnType<typeof getElevenLabsVoiceList>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};
export function useGetElevenLabsVoiceList<
  TData = Awaited<ReturnType<typeof getElevenLabsVoiceList>>,
  TError = unknown,
>(
  params: GetElevenLabsVoiceListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getElevenLabsVoiceList>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};

export function useGetElevenLabsVoiceList<
  TData = Awaited<ReturnType<typeof getElevenLabsVoiceList>>,
  TError = unknown,
>(
  params: GetElevenLabsVoiceListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getElevenLabsVoiceList>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetElevenLabsVoiceListQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & {queryKey: DataTag<QueryKey, TData, TError>};

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Clones a voice file for ElevenLabs
 */
export const cloneElevenLabsVoice = (
  voiceFile: VoiceFile,
  params: CloneElevenLabsVoiceParams,
  signal?: AbortSignal,
) => {
  const formData = new FormData();
  if (voiceFile.files !== undefined) {
    voiceFile.files.forEach(value => formData.append("files", value));
  }
  if (voiceFile.name !== undefined) {
    formData.append("name", voiceFile.name);
  }
  if (voiceFile.description !== undefined) {
    formData.append("description", voiceFile.description);
  }
  if (voiceFile.labels !== undefined) {
    formData.append("labels", voiceFile.labels);
  }

  return axiosInstance<void>({
    url: `/voices/elevenlabs`,
    method: "POST",
    headers: {"Content-Type": "multipart/form-data"},
    data: formData,
    params,
    signal,
  });
};

export const getCloneElevenLabsVoiceMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof cloneElevenLabsVoice>>,
    TError,
    {data: VoiceFile; params: CloneElevenLabsVoiceParams},
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof cloneElevenLabsVoice>>,
  TError,
  {data: VoiceFile; params: CloneElevenLabsVoiceParams},
  TContext
> => {
  const mutationKey = ["cloneElevenLabsVoice"];
  const {mutation: mutationOptions} = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : {...options, mutation: {...options.mutation, mutationKey}}
    : {mutation: {mutationKey}};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof cloneElevenLabsVoice>>,
    {data: VoiceFile; params: CloneElevenLabsVoiceParams}
  > = props => {
    const {data, params} = props ?? {};

    return cloneElevenLabsVoice(data, params);
  };

  return {mutationFn, ...mutationOptions};
};

export type CloneElevenLabsVoiceMutationResult = NonNullable<
  Awaited<ReturnType<typeof cloneElevenLabsVoice>>
>;
export type CloneElevenLabsVoiceMutationBody = VoiceFile;
export type CloneElevenLabsVoiceMutationError = unknown;

export const useCloneElevenLabsVoice = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof cloneElevenLabsVoice>>,
      TError,
      {data: VoiceFile; params: CloneElevenLabsVoiceParams},
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof cloneElevenLabsVoice>>,
  TError,
  {data: VoiceFile; params: CloneElevenLabsVoiceParams},
  TContext
> => {
  const mutationOptions = getCloneElevenLabsVoiceMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Import some voice
 */
export const importElevenLabsVoice = (
  voiceId: string,
  params: ImportElevenLabsVoiceParams,
) => {
  return axiosInstance<void>({
    url: `/voices/${voiceId}/elevenlabs`,
    method: "PUT",
    params,
  });
};

export const getImportElevenLabsVoiceMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof importElevenLabsVoice>>,
    TError,
    {voiceId: string; params: ImportElevenLabsVoiceParams},
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof importElevenLabsVoice>>,
  TError,
  {voiceId: string; params: ImportElevenLabsVoiceParams},
  TContext
> => {
  const mutationKey = ["importElevenLabsVoice"];
  const {mutation: mutationOptions} = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : {...options, mutation: {...options.mutation, mutationKey}}
    : {mutation: {mutationKey}};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof importElevenLabsVoice>>,
    {voiceId: string; params: ImportElevenLabsVoiceParams}
  > = props => {
    const {voiceId, params} = props ?? {};

    return importElevenLabsVoice(voiceId, params);
  };

  return {mutationFn, ...mutationOptions};
};

export type ImportElevenLabsVoiceMutationResult = NonNullable<
  Awaited<ReturnType<typeof importElevenLabsVoice>>
>;

export type ImportElevenLabsVoiceMutationError = unknown;

export const useImportElevenLabsVoice = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof importElevenLabsVoice>>,
      TError,
      {voiceId: string; params: ImportElevenLabsVoiceParams},
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof importElevenLabsVoice>>,
  TError,
  {voiceId: string; params: ImportElevenLabsVoiceParams},
  TContext
> => {
  const mutationOptions = getImportElevenLabsVoiceMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Get list of workflows
 */
export const getWorkflowList = (signal?: AbortSignal) => {
  return axiosInstance<GetWorkflowList200>({
    url: `/workflows`,
    method: "GET",
    signal,
  });
};

export const getGetWorkflowListQueryKey = () => {
  return [`/workflows`] as const;
};

export const getGetWorkflowListQueryOptions = <
  TData = Awaited<ReturnType<typeof getWorkflowList>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getWorkflowList>>, TError, TData>
  >;
}) => {
  const {query: queryOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetWorkflowListQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getWorkflowList>>> = ({
    signal,
  }) => getWorkflowList(signal);

  return {queryKey, queryFn, ...queryOptions} as UseQueryOptions<
    Awaited<ReturnType<typeof getWorkflowList>>,
    TError,
    TData
  > & {queryKey: DataTag<QueryKey, TData, TError>};
};

export type GetWorkflowListQueryResult = NonNullable<
  Awaited<ReturnType<typeof getWorkflowList>>
>;
export type GetWorkflowListQueryError = unknown;

export function useGetWorkflowList<
  TData = Awaited<ReturnType<typeof getWorkflowList>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getWorkflowList>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWorkflowList>>,
          TError,
          Awaited<ReturnType<typeof getWorkflowList>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetWorkflowList<
  TData = Awaited<ReturnType<typeof getWorkflowList>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getWorkflowList>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWorkflowList>>,
          TError,
          Awaited<ReturnType<typeof getWorkflowList>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};
export function useGetWorkflowList<
  TData = Awaited<ReturnType<typeof getWorkflowList>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getWorkflowList>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};

export function useGetWorkflowList<
  TData = Awaited<ReturnType<typeof getWorkflowList>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getWorkflowList>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetWorkflowListQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & {queryKey: DataTag<QueryKey, TData, TError>};

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Creates a new workflow
 */
export const createWorkflow = (workflow: Workflow, signal?: AbortSignal) => {
  return axiosInstance<CreateResult>({
    url: `/workflows`,
    method: "POST",
    headers: {"Content-Type": "application/json"},
    data: workflow,
    signal,
  });
};

export const getCreateWorkflowMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createWorkflow>>,
    TError,
    {data: Workflow},
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createWorkflow>>,
  TError,
  {data: Workflow},
  TContext
> => {
  const mutationKey = ["createWorkflow"];
  const {mutation: mutationOptions} = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : {...options, mutation: {...options.mutation, mutationKey}}
    : {mutation: {mutationKey}};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createWorkflow>>,
    {data: Workflow}
  > = props => {
    const {data} = props ?? {};

    return createWorkflow(data);
  };

  return {mutationFn, ...mutationOptions};
};

export type CreateWorkflowMutationResult = NonNullable<
  Awaited<ReturnType<typeof createWorkflow>>
>;
export type CreateWorkflowMutationBody = Workflow;
export type CreateWorkflowMutationError = void;

export const useCreateWorkflow = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createWorkflow>>,
      TError,
      {data: Workflow},
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createWorkflow>>,
  TError,
  {data: Workflow},
  TContext
> => {
  const mutationOptions = getCreateWorkflowMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Gets a workflow by id
 */
export const getWorkflowById = (workflowId: string, signal?: AbortSignal) => {
  return axiosInstance<Workflow>({
    url: `/workflows/${workflowId}`,
    method: "GET",
    signal,
  });
};

export const getGetWorkflowByIdQueryKey = (workflowId: string) => {
  return [`/workflows/${workflowId}`] as const;
};

export const getGetWorkflowByIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getWorkflowById>>,
  TError = void,
>(
  workflowId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getWorkflowById>>,
        TError,
        TData
      >
    >;
  },
) => {
  const {query: queryOptions} = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetWorkflowByIdQueryKey(workflowId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getWorkflowById>>> = ({
    signal,
  }) => getWorkflowById(workflowId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!workflowId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getWorkflowById>>,
    TError,
    TData
  > & {queryKey: DataTag<QueryKey, TData, TError>};
};

export type GetWorkflowByIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getWorkflowById>>
>;
export type GetWorkflowByIdQueryError = void;

export function useGetWorkflowById<
  TData = Awaited<ReturnType<typeof getWorkflowById>>,
  TError = void,
>(
  workflowId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getWorkflowById>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWorkflowById>>,
          TError,
          Awaited<ReturnType<typeof getWorkflowById>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetWorkflowById<
  TData = Awaited<ReturnType<typeof getWorkflowById>>,
  TError = void,
>(
  workflowId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getWorkflowById>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWorkflowById>>,
          TError,
          Awaited<ReturnType<typeof getWorkflowById>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};
export function useGetWorkflowById<
  TData = Awaited<ReturnType<typeof getWorkflowById>>,
  TError = void,
>(
  workflowId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getWorkflowById>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};

export function useGetWorkflowById<
  TData = Awaited<ReturnType<typeof getWorkflowById>>,
  TError = void,
>(
  workflowId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getWorkflowById>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetWorkflowByIdQueryOptions(workflowId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & {queryKey: DataTag<QueryKey, TData, TError>};

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Deletes a workflow by id
 */
export const deleteWorkflowById = (workflowId: string) => {
  return axiosInstance<void>({
    url: `/workflows/${workflowId}`,
    method: "DELETE",
  });
};

export const getDeleteWorkflowByIdMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteWorkflowById>>,
    TError,
    {workflowId: string},
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteWorkflowById>>,
  TError,
  {workflowId: string},
  TContext
> => {
  const mutationKey = ["deleteWorkflowById"];
  const {mutation: mutationOptions} = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : {...options, mutation: {...options.mutation, mutationKey}}
    : {mutation: {mutationKey}};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteWorkflowById>>,
    {workflowId: string}
  > = props => {
    const {workflowId} = props ?? {};

    return deleteWorkflowById(workflowId);
  };

  return {mutationFn, ...mutationOptions};
};

export type DeleteWorkflowByIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteWorkflowById>>
>;

export type DeleteWorkflowByIdMutationError = void;

export const useDeleteWorkflowById = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteWorkflowById>>,
      TError,
      {workflowId: string},
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteWorkflowById>>,
  TError,
  {workflowId: string},
  TContext
> => {
  const mutationOptions = getDeleteWorkflowByIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Renames a workflow by id
 */
export const renameWorkflow = (
  workflowId: string,
  renameWorkflowBody: RenameWorkflowBody,
) => {
  return axiosInstance<void>({
    url: `/workflows/${workflowId}`,
    method: "PATCH",
    headers: {"Content-Type": "application/json"},
    data: renameWorkflowBody,
  });
};

export const getRenameWorkflowMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof renameWorkflow>>,
    TError,
    {workflowId: string; data: RenameWorkflowBody},
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof renameWorkflow>>,
  TError,
  {workflowId: string; data: RenameWorkflowBody},
  TContext
> => {
  const mutationKey = ["renameWorkflow"];
  const {mutation: mutationOptions} = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : {...options, mutation: {...options.mutation, mutationKey}}
    : {mutation: {mutationKey}};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof renameWorkflow>>,
    {workflowId: string; data: RenameWorkflowBody}
  > = props => {
    const {workflowId, data} = props ?? {};

    return renameWorkflow(workflowId, data);
  };

  return {mutationFn, ...mutationOptions};
};

export type RenameWorkflowMutationResult = NonNullable<
  Awaited<ReturnType<typeof renameWorkflow>>
>;
export type RenameWorkflowMutationBody = RenameWorkflowBody;
export type RenameWorkflowMutationError = void;

export const useRenameWorkflow = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof renameWorkflow>>,
      TError,
      {workflowId: string; data: RenameWorkflowBody},
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof renameWorkflow>>,
  TError,
  {workflowId: string; data: RenameWorkflowBody},
  TContext
> => {
  const mutationOptions = getRenameWorkflowMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Start an outbound call
 */
export const startCallOutbound = (
  requiredInformationCallInputOutbound: RequiredInformationCallInputOutbound,
  signal?: AbortSignal,
) => {
  return axiosInstance<CallSuccessResponse>({
    url: `/calls/outbound`,
    method: "POST",
    headers: {"Content-Type": "application/json"},
    data: requiredInformationCallInputOutbound,
    signal,
  });
};

export const getStartCallOutboundMutationOptions = <
  TError = PublicAPIErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof startCallOutbound>>,
    TError,
    {data: RequiredInformationCallInputOutbound},
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof startCallOutbound>>,
  TError,
  {data: RequiredInformationCallInputOutbound},
  TContext
> => {
  const mutationKey = ["startCallOutbound"];
  const {mutation: mutationOptions} = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : {...options, mutation: {...options.mutation, mutationKey}}
    : {mutation: {mutationKey}};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof startCallOutbound>>,
    {data: RequiredInformationCallInputOutbound}
  > = props => {
    const {data} = props ?? {};

    return startCallOutbound(data);
  };

  return {mutationFn, ...mutationOptions};
};

export type StartCallOutboundMutationResult = NonNullable<
  Awaited<ReturnType<typeof startCallOutbound>>
>;
export type StartCallOutboundMutationBody =
  RequiredInformationCallInputOutbound;
export type StartCallOutboundMutationError = PublicAPIErrorResponse;

export const useStartCallOutbound = <
  TError = PublicAPIErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof startCallOutbound>>,
      TError,
      {data: RequiredInformationCallInputOutbound},
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof startCallOutbound>>,
  TError,
  {data: RequiredInformationCallInputOutbound},
  TContext
> => {
  const mutationOptions = getStartCallOutboundMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Start an outbound call for test.
 */
export const startTestOutbound = (
  requiredInformationCallInputOutbound: RequiredInformationCallInputOutbound,
  signal?: AbortSignal,
) => {
  return axiosInstance<CallSuccessResponse>({
    url: `/calls/outbound-test`,
    method: "POST",
    headers: {"Content-Type": "application/json"},
    data: requiredInformationCallInputOutbound,
    signal,
  });
};

export const getStartTestOutboundMutationOptions = <
  TError = PublicAPIErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof startTestOutbound>>,
    TError,
    {data: RequiredInformationCallInputOutbound},
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof startTestOutbound>>,
  TError,
  {data: RequiredInformationCallInputOutbound},
  TContext
> => {
  const mutationKey = ["startTestOutbound"];
  const {mutation: mutationOptions} = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : {...options, mutation: {...options.mutation, mutationKey}}
    : {mutation: {mutationKey}};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof startTestOutbound>>,
    {data: RequiredInformationCallInputOutbound}
  > = props => {
    const {data} = props ?? {};

    return startTestOutbound(data);
  };

  return {mutationFn, ...mutationOptions};
};

export type StartTestOutboundMutationResult = NonNullable<
  Awaited<ReturnType<typeof startTestOutbound>>
>;
export type StartTestOutboundMutationBody =
  RequiredInformationCallInputOutbound;
export type StartTestOutboundMutationError = PublicAPIErrorResponse;

export const useStartTestOutbound = <
  TError = PublicAPIErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof startTestOutbound>>,
      TError,
      {data: RequiredInformationCallInputOutbound},
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof startTestOutbound>>,
  TError,
  {data: RequiredInformationCallInputOutbound},
  TContext
> => {
  const mutationOptions = getStartTestOutboundMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Gets the user theme
 */
export const getTheme = (params: GetThemeParams, signal?: AbortSignal) => {
  return axiosInstance<Appearance>({
    url: `/themes`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetThemeQueryKey = (params: GetThemeParams) => {
  return [`/themes`, ...(params ? [params] : [])] as const;
};

export const getGetThemeQueryOptions = <
  TData = Awaited<ReturnType<typeof getTheme>>,
  TError = void,
>(
  params: GetThemeParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTheme>>, TError, TData>
    >;
  },
) => {
  const {query: queryOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetThemeQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTheme>>> = ({
    signal,
  }) => getTheme(params, signal);

  return {queryKey, queryFn, ...queryOptions} as UseQueryOptions<
    Awaited<ReturnType<typeof getTheme>>,
    TError,
    TData
  > & {queryKey: DataTag<QueryKey, TData, TError>};
};

export type GetThemeQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTheme>>
>;
export type GetThemeQueryError = void;

export function useGetTheme<
  TData = Awaited<ReturnType<typeof getTheme>>,
  TError = void,
>(
  params: GetThemeParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTheme>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTheme>>,
          TError,
          Awaited<ReturnType<typeof getTheme>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTheme<
  TData = Awaited<ReturnType<typeof getTheme>>,
  TError = void,
>(
  params: GetThemeParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTheme>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTheme>>,
          TError,
          Awaited<ReturnType<typeof getTheme>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};
export function useGetTheme<
  TData = Awaited<ReturnType<typeof getTheme>>,
  TError = void,
>(
  params: GetThemeParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTheme>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};

export function useGetTheme<
  TData = Awaited<ReturnType<typeof getTheme>>,
  TError = void,
>(
  params: GetThemeParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTheme>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetThemeQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & {queryKey: DataTag<QueryKey, TData, TError>};

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Sets the user theme
 */
export const setTheme = (appearance: Appearance, params: SetThemeParams) => {
  return axiosInstance<void>({
    url: `/themes`,
    method: "PUT",
    headers: {"Content-Type": "application/json"},
    data: appearance,
    params,
  });
};

export const getSetThemeMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setTheme>>,
    TError,
    {data: Appearance; params: SetThemeParams},
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof setTheme>>,
  TError,
  {data: Appearance; params: SetThemeParams},
  TContext
> => {
  const mutationKey = ["setTheme"];
  const {mutation: mutationOptions} = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : {...options, mutation: {...options.mutation, mutationKey}}
    : {mutation: {mutationKey}};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof setTheme>>,
    {data: Appearance; params: SetThemeParams}
  > = props => {
    const {data, params} = props ?? {};

    return setTheme(data, params);
  };

  return {mutationFn, ...mutationOptions};
};

export type SetThemeMutationResult = NonNullable<
  Awaited<ReturnType<typeof setTheme>>
>;
export type SetThemeMutationBody = Appearance;
export type SetThemeMutationError = void;

export const useSetTheme = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof setTheme>>,
      TError,
      {data: Appearance; params: SetThemeParams},
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof setTheme>>,
  TError,
  {data: Appearance; params: SetThemeParams},
  TContext
> => {
  const mutationOptions = getSetThemeMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Get list of valid caller ID
 */
export const getValidCallerIdList = (
  params: GetValidCallerIdListParams,
  signal?: AbortSignal,
) => {
  return axiosInstance<GetValidCallerIdList200>({
    url: `/caller_ids`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetValidCallerIdListQueryKey = (
  params: GetValidCallerIdListParams,
) => {
  return [`/caller_ids`, ...(params ? [params] : [])] as const;
};

export const getGetValidCallerIdListQueryOptions = <
  TData = Awaited<ReturnType<typeof getValidCallerIdList>>,
  TError = GetValidCallerIdList500,
>(
  params: GetValidCallerIdListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getValidCallerIdList>>,
        TError,
        TData
      >
    >;
  },
) => {
  const {query: queryOptions} = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetValidCallerIdListQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getValidCallerIdList>>
  > = ({signal}) => getValidCallerIdList(params, signal);

  return {queryKey, queryFn, ...queryOptions} as UseQueryOptions<
    Awaited<ReturnType<typeof getValidCallerIdList>>,
    TError,
    TData
  > & {queryKey: DataTag<QueryKey, TData, TError>};
};

export type GetValidCallerIdListQueryResult = NonNullable<
  Awaited<ReturnType<typeof getValidCallerIdList>>
>;
export type GetValidCallerIdListQueryError = GetValidCallerIdList500;

export function useGetValidCallerIdList<
  TData = Awaited<ReturnType<typeof getValidCallerIdList>>,
  TError = GetValidCallerIdList500,
>(
  params: GetValidCallerIdListParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getValidCallerIdList>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getValidCallerIdList>>,
          TError,
          Awaited<ReturnType<typeof getValidCallerIdList>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetValidCallerIdList<
  TData = Awaited<ReturnType<typeof getValidCallerIdList>>,
  TError = GetValidCallerIdList500,
>(
  params: GetValidCallerIdListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getValidCallerIdList>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getValidCallerIdList>>,
          TError,
          Awaited<ReturnType<typeof getValidCallerIdList>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};
export function useGetValidCallerIdList<
  TData = Awaited<ReturnType<typeof getValidCallerIdList>>,
  TError = GetValidCallerIdList500,
>(
  params: GetValidCallerIdListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getValidCallerIdList>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};

export function useGetValidCallerIdList<
  TData = Awaited<ReturnType<typeof getValidCallerIdList>>,
  TError = GetValidCallerIdList500,
>(
  params: GetValidCallerIdListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getValidCallerIdList>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetValidCallerIdListQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & {queryKey: DataTag<QueryKey, TData, TError>};

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Initializes a web hook using assistant data
 */
export const initializeWebHook = (
  assistantId: string,
  initializeWebHookBody: InitializeWebHookBody,
) => {
  return axiosInstance<void>({
    url: `/assistants/${assistantId}/webhooks`,
    method: "PUT",
    headers: {"Content-Type": "application/json"},
    data: initializeWebHookBody,
  });
};

export const getInitializeWebHookMutationOptions = <
  TError = ErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof initializeWebHook>>,
    TError,
    {assistantId: string; data: InitializeWebHookBody},
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof initializeWebHook>>,
  TError,
  {assistantId: string; data: InitializeWebHookBody},
  TContext
> => {
  const mutationKey = ["initializeWebHook"];
  const {mutation: mutationOptions} = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : {...options, mutation: {...options.mutation, mutationKey}}
    : {mutation: {mutationKey}};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof initializeWebHook>>,
    {assistantId: string; data: InitializeWebHookBody}
  > = props => {
    const {assistantId, data} = props ?? {};

    return initializeWebHook(assistantId, data);
  };

  return {mutationFn, ...mutationOptions};
};

export type InitializeWebHookMutationResult = NonNullable<
  Awaited<ReturnType<typeof initializeWebHook>>
>;
export type InitializeWebHookMutationBody = InitializeWebHookBody;
export type InitializeWebHookMutationError = ErrorResponse;

export const useInitializeWebHook = <
  TError = ErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof initializeWebHook>>,
      TError,
      {assistantId: string; data: InitializeWebHookBody},
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof initializeWebHook>>,
  TError,
  {assistantId: string; data: InitializeWebHookBody},
  TContext
> => {
  const mutationOptions = getInitializeWebHookMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Retrieve a paginated list of webhook logs with filtering and search capability
 */
export const listWebhookLogs = (
  params: ListWebhookLogsParams,
  signal?: AbortSignal,
) => {
  return axiosInstance<WebhookAssistentPaginatedList>({
    url: `/logs`,
    method: "GET",
    params,
    signal,
  });
};

export const getListWebhookLogsQueryKey = (params: ListWebhookLogsParams) => {
  return [`/logs`, ...(params ? [params] : [])] as const;
};

export const getListWebhookLogsQueryOptions = <
  TData = Awaited<ReturnType<typeof listWebhookLogs>>,
  TError = ErrorResponse,
>(
  params: ListWebhookLogsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listWebhookLogs>>,
        TError,
        TData
      >
    >;
  },
) => {
  const {query: queryOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListWebhookLogsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listWebhookLogs>>> = ({
    signal,
  }) => listWebhookLogs(params, signal);

  return {queryKey, queryFn, ...queryOptions} as UseQueryOptions<
    Awaited<ReturnType<typeof listWebhookLogs>>,
    TError,
    TData
  > & {queryKey: DataTag<QueryKey, TData, TError>};
};

export type ListWebhookLogsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listWebhookLogs>>
>;
export type ListWebhookLogsQueryError = ErrorResponse;

export function useListWebhookLogs<
  TData = Awaited<ReturnType<typeof listWebhookLogs>>,
  TError = ErrorResponse,
>(
  params: ListWebhookLogsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listWebhookLogs>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listWebhookLogs>>,
          TError,
          Awaited<ReturnType<typeof listWebhookLogs>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListWebhookLogs<
  TData = Awaited<ReturnType<typeof listWebhookLogs>>,
  TError = ErrorResponse,
>(
  params: ListWebhookLogsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listWebhookLogs>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listWebhookLogs>>,
          TError,
          Awaited<ReturnType<typeof listWebhookLogs>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};
export function useListWebhookLogs<
  TData = Awaited<ReturnType<typeof listWebhookLogs>>,
  TError = ErrorResponse,
>(
  params: ListWebhookLogsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listWebhookLogs>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};

export function useListWebhookLogs<
  TData = Awaited<ReturnType<typeof listWebhookLogs>>,
  TError = ErrorResponse,
>(
  params: ListWebhookLogsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listWebhookLogs>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListWebhookLogsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & {queryKey: DataTag<QueryKey, TData, TError>};

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Retrieve detailed information for a specific webhook log
 */
export const getWebhookLogDetail = (
  webhookLogId: string,
  params: GetWebhookLogDetailParams,
  signal?: AbortSignal,
) => {
  return axiosInstance<WebhookLogDetailResponse>({
    url: `/logs/${webhookLogId}`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetWebhookLogDetailQueryKey = (
  webhookLogId: string,
  params: GetWebhookLogDetailParams,
) => {
  return [`/logs/${webhookLogId}`, ...(params ? [params] : [])] as const;
};

export const getGetWebhookLogDetailQueryOptions = <
  TData = Awaited<ReturnType<typeof getWebhookLogDetail>>,
  TError = ErrorResponse,
>(
  webhookLogId: string,
  params: GetWebhookLogDetailParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getWebhookLogDetail>>,
        TError,
        TData
      >
    >;
  },
) => {
  const {query: queryOptions} = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetWebhookLogDetailQueryKey(webhookLogId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getWebhookLogDetail>>
  > = ({signal}) => getWebhookLogDetail(webhookLogId, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!webhookLogId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getWebhookLogDetail>>,
    TError,
    TData
  > & {queryKey: DataTag<QueryKey, TData, TError>};
};

export type GetWebhookLogDetailQueryResult = NonNullable<
  Awaited<ReturnType<typeof getWebhookLogDetail>>
>;
export type GetWebhookLogDetailQueryError = ErrorResponse;

export function useGetWebhookLogDetail<
  TData = Awaited<ReturnType<typeof getWebhookLogDetail>>,
  TError = ErrorResponse,
>(
  webhookLogId: string,
  params: GetWebhookLogDetailParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getWebhookLogDetail>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWebhookLogDetail>>,
          TError,
          Awaited<ReturnType<typeof getWebhookLogDetail>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetWebhookLogDetail<
  TData = Awaited<ReturnType<typeof getWebhookLogDetail>>,
  TError = ErrorResponse,
>(
  webhookLogId: string,
  params: GetWebhookLogDetailParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getWebhookLogDetail>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWebhookLogDetail>>,
          TError,
          Awaited<ReturnType<typeof getWebhookLogDetail>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};
export function useGetWebhookLogDetail<
  TData = Awaited<ReturnType<typeof getWebhookLogDetail>>,
  TError = ErrorResponse,
>(
  webhookLogId: string,
  params: GetWebhookLogDetailParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getWebhookLogDetail>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};

export function useGetWebhookLogDetail<
  TData = Awaited<ReturnType<typeof getWebhookLogDetail>>,
  TError = ErrorResponse,
>(
  webhookLogId: string,
  params: GetWebhookLogDetailParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getWebhookLogDetail>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetWebhookLogDetailQueryOptions(
    webhookLogId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & {queryKey: DataTag<QueryKey, TData, TError>};

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get the list of world time zones
 */
export const getTimeZoneList = (signal?: AbortSignal) => {
  return axiosInstance<TimeZone[]>({url: `/time_zones`, method: "GET", signal});
};

export const getGetTimeZoneListQueryKey = () => {
  return [`/time_zones`] as const;
};

export const getGetTimeZoneListQueryOptions = <
  TData = Awaited<ReturnType<typeof getTimeZoneList>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getTimeZoneList>>, TError, TData>
  >;
}) => {
  const {query: queryOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTimeZoneListQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTimeZoneList>>> = ({
    signal,
  }) => getTimeZoneList(signal);

  return {queryKey, queryFn, ...queryOptions} as UseQueryOptions<
    Awaited<ReturnType<typeof getTimeZoneList>>,
    TError,
    TData
  > & {queryKey: DataTag<QueryKey, TData, TError>};
};

export type GetTimeZoneListQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTimeZoneList>>
>;
export type GetTimeZoneListQueryError = unknown;

export function useGetTimeZoneList<
  TData = Awaited<ReturnType<typeof getTimeZoneList>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTimeZoneList>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTimeZoneList>>,
          TError,
          Awaited<ReturnType<typeof getTimeZoneList>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTimeZoneList<
  TData = Awaited<ReturnType<typeof getTimeZoneList>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTimeZoneList>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTimeZoneList>>,
          TError,
          Awaited<ReturnType<typeof getTimeZoneList>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};
export function useGetTimeZoneList<
  TData = Awaited<ReturnType<typeof getTimeZoneList>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTimeZoneList>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};

export function useGetTimeZoneList<
  TData = Awaited<ReturnType<typeof getTimeZoneList>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTimeZoneList>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetTimeZoneListQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & {queryKey: DataTag<QueryKey, TData, TError>};

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Guess the user time zone
 */
export const guessClientTimeZone = (signal?: AbortSignal) => {
  return axiosInstance<TimeZone>({
    url: `/time_zones/current`,
    method: "GET",
    signal,
  });
};

export const getGuessClientTimeZoneQueryKey = () => {
  return [`/time_zones/current`] as const;
};

export const getGuessClientTimeZoneQueryOptions = <
  TData = Awaited<ReturnType<typeof guessClientTimeZone>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof guessClientTimeZone>>,
      TError,
      TData
    >
  >;
}) => {
  const {query: queryOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGuessClientTimeZoneQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof guessClientTimeZone>>
  > = ({signal}) => guessClientTimeZone(signal);

  return {queryKey, queryFn, ...queryOptions} as UseQueryOptions<
    Awaited<ReturnType<typeof guessClientTimeZone>>,
    TError,
    TData
  > & {queryKey: DataTag<QueryKey, TData, TError>};
};

export type GuessClientTimeZoneQueryResult = NonNullable<
  Awaited<ReturnType<typeof guessClientTimeZone>>
>;
export type GuessClientTimeZoneQueryError = unknown;

export function useGuessClientTimeZone<
  TData = Awaited<ReturnType<typeof guessClientTimeZone>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof guessClientTimeZone>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof guessClientTimeZone>>,
          TError,
          Awaited<ReturnType<typeof guessClientTimeZone>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGuessClientTimeZone<
  TData = Awaited<ReturnType<typeof guessClientTimeZone>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof guessClientTimeZone>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof guessClientTimeZone>>,
          TError,
          Awaited<ReturnType<typeof guessClientTimeZone>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};
export function useGuessClientTimeZone<
  TData = Awaited<ReturnType<typeof guessClientTimeZone>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof guessClientTimeZone>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};

export function useGuessClientTimeZone<
  TData = Awaited<ReturnType<typeof guessClientTimeZone>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof guessClientTimeZone>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGuessClientTimeZoneQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & {queryKey: DataTag<QueryKey, TData, TError>};

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get list of valid locales
 */
export const getLocaleList = (signal?: AbortSignal) => {
  return axiosInstance<LocaleInfo[]>({url: `/locales`, method: "GET", signal});
};

export const getGetLocaleListQueryKey = () => {
  return [`/locales`] as const;
};

export const getGetLocaleListQueryOptions = <
  TData = Awaited<ReturnType<typeof getLocaleList>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getLocaleList>>, TError, TData>
  >;
}) => {
  const {query: queryOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetLocaleListQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getLocaleList>>> = ({
    signal,
  }) => getLocaleList(signal);

  return {queryKey, queryFn, ...queryOptions} as UseQueryOptions<
    Awaited<ReturnType<typeof getLocaleList>>,
    TError,
    TData
  > & {queryKey: DataTag<QueryKey, TData, TError>};
};

export type GetLocaleListQueryResult = NonNullable<
  Awaited<ReturnType<typeof getLocaleList>>
>;
export type GetLocaleListQueryError = unknown;

export function useGetLocaleList<
  TData = Awaited<ReturnType<typeof getLocaleList>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getLocaleList>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLocaleList>>,
          TError,
          Awaited<ReturnType<typeof getLocaleList>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetLocaleList<
  TData = Awaited<ReturnType<typeof getLocaleList>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getLocaleList>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLocaleList>>,
          TError,
          Awaited<ReturnType<typeof getLocaleList>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};
export function useGetLocaleList<
  TData = Awaited<ReturnType<typeof getLocaleList>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getLocaleList>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};

export function useGetLocaleList<
  TData = Awaited<ReturnType<typeof getLocaleList>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getLocaleList>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetLocaleListQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & {queryKey: DataTag<QueryKey, TData, TError>};

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Guess the user locale
 */
export const guessClientLocale = (signal?: AbortSignal) => {
  return axiosInstance<LocaleInfo>({
    url: `/locales/current`,
    method: "GET",
    signal,
  });
};

export const getGuessClientLocaleQueryKey = () => {
  return [`/locales/current`] as const;
};

export const getGuessClientLocaleQueryOptions = <
  TData = Awaited<ReturnType<typeof guessClientLocale>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof guessClientLocale>>,
      TError,
      TData
    >
  >;
}) => {
  const {query: queryOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGuessClientLocaleQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof guessClientLocale>>
  > = ({signal}) => guessClientLocale(signal);

  return {queryKey, queryFn, ...queryOptions} as UseQueryOptions<
    Awaited<ReturnType<typeof guessClientLocale>>,
    TError,
    TData
  > & {queryKey: DataTag<QueryKey, TData, TError>};
};

export type GuessClientLocaleQueryResult = NonNullable<
  Awaited<ReturnType<typeof guessClientLocale>>
>;
export type GuessClientLocaleQueryError = unknown;

export function useGuessClientLocale<
  TData = Awaited<ReturnType<typeof guessClientLocale>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof guessClientLocale>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof guessClientLocale>>,
          TError,
          Awaited<ReturnType<typeof guessClientLocale>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGuessClientLocale<
  TData = Awaited<ReturnType<typeof guessClientLocale>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof guessClientLocale>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof guessClientLocale>>,
          TError,
          Awaited<ReturnType<typeof guessClientLocale>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};
export function useGuessClientLocale<
  TData = Awaited<ReturnType<typeof guessClientLocale>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof guessClientLocale>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};

export function useGuessClientLocale<
  TData = Awaited<ReturnType<typeof guessClientLocale>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof guessClientLocale>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGuessClientLocaleQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & {queryKey: DataTag<QueryKey, TData, TError>};

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Verify phone number
 */
export const verifyPhoneNumber = (
  phoneNumber: string,
  verifyPhoneNumberBody: VerifyPhoneNumberBody,
) => {
  return axiosInstance<VerifyPhoneNumber200 | void>({
    url: `/phone_numbers/${phoneNumber}/verify`,
    method: "PUT",
    headers: {"Content-Type": "application/json"},
    data: verifyPhoneNumberBody,
  });
};

export const getVerifyPhoneNumberMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof verifyPhoneNumber>>,
    TError,
    {phoneNumber: string; data: VerifyPhoneNumberBody},
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof verifyPhoneNumber>>,
  TError,
  {phoneNumber: string; data: VerifyPhoneNumberBody},
  TContext
> => {
  const mutationKey = ["verifyPhoneNumber"];
  const {mutation: mutationOptions} = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : {...options, mutation: {...options.mutation, mutationKey}}
    : {mutation: {mutationKey}};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof verifyPhoneNumber>>,
    {phoneNumber: string; data: VerifyPhoneNumberBody}
  > = props => {
    const {phoneNumber, data} = props ?? {};

    return verifyPhoneNumber(phoneNumber, data);
  };

  return {mutationFn, ...mutationOptions};
};

export type VerifyPhoneNumberMutationResult = NonNullable<
  Awaited<ReturnType<typeof verifyPhoneNumber>>
>;
export type VerifyPhoneNumberMutationBody = VerifyPhoneNumberBody;
export type VerifyPhoneNumberMutationError = void;

export const useVerifyPhoneNumber = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof verifyPhoneNumber>>,
      TError,
      {phoneNumber: string; data: VerifyPhoneNumberBody},
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof verifyPhoneNumber>>,
  TError,
  {phoneNumber: string; data: VerifyPhoneNumberBody},
  TContext
> => {
  const mutationOptions = getVerifyPhoneNumberMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Get the call payload for a specific call
 */
export const getCallPayload = (
  requiredInformationCallInput: RequiredInformationCallInput,
  signal?: AbortSignal,
) => {
  return axiosInstance<void>({
    url: `/calls/payload`,
    method: "POST",
    headers: {"Content-Type": "application/json"},
    data: requiredInformationCallInput,
    signal,
  });
};

export const getGetCallPayloadMutationOptions = <
  TError = PublicAPIErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getCallPayload>>,
    TError,
    {data: RequiredInformationCallInput},
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getCallPayload>>,
  TError,
  {data: RequiredInformationCallInput},
  TContext
> => {
  const mutationKey = ["getCallPayload"];
  const {mutation: mutationOptions} = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : {...options, mutation: {...options.mutation, mutationKey}}
    : {mutation: {mutationKey}};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getCallPayload>>,
    {data: RequiredInformationCallInput}
  > = props => {
    const {data} = props ?? {};

    return getCallPayload(data);
  };

  return {mutationFn, ...mutationOptions};
};

export type GetCallPayloadMutationResult = NonNullable<
  Awaited<ReturnType<typeof getCallPayload>>
>;
export type GetCallPayloadMutationBody = RequiredInformationCallInput;
export type GetCallPayloadMutationError = PublicAPIErrorResponse;

export const useGetCallPayload = <
  TError = PublicAPIErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof getCallPayload>>,
      TError,
      {data: RequiredInformationCallInput},
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof getCallPayload>>,
  TError,
  {data: RequiredInformationCallInput},
  TContext
> => {
  const mutationOptions = getGetCallPayloadMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Authenticate user and get JWT token
 */
export const authUser = (
  userJWTAuthRequest: UserJWTAuthRequest,
  signal?: AbortSignal,
) => {
  return axiosInstance<UserJWTAuthResponse | void>({
    url: `/users/auth`,
    method: "POST",
    headers: {"Content-Type": "application/json"},
    data: userJWTAuthRequest,
    signal,
  });
};

export const getAuthUserMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof authUser>>,
    TError,
    {data: UserJWTAuthRequest},
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof authUser>>,
  TError,
  {data: UserJWTAuthRequest},
  TContext
> => {
  const mutationKey = ["authUser"];
  const {mutation: mutationOptions} = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : {...options, mutation: {...options.mutation, mutationKey}}
    : {mutation: {mutationKey}};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof authUser>>,
    {data: UserJWTAuthRequest}
  > = props => {
    const {data} = props ?? {};

    return authUser(data);
  };

  return {mutationFn, ...mutationOptions};
};

export type AuthUserMutationResult = NonNullable<
  Awaited<ReturnType<typeof authUser>>
>;
export type AuthUserMutationBody = UserJWTAuthRequest;
export type AuthUserMutationError = void;

export const useAuthUser = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof authUser>>,
      TError,
      {data: UserJWTAuthRequest},
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof authUser>>,
  TError,
  {data: UserJWTAuthRequest},
  TContext
> => {
  const mutationOptions = getAuthUserMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * WriteCookie to browser.
 */
export const writeCookie = (
  writeCookieRequest: WriteCookieRequest,
  signal?: AbortSignal,
) => {
  return axiosInstance<UserJWTAuthResponse | void>({
    url: `/users/write_cookie`,
    method: "POST",
    headers: {"Content-Type": "application/json"},
    data: writeCookieRequest,
    signal,
  });
};

export const getWriteCookieMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof writeCookie>>,
    TError,
    {data: WriteCookieRequest},
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof writeCookie>>,
  TError,
  {data: WriteCookieRequest},
  TContext
> => {
  const mutationKey = ["writeCookie"];
  const {mutation: mutationOptions} = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : {...options, mutation: {...options.mutation, mutationKey}}
    : {mutation: {mutationKey}};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof writeCookie>>,
    {data: WriteCookieRequest}
  > = props => {
    const {data} = props ?? {};

    return writeCookie(data);
  };

  return {mutationFn, ...mutationOptions};
};

export type WriteCookieMutationResult = NonNullable<
  Awaited<ReturnType<typeof writeCookie>>
>;
export type WriteCookieMutationBody = WriteCookieRequest;
export type WriteCookieMutationError = void;

export const useWriteCookie = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof writeCookie>>,
      TError,
      {data: WriteCookieRequest},
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof writeCookie>>,
  TError,
  {data: WriteCookieRequest},
  TContext
> => {
  const mutationOptions = getWriteCookieMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Create a new simulation case
 */
export const createSimulationCase = (
  simulationCaseCreateIn: SimulationCaseCreateIn,
  params: CreateSimulationCaseParams,
  signal?: AbortSignal,
) => {
  return axiosInstance<SimulationCaseReadOut>({
    url: `/simulation_cases`,
    method: "POST",
    headers: {"Content-Type": "application/json"},
    data: simulationCaseCreateIn,
    params,
    signal,
  });
};

export const getCreateSimulationCaseMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createSimulationCase>>,
    TError,
    {data: SimulationCaseCreateIn; params: CreateSimulationCaseParams},
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createSimulationCase>>,
  TError,
  {data: SimulationCaseCreateIn; params: CreateSimulationCaseParams},
  TContext
> => {
  const mutationKey = ["createSimulationCase"];
  const {mutation: mutationOptions} = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : {...options, mutation: {...options.mutation, mutationKey}}
    : {mutation: {mutationKey}};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createSimulationCase>>,
    {data: SimulationCaseCreateIn; params: CreateSimulationCaseParams}
  > = props => {
    const {data, params} = props ?? {};

    return createSimulationCase(data, params);
  };

  return {mutationFn, ...mutationOptions};
};

export type CreateSimulationCaseMutationResult = NonNullable<
  Awaited<ReturnType<typeof createSimulationCase>>
>;
export type CreateSimulationCaseMutationBody = SimulationCaseCreateIn;
export type CreateSimulationCaseMutationError = void;

export const useCreateSimulationCase = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createSimulationCase>>,
      TError,
      {data: SimulationCaseCreateIn; params: CreateSimulationCaseParams},
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createSimulationCase>>,
  TError,
  {data: SimulationCaseCreateIn; params: CreateSimulationCaseParams},
  TContext
> => {
  const mutationOptions = getCreateSimulationCaseMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * List simulation cases with pagination and filtering
 */
export const listSimulationCases = (
  params: ListSimulationCasesParams,
  signal?: AbortSignal,
) => {
  return axiosInstance<ListSimulationCases200>({
    url: `/simulation_cases`,
    method: "GET",
    params,
    signal,
  });
};

export const getListSimulationCasesQueryKey = (
  params: ListSimulationCasesParams,
) => {
  return [`/simulation_cases`, ...(params ? [params] : [])] as const;
};

export const getListSimulationCasesQueryOptions = <
  TData = Awaited<ReturnType<typeof listSimulationCases>>,
  TError = void,
>(
  params: ListSimulationCasesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listSimulationCases>>,
        TError,
        TData
      >
    >;
  },
) => {
  const {query: queryOptions} = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListSimulationCasesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listSimulationCases>>
  > = ({signal}) => listSimulationCases(params, signal);

  return {queryKey, queryFn, ...queryOptions} as UseQueryOptions<
    Awaited<ReturnType<typeof listSimulationCases>>,
    TError,
    TData
  > & {queryKey: DataTag<QueryKey, TData, TError>};
};

export type ListSimulationCasesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listSimulationCases>>
>;
export type ListSimulationCasesQueryError = void;

export function useListSimulationCases<
  TData = Awaited<ReturnType<typeof listSimulationCases>>,
  TError = void,
>(
  params: ListSimulationCasesParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listSimulationCases>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSimulationCases>>,
          TError,
          Awaited<ReturnType<typeof listSimulationCases>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListSimulationCases<
  TData = Awaited<ReturnType<typeof listSimulationCases>>,
  TError = void,
>(
  params: ListSimulationCasesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listSimulationCases>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSimulationCases>>,
          TError,
          Awaited<ReturnType<typeof listSimulationCases>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};
export function useListSimulationCases<
  TData = Awaited<ReturnType<typeof listSimulationCases>>,
  TError = void,
>(
  params: ListSimulationCasesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listSimulationCases>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};

export function useListSimulationCases<
  TData = Awaited<ReturnType<typeof listSimulationCases>>,
  TError = void,
>(
  params: ListSimulationCasesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listSimulationCases>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListSimulationCasesQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & {queryKey: DataTag<QueryKey, TData, TError>};

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get a specific simulation case by ID
 */
export const getSimulationCase = (
  simulationCaseId: string,
  params: GetSimulationCaseParams,
  signal?: AbortSignal,
) => {
  return axiosInstance<SimulationCaseReadOut>({
    url: `/simulation_cases/${simulationCaseId}`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetSimulationCaseQueryKey = (
  simulationCaseId: string,
  params: GetSimulationCaseParams,
) => {
  return [
    `/simulation_cases/${simulationCaseId}`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetSimulationCaseQueryOptions = <
  TData = Awaited<ReturnType<typeof getSimulationCase>>,
  TError = void,
>(
  simulationCaseId: string,
  params: GetSimulationCaseParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSimulationCase>>,
        TError,
        TData
      >
    >;
  },
) => {
  const {query: queryOptions} = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetSimulationCaseQueryKey(simulationCaseId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getSimulationCase>>
  > = ({signal}) => getSimulationCase(simulationCaseId, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!simulationCaseId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getSimulationCase>>,
    TError,
    TData
  > & {queryKey: DataTag<QueryKey, TData, TError>};
};

export type GetSimulationCaseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSimulationCase>>
>;
export type GetSimulationCaseQueryError = void;

export function useGetSimulationCase<
  TData = Awaited<ReturnType<typeof getSimulationCase>>,
  TError = void,
>(
  simulationCaseId: string,
  params: GetSimulationCaseParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSimulationCase>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSimulationCase>>,
          TError,
          Awaited<ReturnType<typeof getSimulationCase>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSimulationCase<
  TData = Awaited<ReturnType<typeof getSimulationCase>>,
  TError = void,
>(
  simulationCaseId: string,
  params: GetSimulationCaseParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSimulationCase>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSimulationCase>>,
          TError,
          Awaited<ReturnType<typeof getSimulationCase>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};
export function useGetSimulationCase<
  TData = Awaited<ReturnType<typeof getSimulationCase>>,
  TError = void,
>(
  simulationCaseId: string,
  params: GetSimulationCaseParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSimulationCase>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};

export function useGetSimulationCase<
  TData = Awaited<ReturnType<typeof getSimulationCase>>,
  TError = void,
>(
  simulationCaseId: string,
  params: GetSimulationCaseParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSimulationCase>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetSimulationCaseQueryOptions(
    simulationCaseId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & {queryKey: DataTag<QueryKey, TData, TError>};

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Update a simulation case
 */
export const updateSimulationCase = (
  simulationCaseId: string,
  simulationCaseUpdateIn: SimulationCaseUpdateIn,
  params: UpdateSimulationCaseParams,
) => {
  return axiosInstance<SimulationCaseReadOut>({
    url: `/simulation_cases/${simulationCaseId}`,
    method: "PUT",
    headers: {"Content-Type": "application/json"},
    data: simulationCaseUpdateIn,
    params,
  });
};

export const getUpdateSimulationCaseMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateSimulationCase>>,
    TError,
    {
      simulationCaseId: string;
      data: SimulationCaseUpdateIn;
      params: UpdateSimulationCaseParams;
    },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateSimulationCase>>,
  TError,
  {
    simulationCaseId: string;
    data: SimulationCaseUpdateIn;
    params: UpdateSimulationCaseParams;
  },
  TContext
> => {
  const mutationKey = ["updateSimulationCase"];
  const {mutation: mutationOptions} = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : {...options, mutation: {...options.mutation, mutationKey}}
    : {mutation: {mutationKey}};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateSimulationCase>>,
    {
      simulationCaseId: string;
      data: SimulationCaseUpdateIn;
      params: UpdateSimulationCaseParams;
    }
  > = props => {
    const {simulationCaseId, data, params} = props ?? {};

    return updateSimulationCase(simulationCaseId, data, params);
  };

  return {mutationFn, ...mutationOptions};
};

export type UpdateSimulationCaseMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateSimulationCase>>
>;
export type UpdateSimulationCaseMutationBody = SimulationCaseUpdateIn;
export type UpdateSimulationCaseMutationError = void;

export const useUpdateSimulationCase = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateSimulationCase>>,
      TError,
      {
        simulationCaseId: string;
        data: SimulationCaseUpdateIn;
        params: UpdateSimulationCaseParams;
      },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateSimulationCase>>,
  TError,
  {
    simulationCaseId: string;
    data: SimulationCaseUpdateIn;
    params: UpdateSimulationCaseParams;
  },
  TContext
> => {
  const mutationOptions = getUpdateSimulationCaseMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Delete a simulation case
 */
export const deleteSimulationCase = (
  simulationCaseId: string,
  params: DeleteSimulationCaseParams,
) => {
  return axiosInstance<void>({
    url: `/simulation_cases/${simulationCaseId}`,
    method: "DELETE",
    params,
  });
};

export const getDeleteSimulationCaseMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSimulationCase>>,
    TError,
    {simulationCaseId: string; params: DeleteSimulationCaseParams},
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteSimulationCase>>,
  TError,
  {simulationCaseId: string; params: DeleteSimulationCaseParams},
  TContext
> => {
  const mutationKey = ["deleteSimulationCase"];
  const {mutation: mutationOptions} = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : {...options, mutation: {...options.mutation, mutationKey}}
    : {mutation: {mutationKey}};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteSimulationCase>>,
    {simulationCaseId: string; params: DeleteSimulationCaseParams}
  > = props => {
    const {simulationCaseId, params} = props ?? {};

    return deleteSimulationCase(simulationCaseId, params);
  };

  return {mutationFn, ...mutationOptions};
};

export type DeleteSimulationCaseMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteSimulationCase>>
>;

export type DeleteSimulationCaseMutationError = void;

export const useDeleteSimulationCase = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteSimulationCase>>,
      TError,
      {simulationCaseId: string; params: DeleteSimulationCaseParams},
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteSimulationCase>>,
  TError,
  {simulationCaseId: string; params: DeleteSimulationCaseParams},
  TContext
> => {
  const mutationOptions = getDeleteSimulationCaseMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Stream simulation case generation results using NDJSON (Newline Delimited JSON) with fetch() + ReadableStream support
 */
export const generateSimulationCases = (
  generateSimulationCasesBody: GenerateSimulationCasesBody,
  params: GenerateSimulationCasesParams,
  signal?: AbortSignal,
) => {
  return axiosInstance<string>({
    url: `/simulation_cases/generate`,
    method: "POST",
    headers: {"Content-Type": "application/json"},
    data: generateSimulationCasesBody,
    params,
    signal,
  });
};

export const getGenerateSimulationCasesMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateSimulationCases>>,
    TError,
    {data: GenerateSimulationCasesBody; params: GenerateSimulationCasesParams},
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof generateSimulationCases>>,
  TError,
  {data: GenerateSimulationCasesBody; params: GenerateSimulationCasesParams},
  TContext
> => {
  const mutationKey = ["generateSimulationCases"];
  const {mutation: mutationOptions} = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : {...options, mutation: {...options.mutation, mutationKey}}
    : {mutation: {mutationKey}};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof generateSimulationCases>>,
    {data: GenerateSimulationCasesBody; params: GenerateSimulationCasesParams}
  > = props => {
    const {data, params} = props ?? {};

    return generateSimulationCases(data, params);
  };

  return {mutationFn, ...mutationOptions};
};

export type GenerateSimulationCasesMutationResult = NonNullable<
  Awaited<ReturnType<typeof generateSimulationCases>>
>;
export type GenerateSimulationCasesMutationBody = GenerateSimulationCasesBody;
export type GenerateSimulationCasesMutationError = void;

export const useGenerateSimulationCases = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof generateSimulationCases>>,
      TError,
      {
        data: GenerateSimulationCasesBody;
        params: GenerateSimulationCasesParams;
      },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof generateSimulationCases>>,
  TError,
  {data: GenerateSimulationCasesBody; params: GenerateSimulationCasesParams},
  TContext
> => {
  const mutationOptions = getGenerateSimulationCasesMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * List all simulation cases created for a specific agent (no pagination)
 */
export const listSimulationCasesByAgent = (
  params: ListSimulationCasesByAgentParams,
  signal?: AbortSignal,
) => {
  return axiosInstance<SimulationCaseReadOut[]>({
    url: `/simulation_cases/by_agent`,
    method: "GET",
    params,
    signal,
  });
};

export const getListSimulationCasesByAgentQueryKey = (
  params: ListSimulationCasesByAgentParams,
) => {
  return [`/simulation_cases/by_agent`, ...(params ? [params] : [])] as const;
};

export const getListSimulationCasesByAgentQueryOptions = <
  TData = Awaited<ReturnType<typeof listSimulationCasesByAgent>>,
  TError = void,
>(
  params: ListSimulationCasesByAgentParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listSimulationCasesByAgent>>,
        TError,
        TData
      >
    >;
  },
) => {
  const {query: queryOptions} = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListSimulationCasesByAgentQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listSimulationCasesByAgent>>
  > = ({signal}) => listSimulationCasesByAgent(params, signal);

  return {queryKey, queryFn, ...queryOptions} as UseQueryOptions<
    Awaited<ReturnType<typeof listSimulationCasesByAgent>>,
    TError,
    TData
  > & {queryKey: DataTag<QueryKey, TData, TError>};
};

export type ListSimulationCasesByAgentQueryResult = NonNullable<
  Awaited<ReturnType<typeof listSimulationCasesByAgent>>
>;
export type ListSimulationCasesByAgentQueryError = void;

export function useListSimulationCasesByAgent<
  TData = Awaited<ReturnType<typeof listSimulationCasesByAgent>>,
  TError = void,
>(
  params: ListSimulationCasesByAgentParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listSimulationCasesByAgent>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSimulationCasesByAgent>>,
          TError,
          Awaited<ReturnType<typeof listSimulationCasesByAgent>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListSimulationCasesByAgent<
  TData = Awaited<ReturnType<typeof listSimulationCasesByAgent>>,
  TError = void,
>(
  params: ListSimulationCasesByAgentParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listSimulationCasesByAgent>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSimulationCasesByAgent>>,
          TError,
          Awaited<ReturnType<typeof listSimulationCasesByAgent>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};
export function useListSimulationCasesByAgent<
  TData = Awaited<ReturnType<typeof listSimulationCasesByAgent>>,
  TError = void,
>(
  params: ListSimulationCasesByAgentParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listSimulationCasesByAgent>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};

export function useListSimulationCasesByAgent<
  TData = Awaited<ReturnType<typeof listSimulationCasesByAgent>>,
  TError = void,
>(
  params: ListSimulationCasesByAgentParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listSimulationCasesByAgent>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListSimulationCasesByAgentQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & {queryKey: DataTag<QueryKey, TData, TError>};

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Create a new simulation suite
 */
export const createSimulationSuite = (
  simulationSuiteCreateIn: SimulationSuiteCreateIn,
  params: CreateSimulationSuiteParams,
  signal?: AbortSignal,
) => {
  return axiosInstance<SimulationSuiteReadOut>({
    url: `/simulation_suites`,
    method: "POST",
    headers: {"Content-Type": "application/json"},
    data: simulationSuiteCreateIn,
    params,
    signal,
  });
};

export const getCreateSimulationSuiteMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createSimulationSuite>>,
    TError,
    {data: SimulationSuiteCreateIn; params: CreateSimulationSuiteParams},
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createSimulationSuite>>,
  TError,
  {data: SimulationSuiteCreateIn; params: CreateSimulationSuiteParams},
  TContext
> => {
  const mutationKey = ["createSimulationSuite"];
  const {mutation: mutationOptions} = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : {...options, mutation: {...options.mutation, mutationKey}}
    : {mutation: {mutationKey}};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createSimulationSuite>>,
    {data: SimulationSuiteCreateIn; params: CreateSimulationSuiteParams}
  > = props => {
    const {data, params} = props ?? {};

    return createSimulationSuite(data, params);
  };

  return {mutationFn, ...mutationOptions};
};

export type CreateSimulationSuiteMutationResult = NonNullable<
  Awaited<ReturnType<typeof createSimulationSuite>>
>;
export type CreateSimulationSuiteMutationBody = SimulationSuiteCreateIn;
export type CreateSimulationSuiteMutationError = void;

export const useCreateSimulationSuite = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createSimulationSuite>>,
      TError,
      {data: SimulationSuiteCreateIn; params: CreateSimulationSuiteParams},
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createSimulationSuite>>,
  TError,
  {data: SimulationSuiteCreateIn; params: CreateSimulationSuiteParams},
  TContext
> => {
  const mutationOptions = getCreateSimulationSuiteMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * List simulation suites with pagination
 */
export const listSimulationSuites = (
  params: ListSimulationSuitesParams,
  signal?: AbortSignal,
) => {
  return axiosInstance<PaginatedSimulationSuitesList>({
    url: `/simulation_suites`,
    method: "GET",
    params,
    signal,
  });
};

export const getListSimulationSuitesQueryKey = (
  params: ListSimulationSuitesParams,
) => {
  return [`/simulation_suites`, ...(params ? [params] : [])] as const;
};

export const getListSimulationSuitesQueryOptions = <
  TData = Awaited<ReturnType<typeof listSimulationSuites>>,
  TError = void,
>(
  params: ListSimulationSuitesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listSimulationSuites>>,
        TError,
        TData
      >
    >;
  },
) => {
  const {query: queryOptions} = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListSimulationSuitesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listSimulationSuites>>
  > = ({signal}) => listSimulationSuites(params, signal);

  return {queryKey, queryFn, ...queryOptions} as UseQueryOptions<
    Awaited<ReturnType<typeof listSimulationSuites>>,
    TError,
    TData
  > & {queryKey: DataTag<QueryKey, TData, TError>};
};

export type ListSimulationSuitesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listSimulationSuites>>
>;
export type ListSimulationSuitesQueryError = void;

export function useListSimulationSuites<
  TData = Awaited<ReturnType<typeof listSimulationSuites>>,
  TError = void,
>(
  params: ListSimulationSuitesParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listSimulationSuites>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSimulationSuites>>,
          TError,
          Awaited<ReturnType<typeof listSimulationSuites>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListSimulationSuites<
  TData = Awaited<ReturnType<typeof listSimulationSuites>>,
  TError = void,
>(
  params: ListSimulationSuitesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listSimulationSuites>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSimulationSuites>>,
          TError,
          Awaited<ReturnType<typeof listSimulationSuites>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};
export function useListSimulationSuites<
  TData = Awaited<ReturnType<typeof listSimulationSuites>>,
  TError = void,
>(
  params: ListSimulationSuitesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listSimulationSuites>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};

export function useListSimulationSuites<
  TData = Awaited<ReturnType<typeof listSimulationSuites>>,
  TError = void,
>(
  params: ListSimulationSuitesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listSimulationSuites>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListSimulationSuitesQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & {queryKey: DataTag<QueryKey, TData, TError>};

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get a specific simulation suite by ID
 */
export const getSimulationSuite = (
  suiteId: string,
  params: GetSimulationSuiteParams,
  signal?: AbortSignal,
) => {
  return axiosInstance<SimulationSuiteReadOut>({
    url: `/simulation_suites/${suiteId}`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetSimulationSuiteQueryKey = (
  suiteId: string,
  params: GetSimulationSuiteParams,
) => {
  return [
    `/simulation_suites/${suiteId}`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetSimulationSuiteQueryOptions = <
  TData = Awaited<ReturnType<typeof getSimulationSuite>>,
  TError = void,
>(
  suiteId: string,
  params: GetSimulationSuiteParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSimulationSuite>>,
        TError,
        TData
      >
    >;
  },
) => {
  const {query: queryOptions} = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetSimulationSuiteQueryKey(suiteId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getSimulationSuite>>
  > = ({signal}) => getSimulationSuite(suiteId, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!suiteId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getSimulationSuite>>,
    TError,
    TData
  > & {queryKey: DataTag<QueryKey, TData, TError>};
};

export type GetSimulationSuiteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSimulationSuite>>
>;
export type GetSimulationSuiteQueryError = void;

export function useGetSimulationSuite<
  TData = Awaited<ReturnType<typeof getSimulationSuite>>,
  TError = void,
>(
  suiteId: string,
  params: GetSimulationSuiteParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSimulationSuite>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSimulationSuite>>,
          TError,
          Awaited<ReturnType<typeof getSimulationSuite>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSimulationSuite<
  TData = Awaited<ReturnType<typeof getSimulationSuite>>,
  TError = void,
>(
  suiteId: string,
  params: GetSimulationSuiteParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSimulationSuite>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSimulationSuite>>,
          TError,
          Awaited<ReturnType<typeof getSimulationSuite>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};
export function useGetSimulationSuite<
  TData = Awaited<ReturnType<typeof getSimulationSuite>>,
  TError = void,
>(
  suiteId: string,
  params: GetSimulationSuiteParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSimulationSuite>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};

export function useGetSimulationSuite<
  TData = Awaited<ReturnType<typeof getSimulationSuite>>,
  TError = void,
>(
  suiteId: string,
  params: GetSimulationSuiteParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSimulationSuite>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetSimulationSuiteQueryOptions(
    suiteId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & {queryKey: DataTag<QueryKey, TData, TError>};

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Update a simulation suite
 */
export const updateSimulationSuite = (
  suiteId: string,
  simulationSuiteUpdateIn: SimulationSuiteUpdateIn,
  params: UpdateSimulationSuiteParams,
) => {
  return axiosInstance<SimulationSuiteReadOut>({
    url: `/simulation_suites/${suiteId}`,
    method: "PUT",
    headers: {"Content-Type": "application/json"},
    data: simulationSuiteUpdateIn,
    params,
  });
};

export const getUpdateSimulationSuiteMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateSimulationSuite>>,
    TError,
    {
      suiteId: string;
      data: SimulationSuiteUpdateIn;
      params: UpdateSimulationSuiteParams;
    },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateSimulationSuite>>,
  TError,
  {
    suiteId: string;
    data: SimulationSuiteUpdateIn;
    params: UpdateSimulationSuiteParams;
  },
  TContext
> => {
  const mutationKey = ["updateSimulationSuite"];
  const {mutation: mutationOptions} = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : {...options, mutation: {...options.mutation, mutationKey}}
    : {mutation: {mutationKey}};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateSimulationSuite>>,
    {
      suiteId: string;
      data: SimulationSuiteUpdateIn;
      params: UpdateSimulationSuiteParams;
    }
  > = props => {
    const {suiteId, data, params} = props ?? {};

    return updateSimulationSuite(suiteId, data, params);
  };

  return {mutationFn, ...mutationOptions};
};

export type UpdateSimulationSuiteMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateSimulationSuite>>
>;
export type UpdateSimulationSuiteMutationBody = SimulationSuiteUpdateIn;
export type UpdateSimulationSuiteMutationError = void;

export const useUpdateSimulationSuite = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateSimulationSuite>>,
      TError,
      {
        suiteId: string;
        data: SimulationSuiteUpdateIn;
        params: UpdateSimulationSuiteParams;
      },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateSimulationSuite>>,
  TError,
  {
    suiteId: string;
    data: SimulationSuiteUpdateIn;
    params: UpdateSimulationSuiteParams;
  },
  TContext
> => {
  const mutationOptions = getUpdateSimulationSuiteMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Delete a simulation suite (cascade deletes simulation_cases)
 */
export const deleteSimulationSuite = (
  suiteId: string,
  params: DeleteSimulationSuiteParams,
) => {
  return axiosInstance<void>({
    url: `/simulation_suites/${suiteId}`,
    method: "DELETE",
    params,
  });
};

export const getDeleteSimulationSuiteMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSimulationSuite>>,
    TError,
    {suiteId: string; params: DeleteSimulationSuiteParams},
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteSimulationSuite>>,
  TError,
  {suiteId: string; params: DeleteSimulationSuiteParams},
  TContext
> => {
  const mutationKey = ["deleteSimulationSuite"];
  const {mutation: mutationOptions} = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : {...options, mutation: {...options.mutation, mutationKey}}
    : {mutation: {mutationKey}};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteSimulationSuite>>,
    {suiteId: string; params: DeleteSimulationSuiteParams}
  > = props => {
    const {suiteId, params} = props ?? {};

    return deleteSimulationSuite(suiteId, params);
  };

  return {mutationFn, ...mutationOptions};
};

export type DeleteSimulationSuiteMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteSimulationSuite>>
>;

export type DeleteSimulationSuiteMutationError = void;

export const useDeleteSimulationSuite = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteSimulationSuite>>,
      TError,
      {suiteId: string; params: DeleteSimulationSuiteParams},
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteSimulationSuite>>,
  TError,
  {suiteId: string; params: DeleteSimulationSuiteParams},
  TContext
> => {
  const mutationOptions = getDeleteSimulationSuiteMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Create a new simulation scenario
 */
export const createSimulationScenario = (
  simulationScenarioCreateIn: SimulationScenarioCreateIn,
  params: CreateSimulationScenarioParams,
  signal?: AbortSignal,
) => {
  return axiosInstance<SimulationScenarioReadOut>({
    url: `/simulation_scenarios`,
    method: "POST",
    headers: {"Content-Type": "application/json"},
    data: simulationScenarioCreateIn,
    params,
    signal,
  });
};

export const getCreateSimulationScenarioMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createSimulationScenario>>,
    TError,
    {data: SimulationScenarioCreateIn; params: CreateSimulationScenarioParams},
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createSimulationScenario>>,
  TError,
  {data: SimulationScenarioCreateIn; params: CreateSimulationScenarioParams},
  TContext
> => {
  const mutationKey = ["createSimulationScenario"];
  const {mutation: mutationOptions} = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : {...options, mutation: {...options.mutation, mutationKey}}
    : {mutation: {mutationKey}};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createSimulationScenario>>,
    {data: SimulationScenarioCreateIn; params: CreateSimulationScenarioParams}
  > = props => {
    const {data, params} = props ?? {};

    return createSimulationScenario(data, params);
  };

  return {mutationFn, ...mutationOptions};
};

export type CreateSimulationScenarioMutationResult = NonNullable<
  Awaited<ReturnType<typeof createSimulationScenario>>
>;
export type CreateSimulationScenarioMutationBody = SimulationScenarioCreateIn;
export type CreateSimulationScenarioMutationError = void;

export const useCreateSimulationScenario = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createSimulationScenario>>,
      TError,
      {
        data: SimulationScenarioCreateIn;
        params: CreateSimulationScenarioParams;
      },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createSimulationScenario>>,
  TError,
  {data: SimulationScenarioCreateIn; params: CreateSimulationScenarioParams},
  TContext
> => {
  const mutationOptions = getCreateSimulationScenarioMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * List simulation simulation scenarios with pagination
 */
export const listSimulationScenarios = (
  params: ListSimulationScenariosParams,
  signal?: AbortSignal,
) => {
  return axiosInstance<ListSimulationScenarios200>({
    url: `/simulation_scenarios`,
    method: "GET",
    params,
    signal,
  });
};

export const getListSimulationScenariosQueryKey = (
  params: ListSimulationScenariosParams,
) => {
  return [`/simulation_scenarios`, ...(params ? [params] : [])] as const;
};

export const getListSimulationScenariosQueryOptions = <
  TData = Awaited<ReturnType<typeof listSimulationScenarios>>,
  TError = void,
>(
  params: ListSimulationScenariosParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listSimulationScenarios>>,
        TError,
        TData
      >
    >;
  },
) => {
  const {query: queryOptions} = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListSimulationScenariosQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listSimulationScenarios>>
  > = ({signal}) => listSimulationScenarios(params, signal);

  return {queryKey, queryFn, ...queryOptions} as UseQueryOptions<
    Awaited<ReturnType<typeof listSimulationScenarios>>,
    TError,
    TData
  > & {queryKey: DataTag<QueryKey, TData, TError>};
};

export type ListSimulationScenariosQueryResult = NonNullable<
  Awaited<ReturnType<typeof listSimulationScenarios>>
>;
export type ListSimulationScenariosQueryError = void;

export function useListSimulationScenarios<
  TData = Awaited<ReturnType<typeof listSimulationScenarios>>,
  TError = void,
>(
  params: ListSimulationScenariosParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listSimulationScenarios>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSimulationScenarios>>,
          TError,
          Awaited<ReturnType<typeof listSimulationScenarios>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListSimulationScenarios<
  TData = Awaited<ReturnType<typeof listSimulationScenarios>>,
  TError = void,
>(
  params: ListSimulationScenariosParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listSimulationScenarios>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSimulationScenarios>>,
          TError,
          Awaited<ReturnType<typeof listSimulationScenarios>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};
export function useListSimulationScenarios<
  TData = Awaited<ReturnType<typeof listSimulationScenarios>>,
  TError = void,
>(
  params: ListSimulationScenariosParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listSimulationScenarios>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};

export function useListSimulationScenarios<
  TData = Awaited<ReturnType<typeof listSimulationScenarios>>,
  TError = void,
>(
  params: ListSimulationScenariosParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listSimulationScenarios>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListSimulationScenariosQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & {queryKey: DataTag<QueryKey, TData, TError>};

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get a specific simulation scenario by ID
 */
export const getSimulationScenario = (
  scenarioId: string,
  params: GetSimulationScenarioParams,
  signal?: AbortSignal,
) => {
  return axiosInstance<SimulationScenarioReadOut>({
    url: `/simulation_scenarios/${scenarioId}`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetSimulationScenarioQueryKey = (
  scenarioId: string,
  params: GetSimulationScenarioParams,
) => {
  return [
    `/simulation_scenarios/${scenarioId}`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetSimulationScenarioQueryOptions = <
  TData = Awaited<ReturnType<typeof getSimulationScenario>>,
  TError = void,
>(
  scenarioId: string,
  params: GetSimulationScenarioParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSimulationScenario>>,
        TError,
        TData
      >
    >;
  },
) => {
  const {query: queryOptions} = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetSimulationScenarioQueryKey(scenarioId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getSimulationScenario>>
  > = ({signal}) => getSimulationScenario(scenarioId, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!scenarioId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getSimulationScenario>>,
    TError,
    TData
  > & {queryKey: DataTag<QueryKey, TData, TError>};
};

export type GetSimulationScenarioQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSimulationScenario>>
>;
export type GetSimulationScenarioQueryError = void;

export function useGetSimulationScenario<
  TData = Awaited<ReturnType<typeof getSimulationScenario>>,
  TError = void,
>(
  scenarioId: string,
  params: GetSimulationScenarioParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSimulationScenario>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSimulationScenario>>,
          TError,
          Awaited<ReturnType<typeof getSimulationScenario>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSimulationScenario<
  TData = Awaited<ReturnType<typeof getSimulationScenario>>,
  TError = void,
>(
  scenarioId: string,
  params: GetSimulationScenarioParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSimulationScenario>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSimulationScenario>>,
          TError,
          Awaited<ReturnType<typeof getSimulationScenario>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};
export function useGetSimulationScenario<
  TData = Awaited<ReturnType<typeof getSimulationScenario>>,
  TError = void,
>(
  scenarioId: string,
  params: GetSimulationScenarioParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSimulationScenario>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};

export function useGetSimulationScenario<
  TData = Awaited<ReturnType<typeof getSimulationScenario>>,
  TError = void,
>(
  scenarioId: string,
  params: GetSimulationScenarioParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSimulationScenario>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetSimulationScenarioQueryOptions(
    scenarioId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & {queryKey: DataTag<QueryKey, TData, TError>};

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Update a simulation scenario
 */
export const updateSimulationScenario = (
  scenarioId: string,
  simulationScenarioUpdateIn: SimulationScenarioUpdateIn,
  params: UpdateSimulationScenarioParams,
) => {
  return axiosInstance<SimulationScenarioReadOut>({
    url: `/simulation_scenarios/${scenarioId}`,
    method: "PUT",
    headers: {"Content-Type": "application/json"},
    data: simulationScenarioUpdateIn,
    params,
  });
};

export const getUpdateSimulationScenarioMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateSimulationScenario>>,
    TError,
    {
      scenarioId: string;
      data: SimulationScenarioUpdateIn;
      params: UpdateSimulationScenarioParams;
    },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateSimulationScenario>>,
  TError,
  {
    scenarioId: string;
    data: SimulationScenarioUpdateIn;
    params: UpdateSimulationScenarioParams;
  },
  TContext
> => {
  const mutationKey = ["updateSimulationScenario"];
  const {mutation: mutationOptions} = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : {...options, mutation: {...options.mutation, mutationKey}}
    : {mutation: {mutationKey}};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateSimulationScenario>>,
    {
      scenarioId: string;
      data: SimulationScenarioUpdateIn;
      params: UpdateSimulationScenarioParams;
    }
  > = props => {
    const {scenarioId, data, params} = props ?? {};

    return updateSimulationScenario(scenarioId, data, params);
  };

  return {mutationFn, ...mutationOptions};
};

export type UpdateSimulationScenarioMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateSimulationScenario>>
>;
export type UpdateSimulationScenarioMutationBody = SimulationScenarioUpdateIn;
export type UpdateSimulationScenarioMutationError = void;

export const useUpdateSimulationScenario = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateSimulationScenario>>,
      TError,
      {
        scenarioId: string;
        data: SimulationScenarioUpdateIn;
        params: UpdateSimulationScenarioParams;
      },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateSimulationScenario>>,
  TError,
  {
    scenarioId: string;
    data: SimulationScenarioUpdateIn;
    params: UpdateSimulationScenarioParams;
  },
  TContext
> => {
  const mutationOptions = getUpdateSimulationScenarioMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Delete a simulation scenario
 */
export const deleteSimulationScenario = (
  scenarioId: string,
  params: DeleteSimulationScenarioParams,
) => {
  return axiosInstance<void>({
    url: `/simulation_scenarios/${scenarioId}`,
    method: "DELETE",
    params,
  });
};

export const getDeleteSimulationScenarioMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSimulationScenario>>,
    TError,
    {scenarioId: string; params: DeleteSimulationScenarioParams},
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteSimulationScenario>>,
  TError,
  {scenarioId: string; params: DeleteSimulationScenarioParams},
  TContext
> => {
  const mutationKey = ["deleteSimulationScenario"];
  const {mutation: mutationOptions} = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : {...options, mutation: {...options.mutation, mutationKey}}
    : {mutation: {mutationKey}};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteSimulationScenario>>,
    {scenarioId: string; params: DeleteSimulationScenarioParams}
  > = props => {
    const {scenarioId, params} = props ?? {};

    return deleteSimulationScenario(scenarioId, params);
  };

  return {mutationFn, ...mutationOptions};
};

export type DeleteSimulationScenarioMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteSimulationScenario>>
>;

export type DeleteSimulationScenarioMutationError = void;

export const useDeleteSimulationScenario = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteSimulationScenario>>,
      TError,
      {scenarioId: string; params: DeleteSimulationScenarioParams},
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteSimulationScenario>>,
  TError,
  {scenarioId: string; params: DeleteSimulationScenarioParams},
  TContext
> => {
  const mutationOptions = getDeleteSimulationScenarioMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Start a new simulation using a simulation case
 */
export const startSimulation = (
  simulationCreateIn: SimulationCreateIn,
  params: StartSimulationParams,
  signal?: AbortSignal,
) => {
  return axiosInstance<SimulationReadOut>({
    url: `/simulations/start`,
    method: "POST",
    headers: {"Content-Type": "application/json"},
    data: simulationCreateIn,
    params,
    signal,
  });
};

export const getStartSimulationMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof startSimulation>>,
    TError,
    {data: SimulationCreateIn; params: StartSimulationParams},
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof startSimulation>>,
  TError,
  {data: SimulationCreateIn; params: StartSimulationParams},
  TContext
> => {
  const mutationKey = ["startSimulation"];
  const {mutation: mutationOptions} = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : {...options, mutation: {...options.mutation, mutationKey}}
    : {mutation: {mutationKey}};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof startSimulation>>,
    {data: SimulationCreateIn; params: StartSimulationParams}
  > = props => {
    const {data, params} = props ?? {};

    return startSimulation(data, params);
  };

  return {mutationFn, ...mutationOptions};
};

export type StartSimulationMutationResult = NonNullable<
  Awaited<ReturnType<typeof startSimulation>>
>;
export type StartSimulationMutationBody = SimulationCreateIn;
export type StartSimulationMutationError = void;

export const useStartSimulation = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof startSimulation>>,
      TError,
      {data: SimulationCreateIn; params: StartSimulationParams},
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof startSimulation>>,
  TError,
  {data: SimulationCreateIn; params: StartSimulationParams},
  TContext
> => {
  const mutationOptions = getStartSimulationMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Get simulation session details by session ID
 */
export const getSimulationSession = (
  simulationSessionId: string,
  params: GetSimulationSessionParams,
  signal?: AbortSignal,
) => {
  return axiosInstance<SimulationSessionReadOut>({
    url: `/simulations/session/${simulationSessionId}`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetSimulationSessionQueryKey = (
  simulationSessionId: string,
  params: GetSimulationSessionParams,
) => {
  return [
    `/simulations/session/${simulationSessionId}`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetSimulationSessionQueryOptions = <
  TData = Awaited<ReturnType<typeof getSimulationSession>>,
  TError = void,
>(
  simulationSessionId: string,
  params: GetSimulationSessionParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSimulationSession>>,
        TError,
        TData
      >
    >;
  },
) => {
  const {query: queryOptions} = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetSimulationSessionQueryKey(simulationSessionId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getSimulationSession>>
  > = ({signal}) => getSimulationSession(simulationSessionId, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!simulationSessionId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getSimulationSession>>,
    TError,
    TData
  > & {queryKey: DataTag<QueryKey, TData, TError>};
};

export type GetSimulationSessionQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSimulationSession>>
>;
export type GetSimulationSessionQueryError = void;

export function useGetSimulationSession<
  TData = Awaited<ReturnType<typeof getSimulationSession>>,
  TError = void,
>(
  simulationSessionId: string,
  params: GetSimulationSessionParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSimulationSession>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSimulationSession>>,
          TError,
          Awaited<ReturnType<typeof getSimulationSession>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSimulationSession<
  TData = Awaited<ReturnType<typeof getSimulationSession>>,
  TError = void,
>(
  simulationSessionId: string,
  params: GetSimulationSessionParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSimulationSession>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSimulationSession>>,
          TError,
          Awaited<ReturnType<typeof getSimulationSession>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};
export function useGetSimulationSession<
  TData = Awaited<ReturnType<typeof getSimulationSession>>,
  TError = void,
>(
  simulationSessionId: string,
  params: GetSimulationSessionParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSimulationSession>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};

export function useGetSimulationSession<
  TData = Awaited<ReturnType<typeof getSimulationSession>>,
  TError = void,
>(
  simulationSessionId: string,
  params: GetSimulationSessionParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSimulationSession>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetSimulationSessionQueryOptions(
    simulationSessionId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & {queryKey: DataTag<QueryKey, TData, TError>};

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * List simulation sessions with pagination
 */
export const listSimulationSessions = (
  params: ListSimulationSessionsParams,
  signal?: AbortSignal,
) => {
  return axiosInstance<PaginatedSimulationSessionList>({
    url: `/simulations/sessions`,
    method: "GET",
    params,
    signal,
  });
};

export const getListSimulationSessionsQueryKey = (
  params: ListSimulationSessionsParams,
) => {
  return [`/simulations/sessions`, ...(params ? [params] : [])] as const;
};

export const getListSimulationSessionsQueryOptions = <
  TData = Awaited<ReturnType<typeof listSimulationSessions>>,
  TError = unknown,
>(
  params: ListSimulationSessionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listSimulationSessions>>,
        TError,
        TData
      >
    >;
  },
) => {
  const {query: queryOptions} = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListSimulationSessionsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listSimulationSessions>>
  > = ({signal}) => listSimulationSessions(params, signal);

  return {queryKey, queryFn, ...queryOptions} as UseQueryOptions<
    Awaited<ReturnType<typeof listSimulationSessions>>,
    TError,
    TData
  > & {queryKey: DataTag<QueryKey, TData, TError>};
};

export type ListSimulationSessionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listSimulationSessions>>
>;
export type ListSimulationSessionsQueryError = unknown;

export function useListSimulationSessions<
  TData = Awaited<ReturnType<typeof listSimulationSessions>>,
  TError = unknown,
>(
  params: ListSimulationSessionsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listSimulationSessions>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSimulationSessions>>,
          TError,
          Awaited<ReturnType<typeof listSimulationSessions>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListSimulationSessions<
  TData = Awaited<ReturnType<typeof listSimulationSessions>>,
  TError = unknown,
>(
  params: ListSimulationSessionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listSimulationSessions>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSimulationSessions>>,
          TError,
          Awaited<ReturnType<typeof listSimulationSessions>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};
export function useListSimulationSessions<
  TData = Awaited<ReturnType<typeof listSimulationSessions>>,
  TError = unknown,
>(
  params: ListSimulationSessionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listSimulationSessions>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};

export function useListSimulationSessions<
  TData = Awaited<ReturnType<typeof listSimulationSessions>>,
  TError = unknown,
>(
  params: ListSimulationSessionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listSimulationSessions>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListSimulationSessionsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & {queryKey: DataTag<QueryKey, TData, TError>};

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * List simulations with pagination and filtering
 */
export const listSimulations = (
  params: ListSimulationsParams,
  signal?: AbortSignal,
) => {
  return axiosInstance<PaginatedSimulationsList>({
    url: `/simulations`,
    method: "GET",
    params,
    signal,
  });
};

export const getListSimulationsQueryKey = (params: ListSimulationsParams) => {
  return [`/simulations`, ...(params ? [params] : [])] as const;
};

export const getListSimulationsQueryOptions = <
  TData = Awaited<ReturnType<typeof listSimulations>>,
  TError = void,
>(
  params: ListSimulationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listSimulations>>,
        TError,
        TData
      >
    >;
  },
) => {
  const {query: queryOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListSimulationsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listSimulations>>> = ({
    signal,
  }) => listSimulations(params, signal);

  return {queryKey, queryFn, ...queryOptions} as UseQueryOptions<
    Awaited<ReturnType<typeof listSimulations>>,
    TError,
    TData
  > & {queryKey: DataTag<QueryKey, TData, TError>};
};

export type ListSimulationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listSimulations>>
>;
export type ListSimulationsQueryError = void;

export function useListSimulations<
  TData = Awaited<ReturnType<typeof listSimulations>>,
  TError = void,
>(
  params: ListSimulationsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listSimulations>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSimulations>>,
          TError,
          Awaited<ReturnType<typeof listSimulations>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListSimulations<
  TData = Awaited<ReturnType<typeof listSimulations>>,
  TError = void,
>(
  params: ListSimulationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listSimulations>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSimulations>>,
          TError,
          Awaited<ReturnType<typeof listSimulations>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};
export function useListSimulations<
  TData = Awaited<ReturnType<typeof listSimulations>>,
  TError = void,
>(
  params: ListSimulationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listSimulations>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};

export function useListSimulations<
  TData = Awaited<ReturnType<typeof listSimulations>>,
  TError = void,
>(
  params: ListSimulationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listSimulations>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListSimulationsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & {queryKey: DataTag<QueryKey, TData, TError>};

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get paginated contacts for a workspace
 */
export const getContacts = (
  params: GetContactsParams,
  signal?: AbortSignal,
) => {
  return axiosInstance<GetContacts200 | void>({
    url: `/contacts`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetContactsQueryKey = (params: GetContactsParams) => {
  return [`/contacts`, ...(params ? [params] : [])] as const;
};

export const getGetContactsQueryOptions = <
  TData = Awaited<ReturnType<typeof getContacts>>,
  TError = unknown,
>(
  params: GetContactsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getContacts>>, TError, TData>
    >;
  },
) => {
  const {query: queryOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetContactsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getContacts>>> = ({
    signal,
  }) => getContacts(params, signal);

  return {queryKey, queryFn, ...queryOptions} as UseQueryOptions<
    Awaited<ReturnType<typeof getContacts>>,
    TError,
    TData
  > & {queryKey: DataTag<QueryKey, TData, TError>};
};

export type GetContactsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getContacts>>
>;
export type GetContactsQueryError = unknown;

export function useGetContacts<
  TData = Awaited<ReturnType<typeof getContacts>>,
  TError = unknown,
>(
  params: GetContactsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getContacts>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getContacts>>,
          TError,
          Awaited<ReturnType<typeof getContacts>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetContacts<
  TData = Awaited<ReturnType<typeof getContacts>>,
  TError = unknown,
>(
  params: GetContactsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getContacts>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getContacts>>,
          TError,
          Awaited<ReturnType<typeof getContacts>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};
export function useGetContacts<
  TData = Awaited<ReturnType<typeof getContacts>>,
  TError = unknown,
>(
  params: GetContactsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getContacts>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};

export function useGetContacts<
  TData = Awaited<ReturnType<typeof getContacts>>,
  TError = unknown,
>(
  params: GetContactsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getContacts>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetContactsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & {queryKey: DataTag<QueryKey, TData, TError>};

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Create a new contact
 */
export const createContact = (
  contactCreateRequest: ContactCreateRequest,
  signal?: AbortSignal,
) => {
  return axiosInstance<ContactIdResponse>({
    url: `/contacts`,
    method: "POST",
    headers: {"Content-Type": "application/json"},
    data: contactCreateRequest,
    signal,
  });
};

export const getCreateContactMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createContact>>,
    TError,
    {data: ContactCreateRequest},
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createContact>>,
  TError,
  {data: ContactCreateRequest},
  TContext
> => {
  const mutationKey = ["createContact"];
  const {mutation: mutationOptions} = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : {...options, mutation: {...options.mutation, mutationKey}}
    : {mutation: {mutationKey}};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createContact>>,
    {data: ContactCreateRequest}
  > = props => {
    const {data} = props ?? {};

    return createContact(data);
  };

  return {mutationFn, ...mutationOptions};
};

export type CreateContactMutationResult = NonNullable<
  Awaited<ReturnType<typeof createContact>>
>;
export type CreateContactMutationBody = ContactCreateRequest;
export type CreateContactMutationError = void;

export const useCreateContact = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createContact>>,
      TError,
      {data: ContactCreateRequest},
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createContact>>,
  TError,
  {data: ContactCreateRequest},
  TContext
> => {
  const mutationOptions = getCreateContactMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Get a specific contact by ID
 */
export const getContact = (contactId: string, signal?: AbortSignal) => {
  return axiosInstance<ContactResponse>({
    url: `/contacts/${contactId}`,
    method: "GET",
    signal,
  });
};

export const getGetContactQueryKey = (contactId: string) => {
  return [`/contacts/${contactId}`] as const;
};

export const getGetContactQueryOptions = <
  TData = Awaited<ReturnType<typeof getContact>>,
  TError = void,
>(
  contactId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getContact>>, TError, TData>
    >;
  },
) => {
  const {query: queryOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetContactQueryKey(contactId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getContact>>> = ({
    signal,
  }) => getContact(contactId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!contactId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getContact>>,
    TError,
    TData
  > & {queryKey: DataTag<QueryKey, TData, TError>};
};

export type GetContactQueryResult = NonNullable<
  Awaited<ReturnType<typeof getContact>>
>;
export type GetContactQueryError = void;

export function useGetContact<
  TData = Awaited<ReturnType<typeof getContact>>,
  TError = void,
>(
  contactId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getContact>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getContact>>,
          TError,
          Awaited<ReturnType<typeof getContact>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetContact<
  TData = Awaited<ReturnType<typeof getContact>>,
  TError = void,
>(
  contactId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getContact>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getContact>>,
          TError,
          Awaited<ReturnType<typeof getContact>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};
export function useGetContact<
  TData = Awaited<ReturnType<typeof getContact>>,
  TError = void,
>(
  contactId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getContact>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};

export function useGetContact<
  TData = Awaited<ReturnType<typeof getContact>>,
  TError = void,
>(
  contactId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getContact>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetContactQueryOptions(contactId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & {queryKey: DataTag<QueryKey, TData, TError>};

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Update a contact
 */
export const updateContact = (
  contactId: string,
  contactUpdateRequest: ContactUpdateRequest,
) => {
  return axiosInstance<ContactIdResponse>({
    url: `/contacts/${contactId}`,
    method: "PATCH",
    headers: {"Content-Type": "application/json"},
    data: contactUpdateRequest,
  });
};

export const getUpdateContactMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateContact>>,
    TError,
    {contactId: string; data: ContactUpdateRequest},
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateContact>>,
  TError,
  {contactId: string; data: ContactUpdateRequest},
  TContext
> => {
  const mutationKey = ["updateContact"];
  const {mutation: mutationOptions} = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : {...options, mutation: {...options.mutation, mutationKey}}
    : {mutation: {mutationKey}};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateContact>>,
    {contactId: string; data: ContactUpdateRequest}
  > = props => {
    const {contactId, data} = props ?? {};

    return updateContact(contactId, data);
  };

  return {mutationFn, ...mutationOptions};
};

export type UpdateContactMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateContact>>
>;
export type UpdateContactMutationBody = ContactUpdateRequest;
export type UpdateContactMutationError = void;

export const useUpdateContact = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateContact>>,
      TError,
      {contactId: string; data: ContactUpdateRequest},
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateContact>>,
  TError,
  {contactId: string; data: ContactUpdateRequest},
  TContext
> => {
  const mutationOptions = getUpdateContactMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Delete a contact
 */
export const deleteContact = (contactId: string) => {
  return axiosInstance<void>({url: `/contacts/${contactId}`, method: "DELETE"});
};

export const getDeleteContactMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteContact>>,
    TError,
    {contactId: string},
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteContact>>,
  TError,
  {contactId: string},
  TContext
> => {
  const mutationKey = ["deleteContact"];
  const {mutation: mutationOptions} = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : {...options, mutation: {...options.mutation, mutationKey}}
    : {mutation: {mutationKey}};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteContact>>,
    {contactId: string}
  > = props => {
    const {contactId} = props ?? {};

    return deleteContact(contactId);
  };

  return {mutationFn, ...mutationOptions};
};

export type DeleteContactMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteContact>>
>;

export type DeleteContactMutationError = void;

export const useDeleteContact = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteContact>>,
      TError,
      {contactId: string},
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteContact>>,
  TError,
  {contactId: string},
  TContext
> => {
  const mutationOptions = getDeleteContactMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Get all memory stores for a contact
 */
export const getContactMemoryStores = (
  contactId: string,
  signal?: AbortSignal,
) => {
  return axiosInstance<ContactMemoryResponse[]>({
    url: `/contacts/${contactId}/memory_stores`,
    method: "GET",
    signal,
  });
};

export const getGetContactMemoryStoresQueryKey = (contactId: string) => {
  return [`/contacts/${contactId}/memory_stores`] as const;
};

export const getGetContactMemoryStoresQueryOptions = <
  TData = Awaited<ReturnType<typeof getContactMemoryStores>>,
  TError = unknown,
>(
  contactId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getContactMemoryStores>>,
        TError,
        TData
      >
    >;
  },
) => {
  const {query: queryOptions} = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetContactMemoryStoresQueryKey(contactId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getContactMemoryStores>>
  > = ({signal}) => getContactMemoryStores(contactId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!contactId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getContactMemoryStores>>,
    TError,
    TData
  > & {queryKey: DataTag<QueryKey, TData, TError>};
};

export type GetContactMemoryStoresQueryResult = NonNullable<
  Awaited<ReturnType<typeof getContactMemoryStores>>
>;
export type GetContactMemoryStoresQueryError = unknown;

export function useGetContactMemoryStores<
  TData = Awaited<ReturnType<typeof getContactMemoryStores>>,
  TError = unknown,
>(
  contactId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getContactMemoryStores>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getContactMemoryStores>>,
          TError,
          Awaited<ReturnType<typeof getContactMemoryStores>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetContactMemoryStores<
  TData = Awaited<ReturnType<typeof getContactMemoryStores>>,
  TError = unknown,
>(
  contactId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getContactMemoryStores>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getContactMemoryStores>>,
          TError,
          Awaited<ReturnType<typeof getContactMemoryStores>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};
export function useGetContactMemoryStores<
  TData = Awaited<ReturnType<typeof getContactMemoryStores>>,
  TError = unknown,
>(
  contactId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getContactMemoryStores>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};

export function useGetContactMemoryStores<
  TData = Awaited<ReturnType<typeof getContactMemoryStores>>,
  TError = unknown,
>(
  contactId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getContactMemoryStores>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetContactMemoryStoresQueryOptions(
    contactId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & {queryKey: DataTag<QueryKey, TData, TError>};

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get memory data for a specific contact in a specific memory store
 */
export const getContactMemoryInStore = (
  contactId: string,
  memoryStoreId: string,
  signal?: AbortSignal,
) => {
  return axiosInstance<ContactMemoryResponse>({
    url: `/contacts/${contactId}/memory_stores/${memoryStoreId}`,
    method: "GET",
    signal,
  });
};

export const getGetContactMemoryInStoreQueryKey = (
  contactId: string,
  memoryStoreId: string,
) => {
  return [`/contacts/${contactId}/memory_stores/${memoryStoreId}`] as const;
};

export const getGetContactMemoryInStoreQueryOptions = <
  TData = Awaited<ReturnType<typeof getContactMemoryInStore>>,
  TError = void,
>(
  contactId: string,
  memoryStoreId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getContactMemoryInStore>>,
        TError,
        TData
      >
    >;
  },
) => {
  const {query: queryOptions} = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetContactMemoryInStoreQueryKey(contactId, memoryStoreId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getContactMemoryInStore>>
  > = ({signal}) => getContactMemoryInStore(contactId, memoryStoreId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(contactId && memoryStoreId),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getContactMemoryInStore>>,
    TError,
    TData
  > & {queryKey: DataTag<QueryKey, TData, TError>};
};

export type GetContactMemoryInStoreQueryResult = NonNullable<
  Awaited<ReturnType<typeof getContactMemoryInStore>>
>;
export type GetContactMemoryInStoreQueryError = void;

export function useGetContactMemoryInStore<
  TData = Awaited<ReturnType<typeof getContactMemoryInStore>>,
  TError = void,
>(
  contactId: string,
  memoryStoreId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getContactMemoryInStore>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getContactMemoryInStore>>,
          TError,
          Awaited<ReturnType<typeof getContactMemoryInStore>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetContactMemoryInStore<
  TData = Awaited<ReturnType<typeof getContactMemoryInStore>>,
  TError = void,
>(
  contactId: string,
  memoryStoreId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getContactMemoryInStore>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getContactMemoryInStore>>,
          TError,
          Awaited<ReturnType<typeof getContactMemoryInStore>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};
export function useGetContactMemoryInStore<
  TData = Awaited<ReturnType<typeof getContactMemoryInStore>>,
  TError = void,
>(
  contactId: string,
  memoryStoreId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getContactMemoryInStore>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};

export function useGetContactMemoryInStore<
  TData = Awaited<ReturnType<typeof getContactMemoryInStore>>,
  TError = void,
>(
  contactId: string,
  memoryStoreId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getContactMemoryInStore>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetContactMemoryInStoreQueryOptions(
    contactId,
    memoryStoreId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & {queryKey: DataTag<QueryKey, TData, TError>};

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get all memory data for a contact across all memory stores
 */
export const getContactMemories = (contactId: string, signal?: AbortSignal) => {
  return axiosInstance<ContactMemoryResponse[]>({
    url: `/contacts/${contactId}/memories`,
    method: "GET",
    signal,
  });
};

export const getGetContactMemoriesQueryKey = (contactId: string) => {
  return [`/contacts/${contactId}/memories`] as const;
};

export const getGetContactMemoriesQueryOptions = <
  TData = Awaited<ReturnType<typeof getContactMemories>>,
  TError = unknown,
>(
  contactId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getContactMemories>>,
        TError,
        TData
      >
    >;
  },
) => {
  const {query: queryOptions} = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetContactMemoriesQueryKey(contactId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getContactMemories>>
  > = ({signal}) => getContactMemories(contactId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!contactId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getContactMemories>>,
    TError,
    TData
  > & {queryKey: DataTag<QueryKey, TData, TError>};
};

export type GetContactMemoriesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getContactMemories>>
>;
export type GetContactMemoriesQueryError = unknown;

export function useGetContactMemories<
  TData = Awaited<ReturnType<typeof getContactMemories>>,
  TError = unknown,
>(
  contactId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getContactMemories>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getContactMemories>>,
          TError,
          Awaited<ReturnType<typeof getContactMemories>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetContactMemories<
  TData = Awaited<ReturnType<typeof getContactMemories>>,
  TError = unknown,
>(
  contactId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getContactMemories>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getContactMemories>>,
          TError,
          Awaited<ReturnType<typeof getContactMemories>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};
export function useGetContactMemories<
  TData = Awaited<ReturnType<typeof getContactMemories>>,
  TError = unknown,
>(
  contactId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getContactMemories>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};

export function useGetContactMemories<
  TData = Awaited<ReturnType<typeof getContactMemories>>,
  TError = unknown,
>(
  contactId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getContactMemories>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetContactMemoriesQueryOptions(contactId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & {queryKey: DataTag<QueryKey, TData, TError>};

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Initiates registration of a WhatsApp sender (phone number) via Twilio. Returns registration status and SID.
 * @summary Register a WhatsApp sender
 */
export const registerWhatsAppSender = (
  whatsAppSenderRegistrationRequest: WhatsAppSenderRegistrationRequest,
  signal?: AbortSignal,
) => {
  return axiosInstance<WhatsAppSenderRegistrationResponse>({
    url: `/whatsapp/senders`,
    method: "POST",
    headers: {"Content-Type": "application/json"},
    data: whatsAppSenderRegistrationRequest,
    signal,
  });
};

export const getRegisterWhatsAppSenderMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof registerWhatsAppSender>>,
    TError,
    {data: WhatsAppSenderRegistrationRequest},
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof registerWhatsAppSender>>,
  TError,
  {data: WhatsAppSenderRegistrationRequest},
  TContext
> => {
  const mutationKey = ["registerWhatsAppSender"];
  const {mutation: mutationOptions} = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : {...options, mutation: {...options.mutation, mutationKey}}
    : {mutation: {mutationKey}};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof registerWhatsAppSender>>,
    {data: WhatsAppSenderRegistrationRequest}
  > = props => {
    const {data} = props ?? {};

    return registerWhatsAppSender(data);
  };

  return {mutationFn, ...mutationOptions};
};

export type RegisterWhatsAppSenderMutationResult = NonNullable<
  Awaited<ReturnType<typeof registerWhatsAppSender>>
>;
export type RegisterWhatsAppSenderMutationBody =
  WhatsAppSenderRegistrationRequest;
export type RegisterWhatsAppSenderMutationError = void;

/**
 * @summary Register a WhatsApp sender
 */
export const useRegisterWhatsAppSender = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof registerWhatsAppSender>>,
      TError,
      {data: WhatsAppSenderRegistrationRequest},
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof registerWhatsAppSender>>,
  TError,
  {data: WhatsAppSenderRegistrationRequest},
  TContext
> => {
  const mutationOptions = getRegisterWhatsAppSenderMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Polls the status of a WhatsApp sender registration using the SID.
 * @summary Get WhatsApp sender registration status
 */
export const getWhatsAppSenderStatus = (
  params: GetWhatsAppSenderStatusParams,
  signal?: AbortSignal,
) => {
  return axiosInstance<WhatsAppSenderStatusResponse>({
    url: `/whatsapp/senders`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetWhatsAppSenderStatusQueryKey = (
  params: GetWhatsAppSenderStatusParams,
) => {
  return [`/whatsapp/senders`, ...(params ? [params] : [])] as const;
};

export const getGetWhatsAppSenderStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof getWhatsAppSenderStatus>>,
  TError = void,
>(
  params: GetWhatsAppSenderStatusParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getWhatsAppSenderStatus>>,
        TError,
        TData
      >
    >;
  },
) => {
  const {query: queryOptions} = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetWhatsAppSenderStatusQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getWhatsAppSenderStatus>>
  > = ({signal}) => getWhatsAppSenderStatus(params, signal);

  return {queryKey, queryFn, ...queryOptions} as UseQueryOptions<
    Awaited<ReturnType<typeof getWhatsAppSenderStatus>>,
    TError,
    TData
  > & {queryKey: DataTag<QueryKey, TData, TError>};
};

export type GetWhatsAppSenderStatusQueryResult = NonNullable<
  Awaited<ReturnType<typeof getWhatsAppSenderStatus>>
>;
export type GetWhatsAppSenderStatusQueryError = void;

export function useGetWhatsAppSenderStatus<
  TData = Awaited<ReturnType<typeof getWhatsAppSenderStatus>>,
  TError = void,
>(
  params: GetWhatsAppSenderStatusParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getWhatsAppSenderStatus>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWhatsAppSenderStatus>>,
          TError,
          Awaited<ReturnType<typeof getWhatsAppSenderStatus>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetWhatsAppSenderStatus<
  TData = Awaited<ReturnType<typeof getWhatsAppSenderStatus>>,
  TError = void,
>(
  params: GetWhatsAppSenderStatusParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getWhatsAppSenderStatus>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWhatsAppSenderStatus>>,
          TError,
          Awaited<ReturnType<typeof getWhatsAppSenderStatus>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};
export function useGetWhatsAppSenderStatus<
  TData = Awaited<ReturnType<typeof getWhatsAppSenderStatus>>,
  TError = void,
>(
  params: GetWhatsAppSenderStatusParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getWhatsAppSenderStatus>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};
/**
 * @summary Get WhatsApp sender registration status
 */

export function useGetWhatsAppSenderStatus<
  TData = Awaited<ReturnType<typeof getWhatsAppSenderStatus>>,
  TError = void,
>(
  params: GetWhatsAppSenderStatusParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getWhatsAppSenderStatus>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetWhatsAppSenderStatusQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & {queryKey: DataTag<QueryKey, TData, TError>};

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get paginated memory stores for a workspace
 */
export const getMemoryStores = (
  params: GetMemoryStoresParams,
  signal?: AbortSignal,
) => {
  return axiosInstance<GetMemoryStores200 | void>({
    url: `/memory_stores`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetMemoryStoresQueryKey = (params: GetMemoryStoresParams) => {
  return [`/memory_stores`, ...(params ? [params] : [])] as const;
};

export const getGetMemoryStoresQueryOptions = <
  TData = Awaited<ReturnType<typeof getMemoryStores>>,
  TError = unknown,
>(
  params: GetMemoryStoresParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMemoryStores>>,
        TError,
        TData
      >
    >;
  },
) => {
  const {query: queryOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMemoryStoresQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMemoryStores>>> = ({
    signal,
  }) => getMemoryStores(params, signal);

  return {queryKey, queryFn, ...queryOptions} as UseQueryOptions<
    Awaited<ReturnType<typeof getMemoryStores>>,
    TError,
    TData
  > & {queryKey: DataTag<QueryKey, TData, TError>};
};

export type GetMemoryStoresQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMemoryStores>>
>;
export type GetMemoryStoresQueryError = unknown;

export function useGetMemoryStores<
  TData = Awaited<ReturnType<typeof getMemoryStores>>,
  TError = unknown,
>(
  params: GetMemoryStoresParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMemoryStores>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMemoryStores>>,
          TError,
          Awaited<ReturnType<typeof getMemoryStores>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetMemoryStores<
  TData = Awaited<ReturnType<typeof getMemoryStores>>,
  TError = unknown,
>(
  params: GetMemoryStoresParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMemoryStores>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMemoryStores>>,
          TError,
          Awaited<ReturnType<typeof getMemoryStores>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};
export function useGetMemoryStores<
  TData = Awaited<ReturnType<typeof getMemoryStores>>,
  TError = unknown,
>(
  params: GetMemoryStoresParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMemoryStores>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};

export function useGetMemoryStores<
  TData = Awaited<ReturnType<typeof getMemoryStores>>,
  TError = unknown,
>(
  params: GetMemoryStoresParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMemoryStores>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetMemoryStoresQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & {queryKey: DataTag<QueryKey, TData, TError>};

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Create a new memory store
 */
export const createMemoryStore = (
  memoryStoreCreateRequest: MemoryStoreCreateRequest,
  signal?: AbortSignal,
) => {
  return axiosInstance<MemoryStoreResponse>({
    url: `/memory_stores`,
    method: "POST",
    headers: {"Content-Type": "application/json"},
    data: memoryStoreCreateRequest,
    signal,
  });
};

export const getCreateMemoryStoreMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createMemoryStore>>,
    TError,
    {data: MemoryStoreCreateRequest},
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createMemoryStore>>,
  TError,
  {data: MemoryStoreCreateRequest},
  TContext
> => {
  const mutationKey = ["createMemoryStore"];
  const {mutation: mutationOptions} = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : {...options, mutation: {...options.mutation, mutationKey}}
    : {mutation: {mutationKey}};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createMemoryStore>>,
    {data: MemoryStoreCreateRequest}
  > = props => {
    const {data} = props ?? {};

    return createMemoryStore(data);
  };

  return {mutationFn, ...mutationOptions};
};

export type CreateMemoryStoreMutationResult = NonNullable<
  Awaited<ReturnType<typeof createMemoryStore>>
>;
export type CreateMemoryStoreMutationBody = MemoryStoreCreateRequest;
export type CreateMemoryStoreMutationError = void;

export const useCreateMemoryStore = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createMemoryStore>>,
      TError,
      {data: MemoryStoreCreateRequest},
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createMemoryStore>>,
  TError,
  {data: MemoryStoreCreateRequest},
  TContext
> => {
  const mutationOptions = getCreateMemoryStoreMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Get a specific memory store by ID
 */
export const getMemoryStore = (memoryStoreId: string, signal?: AbortSignal) => {
  return axiosInstance<MemoryStoreResponse>({
    url: `/memory_stores/${memoryStoreId}`,
    method: "GET",
    signal,
  });
};

export const getGetMemoryStoreQueryKey = (memoryStoreId: string) => {
  return [`/memory_stores/${memoryStoreId}`] as const;
};

export const getGetMemoryStoreQueryOptions = <
  TData = Awaited<ReturnType<typeof getMemoryStore>>,
  TError = void,
>(
  memoryStoreId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMemoryStore>>, TError, TData>
    >;
  },
) => {
  const {query: queryOptions} = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMemoryStoreQueryKey(memoryStoreId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMemoryStore>>> = ({
    signal,
  }) => getMemoryStore(memoryStoreId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!memoryStoreId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getMemoryStore>>,
    TError,
    TData
  > & {queryKey: DataTag<QueryKey, TData, TError>};
};

export type GetMemoryStoreQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMemoryStore>>
>;
export type GetMemoryStoreQueryError = void;

export function useGetMemoryStore<
  TData = Awaited<ReturnType<typeof getMemoryStore>>,
  TError = void,
>(
  memoryStoreId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMemoryStore>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMemoryStore>>,
          TError,
          Awaited<ReturnType<typeof getMemoryStore>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetMemoryStore<
  TData = Awaited<ReturnType<typeof getMemoryStore>>,
  TError = void,
>(
  memoryStoreId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMemoryStore>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMemoryStore>>,
          TError,
          Awaited<ReturnType<typeof getMemoryStore>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};
export function useGetMemoryStore<
  TData = Awaited<ReturnType<typeof getMemoryStore>>,
  TError = void,
>(
  memoryStoreId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMemoryStore>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};

export function useGetMemoryStore<
  TData = Awaited<ReturnType<typeof getMemoryStore>>,
  TError = void,
>(
  memoryStoreId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMemoryStore>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetMemoryStoreQueryOptions(memoryStoreId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & {queryKey: DataTag<QueryKey, TData, TError>};

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Update a memory store
 */
export const updateMemoryStore = (
  memoryStoreId: string,
  memoryStoreUpdateRequest: MemoryStoreUpdateRequest,
) => {
  return axiosInstance<MemoryStoreIdResponse>({
    url: `/memory_stores/${memoryStoreId}`,
    method: "PATCH",
    headers: {"Content-Type": "application/json"},
    data: memoryStoreUpdateRequest,
  });
};

export const getUpdateMemoryStoreMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateMemoryStore>>,
    TError,
    {memoryStoreId: string; data: MemoryStoreUpdateRequest},
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateMemoryStore>>,
  TError,
  {memoryStoreId: string; data: MemoryStoreUpdateRequest},
  TContext
> => {
  const mutationKey = ["updateMemoryStore"];
  const {mutation: mutationOptions} = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : {...options, mutation: {...options.mutation, mutationKey}}
    : {mutation: {mutationKey}};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateMemoryStore>>,
    {memoryStoreId: string; data: MemoryStoreUpdateRequest}
  > = props => {
    const {memoryStoreId, data} = props ?? {};

    return updateMemoryStore(memoryStoreId, data);
  };

  return {mutationFn, ...mutationOptions};
};

export type UpdateMemoryStoreMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateMemoryStore>>
>;
export type UpdateMemoryStoreMutationBody = MemoryStoreUpdateRequest;
export type UpdateMemoryStoreMutationError = void;

export const useUpdateMemoryStore = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateMemoryStore>>,
      TError,
      {memoryStoreId: string; data: MemoryStoreUpdateRequest},
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateMemoryStore>>,
  TError,
  {memoryStoreId: string; data: MemoryStoreUpdateRequest},
  TContext
> => {
  const mutationOptions = getUpdateMemoryStoreMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Delete a memory store
 */
export const deleteMemoryStore = (memoryStoreId: string) => {
  return axiosInstance<void>({
    url: `/memory_stores/${memoryStoreId}`,
    method: "DELETE",
  });
};

export const getDeleteMemoryStoreMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteMemoryStore>>,
    TError,
    {memoryStoreId: string},
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteMemoryStore>>,
  TError,
  {memoryStoreId: string},
  TContext
> => {
  const mutationKey = ["deleteMemoryStore"];
  const {mutation: mutationOptions} = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : {...options, mutation: {...options.mutation, mutationKey}}
    : {mutation: {mutationKey}};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteMemoryStore>>,
    {memoryStoreId: string}
  > = props => {
    const {memoryStoreId} = props ?? {};

    return deleteMemoryStore(memoryStoreId);
  };

  return {mutationFn, ...mutationOptions};
};

export type DeleteMemoryStoreMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteMemoryStore>>
>;

export type DeleteMemoryStoreMutationError = void;

export const useDeleteMemoryStore = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteMemoryStore>>,
      TError,
      {memoryStoreId: string},
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteMemoryStore>>,
  TError,
  {memoryStoreId: string},
  TContext
> => {
  const mutationOptions = getDeleteMemoryStoreMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Get paginated contacts for a memory store
 */
export const getMemoryStoreContacts = (
  memoryStoreId: string,
  params?: GetMemoryStoreContactsParams,
  signal?: AbortSignal,
) => {
  return axiosInstance<GetMemoryStoreContacts200>({
    url: `/memory_stores/${memoryStoreId}/contacts`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetMemoryStoreContactsQueryKey = (
  memoryStoreId: string,
  params?: GetMemoryStoreContactsParams,
) => {
  return [
    `/memory_stores/${memoryStoreId}/contacts`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetMemoryStoreContactsQueryOptions = <
  TData = Awaited<ReturnType<typeof getMemoryStoreContacts>>,
  TError = unknown,
>(
  memoryStoreId: string,
  params?: GetMemoryStoreContactsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMemoryStoreContacts>>,
        TError,
        TData
      >
    >;
  },
) => {
  const {query: queryOptions} = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetMemoryStoreContactsQueryKey(memoryStoreId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMemoryStoreContacts>>
  > = ({signal}) => getMemoryStoreContacts(memoryStoreId, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!memoryStoreId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getMemoryStoreContacts>>,
    TError,
    TData
  > & {queryKey: DataTag<QueryKey, TData, TError>};
};

export type GetMemoryStoreContactsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMemoryStoreContacts>>
>;
export type GetMemoryStoreContactsQueryError = unknown;

export function useGetMemoryStoreContacts<
  TData = Awaited<ReturnType<typeof getMemoryStoreContacts>>,
  TError = unknown,
>(
  memoryStoreId: string,
  params: undefined | GetMemoryStoreContactsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMemoryStoreContacts>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMemoryStoreContacts>>,
          TError,
          Awaited<ReturnType<typeof getMemoryStoreContacts>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetMemoryStoreContacts<
  TData = Awaited<ReturnType<typeof getMemoryStoreContacts>>,
  TError = unknown,
>(
  memoryStoreId: string,
  params?: GetMemoryStoreContactsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMemoryStoreContacts>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMemoryStoreContacts>>,
          TError,
          Awaited<ReturnType<typeof getMemoryStoreContacts>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};
export function useGetMemoryStoreContacts<
  TData = Awaited<ReturnType<typeof getMemoryStoreContacts>>,
  TError = unknown,
>(
  memoryStoreId: string,
  params?: GetMemoryStoreContactsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMemoryStoreContacts>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};

export function useGetMemoryStoreContacts<
  TData = Awaited<ReturnType<typeof getMemoryStoreContacts>>,
  TError = unknown,
>(
  memoryStoreId: string,
  params?: GetMemoryStoreContactsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMemoryStoreContacts>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetMemoryStoreContactsQueryOptions(
    memoryStoreId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & {queryKey: DataTag<QueryKey, TData, TError>};

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Add a contact to a memory store
 */
export const addContactToMemoryStore = (
  contactMemoryRequest: ContactMemoryRequest,
  signal?: AbortSignal,
) => {
  return axiosInstance<void>({
    url: `/contact_memory_store`,
    method: "POST",
    headers: {"Content-Type": "application/json"},
    data: contactMemoryRequest,
    signal,
  });
};

export const getAddContactToMemoryStoreMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addContactToMemoryStore>>,
    TError,
    {data: ContactMemoryRequest},
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof addContactToMemoryStore>>,
  TError,
  {data: ContactMemoryRequest},
  TContext
> => {
  const mutationKey = ["addContactToMemoryStore"];
  const {mutation: mutationOptions} = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : {...options, mutation: {...options.mutation, mutationKey}}
    : {mutation: {mutationKey}};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof addContactToMemoryStore>>,
    {data: ContactMemoryRequest}
  > = props => {
    const {data} = props ?? {};

    return addContactToMemoryStore(data);
  };

  return {mutationFn, ...mutationOptions};
};

export type AddContactToMemoryStoreMutationResult = NonNullable<
  Awaited<ReturnType<typeof addContactToMemoryStore>>
>;
export type AddContactToMemoryStoreMutationBody = ContactMemoryRequest;
export type AddContactToMemoryStoreMutationError = void;

export const useAddContactToMemoryStore = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof addContactToMemoryStore>>,
      TError,
      {data: ContactMemoryRequest},
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof addContactToMemoryStore>>,
  TError,
  {data: ContactMemoryRequest},
  TContext
> => {
  const mutationOptions = getAddContactToMemoryStoreMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Remove a contact from a memory store
 */
export const removeContactFromMemoryStore = (
  params: RemoveContactFromMemoryStoreParams,
) => {
  return axiosInstance<void>({
    url: `/contact_memory_store`,
    method: "DELETE",
    params,
  });
};

export const getRemoveContactFromMemoryStoreMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof removeContactFromMemoryStore>>,
    TError,
    {params: RemoveContactFromMemoryStoreParams},
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof removeContactFromMemoryStore>>,
  TError,
  {params: RemoveContactFromMemoryStoreParams},
  TContext
> => {
  const mutationKey = ["removeContactFromMemoryStore"];
  const {mutation: mutationOptions} = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : {...options, mutation: {...options.mutation, mutationKey}}
    : {mutation: {mutationKey}};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof removeContactFromMemoryStore>>,
    {params: RemoveContactFromMemoryStoreParams}
  > = props => {
    const {params} = props ?? {};

    return removeContactFromMemoryStore(params);
  };

  return {mutationFn, ...mutationOptions};
};

export type RemoveContactFromMemoryStoreMutationResult = NonNullable<
  Awaited<ReturnType<typeof removeContactFromMemoryStore>>
>;

export type RemoveContactFromMemoryStoreMutationError = void;

export const useRemoveContactFromMemoryStore = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof removeContactFromMemoryStore>>,
      TError,
      {params: RemoveContactFromMemoryStoreParams},
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof removeContactFromMemoryStore>>,
  TError,
  {params: RemoveContactFromMemoryStoreParams},
  TContext
> => {
  const mutationOptions =
    getRemoveContactFromMemoryStoreMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Get paginated contacts for a workspace via /api prefix
 */
export const getContactsApi = (
  params: GetContactsApiParams,
  signal?: AbortSignal,
) => {
  return axiosInstance<GetContactsApi200 | void>({
    url: `/api/contacts`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetContactsApiQueryKey = (params: GetContactsApiParams) => {
  return [`/api/contacts`, ...(params ? [params] : [])] as const;
};

export const getGetContactsApiQueryOptions = <
  TData = Awaited<ReturnType<typeof getContactsApi>>,
  TError = unknown,
>(
  params: GetContactsApiParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getContactsApi>>, TError, TData>
    >;
  },
) => {
  const {query: queryOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetContactsApiQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getContactsApi>>> = ({
    signal,
  }) => getContactsApi(params, signal);

  return {queryKey, queryFn, ...queryOptions} as UseQueryOptions<
    Awaited<ReturnType<typeof getContactsApi>>,
    TError,
    TData
  > & {queryKey: DataTag<QueryKey, TData, TError>};
};

export type GetContactsApiQueryResult = NonNullable<
  Awaited<ReturnType<typeof getContactsApi>>
>;
export type GetContactsApiQueryError = unknown;

export function useGetContactsApi<
  TData = Awaited<ReturnType<typeof getContactsApi>>,
  TError = unknown,
>(
  params: GetContactsApiParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getContactsApi>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getContactsApi>>,
          TError,
          Awaited<ReturnType<typeof getContactsApi>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetContactsApi<
  TData = Awaited<ReturnType<typeof getContactsApi>>,
  TError = unknown,
>(
  params: GetContactsApiParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getContactsApi>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getContactsApi>>,
          TError,
          Awaited<ReturnType<typeof getContactsApi>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};
export function useGetContactsApi<
  TData = Awaited<ReturnType<typeof getContactsApi>>,
  TError = unknown,
>(
  params: GetContactsApiParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getContactsApi>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};

export function useGetContactsApi<
  TData = Awaited<ReturnType<typeof getContactsApi>>,
  TError = unknown,
>(
  params: GetContactsApiParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getContactsApi>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetContactsApiQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & {queryKey: DataTag<QueryKey, TData, TError>};

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Create a new contact via /api prefix
 */
export const createContactApi = (
  contactCreateRequest: ContactCreateRequest,
  signal?: AbortSignal,
) => {
  return axiosInstance<ContactIdResponse>({
    url: `/api/contacts`,
    method: "POST",
    headers: {"Content-Type": "application/json"},
    data: contactCreateRequest,
    signal,
  });
};

export const getCreateContactApiMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createContactApi>>,
    TError,
    {data: ContactCreateRequest},
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createContactApi>>,
  TError,
  {data: ContactCreateRequest},
  TContext
> => {
  const mutationKey = ["createContactApi"];
  const {mutation: mutationOptions} = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : {...options, mutation: {...options.mutation, mutationKey}}
    : {mutation: {mutationKey}};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createContactApi>>,
    {data: ContactCreateRequest}
  > = props => {
    const {data} = props ?? {};

    return createContactApi(data);
  };

  return {mutationFn, ...mutationOptions};
};

export type CreateContactApiMutationResult = NonNullable<
  Awaited<ReturnType<typeof createContactApi>>
>;
export type CreateContactApiMutationBody = ContactCreateRequest;
export type CreateContactApiMutationError = void;

export const useCreateContactApi = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createContactApi>>,
      TError,
      {data: ContactCreateRequest},
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createContactApi>>,
  TError,
  {data: ContactCreateRequest},
  TContext
> => {
  const mutationOptions = getCreateContactApiMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Get a specific contact by ID via /api prefix
 */
export const getContactApi = (contactId: string, signal?: AbortSignal) => {
  return axiosInstance<ContactResponse>({
    url: `/api/contacts/${contactId}`,
    method: "GET",
    signal,
  });
};

export const getGetContactApiQueryKey = (contactId: string) => {
  return [`/api/contacts/${contactId}`] as const;
};

export const getGetContactApiQueryOptions = <
  TData = Awaited<ReturnType<typeof getContactApi>>,
  TError = void,
>(
  contactId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getContactApi>>, TError, TData>
    >;
  },
) => {
  const {query: queryOptions} = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetContactApiQueryKey(contactId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getContactApi>>> = ({
    signal,
  }) => getContactApi(contactId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!contactId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getContactApi>>,
    TError,
    TData
  > & {queryKey: DataTag<QueryKey, TData, TError>};
};

export type GetContactApiQueryResult = NonNullable<
  Awaited<ReturnType<typeof getContactApi>>
>;
export type GetContactApiQueryError = void;

export function useGetContactApi<
  TData = Awaited<ReturnType<typeof getContactApi>>,
  TError = void,
>(
  contactId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getContactApi>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getContactApi>>,
          TError,
          Awaited<ReturnType<typeof getContactApi>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetContactApi<
  TData = Awaited<ReturnType<typeof getContactApi>>,
  TError = void,
>(
  contactId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getContactApi>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getContactApi>>,
          TError,
          Awaited<ReturnType<typeof getContactApi>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};
export function useGetContactApi<
  TData = Awaited<ReturnType<typeof getContactApi>>,
  TError = void,
>(
  contactId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getContactApi>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};

export function useGetContactApi<
  TData = Awaited<ReturnType<typeof getContactApi>>,
  TError = void,
>(
  contactId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getContactApi>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetContactApiQueryOptions(contactId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & {queryKey: DataTag<QueryKey, TData, TError>};

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Update a contact via /api prefix
 */
export const updateContactApi = (
  contactId: string,
  contactUpdateRequest: ContactUpdateRequest,
) => {
  return axiosInstance<ContactIdResponse>({
    url: `/api/contacts/${contactId}`,
    method: "PATCH",
    headers: {"Content-Type": "application/json"},
    data: contactUpdateRequest,
  });
};

export const getUpdateContactApiMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateContactApi>>,
    TError,
    {contactId: string; data: ContactUpdateRequest},
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateContactApi>>,
  TError,
  {contactId: string; data: ContactUpdateRequest},
  TContext
> => {
  const mutationKey = ["updateContactApi"];
  const {mutation: mutationOptions} = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : {...options, mutation: {...options.mutation, mutationKey}}
    : {mutation: {mutationKey}};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateContactApi>>,
    {contactId: string; data: ContactUpdateRequest}
  > = props => {
    const {contactId, data} = props ?? {};

    return updateContactApi(contactId, data);
  };

  return {mutationFn, ...mutationOptions};
};

export type UpdateContactApiMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateContactApi>>
>;
export type UpdateContactApiMutationBody = ContactUpdateRequest;
export type UpdateContactApiMutationError = void;

export const useUpdateContactApi = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateContactApi>>,
      TError,
      {contactId: string; data: ContactUpdateRequest},
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateContactApi>>,
  TError,
  {contactId: string; data: ContactUpdateRequest},
  TContext
> => {
  const mutationOptions = getUpdateContactApiMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Delete a contact via /api prefix
 */
export const deleteContactApi = (contactId: string) => {
  return axiosInstance<void>({
    url: `/api/contacts/${contactId}`,
    method: "DELETE",
  });
};

export const getDeleteContactApiMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteContactApi>>,
    TError,
    {contactId: string},
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteContactApi>>,
  TError,
  {contactId: string},
  TContext
> => {
  const mutationKey = ["deleteContactApi"];
  const {mutation: mutationOptions} = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : {...options, mutation: {...options.mutation, mutationKey}}
    : {mutation: {mutationKey}};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteContactApi>>,
    {contactId: string}
  > = props => {
    const {contactId} = props ?? {};

    return deleteContactApi(contactId);
  };

  return {mutationFn, ...mutationOptions};
};

export type DeleteContactApiMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteContactApi>>
>;

export type DeleteContactApiMutationError = void;

export const useDeleteContactApi = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteContactApi>>,
      TError,
      {contactId: string},
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteContactApi>>,
  TError,
  {contactId: string},
  TContext
> => {
  const mutationOptions = getDeleteContactApiMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Get all memory stores for a contact via /api prefix
 */
export const getContactMemoryStoresApi = (
  contactId: string,
  signal?: AbortSignal,
) => {
  return axiosInstance<ContactMemoryResponse[]>({
    url: `/api/contacts/${contactId}/memory_stores`,
    method: "GET",
    signal,
  });
};

export const getGetContactMemoryStoresApiQueryKey = (contactId: string) => {
  return [`/api/contacts/${contactId}/memory_stores`] as const;
};

export const getGetContactMemoryStoresApiQueryOptions = <
  TData = Awaited<ReturnType<typeof getContactMemoryStoresApi>>,
  TError = unknown,
>(
  contactId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getContactMemoryStoresApi>>,
        TError,
        TData
      >
    >;
  },
) => {
  const {query: queryOptions} = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetContactMemoryStoresApiQueryKey(contactId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getContactMemoryStoresApi>>
  > = ({signal}) => getContactMemoryStoresApi(contactId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!contactId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getContactMemoryStoresApi>>,
    TError,
    TData
  > & {queryKey: DataTag<QueryKey, TData, TError>};
};

export type GetContactMemoryStoresApiQueryResult = NonNullable<
  Awaited<ReturnType<typeof getContactMemoryStoresApi>>
>;
export type GetContactMemoryStoresApiQueryError = unknown;

export function useGetContactMemoryStoresApi<
  TData = Awaited<ReturnType<typeof getContactMemoryStoresApi>>,
  TError = unknown,
>(
  contactId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getContactMemoryStoresApi>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getContactMemoryStoresApi>>,
          TError,
          Awaited<ReturnType<typeof getContactMemoryStoresApi>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetContactMemoryStoresApi<
  TData = Awaited<ReturnType<typeof getContactMemoryStoresApi>>,
  TError = unknown,
>(
  contactId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getContactMemoryStoresApi>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getContactMemoryStoresApi>>,
          TError,
          Awaited<ReturnType<typeof getContactMemoryStoresApi>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};
export function useGetContactMemoryStoresApi<
  TData = Awaited<ReturnType<typeof getContactMemoryStoresApi>>,
  TError = unknown,
>(
  contactId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getContactMemoryStoresApi>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};

export function useGetContactMemoryStoresApi<
  TData = Awaited<ReturnType<typeof getContactMemoryStoresApi>>,
  TError = unknown,
>(
  contactId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getContactMemoryStoresApi>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetContactMemoryStoresApiQueryOptions(
    contactId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & {queryKey: DataTag<QueryKey, TData, TError>};

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get memory data for a specific contact in a specific memory store via /api prefix
 */
export const getContactMemoryInStoreApi = (
  contactId: string,
  memoryStoreId: string,
  signal?: AbortSignal,
) => {
  return axiosInstance<ContactMemoryResponse>({
    url: `/api/contacts/${contactId}/memory_stores/${memoryStoreId}`,
    method: "GET",
    signal,
  });
};

export const getGetContactMemoryInStoreApiQueryKey = (
  contactId: string,
  memoryStoreId: string,
) => {
  return [`/api/contacts/${contactId}/memory_stores/${memoryStoreId}`] as const;
};

export const getGetContactMemoryInStoreApiQueryOptions = <
  TData = Awaited<ReturnType<typeof getContactMemoryInStoreApi>>,
  TError = void,
>(
  contactId: string,
  memoryStoreId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getContactMemoryInStoreApi>>,
        TError,
        TData
      >
    >;
  },
) => {
  const {query: queryOptions} = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetContactMemoryInStoreApiQueryKey(contactId, memoryStoreId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getContactMemoryInStoreApi>>
  > = ({signal}) =>
    getContactMemoryInStoreApi(contactId, memoryStoreId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(contactId && memoryStoreId),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getContactMemoryInStoreApi>>,
    TError,
    TData
  > & {queryKey: DataTag<QueryKey, TData, TError>};
};

export type GetContactMemoryInStoreApiQueryResult = NonNullable<
  Awaited<ReturnType<typeof getContactMemoryInStoreApi>>
>;
export type GetContactMemoryInStoreApiQueryError = void;

export function useGetContactMemoryInStoreApi<
  TData = Awaited<ReturnType<typeof getContactMemoryInStoreApi>>,
  TError = void,
>(
  contactId: string,
  memoryStoreId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getContactMemoryInStoreApi>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getContactMemoryInStoreApi>>,
          TError,
          Awaited<ReturnType<typeof getContactMemoryInStoreApi>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetContactMemoryInStoreApi<
  TData = Awaited<ReturnType<typeof getContactMemoryInStoreApi>>,
  TError = void,
>(
  contactId: string,
  memoryStoreId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getContactMemoryInStoreApi>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getContactMemoryInStoreApi>>,
          TError,
          Awaited<ReturnType<typeof getContactMemoryInStoreApi>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};
export function useGetContactMemoryInStoreApi<
  TData = Awaited<ReturnType<typeof getContactMemoryInStoreApi>>,
  TError = void,
>(
  contactId: string,
  memoryStoreId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getContactMemoryInStoreApi>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};

export function useGetContactMemoryInStoreApi<
  TData = Awaited<ReturnType<typeof getContactMemoryInStoreApi>>,
  TError = void,
>(
  contactId: string,
  memoryStoreId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getContactMemoryInStoreApi>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetContactMemoryInStoreApiQueryOptions(
    contactId,
    memoryStoreId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & {queryKey: DataTag<QueryKey, TData, TError>};

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get all memory data for a contact across all memory stores via /api prefix
 */
export const getContactMemoriesApi = (
  contactId: string,
  signal?: AbortSignal,
) => {
  return axiosInstance<ContactMemoryResponse[]>({
    url: `/api/contacts/${contactId}/memories`,
    method: "GET",
    signal,
  });
};

export const getGetContactMemoriesApiQueryKey = (contactId: string) => {
  return [`/api/contacts/${contactId}/memories`] as const;
};

export const getGetContactMemoriesApiQueryOptions = <
  TData = Awaited<ReturnType<typeof getContactMemoriesApi>>,
  TError = unknown,
>(
  contactId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getContactMemoriesApi>>,
        TError,
        TData
      >
    >;
  },
) => {
  const {query: queryOptions} = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetContactMemoriesApiQueryKey(contactId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getContactMemoriesApi>>
  > = ({signal}) => getContactMemoriesApi(contactId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!contactId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getContactMemoriesApi>>,
    TError,
    TData
  > & {queryKey: DataTag<QueryKey, TData, TError>};
};

export type GetContactMemoriesApiQueryResult = NonNullable<
  Awaited<ReturnType<typeof getContactMemoriesApi>>
>;
export type GetContactMemoriesApiQueryError = unknown;

export function useGetContactMemoriesApi<
  TData = Awaited<ReturnType<typeof getContactMemoriesApi>>,
  TError = unknown,
>(
  contactId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getContactMemoriesApi>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getContactMemoriesApi>>,
          TError,
          Awaited<ReturnType<typeof getContactMemoriesApi>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetContactMemoriesApi<
  TData = Awaited<ReturnType<typeof getContactMemoriesApi>>,
  TError = unknown,
>(
  contactId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getContactMemoriesApi>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getContactMemoriesApi>>,
          TError,
          Awaited<ReturnType<typeof getContactMemoriesApi>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};
export function useGetContactMemoriesApi<
  TData = Awaited<ReturnType<typeof getContactMemoriesApi>>,
  TError = unknown,
>(
  contactId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getContactMemoriesApi>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};

export function useGetContactMemoriesApi<
  TData = Awaited<ReturnType<typeof getContactMemoriesApi>>,
  TError = unknown,
>(
  contactId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getContactMemoriesApi>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetContactMemoriesApiQueryOptions(contactId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & {queryKey: DataTag<QueryKey, TData, TError>};

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get paginated memory stores for a workspace via /api prefix
 */
export const getMemoryStoresApi = (
  params: GetMemoryStoresApiParams,
  signal?: AbortSignal,
) => {
  return axiosInstance<GetMemoryStoresApi200 | void>({
    url: `/api/memory_stores`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetMemoryStoresApiQueryKey = (
  params: GetMemoryStoresApiParams,
) => {
  return [`/api/memory_stores`, ...(params ? [params] : [])] as const;
};

export const getGetMemoryStoresApiQueryOptions = <
  TData = Awaited<ReturnType<typeof getMemoryStoresApi>>,
  TError = unknown,
>(
  params: GetMemoryStoresApiParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMemoryStoresApi>>,
        TError,
        TData
      >
    >;
  },
) => {
  const {query: queryOptions} = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMemoryStoresApiQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMemoryStoresApi>>
  > = ({signal}) => getMemoryStoresApi(params, signal);

  return {queryKey, queryFn, ...queryOptions} as UseQueryOptions<
    Awaited<ReturnType<typeof getMemoryStoresApi>>,
    TError,
    TData
  > & {queryKey: DataTag<QueryKey, TData, TError>};
};

export type GetMemoryStoresApiQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMemoryStoresApi>>
>;
export type GetMemoryStoresApiQueryError = unknown;

export function useGetMemoryStoresApi<
  TData = Awaited<ReturnType<typeof getMemoryStoresApi>>,
  TError = unknown,
>(
  params: GetMemoryStoresApiParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMemoryStoresApi>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMemoryStoresApi>>,
          TError,
          Awaited<ReturnType<typeof getMemoryStoresApi>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetMemoryStoresApi<
  TData = Awaited<ReturnType<typeof getMemoryStoresApi>>,
  TError = unknown,
>(
  params: GetMemoryStoresApiParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMemoryStoresApi>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMemoryStoresApi>>,
          TError,
          Awaited<ReturnType<typeof getMemoryStoresApi>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};
export function useGetMemoryStoresApi<
  TData = Awaited<ReturnType<typeof getMemoryStoresApi>>,
  TError = unknown,
>(
  params: GetMemoryStoresApiParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMemoryStoresApi>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};

export function useGetMemoryStoresApi<
  TData = Awaited<ReturnType<typeof getMemoryStoresApi>>,
  TError = unknown,
>(
  params: GetMemoryStoresApiParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMemoryStoresApi>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetMemoryStoresApiQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & {queryKey: DataTag<QueryKey, TData, TError>};

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Create a new memory store via /api prefix
 */
export const createMemoryStoreApi = (
  memoryStoreCreateRequest: MemoryStoreCreateRequest,
  signal?: AbortSignal,
) => {
  return axiosInstance<MemoryStoreResponse>({
    url: `/api/memory_stores`,
    method: "POST",
    headers: {"Content-Type": "application/json"},
    data: memoryStoreCreateRequest,
    signal,
  });
};

export const getCreateMemoryStoreApiMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createMemoryStoreApi>>,
    TError,
    {data: MemoryStoreCreateRequest},
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createMemoryStoreApi>>,
  TError,
  {data: MemoryStoreCreateRequest},
  TContext
> => {
  const mutationKey = ["createMemoryStoreApi"];
  const {mutation: mutationOptions} = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : {...options, mutation: {...options.mutation, mutationKey}}
    : {mutation: {mutationKey}};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createMemoryStoreApi>>,
    {data: MemoryStoreCreateRequest}
  > = props => {
    const {data} = props ?? {};

    return createMemoryStoreApi(data);
  };

  return {mutationFn, ...mutationOptions};
};

export type CreateMemoryStoreApiMutationResult = NonNullable<
  Awaited<ReturnType<typeof createMemoryStoreApi>>
>;
export type CreateMemoryStoreApiMutationBody = MemoryStoreCreateRequest;
export type CreateMemoryStoreApiMutationError = void;

export const useCreateMemoryStoreApi = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createMemoryStoreApi>>,
      TError,
      {data: MemoryStoreCreateRequest},
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createMemoryStoreApi>>,
  TError,
  {data: MemoryStoreCreateRequest},
  TContext
> => {
  const mutationOptions = getCreateMemoryStoreApiMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Get a specific memory store by ID via /api prefix
 */
export const getMemoryStoreApi = (
  memoryStoreId: string,
  signal?: AbortSignal,
) => {
  return axiosInstance<MemoryStoreResponse>({
    url: `/api/memory_stores/${memoryStoreId}`,
    method: "GET",
    signal,
  });
};

export const getGetMemoryStoreApiQueryKey = (memoryStoreId: string) => {
  return [`/api/memory_stores/${memoryStoreId}`] as const;
};

export const getGetMemoryStoreApiQueryOptions = <
  TData = Awaited<ReturnType<typeof getMemoryStoreApi>>,
  TError = void,
>(
  memoryStoreId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMemoryStoreApi>>,
        TError,
        TData
      >
    >;
  },
) => {
  const {query: queryOptions} = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMemoryStoreApiQueryKey(memoryStoreId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMemoryStoreApi>>
  > = ({signal}) => getMemoryStoreApi(memoryStoreId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!memoryStoreId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getMemoryStoreApi>>,
    TError,
    TData
  > & {queryKey: DataTag<QueryKey, TData, TError>};
};

export type GetMemoryStoreApiQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMemoryStoreApi>>
>;
export type GetMemoryStoreApiQueryError = void;

export function useGetMemoryStoreApi<
  TData = Awaited<ReturnType<typeof getMemoryStoreApi>>,
  TError = void,
>(
  memoryStoreId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMemoryStoreApi>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMemoryStoreApi>>,
          TError,
          Awaited<ReturnType<typeof getMemoryStoreApi>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetMemoryStoreApi<
  TData = Awaited<ReturnType<typeof getMemoryStoreApi>>,
  TError = void,
>(
  memoryStoreId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMemoryStoreApi>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMemoryStoreApi>>,
          TError,
          Awaited<ReturnType<typeof getMemoryStoreApi>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};
export function useGetMemoryStoreApi<
  TData = Awaited<ReturnType<typeof getMemoryStoreApi>>,
  TError = void,
>(
  memoryStoreId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMemoryStoreApi>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};

export function useGetMemoryStoreApi<
  TData = Awaited<ReturnType<typeof getMemoryStoreApi>>,
  TError = void,
>(
  memoryStoreId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMemoryStoreApi>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetMemoryStoreApiQueryOptions(memoryStoreId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & {queryKey: DataTag<QueryKey, TData, TError>};

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Update a memory store via /api prefix
 */
export const updateMemoryStoreApi = (
  memoryStoreId: string,
  memoryStoreUpdateRequest: MemoryStoreUpdateRequest,
) => {
  return axiosInstance<MemoryStoreIdResponse>({
    url: `/api/memory_stores/${memoryStoreId}`,
    method: "PATCH",
    headers: {"Content-Type": "application/json"},
    data: memoryStoreUpdateRequest,
  });
};

export const getUpdateMemoryStoreApiMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateMemoryStoreApi>>,
    TError,
    {memoryStoreId: string; data: MemoryStoreUpdateRequest},
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateMemoryStoreApi>>,
  TError,
  {memoryStoreId: string; data: MemoryStoreUpdateRequest},
  TContext
> => {
  const mutationKey = ["updateMemoryStoreApi"];
  const {mutation: mutationOptions} = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : {...options, mutation: {...options.mutation, mutationKey}}
    : {mutation: {mutationKey}};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateMemoryStoreApi>>,
    {memoryStoreId: string; data: MemoryStoreUpdateRequest}
  > = props => {
    const {memoryStoreId, data} = props ?? {};

    return updateMemoryStoreApi(memoryStoreId, data);
  };

  return {mutationFn, ...mutationOptions};
};

export type UpdateMemoryStoreApiMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateMemoryStoreApi>>
>;
export type UpdateMemoryStoreApiMutationBody = MemoryStoreUpdateRequest;
export type UpdateMemoryStoreApiMutationError = void;

export const useUpdateMemoryStoreApi = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateMemoryStoreApi>>,
      TError,
      {memoryStoreId: string; data: MemoryStoreUpdateRequest},
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateMemoryStoreApi>>,
  TError,
  {memoryStoreId: string; data: MemoryStoreUpdateRequest},
  TContext
> => {
  const mutationOptions = getUpdateMemoryStoreApiMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Delete a memory store via /api prefix
 */
export const deleteMemoryStoreApi = (memoryStoreId: string) => {
  return axiosInstance<void>({
    url: `/api/memory_stores/${memoryStoreId}`,
    method: "DELETE",
  });
};

export const getDeleteMemoryStoreApiMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteMemoryStoreApi>>,
    TError,
    {memoryStoreId: string},
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteMemoryStoreApi>>,
  TError,
  {memoryStoreId: string},
  TContext
> => {
  const mutationKey = ["deleteMemoryStoreApi"];
  const {mutation: mutationOptions} = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : {...options, mutation: {...options.mutation, mutationKey}}
    : {mutation: {mutationKey}};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteMemoryStoreApi>>,
    {memoryStoreId: string}
  > = props => {
    const {memoryStoreId} = props ?? {};

    return deleteMemoryStoreApi(memoryStoreId);
  };

  return {mutationFn, ...mutationOptions};
};

export type DeleteMemoryStoreApiMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteMemoryStoreApi>>
>;

export type DeleteMemoryStoreApiMutationError = void;

export const useDeleteMemoryStoreApi = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteMemoryStoreApi>>,
      TError,
      {memoryStoreId: string},
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteMemoryStoreApi>>,
  TError,
  {memoryStoreId: string},
  TContext
> => {
  const mutationOptions = getDeleteMemoryStoreApiMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Get paginated contacts for a memory store via /api prefix
 */
export const getMemoryStoreContactsApi = (
  memoryStoreId: string,
  params?: GetMemoryStoreContactsApiParams,
  signal?: AbortSignal,
) => {
  return axiosInstance<GetMemoryStoreContactsApi200>({
    url: `/api/memory_stores/${memoryStoreId}/contacts`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetMemoryStoreContactsApiQueryKey = (
  memoryStoreId: string,
  params?: GetMemoryStoreContactsApiParams,
) => {
  return [
    `/api/memory_stores/${memoryStoreId}/contacts`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetMemoryStoreContactsApiQueryOptions = <
  TData = Awaited<ReturnType<typeof getMemoryStoreContactsApi>>,
  TError = unknown,
>(
  memoryStoreId: string,
  params?: GetMemoryStoreContactsApiParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMemoryStoreContactsApi>>,
        TError,
        TData
      >
    >;
  },
) => {
  const {query: queryOptions} = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetMemoryStoreContactsApiQueryKey(memoryStoreId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMemoryStoreContactsApi>>
  > = ({signal}) => getMemoryStoreContactsApi(memoryStoreId, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!memoryStoreId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getMemoryStoreContactsApi>>,
    TError,
    TData
  > & {queryKey: DataTag<QueryKey, TData, TError>};
};

export type GetMemoryStoreContactsApiQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMemoryStoreContactsApi>>
>;
export type GetMemoryStoreContactsApiQueryError = unknown;

export function useGetMemoryStoreContactsApi<
  TData = Awaited<ReturnType<typeof getMemoryStoreContactsApi>>,
  TError = unknown,
>(
  memoryStoreId: string,
  params: undefined | GetMemoryStoreContactsApiParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMemoryStoreContactsApi>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMemoryStoreContactsApi>>,
          TError,
          Awaited<ReturnType<typeof getMemoryStoreContactsApi>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetMemoryStoreContactsApi<
  TData = Awaited<ReturnType<typeof getMemoryStoreContactsApi>>,
  TError = unknown,
>(
  memoryStoreId: string,
  params?: GetMemoryStoreContactsApiParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMemoryStoreContactsApi>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMemoryStoreContactsApi>>,
          TError,
          Awaited<ReturnType<typeof getMemoryStoreContactsApi>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};
export function useGetMemoryStoreContactsApi<
  TData = Awaited<ReturnType<typeof getMemoryStoreContactsApi>>,
  TError = unknown,
>(
  memoryStoreId: string,
  params?: GetMemoryStoreContactsApiParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMemoryStoreContactsApi>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};

export function useGetMemoryStoreContactsApi<
  TData = Awaited<ReturnType<typeof getMemoryStoreContactsApi>>,
  TError = unknown,
>(
  memoryStoreId: string,
  params?: GetMemoryStoreContactsApiParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMemoryStoreContactsApi>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetMemoryStoreContactsApiQueryOptions(
    memoryStoreId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & {queryKey: DataTag<QueryKey, TData, TError>};

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Add a contact to a memory store via /api prefix
 */
export const addContactToMemoryStoreApi = (
  contactMemoryRequest: ContactMemoryRequest,
  signal?: AbortSignal,
) => {
  return axiosInstance<void>({
    url: `/api/contact_memory_store`,
    method: "POST",
    headers: {"Content-Type": "application/json"},
    data: contactMemoryRequest,
    signal,
  });
};

export const getAddContactToMemoryStoreApiMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addContactToMemoryStoreApi>>,
    TError,
    {data: ContactMemoryRequest},
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof addContactToMemoryStoreApi>>,
  TError,
  {data: ContactMemoryRequest},
  TContext
> => {
  const mutationKey = ["addContactToMemoryStoreApi"];
  const {mutation: mutationOptions} = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : {...options, mutation: {...options.mutation, mutationKey}}
    : {mutation: {mutationKey}};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof addContactToMemoryStoreApi>>,
    {data: ContactMemoryRequest}
  > = props => {
    const {data} = props ?? {};

    return addContactToMemoryStoreApi(data);
  };

  return {mutationFn, ...mutationOptions};
};

export type AddContactToMemoryStoreApiMutationResult = NonNullable<
  Awaited<ReturnType<typeof addContactToMemoryStoreApi>>
>;
export type AddContactToMemoryStoreApiMutationBody = ContactMemoryRequest;
export type AddContactToMemoryStoreApiMutationError = void;

export const useAddContactToMemoryStoreApi = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof addContactToMemoryStoreApi>>,
      TError,
      {data: ContactMemoryRequest},
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof addContactToMemoryStoreApi>>,
  TError,
  {data: ContactMemoryRequest},
  TContext
> => {
  const mutationOptions = getAddContactToMemoryStoreApiMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Remove a contact from a memory store via /api prefix
 */
export const removeContactFromMemoryStoreApi = (
  params: RemoveContactFromMemoryStoreApiParams,
) => {
  return axiosInstance<void>({
    url: `/api/contact_memory_store`,
    method: "DELETE",
    params,
  });
};

export const getRemoveContactFromMemoryStoreApiMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof removeContactFromMemoryStoreApi>>,
    TError,
    {params: RemoveContactFromMemoryStoreApiParams},
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof removeContactFromMemoryStoreApi>>,
  TError,
  {params: RemoveContactFromMemoryStoreApiParams},
  TContext
> => {
  const mutationKey = ["removeContactFromMemoryStoreApi"];
  const {mutation: mutationOptions} = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : {...options, mutation: {...options.mutation, mutationKey}}
    : {mutation: {mutationKey}};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof removeContactFromMemoryStoreApi>>,
    {params: RemoveContactFromMemoryStoreApiParams}
  > = props => {
    const {params} = props ?? {};

    return removeContactFromMemoryStoreApi(params);
  };

  return {mutationFn, ...mutationOptions};
};

export type RemoveContactFromMemoryStoreApiMutationResult = NonNullable<
  Awaited<ReturnType<typeof removeContactFromMemoryStoreApi>>
>;

export type RemoveContactFromMemoryStoreApiMutationError = void;

export const useRemoveContactFromMemoryStoreApi = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof removeContactFromMemoryStoreApi>>,
      TError,
      {params: RemoveContactFromMemoryStoreApiParams},
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof removeContactFromMemoryStoreApi>>,
  TError,
  {params: RemoveContactFromMemoryStoreApiParams},
  TContext
> => {
  const mutationOptions =
    getRemoveContactFromMemoryStoreApiMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Gets the memory store attached to an assistant via /api prefix
 */
export const getAssistantMemoryStoreApi = (
  assistantId: string,
  signal?: AbortSignal,
) => {
  return axiosInstance<MemoryStoreResponse>({
    url: `/api/assistants/${assistantId}/memory_stores`,
    method: "GET",
    signal,
  });
};

export const getGetAssistantMemoryStoreApiQueryKey = (assistantId: string) => {
  return [`/api/assistants/${assistantId}/memory_stores`] as const;
};

export const getGetAssistantMemoryStoreApiQueryOptions = <
  TData = Awaited<ReturnType<typeof getAssistantMemoryStoreApi>>,
  TError = void,
>(
  assistantId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssistantMemoryStoreApi>>,
        TError,
        TData
      >
    >;
  },
) => {
  const {query: queryOptions} = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetAssistantMemoryStoreApiQueryKey(assistantId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAssistantMemoryStoreApi>>
  > = ({signal}) => getAssistantMemoryStoreApi(assistantId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!assistantId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getAssistantMemoryStoreApi>>,
    TError,
    TData
  > & {queryKey: DataTag<QueryKey, TData, TError>};
};

export type GetAssistantMemoryStoreApiQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAssistantMemoryStoreApi>>
>;
export type GetAssistantMemoryStoreApiQueryError = void;

export function useGetAssistantMemoryStoreApi<
  TData = Awaited<ReturnType<typeof getAssistantMemoryStoreApi>>,
  TError = void,
>(
  assistantId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssistantMemoryStoreApi>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAssistantMemoryStoreApi>>,
          TError,
          Awaited<ReturnType<typeof getAssistantMemoryStoreApi>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAssistantMemoryStoreApi<
  TData = Awaited<ReturnType<typeof getAssistantMemoryStoreApi>>,
  TError = void,
>(
  assistantId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssistantMemoryStoreApi>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAssistantMemoryStoreApi>>,
          TError,
          Awaited<ReturnType<typeof getAssistantMemoryStoreApi>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};
export function useGetAssistantMemoryStoreApi<
  TData = Awaited<ReturnType<typeof getAssistantMemoryStoreApi>>,
  TError = void,
>(
  assistantId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssistantMemoryStoreApi>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};

export function useGetAssistantMemoryStoreApi<
  TData = Awaited<ReturnType<typeof getAssistantMemoryStoreApi>>,
  TError = void,
>(
  assistantId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAssistantMemoryStoreApi>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetAssistantMemoryStoreApiQueryOptions(
    assistantId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & {queryKey: DataTag<QueryKey, TData, TError>};

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Attaches a memory store to an assistant via /api prefix
 */
export const attachMemoryStoreToAssistantApi = (
  assistantId: string,
  memoryStoreId: string,
) => {
  return axiosInstance<void>({
    url: `/api/assistants/${assistantId}/memory_stores/${memoryStoreId}`,
    method: "PUT",
  });
};

export const getAttachMemoryStoreToAssistantApiMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof attachMemoryStoreToAssistantApi>>,
    TError,
    {assistantId: string; memoryStoreId: string},
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof attachMemoryStoreToAssistantApi>>,
  TError,
  {assistantId: string; memoryStoreId: string},
  TContext
> => {
  const mutationKey = ["attachMemoryStoreToAssistantApi"];
  const {mutation: mutationOptions} = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : {...options, mutation: {...options.mutation, mutationKey}}
    : {mutation: {mutationKey}};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof attachMemoryStoreToAssistantApi>>,
    {assistantId: string; memoryStoreId: string}
  > = props => {
    const {assistantId, memoryStoreId} = props ?? {};

    return attachMemoryStoreToAssistantApi(assistantId, memoryStoreId);
  };

  return {mutationFn, ...mutationOptions};
};

export type AttachMemoryStoreToAssistantApiMutationResult = NonNullable<
  Awaited<ReturnType<typeof attachMemoryStoreToAssistantApi>>
>;

export type AttachMemoryStoreToAssistantApiMutationError = void;

export const useAttachMemoryStoreToAssistantApi = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof attachMemoryStoreToAssistantApi>>,
      TError,
      {assistantId: string; memoryStoreId: string},
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof attachMemoryStoreToAssistantApi>>,
  TError,
  {assistantId: string; memoryStoreId: string},
  TContext
> => {
  const mutationOptions =
    getAttachMemoryStoreToAssistantApiMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Detaches a memory store from an assistant via /api prefix
 */
export const detachMemoryStoreFromAssistantApi = (
  assistantId: string,
  memoryStoreId: string,
) => {
  return axiosInstance<void>({
    url: `/api/assistants/${assistantId}/memory_stores/${memoryStoreId}`,
    method: "DELETE",
  });
};

export const getDetachMemoryStoreFromAssistantApiMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof detachMemoryStoreFromAssistantApi>>,
    TError,
    {assistantId: string; memoryStoreId: string},
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof detachMemoryStoreFromAssistantApi>>,
  TError,
  {assistantId: string; memoryStoreId: string},
  TContext
> => {
  const mutationKey = ["detachMemoryStoreFromAssistantApi"];
  const {mutation: mutationOptions} = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : {...options, mutation: {...options.mutation, mutationKey}}
    : {mutation: {mutationKey}};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof detachMemoryStoreFromAssistantApi>>,
    {assistantId: string; memoryStoreId: string}
  > = props => {
    const {assistantId, memoryStoreId} = props ?? {};

    return detachMemoryStoreFromAssistantApi(assistantId, memoryStoreId);
  };

  return {mutationFn, ...mutationOptions};
};

export type DetachMemoryStoreFromAssistantApiMutationResult = NonNullable<
  Awaited<ReturnType<typeof detachMemoryStoreFromAssistantApi>>
>;

export type DetachMemoryStoreFromAssistantApiMutationError = void;

export const useDetachMemoryStoreFromAssistantApi = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof detachMemoryStoreFromAssistantApi>>,
      TError,
      {assistantId: string; memoryStoreId: string},
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof detachMemoryStoreFromAssistantApi>>,
  TError,
  {assistantId: string; memoryStoreId: string},
  TContext
> => {
  const mutationOptions =
    getDetachMemoryStoreFromAssistantApiMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Get a specific simulation by ID
 */
export const getSimulation = (
  simulationId: string,
  params: GetSimulationParams,
  signal?: AbortSignal,
) => {
  return axiosInstance<SimulationReadOut>({
    url: `/simulations/${simulationId}`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetSimulationQueryKey = (
  simulationId: string,
  params: GetSimulationParams,
) => {
  return [`/simulations/${simulationId}`, ...(params ? [params] : [])] as const;
};

export const getGetSimulationQueryOptions = <
  TData = Awaited<ReturnType<typeof getSimulation>>,
  TError = void,
>(
  simulationId: string,
  params: GetSimulationParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSimulation>>, TError, TData>
    >;
  },
) => {
  const {query: queryOptions} = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetSimulationQueryKey(simulationId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSimulation>>> = ({
    signal,
  }) => getSimulation(simulationId, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!simulationId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getSimulation>>,
    TError,
    TData
  > & {queryKey: DataTag<QueryKey, TData, TError>};
};

export type GetSimulationQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSimulation>>
>;
export type GetSimulationQueryError = void;

export function useGetSimulation<
  TData = Awaited<ReturnType<typeof getSimulation>>,
  TError = void,
>(
  simulationId: string,
  params: GetSimulationParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSimulation>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSimulation>>,
          TError,
          Awaited<ReturnType<typeof getSimulation>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSimulation<
  TData = Awaited<ReturnType<typeof getSimulation>>,
  TError = void,
>(
  simulationId: string,
  params: GetSimulationParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSimulation>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSimulation>>,
          TError,
          Awaited<ReturnType<typeof getSimulation>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};
export function useGetSimulation<
  TData = Awaited<ReturnType<typeof getSimulation>>,
  TError = void,
>(
  simulationId: string,
  params: GetSimulationParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSimulation>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};

export function useGetSimulation<
  TData = Awaited<ReturnType<typeof getSimulation>>,
  TError = void,
>(
  simulationId: string,
  params: GetSimulationParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSimulation>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetSimulationQueryOptions(
    simulationId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & {queryKey: DataTag<QueryKey, TData, TError>};

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Proxy GET request to BubbleAuthProxy
 */
export const bubbleAuthProxyGet = (
  params?: BubbleAuthProxyGetParams,
  signal?: AbortSignal,
) => {
  return axiosInstance<BubbleAuthProxyGet200>({
    url: `/proxy/`,
    method: "GET",
    params,
    signal,
  });
};

export const getBubbleAuthProxyGetQueryKey = (
  params?: BubbleAuthProxyGetParams,
) => {
  return [`/proxy/`, ...(params ? [params] : [])] as const;
};

export const getBubbleAuthProxyGetQueryOptions = <
  TData = Awaited<ReturnType<typeof bubbleAuthProxyGet>>,
  TError = unknown,
>(
  params?: BubbleAuthProxyGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof bubbleAuthProxyGet>>,
        TError,
        TData
      >
    >;
  },
) => {
  const {query: queryOptions} = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getBubbleAuthProxyGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof bubbleAuthProxyGet>>
  > = ({signal}) => bubbleAuthProxyGet(params, signal);

  return {queryKey, queryFn, ...queryOptions} as UseQueryOptions<
    Awaited<ReturnType<typeof bubbleAuthProxyGet>>,
    TError,
    TData
  > & {queryKey: DataTag<QueryKey, TData, TError>};
};

export type BubbleAuthProxyGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof bubbleAuthProxyGet>>
>;
export type BubbleAuthProxyGetQueryError = unknown;

export function useBubbleAuthProxyGet<
  TData = Awaited<ReturnType<typeof bubbleAuthProxyGet>>,
  TError = unknown,
>(
  params: undefined | BubbleAuthProxyGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof bubbleAuthProxyGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof bubbleAuthProxyGet>>,
          TError,
          Awaited<ReturnType<typeof bubbleAuthProxyGet>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useBubbleAuthProxyGet<
  TData = Awaited<ReturnType<typeof bubbleAuthProxyGet>>,
  TError = unknown,
>(
  params?: BubbleAuthProxyGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof bubbleAuthProxyGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof bubbleAuthProxyGet>>,
          TError,
          Awaited<ReturnType<typeof bubbleAuthProxyGet>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};
export function useBubbleAuthProxyGet<
  TData = Awaited<ReturnType<typeof bubbleAuthProxyGet>>,
  TError = unknown,
>(
  params?: BubbleAuthProxyGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof bubbleAuthProxyGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};
/**
 * @summary Proxy GET request to BubbleAuthProxy
 */

export function useBubbleAuthProxyGet<
  TData = Awaited<ReturnType<typeof bubbleAuthProxyGet>>,
  TError = unknown,
>(
  params?: BubbleAuthProxyGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof bubbleAuthProxyGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getBubbleAuthProxyGetQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & {queryKey: DataTag<QueryKey, TData, TError>};

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Proxy POST request to BubbleAuthProxy
 */
export const bubbleAuthProxyPost = (
  bubbleAuthProxyPostBody?: BubbleAuthProxyPostBody,
  signal?: AbortSignal,
) => {
  return axiosInstance<BubbleAuthProxyPost200>({
    url: `/proxy/`,
    method: "POST",
    headers: {"Content-Type": "application/json"},
    data: bubbleAuthProxyPostBody,
    signal,
  });
};

export const getBubbleAuthProxyPostMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bubbleAuthProxyPost>>,
    TError,
    {data: BubbleAuthProxyPostBody},
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof bubbleAuthProxyPost>>,
  TError,
  {data: BubbleAuthProxyPostBody},
  TContext
> => {
  const mutationKey = ["bubbleAuthProxyPost"];
  const {mutation: mutationOptions} = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : {...options, mutation: {...options.mutation, mutationKey}}
    : {mutation: {mutationKey}};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof bubbleAuthProxyPost>>,
    {data: BubbleAuthProxyPostBody}
  > = props => {
    const {data} = props ?? {};

    return bubbleAuthProxyPost(data);
  };

  return {mutationFn, ...mutationOptions};
};

export type BubbleAuthProxyPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof bubbleAuthProxyPost>>
>;
export type BubbleAuthProxyPostMutationBody = BubbleAuthProxyPostBody;
export type BubbleAuthProxyPostMutationError = unknown;

/**
 * @summary Proxy POST request to BubbleAuthProxy
 */
export const useBubbleAuthProxyPost = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof bubbleAuthProxyPost>>,
      TError,
      {data: BubbleAuthProxyPostBody},
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof bubbleAuthProxyPost>>,
  TError,
  {data: BubbleAuthProxyPostBody},
  TContext
> => {
  const mutationOptions = getBubbleAuthProxyPostMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Proxy PUT request to BubbleAuthProxy
 */
export const bubbleAuthProxyPut = (
  bubbleAuthProxyPutBody?: BubbleAuthProxyPutBody,
) => {
  return axiosInstance<BubbleAuthProxyPut200>({
    url: `/proxy/`,
    method: "PUT",
    headers: {"Content-Type": "application/json"},
    data: bubbleAuthProxyPutBody,
  });
};

export const getBubbleAuthProxyPutMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bubbleAuthProxyPut>>,
    TError,
    {data: BubbleAuthProxyPutBody},
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof bubbleAuthProxyPut>>,
  TError,
  {data: BubbleAuthProxyPutBody},
  TContext
> => {
  const mutationKey = ["bubbleAuthProxyPut"];
  const {mutation: mutationOptions} = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : {...options, mutation: {...options.mutation, mutationKey}}
    : {mutation: {mutationKey}};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof bubbleAuthProxyPut>>,
    {data: BubbleAuthProxyPutBody}
  > = props => {
    const {data} = props ?? {};

    return bubbleAuthProxyPut(data);
  };

  return {mutationFn, ...mutationOptions};
};

export type BubbleAuthProxyPutMutationResult = NonNullable<
  Awaited<ReturnType<typeof bubbleAuthProxyPut>>
>;
export type BubbleAuthProxyPutMutationBody = BubbleAuthProxyPutBody;
export type BubbleAuthProxyPutMutationError = unknown;

/**
 * @summary Proxy PUT request to BubbleAuthProxy
 */
export const useBubbleAuthProxyPut = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof bubbleAuthProxyPut>>,
      TError,
      {data: BubbleAuthProxyPutBody},
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof bubbleAuthProxyPut>>,
  TError,
  {data: BubbleAuthProxyPutBody},
  TContext
> => {
  const mutationOptions = getBubbleAuthProxyPutMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Proxy DELETE request to BubbleAuthProxy
 */
export const bubbleAuthProxyDelete = (params?: BubbleAuthProxyDeleteParams) => {
  return axiosInstance<BubbleAuthProxyDelete200>({
    url: `/proxy/`,
    method: "DELETE",
    params,
  });
};

export const getBubbleAuthProxyDeleteMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bubbleAuthProxyDelete>>,
    TError,
    {params?: BubbleAuthProxyDeleteParams},
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof bubbleAuthProxyDelete>>,
  TError,
  {params?: BubbleAuthProxyDeleteParams},
  TContext
> => {
  const mutationKey = ["bubbleAuthProxyDelete"];
  const {mutation: mutationOptions} = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : {...options, mutation: {...options.mutation, mutationKey}}
    : {mutation: {mutationKey}};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof bubbleAuthProxyDelete>>,
    {params?: BubbleAuthProxyDeleteParams}
  > = props => {
    const {params} = props ?? {};

    return bubbleAuthProxyDelete(params);
  };

  return {mutationFn, ...mutationOptions};
};

export type BubbleAuthProxyDeleteMutationResult = NonNullable<
  Awaited<ReturnType<typeof bubbleAuthProxyDelete>>
>;

export type BubbleAuthProxyDeleteMutationError = unknown;

/**
 * @summary Proxy DELETE request to BubbleAuthProxy
 */
export const useBubbleAuthProxyDelete = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof bubbleAuthProxyDelete>>,
      TError,
      {params?: BubbleAuthProxyDeleteParams},
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof bubbleAuthProxyDelete>>,
  TError,
  {params?: BubbleAuthProxyDeleteParams},
  TContext
> => {
  const mutationOptions = getBubbleAuthProxyDeleteMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Proxy PATCH request to BubbleAuthProxy
 */
export const bubbleAuthProxyPatch = (
  bubbleAuthProxyPatchBody?: BubbleAuthProxyPatchBody,
) => {
  return axiosInstance<BubbleAuthProxyPatch200>({
    url: `/proxy/`,
    method: "PATCH",
    headers: {"Content-Type": "application/json"},
    data: bubbleAuthProxyPatchBody,
  });
};

export const getBubbleAuthProxyPatchMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bubbleAuthProxyPatch>>,
    TError,
    {data: BubbleAuthProxyPatchBody},
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof bubbleAuthProxyPatch>>,
  TError,
  {data: BubbleAuthProxyPatchBody},
  TContext
> => {
  const mutationKey = ["bubbleAuthProxyPatch"];
  const {mutation: mutationOptions} = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : {...options, mutation: {...options.mutation, mutationKey}}
    : {mutation: {mutationKey}};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof bubbleAuthProxyPatch>>,
    {data: BubbleAuthProxyPatchBody}
  > = props => {
    const {data} = props ?? {};

    return bubbleAuthProxyPatch(data);
  };

  return {mutationFn, ...mutationOptions};
};

export type BubbleAuthProxyPatchMutationResult = NonNullable<
  Awaited<ReturnType<typeof bubbleAuthProxyPatch>>
>;
export type BubbleAuthProxyPatchMutationBody = BubbleAuthProxyPatchBody;
export type BubbleAuthProxyPatchMutationError = unknown;

/**
 * @summary Proxy PATCH request to BubbleAuthProxy
 */
export const useBubbleAuthProxyPatch = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof bubbleAuthProxyPatch>>,
      TError,
      {data: BubbleAuthProxyPatchBody},
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof bubbleAuthProxyPatch>>,
  TError,
  {data: BubbleAuthProxyPatchBody},
  TContext
> => {
  const mutationOptions = getBubbleAuthProxyPatchMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Get list of accounts
 */
export const getAccountList = (
  params?: GetAccountListParams,
  signal?: AbortSignal,
) => {
  return axiosInstance<GetAccountList200>({
    url: `/accounts`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetAccountListQueryKey = (params?: GetAccountListParams) => {
  return [`/accounts`, ...(params ? [params] : [])] as const;
};

export const getGetAccountListQueryOptions = <
  TData = Awaited<ReturnType<typeof getAccountList>>,
  TError = unknown,
>(
  params?: GetAccountListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAccountList>>, TError, TData>
    >;
  },
) => {
  const {query: queryOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAccountListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAccountList>>> = ({
    signal,
  }) => getAccountList(params, signal);

  return {queryKey, queryFn, ...queryOptions} as UseQueryOptions<
    Awaited<ReturnType<typeof getAccountList>>,
    TError,
    TData
  > & {queryKey: DataTag<QueryKey, TData, TError>};
};

export type GetAccountListQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAccountList>>
>;
export type GetAccountListQueryError = unknown;

export function useGetAccountList<
  TData = Awaited<ReturnType<typeof getAccountList>>,
  TError = unknown,
>(
  params: undefined | GetAccountListParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAccountList>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAccountList>>,
          TError,
          Awaited<ReturnType<typeof getAccountList>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAccountList<
  TData = Awaited<ReturnType<typeof getAccountList>>,
  TError = unknown,
>(
  params?: GetAccountListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAccountList>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAccountList>>,
          TError,
          Awaited<ReturnType<typeof getAccountList>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};
export function useGetAccountList<
  TData = Awaited<ReturnType<typeof getAccountList>>,
  TError = unknown,
>(
  params?: GetAccountListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAccountList>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};

export function useGetAccountList<
  TData = Awaited<ReturnType<typeof getAccountList>>,
  TError = unknown,
>(
  params?: GetAccountListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAccountList>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetAccountListQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & {queryKey: DataTag<QueryKey, TData, TError>};

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Creates new account
 */
export const createAccount = (account: Account, signal?: AbortSignal) => {
  return axiosInstance<void>({
    url: `/accounts`,
    method: "POST",
    headers: {"Content-Type": "application/json"},
    data: account,
    signal,
  });
};

export const getCreateAccountMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createAccount>>,
    TError,
    {data: Account},
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createAccount>>,
  TError,
  {data: Account},
  TContext
> => {
  const mutationKey = ["createAccount"];
  const {mutation: mutationOptions} = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : {...options, mutation: {...options.mutation, mutationKey}}
    : {mutation: {mutationKey}};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createAccount>>,
    {data: Account}
  > = props => {
    const {data} = props ?? {};

    return createAccount(data);
  };

  return {mutationFn, ...mutationOptions};
};

export type CreateAccountMutationResult = NonNullable<
  Awaited<ReturnType<typeof createAccount>>
>;
export type CreateAccountMutationBody = Account;
export type CreateAccountMutationError = unknown;

export const useCreateAccount = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createAccount>>,
      TError,
      {data: Account},
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createAccount>>,
  TError,
  {data: Account},
  TContext
> => {
  const mutationOptions = getCreateAccountMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Get account bu slug or id
 */
export const getAccountDetails = (
  slug: string,
  params?: GetAccountDetailsParams,
  signal?: AbortSignal,
) => {
  return axiosInstance<Account>({
    url: `/accounts/${slug}`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetAccountDetailsQueryKey = (
  slug: string,
  params?: GetAccountDetailsParams,
) => {
  return [`/accounts/${slug}`, ...(params ? [params] : [])] as const;
};

export const getGetAccountDetailsQueryOptions = <
  TData = Awaited<ReturnType<typeof getAccountDetails>>,
  TError = unknown,
>(
  slug: string,
  params?: GetAccountDetailsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAccountDetails>>,
        TError,
        TData
      >
    >;
  },
) => {
  const {query: queryOptions} = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAccountDetailsQueryKey(slug, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAccountDetails>>
  > = ({signal}) => getAccountDetails(slug, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!slug,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getAccountDetails>>,
    TError,
    TData
  > & {queryKey: DataTag<QueryKey, TData, TError>};
};

export type GetAccountDetailsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAccountDetails>>
>;
export type GetAccountDetailsQueryError = unknown;

export function useGetAccountDetails<
  TData = Awaited<ReturnType<typeof getAccountDetails>>,
  TError = unknown,
>(
  slug: string,
  params: undefined | GetAccountDetailsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAccountDetails>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAccountDetails>>,
          TError,
          Awaited<ReturnType<typeof getAccountDetails>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAccountDetails<
  TData = Awaited<ReturnType<typeof getAccountDetails>>,
  TError = unknown,
>(
  slug: string,
  params?: GetAccountDetailsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAccountDetails>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAccountDetails>>,
          TError,
          Awaited<ReturnType<typeof getAccountDetails>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};
export function useGetAccountDetails<
  TData = Awaited<ReturnType<typeof getAccountDetails>>,
  TError = unknown,
>(
  slug: string,
  params?: GetAccountDetailsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAccountDetails>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};

export function useGetAccountDetails<
  TData = Awaited<ReturnType<typeof getAccountDetails>>,
  TError = unknown,
>(
  slug: string,
  params?: GetAccountDetailsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAccountDetails>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetAccountDetailsQueryOptions(slug, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & {queryKey: DataTag<QueryKey, TData, TError>};

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Delete specified account by slug or id
 */
export const deleteAccount = (slug: string) => {
  return axiosInstance<void>({url: `/accounts/${slug}`, method: "DELETE"});
};

export const getDeleteAccountMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteAccount>>,
    TError,
    {slug: string},
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteAccount>>,
  TError,
  {slug: string},
  TContext
> => {
  const mutationKey = ["deleteAccount"];
  const {mutation: mutationOptions} = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : {...options, mutation: {...options.mutation, mutationKey}}
    : {mutation: {mutationKey}};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteAccount>>,
    {slug: string}
  > = props => {
    const {slug} = props ?? {};

    return deleteAccount(slug);
  };

  return {mutationFn, ...mutationOptions};
};

export type DeleteAccountMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteAccount>>
>;

export type DeleteAccountMutationError = unknown;

export const useDeleteAccount = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteAccount>>,
      TError,
      {slug: string},
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteAccount>>,
  TError,
  {slug: string},
  TContext
> => {
  const mutationOptions = getDeleteAccountMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Update some fields of the specified account by slug
 */
export const updateAccount = (slug: string, account: Account) => {
  return axiosInstance<void>({
    url: `/accounts/${slug}`,
    method: "PATCH",
    headers: {"Content-Type": "application/json"},
    data: account,
  });
};

export const getUpdateAccountMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateAccount>>,
    TError,
    {slug: string; data: Account},
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateAccount>>,
  TError,
  {slug: string; data: Account},
  TContext
> => {
  const mutationKey = ["updateAccount"];
  const {mutation: mutationOptions} = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : {...options, mutation: {...options.mutation, mutationKey}}
    : {mutation: {mutationKey}};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateAccount>>,
    {slug: string; data: Account}
  > = props => {
    const {slug, data} = props ?? {};

    return updateAccount(slug, data);
  };

  return {mutationFn, ...mutationOptions};
};

export type UpdateAccountMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateAccount>>
>;
export type UpdateAccountMutationBody = Account;
export type UpdateAccountMutationError = unknown;

export const useUpdateAccount = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateAccount>>,
      TError,
      {slug: string; data: Account},
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateAccount>>,
  TError,
  {slug: string; data: Account},
  TContext
> => {
  const mutationOptions = getUpdateAccountMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Get list of subaccounts of the workspace
 */
export const getWorkspaceSubaccounts = (
  workspaceId: string,
  signal?: AbortSignal,
) => {
  return axiosInstance<GetWorkspaceSubaccounts200>({
    url: `/workspaces/${workspaceId}/subaccounts`,
    method: "GET",
    signal,
  });
};

export const getGetWorkspaceSubaccountsQueryKey = (workspaceId: string) => {
  return [`/workspaces/${workspaceId}/subaccounts`] as const;
};

export const getGetWorkspaceSubaccountsQueryOptions = <
  TData = Awaited<ReturnType<typeof getWorkspaceSubaccounts>>,
  TError = void,
>(
  workspaceId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getWorkspaceSubaccounts>>,
        TError,
        TData
      >
    >;
  },
) => {
  const {query: queryOptions} = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetWorkspaceSubaccountsQueryKey(workspaceId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getWorkspaceSubaccounts>>
  > = ({signal}) => getWorkspaceSubaccounts(workspaceId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!workspaceId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getWorkspaceSubaccounts>>,
    TError,
    TData
  > & {queryKey: DataTag<QueryKey, TData, TError>};
};

export type GetWorkspaceSubaccountsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getWorkspaceSubaccounts>>
>;
export type GetWorkspaceSubaccountsQueryError = void;

export function useGetWorkspaceSubaccounts<
  TData = Awaited<ReturnType<typeof getWorkspaceSubaccounts>>,
  TError = void,
>(
  workspaceId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getWorkspaceSubaccounts>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWorkspaceSubaccounts>>,
          TError,
          Awaited<ReturnType<typeof getWorkspaceSubaccounts>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetWorkspaceSubaccounts<
  TData = Awaited<ReturnType<typeof getWorkspaceSubaccounts>>,
  TError = void,
>(
  workspaceId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getWorkspaceSubaccounts>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWorkspaceSubaccounts>>,
          TError,
          Awaited<ReturnType<typeof getWorkspaceSubaccounts>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};
export function useGetWorkspaceSubaccounts<
  TData = Awaited<ReturnType<typeof getWorkspaceSubaccounts>>,
  TError = void,
>(
  workspaceId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getWorkspaceSubaccounts>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};

export function useGetWorkspaceSubaccounts<
  TData = Awaited<ReturnType<typeof getWorkspaceSubaccounts>>,
  TError = void,
>(
  workspaceId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getWorkspaceSubaccounts>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetWorkspaceSubaccountsQueryOptions(
    workspaceId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & {queryKey: DataTag<QueryKey, TData, TError>};

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Gets the flat list of capabilities tree leaves
 */
export const getCapabilities = (
  params?: GetCapabilitiesParams,
  signal?: AbortSignal,
) => {
  return axiosInstance<UserInterfaceItem[]>({
    url: `/capabilities`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetCapabilitiesQueryKey = (params?: GetCapabilitiesParams) => {
  return [`/capabilities`, ...(params ? [params] : [])] as const;
};

export const getGetCapabilitiesQueryOptions = <
  TData = Awaited<ReturnType<typeof getCapabilities>>,
  TError = unknown,
>(
  params?: GetCapabilitiesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCapabilities>>,
        TError,
        TData
      >
    >;
  },
) => {
  const {query: queryOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCapabilitiesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCapabilities>>> = ({
    signal,
  }) => getCapabilities(params, signal);

  return {queryKey, queryFn, ...queryOptions} as UseQueryOptions<
    Awaited<ReturnType<typeof getCapabilities>>,
    TError,
    TData
  > & {queryKey: DataTag<QueryKey, TData, TError>};
};

export type GetCapabilitiesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCapabilities>>
>;
export type GetCapabilitiesQueryError = unknown;

export function useGetCapabilities<
  TData = Awaited<ReturnType<typeof getCapabilities>>,
  TError = unknown,
>(
  params: undefined | GetCapabilitiesParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCapabilities>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCapabilities>>,
          TError,
          Awaited<ReturnType<typeof getCapabilities>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetCapabilities<
  TData = Awaited<ReturnType<typeof getCapabilities>>,
  TError = unknown,
>(
  params?: GetCapabilitiesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCapabilities>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCapabilities>>,
          TError,
          Awaited<ReturnType<typeof getCapabilities>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};
export function useGetCapabilities<
  TData = Awaited<ReturnType<typeof getCapabilities>>,
  TError = unknown,
>(
  params?: GetCapabilitiesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCapabilities>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};

export function useGetCapabilities<
  TData = Awaited<ReturnType<typeof getCapabilities>>,
  TError = unknown,
>(
  params?: GetCapabilitiesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCapabilities>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetCapabilitiesQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & {queryKey: DataTag<QueryKey, TData, TError>};

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Attaches several assistants to an account
 */
export const attachAssistantsToAccount = (
  slug: string,
  attachAssistantsToAccountBody: AttachAssistantsToAccountBody,
) => {
  return axiosInstance<void>({
    url: `/accounts/${slug}/assistants`,
    method: "PUT",
    headers: {"Content-Type": "application/json"},
    data: attachAssistantsToAccountBody,
  });
};

export const getAttachAssistantsToAccountMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof attachAssistantsToAccount>>,
    TError,
    {slug: string; data: AttachAssistantsToAccountBody},
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof attachAssistantsToAccount>>,
  TError,
  {slug: string; data: AttachAssistantsToAccountBody},
  TContext
> => {
  const mutationKey = ["attachAssistantsToAccount"];
  const {mutation: mutationOptions} = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : {...options, mutation: {...options.mutation, mutationKey}}
    : {mutation: {mutationKey}};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof attachAssistantsToAccount>>,
    {slug: string; data: AttachAssistantsToAccountBody}
  > = props => {
    const {slug, data} = props ?? {};

    return attachAssistantsToAccount(slug, data);
  };

  return {mutationFn, ...mutationOptions};
};

export type AttachAssistantsToAccountMutationResult = NonNullable<
  Awaited<ReturnType<typeof attachAssistantsToAccount>>
>;
export type AttachAssistantsToAccountMutationBody =
  AttachAssistantsToAccountBody;
export type AttachAssistantsToAccountMutationError = void;

export const useAttachAssistantsToAccount = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof attachAssistantsToAccount>>,
      TError,
      {slug: string; data: AttachAssistantsToAccountBody},
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof attachAssistantsToAccount>>,
  TError,
  {slug: string; data: AttachAssistantsToAccountBody},
  TContext
> => {
  const mutationOptions = getAttachAssistantsToAccountMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Detaches several assistants to an account
 */
export const detachAssistantsFromAccount = (
  slug: string,
  detachAssistantsFromAccountBody: DetachAssistantsFromAccountBody,
) => {
  return axiosInstance<void>({
    url: `/accounts/${slug}/assistants`,
    method: "DELETE",
    headers: {"Content-Type": "application/json"},
    data: detachAssistantsFromAccountBody,
  });
};

export const getDetachAssistantsFromAccountMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof detachAssistantsFromAccount>>,
    TError,
    {slug: string; data: DetachAssistantsFromAccountBody},
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof detachAssistantsFromAccount>>,
  TError,
  {slug: string; data: DetachAssistantsFromAccountBody},
  TContext
> => {
  const mutationKey = ["detachAssistantsFromAccount"];
  const {mutation: mutationOptions} = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : {...options, mutation: {...options.mutation, mutationKey}}
    : {mutation: {mutationKey}};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof detachAssistantsFromAccount>>,
    {slug: string; data: DetachAssistantsFromAccountBody}
  > = props => {
    const {slug, data} = props ?? {};

    return detachAssistantsFromAccount(slug, data);
  };

  return {mutationFn, ...mutationOptions};
};

export type DetachAssistantsFromAccountMutationResult = NonNullable<
  Awaited<ReturnType<typeof detachAssistantsFromAccount>>
>;
export type DetachAssistantsFromAccountMutationBody =
  DetachAssistantsFromAccountBody;
export type DetachAssistantsFromAccountMutationError = void;

export const useDetachAssistantsFromAccount = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof detachAssistantsFromAccount>>,
      TError,
      {slug: string; data: DetachAssistantsFromAccountBody},
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof detachAssistantsFromAccount>>,
  TError,
  {slug: string; data: DetachAssistantsFromAccountBody},
  TContext
> => {
  const mutationOptions =
    getDetachAssistantsFromAccountMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Get account bu slug or id
 */
export const getAccountByWorkspace = (
  workspaceId: string,
  accountType: "voice" | "default",
  signal?: AbortSignal,
) => {
  return axiosInstance<Account>({
    url: `/accounts/${workspaceId}/${accountType}`,
    method: "GET",
    signal,
  });
};

export const getGetAccountByWorkspaceQueryKey = (
  workspaceId: string,
  accountType: "voice" | "default",
) => {
  return [`/accounts/${workspaceId}/${accountType}`] as const;
};

export const getGetAccountByWorkspaceQueryOptions = <
  TData = Awaited<ReturnType<typeof getAccountByWorkspace>>,
  TError = unknown,
>(
  workspaceId: string,
  accountType: "voice" | "default",
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAccountByWorkspace>>,
        TError,
        TData
      >
    >;
  },
) => {
  const {query: queryOptions} = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetAccountByWorkspaceQueryKey(workspaceId, accountType);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAccountByWorkspace>>
  > = ({signal}) => getAccountByWorkspace(workspaceId, accountType, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(workspaceId && accountType),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getAccountByWorkspace>>,
    TError,
    TData
  > & {queryKey: DataTag<QueryKey, TData, TError>};
};

export type GetAccountByWorkspaceQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAccountByWorkspace>>
>;
export type GetAccountByWorkspaceQueryError = unknown;

export function useGetAccountByWorkspace<
  TData = Awaited<ReturnType<typeof getAccountByWorkspace>>,
  TError = unknown,
>(
  workspaceId: string,
  accountType: "voice" | "default",
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAccountByWorkspace>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAccountByWorkspace>>,
          TError,
          Awaited<ReturnType<typeof getAccountByWorkspace>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAccountByWorkspace<
  TData = Awaited<ReturnType<typeof getAccountByWorkspace>>,
  TError = unknown,
>(
  workspaceId: string,
  accountType: "voice" | "default",
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAccountByWorkspace>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAccountByWorkspace>>,
          TError,
          Awaited<ReturnType<typeof getAccountByWorkspace>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};
export function useGetAccountByWorkspace<
  TData = Awaited<ReturnType<typeof getAccountByWorkspace>>,
  TError = unknown,
>(
  workspaceId: string,
  accountType: "voice" | "default",
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAccountByWorkspace>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};

export function useGetAccountByWorkspace<
  TData = Awaited<ReturnType<typeof getAccountByWorkspace>>,
  TError = unknown,
>(
  workspaceId: string,
  accountType: "voice" | "default",
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAccountByWorkspace>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetAccountByWorkspaceQueryOptions(
    workspaceId,
    accountType,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & {queryKey: DataTag<QueryKey, TData, TError>};

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Delete specified account by slug or id
 */
export const deleteAccountByWorkspace = (
  workspaceId: string,
  accountType: "voice" | "default",
) => {
  return axiosInstance<void>({
    url: `/accounts/${workspaceId}/${accountType}`,
    method: "DELETE",
  });
};

export const getDeleteAccountByWorkspaceMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteAccountByWorkspace>>,
    TError,
    {workspaceId: string; accountType: "voice" | "default"},
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteAccountByWorkspace>>,
  TError,
  {workspaceId: string; accountType: "voice" | "default"},
  TContext
> => {
  const mutationKey = ["deleteAccountByWorkspace"];
  const {mutation: mutationOptions} = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : {...options, mutation: {...options.mutation, mutationKey}}
    : {mutation: {mutationKey}};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteAccountByWorkspace>>,
    {workspaceId: string; accountType: "voice" | "default"}
  > = props => {
    const {workspaceId, accountType} = props ?? {};

    return deleteAccountByWorkspace(workspaceId, accountType);
  };

  return {mutationFn, ...mutationOptions};
};

export type DeleteAccountByWorkspaceMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteAccountByWorkspace>>
>;

export type DeleteAccountByWorkspaceMutationError = unknown;

export const useDeleteAccountByWorkspace = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteAccountByWorkspace>>,
      TError,
      {workspaceId: string; accountType: "voice" | "default"},
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteAccountByWorkspace>>,
  TError,
  {workspaceId: string; accountType: "voice" | "default"},
  TContext
> => {
  const mutationOptions = getDeleteAccountByWorkspaceMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Update some fields of the specified account by slug
 */
export const updateAccountByWorkspace = (
  workspaceId: string,
  accountType: "voice" | "default",
  account: Account,
) => {
  return axiosInstance<void>({
    url: `/accounts/${workspaceId}/${accountType}`,
    method: "PATCH",
    headers: {"Content-Type": "application/json"},
    data: account,
  });
};

export const getUpdateAccountByWorkspaceMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateAccountByWorkspace>>,
    TError,
    {workspaceId: string; accountType: "voice" | "default"; data: Account},
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateAccountByWorkspace>>,
  TError,
  {workspaceId: string; accountType: "voice" | "default"; data: Account},
  TContext
> => {
  const mutationKey = ["updateAccountByWorkspace"];
  const {mutation: mutationOptions} = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : {...options, mutation: {...options.mutation, mutationKey}}
    : {mutation: {mutationKey}};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateAccountByWorkspace>>,
    {workspaceId: string; accountType: "voice" | "default"; data: Account}
  > = props => {
    const {workspaceId, accountType, data} = props ?? {};

    return updateAccountByWorkspace(workspaceId, accountType, data);
  };

  return {mutationFn, ...mutationOptions};
};

export type UpdateAccountByWorkspaceMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateAccountByWorkspace>>
>;
export type UpdateAccountByWorkspaceMutationBody = Account;
export type UpdateAccountByWorkspaceMutationError = unknown;

export const useUpdateAccountByWorkspace = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateAccountByWorkspace>>,
      TError,
      {workspaceId: string; accountType: "voice" | "default"; data: Account},
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateAccountByWorkspace>>,
  TError,
  {workspaceId: string; accountType: "voice" | "default"; data: Account},
  TContext
> => {
  const mutationOptions = getUpdateAccountByWorkspaceMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Get account webhook secrets
 */
export const getAccountSecrets = (slug: string, signal?: AbortSignal) => {
  return axiosInstance<NameValue[]>({
    url: `/accounts/${slug}/secrets`,
    method: "GET",
    signal,
  });
};

export const getGetAccountSecretsQueryKey = (slug: string) => {
  return [`/accounts/${slug}/secrets`] as const;
};

export const getGetAccountSecretsQueryOptions = <
  TData = Awaited<ReturnType<typeof getAccountSecrets>>,
  TError = unknown,
>(
  slug: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAccountSecrets>>,
        TError,
        TData
      >
    >;
  },
) => {
  const {query: queryOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAccountSecretsQueryKey(slug);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAccountSecrets>>
  > = ({signal}) => getAccountSecrets(slug, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!slug,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getAccountSecrets>>,
    TError,
    TData
  > & {queryKey: DataTag<QueryKey, TData, TError>};
};

export type GetAccountSecretsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAccountSecrets>>
>;
export type GetAccountSecretsQueryError = unknown;

export function useGetAccountSecrets<
  TData = Awaited<ReturnType<typeof getAccountSecrets>>,
  TError = unknown,
>(
  slug: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAccountSecrets>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAccountSecrets>>,
          TError,
          Awaited<ReturnType<typeof getAccountSecrets>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAccountSecrets<
  TData = Awaited<ReturnType<typeof getAccountSecrets>>,
  TError = unknown,
>(
  slug: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAccountSecrets>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAccountSecrets>>,
          TError,
          Awaited<ReturnType<typeof getAccountSecrets>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};
export function useGetAccountSecrets<
  TData = Awaited<ReturnType<typeof getAccountSecrets>>,
  TError = unknown,
>(
  slug: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAccountSecrets>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};

export function useGetAccountSecrets<
  TData = Awaited<ReturnType<typeof getAccountSecrets>>,
  TError = unknown,
>(
  slug: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAccountSecrets>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetAccountSecretsQueryOptions(slug, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & {queryKey: DataTag<QueryKey, TData, TError>};

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Set account webhook secrets
 */
export const setAccountSecrets = (slug: string, nameValue: NameValue[]) => {
  return axiosInstance<void>({
    url: `/accounts/${slug}/secrets`,
    method: "PUT",
    headers: {"Content-Type": "application/json"},
    data: nameValue,
  });
};

export const getSetAccountSecretsMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setAccountSecrets>>,
    TError,
    {slug: string; data: NameValue[]},
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof setAccountSecrets>>,
  TError,
  {slug: string; data: NameValue[]},
  TContext
> => {
  const mutationKey = ["setAccountSecrets"];
  const {mutation: mutationOptions} = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : {...options, mutation: {...options.mutation, mutationKey}}
    : {mutation: {mutationKey}};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof setAccountSecrets>>,
    {slug: string; data: NameValue[]}
  > = props => {
    const {slug, data} = props ?? {};

    return setAccountSecrets(slug, data);
  };

  return {mutationFn, ...mutationOptions};
};

export type SetAccountSecretsMutationResult = NonNullable<
  Awaited<ReturnType<typeof setAccountSecrets>>
>;
export type SetAccountSecretsMutationBody = NameValue[];
export type SetAccountSecretsMutationError = unknown;

export const useSetAccountSecrets = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof setAccountSecrets>>,
      TError,
      {slug: string; data: NameValue[]},
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof setAccountSecrets>>,
  TError,
  {slug: string; data: NameValue[]},
  TContext
> => {
  const mutationOptions = getSetAccountSecretsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Add domain to the CORS whitelist
 */
export const addDomainWhitelist = (
  domainWhitelist: DomainWhitelist,
  signal?: AbortSignal,
) => {
  return axiosInstance<void>({
    url: `/domain/whitelist`,
    method: "POST",
    headers: {"Content-Type": "application/json"},
    data: domainWhitelist,
    signal,
  });
};

export const getAddDomainWhitelistMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addDomainWhitelist>>,
    TError,
    {data: DomainWhitelist},
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof addDomainWhitelist>>,
  TError,
  {data: DomainWhitelist},
  TContext
> => {
  const mutationKey = ["addDomainWhitelist"];
  const {mutation: mutationOptions} = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : {...options, mutation: {...options.mutation, mutationKey}}
    : {mutation: {mutationKey}};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof addDomainWhitelist>>,
    {data: DomainWhitelist}
  > = props => {
    const {data} = props ?? {};

    return addDomainWhitelist(data);
  };

  return {mutationFn, ...mutationOptions};
};

export type AddDomainWhitelistMutationResult = NonNullable<
  Awaited<ReturnType<typeof addDomainWhitelist>>
>;
export type AddDomainWhitelistMutationBody = DomainWhitelist;
export type AddDomainWhitelistMutationError = void;

export const useAddDomainWhitelist = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof addDomainWhitelist>>,
      TError,
      {data: DomainWhitelist},
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof addDomainWhitelist>>,
  TError,
  {data: DomainWhitelist},
  TContext
> => {
  const mutationOptions = getAddDomainWhitelistMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Remove domain to the CORS whitelist
 */
export const removeDomainWhitelist = (params: RemoveDomainWhitelistParams) => {
  return axiosInstance<void>({
    url: `/domain/whitelist`,
    method: "DELETE",
    params,
  });
};

export const getRemoveDomainWhitelistMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof removeDomainWhitelist>>,
    TError,
    {params: RemoveDomainWhitelistParams},
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof removeDomainWhitelist>>,
  TError,
  {params: RemoveDomainWhitelistParams},
  TContext
> => {
  const mutationKey = ["removeDomainWhitelist"];
  const {mutation: mutationOptions} = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : {...options, mutation: {...options.mutation, mutationKey}}
    : {mutation: {mutationKey}};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof removeDomainWhitelist>>,
    {params: RemoveDomainWhitelistParams}
  > = props => {
    const {params} = props ?? {};

    return removeDomainWhitelist(params);
  };

  return {mutationFn, ...mutationOptions};
};

export type RemoveDomainWhitelistMutationResult = NonNullable<
  Awaited<ReturnType<typeof removeDomainWhitelist>>
>;

export type RemoveDomainWhitelistMutationError = void;

export const useRemoveDomainWhitelist = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof removeDomainWhitelist>>,
      TError,
      {params: RemoveDomainWhitelistParams},
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof removeDomainWhitelist>>,
  TError,
  {params: RemoveDomainWhitelistParams},
  TContext
> => {
  const mutationOptions = getRemoveDomainWhitelistMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Get the PCAP for a specific call
 */
export const getCallPcap = (
  callId: string,
  params: GetCallPcapParams,
  signal?: AbortSignal,
) => {
  return axiosInstance<CallPcap>({
    url: `/calls/pcap/${callId}`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetCallPcapQueryKey = (
  callId: string,
  params: GetCallPcapParams,
) => {
  return [`/calls/pcap/${callId}`, ...(params ? [params] : [])] as const;
};

export const getGetCallPcapQueryOptions = <
  TData = Awaited<ReturnType<typeof getCallPcap>>,
  TError = void,
>(
  callId: string,
  params: GetCallPcapParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCallPcap>>, TError, TData>
    >;
  },
) => {
  const {query: queryOptions} = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetCallPcapQueryKey(callId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCallPcap>>> = ({
    signal,
  }) => getCallPcap(callId, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!callId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getCallPcap>>,
    TError,
    TData
  > & {queryKey: DataTag<QueryKey, TData, TError>};
};

export type GetCallPcapQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCallPcap>>
>;
export type GetCallPcapQueryError = void;

export function useGetCallPcap<
  TData = Awaited<ReturnType<typeof getCallPcap>>,
  TError = void,
>(
  callId: string,
  params: GetCallPcapParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCallPcap>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCallPcap>>,
          TError,
          Awaited<ReturnType<typeof getCallPcap>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetCallPcap<
  TData = Awaited<ReturnType<typeof getCallPcap>>,
  TError = void,
>(
  callId: string,
  params: GetCallPcapParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCallPcap>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCallPcap>>,
          TError,
          Awaited<ReturnType<typeof getCallPcap>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};
export function useGetCallPcap<
  TData = Awaited<ReturnType<typeof getCallPcap>>,
  TError = void,
>(
  callId: string,
  params: GetCallPcapParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCallPcap>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};

export function useGetCallPcap<
  TData = Awaited<ReturnType<typeof getCallPcap>>,
  TError = void,
>(
  callId: string,
  params: GetCallPcapParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCallPcap>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetCallPcapQueryOptions(callId, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & {queryKey: DataTag<QueryKey, TData, TError>};

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get information about all the SIP messages that have been transmitted during a call
 */
export const getCallFlow = (
  callId: string,
  params: GetCallFlowParams,
  signal?: AbortSignal,
) => {
  return axiosInstance<CallFlow>({
    url: `/calls/flow/${callId}`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetCallFlowQueryKey = (
  callId: string,
  params: GetCallFlowParams,
) => {
  return [`/calls/flow/${callId}`, ...(params ? [params] : [])] as const;
};

export const getGetCallFlowQueryOptions = <
  TData = Awaited<ReturnType<typeof getCallFlow>>,
  TError = void,
>(
  callId: string,
  params: GetCallFlowParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCallFlow>>, TError, TData>
    >;
  },
) => {
  const {query: queryOptions} = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetCallFlowQueryKey(callId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCallFlow>>> = ({
    signal,
  }) => getCallFlow(callId, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!callId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getCallFlow>>,
    TError,
    TData
  > & {queryKey: DataTag<QueryKey, TData, TError>};
};

export type GetCallFlowQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCallFlow>>
>;
export type GetCallFlowQueryError = void;

export function useGetCallFlow<
  TData = Awaited<ReturnType<typeof getCallFlow>>,
  TError = void,
>(
  callId: string,
  params: GetCallFlowParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCallFlow>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCallFlow>>,
          TError,
          Awaited<ReturnType<typeof getCallFlow>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetCallFlow<
  TData = Awaited<ReturnType<typeof getCallFlow>>,
  TError = void,
>(
  callId: string,
  params: GetCallFlowParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCallFlow>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCallFlow>>,
          TError,
          Awaited<ReturnType<typeof getCallFlow>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};
export function useGetCallFlow<
  TData = Awaited<ReturnType<typeof getCallFlow>>,
  TError = void,
>(
  callId: string,
  params: GetCallFlowParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCallFlow>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {queryKey: DataTag<QueryKey, TData, TError>};

export function useGetCallFlow<
  TData = Awaited<ReturnType<typeof getCallFlow>>,
  TError = void,
>(
  callId: string,
  params: GetCallFlowParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCallFlow>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetCallFlowQueryOptions(callId, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & {queryKey: DataTag<QueryKey, TData, TError>};

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Track usage and update account minutes, then report to Stripe
 */
export const trackUsage = (
  usageTrackingRequest: UsageTrackingRequest,
  signal?: AbortSignal,
) => {
  return axiosInstance<UsageTrackingResponse>({
    url: `/payment/usage`,
    method: "POST",
    headers: {"Content-Type": "application/json"},
    data: usageTrackingRequest,
    signal,
  });
};

export const getTrackUsageMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof trackUsage>>,
    TError,
    {data: UsageTrackingRequest},
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof trackUsage>>,
  TError,
  {data: UsageTrackingRequest},
  TContext
> => {
  const mutationKey = ["trackUsage"];
  const {mutation: mutationOptions} = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : {...options, mutation: {...options.mutation, mutationKey}}
    : {mutation: {mutationKey}};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof trackUsage>>,
    {data: UsageTrackingRequest}
  > = props => {
    const {data} = props ?? {};

    return trackUsage(data);
  };

  return {mutationFn, ...mutationOptions};
};

export type TrackUsageMutationResult = NonNullable<
  Awaited<ReturnType<typeof trackUsage>>
>;
export type TrackUsageMutationBody = UsageTrackingRequest;
export type TrackUsageMutationError = void;

export const useTrackUsage = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof trackUsage>>,
      TError,
      {data: UsageTrackingRequest},
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof trackUsage>>,
  TError,
  {data: UsageTrackingRequest},
  TContext
> => {
  const mutationOptions = getTrackUsageMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
